import React, { FC } from "react";
interface ISvgComponent {
  fillColor?: string;
  fillColor1?: string;
  customClass?: string;
  width?: number;
  height?: number;
  handleClick?: (e: React.MouseEvent<Element>) => any;
  mouseEnter?: (e: React.MouseEvent<Element>) => any;
  mouseLeave?: (e: React.MouseEvent<Element>) => any;
  iconRef?: any;
  style?: any;
}

export const ExportIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="24"
      height="24"
      className={customClass}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M24.0003 19.1042L24.0003 13.5364C24.0123 12.2511 23.4925 11.0137 22.5551 10.0958C21.6177 9.1779 20.3392 8.65456 19.0003 8.64062L16.0003 8.64062C15.7351 8.64062 15.4807 8.74176 15.2932 8.92179C15.1056 9.10182 15.0003 9.34599 15.0003 9.60059C15.0003 9.85519 15.1056 10.0994 15.2932 10.2794C15.4807 10.4594 15.7351 10.5605 16.0003 10.5605L19.0003 10.5606C19.8089 10.5742 20.5788 10.8952 21.1412 11.453C21.7037 12.0109 22.0126 12.7602 22.0003 13.5364L22.0003 19.1042C22.0126 19.8805 21.7037 20.6297 21.1412 21.1876C20.5788 21.7455 19.8089 22.0665 19.0003 22.0801L5.00028 22.0801C4.19168 22.0665 3.42173 21.7455 2.85932 21.1876C2.29691 20.6297 1.98798 19.8805 2.00028 19.1042L2.00028 13.5364C1.98798 12.7602 2.29691 12.0109 2.85932 11.453C3.42173 10.8952 4.19168 10.5742 5.00028 10.5605L8.00028 10.5605C8.2655 10.5605 8.51986 10.4594 8.70739 10.2794C8.89493 10.0994 9.00029 9.85518 9.00029 9.60059C9.00029 9.34599 8.89493 9.10182 8.70739 8.92179C8.51986 8.74176 8.2655 8.64062 8.00028 8.64062L5.00028 8.64062C3.66134 8.65456 2.38285 9.1779 1.44544 10.0958C0.50803 11.0137 -0.0117151 12.2511 0.000283972 13.5364L0.000283718 19.1042C-0.0117155 20.3896 0.508029 21.627 1.44544 22.5449C2.38285 23.4628 3.66134 23.9861 5.00028 24L19.0003 24C20.3392 23.9861 21.6177 23.4628 22.5551 22.5449C23.4925 21.627 24.0123 20.3896 24.0003 19.1042Z"
        // fill="#797979"
        fill={fillColor ? fillColor : "#273fad"}
      />
      <path
        d="M11.9882 14.1533C12.2534 14.1533 12.5078 14.0522 12.6953 13.8722C12.8828 13.6921 12.9882 13.448 12.9882 13.1934L12.9582 2.4533L17.2812 6.60321C17.3734 6.6949 17.4838 6.76803 17.6058 6.81834C17.7278 6.86865 17.859 6.89514 17.9918 6.89624C18.1246 6.89735 18.2563 6.87306 18.3792 6.82479C18.502 6.77653 18.6137 6.70525 18.7076 6.61511C18.8015 6.52498 18.8757 6.4178 18.926 6.29982C18.9763 6.18185 19.0016 6.05544 19.0005 5.92798C18.9993 5.80051 18.9717 5.67455 18.9193 5.55743C18.8669 5.44031 18.7907 5.33438 18.6952 5.24583L14.1092 0.843439C13.5466 0.303543 12.7837 0.000247091 11.9882 0.000247082C11.1927 0.000247073 10.4298 0.303543 9.8672 0.843439L5.2812 5.24391C5.09904 5.42496 4.99825 5.66745 5.00053 5.91915C5.0028 6.17085 5.10797 6.41162 5.29338 6.5896C5.47879 6.76759 5.7296 6.86854 5.9918 6.87073C6.254 6.87292 6.5066 6.77616 6.6952 6.6013L10.9582 2.50993L10.9882 13.1934C10.9882 13.448 11.0936 13.6921 11.2811 13.8722C11.4686 14.0522 11.723 14.1533 11.9882 14.1533Z"
        // fill="#797979"
        fill={fillColor ? fillColor : "#273fad"}
      />
    </svg>
  );
};

export const PrintIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="24"
      height="24"
      className={customClass}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // onClick={(e) => {
      //   handleClick && handleClick(e)
      // }}
    >
      <g clipPath="url(#clip0_228_684)">
        <path
          d="M19 6V4C19 2.93913 18.5786 1.92172 17.8284 1.17157C17.0783 0.421427 16.0609 0 15 0L9 0C7.93913 0 6.92172 0.421427 6.17157 1.17157C5.42143 1.92172 5 2.93913 5 4V6C3.67441 6.00159 2.40356 6.52888 1.46622 7.46622C0.528882 8.40356 0.00158786 9.67441 0 11L0 16C0.00158786 17.3256 0.528882 18.5964 1.46622 19.5338C2.40356 20.4711 3.67441 20.9984 5 21C5 21.7956 5.31607 22.5587 5.87868 23.1213C6.44129 23.6839 7.20435 24 8 24H16C16.7956 24 17.5587 23.6839 18.1213 23.1213C18.6839 22.5587 19 21.7956 19 21C20.3256 20.9984 21.5964 20.4711 22.5338 19.5338C23.4711 18.5964 23.9984 17.3256 24 16V11C23.9984 9.67441 23.4711 8.40356 22.5338 7.46622C21.5964 6.52888 20.3256 6.00159 19 6ZM7 4C7 3.46957 7.21071 2.96086 7.58579 2.58579C7.96086 2.21071 8.46957 2 9 2H15C15.5304 2 16.0391 2.21071 16.4142 2.58579C16.7893 2.96086 17 3.46957 17 4V6H7V4ZM17 21C17 21.2652 16.8946 21.5196 16.7071 21.7071C16.5196 21.8946 16.2652 22 16 22H8C7.73478 22 7.48043 21.8946 7.29289 21.7071C7.10536 21.5196 7 21.2652 7 21V17C7 16.7348 7.10536 16.4804 7.29289 16.2929C7.48043 16.1054 7.73478 16 8 16H16C16.2652 16 16.5196 16.1054 16.7071 16.2929C16.8946 16.4804 17 16.7348 17 17V21ZM22 16C22 16.7956 21.6839 17.5587 21.1213 18.1213C20.5587 18.6839 19.7956 19 19 19V17C19 16.2044 18.6839 15.4413 18.1213 14.8787C17.5587 14.3161 16.7956 14 16 14H8C7.20435 14 6.44129 14.3161 5.87868 14.8787C5.31607 15.4413 5 16.2044 5 17V19C4.20435 19 3.44129 18.6839 2.87868 18.1213C2.31607 17.5587 2 16.7956 2 16V11C2 10.2044 2.31607 9.44129 2.87868 8.87868C3.44129 8.31607 4.20435 8 5 8H19C19.7956 8 20.5587 8.31607 21.1213 8.87868C21.6839 9.44129 22 10.2044 22 11V16Z"
          // fill="#797979"
          fill={fillColor ? fillColor : "#273fad"}
        />
        <path
          d="M18 10H16C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11C15 11.2652 15.1054 11.5196 15.2929 11.7071C15.4804 11.8946 15.7348 12 16 12H18C18.2652 12 18.5196 11.8946 18.7071 11.7071C18.8946 11.5196 19 11.2652 19 11C19 10.7348 18.8946 10.4804 18.7071 10.2929C18.5196 10.1054 18.2652 10 18 10Z"
          // fill="#797979"
          fill={fillColor ? fillColor : "#273fad"}
        />
      </g>
      <defs>
        <clipPath id="clip0_228_684">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BookingDeleteIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8 3.6H18.5292C18.012 3.6 17.5548 3.27122 17.3904 2.78042L17.0112 1.64033C16.6836 0.659932 15.768 0 14.7348 0H9.26397C8.22957 0 7.314 0.66005 6.9876 1.64165L6.60842 2.77925C6.44522 3.27005 5.98678 3.6 5.46958 3.6H1.2C0.5376 3.6 0 4.1364 0 4.8C0 5.4636 0.5376 6 1.2 6H2.478L3.37917 19.5192C3.54597 22.032 5.64961 24 8.16841 24H15.8328C18.3516 24 20.4552 22.0308 20.622 19.5192L21.5232 6H22.8C23.4624 6 24 5.4636 24 4.8C24 4.1364 23.4624 3.6 22.8 3.6ZM9.26521 2.4L14.736 2.39883L15.1152 3.53877C15.1224 3.56037 15.1332 3.5784 15.1416 3.6H8.86077C8.86797 3.5784 8.88001 3.5592 8.88721 3.5376L9.26521 2.4ZM18.2268 19.3597C18.1428 20.6161 17.0916 21.6 15.8316 21.6H8.16724C6.90844 21.6 5.856 20.6161 5.772 19.3597L4.88276 6H5.47083C5.59923 6 5.72517 5.98317 5.85117 5.96997C5.90277 5.97717 5.94717 6 6.00117 6H18.0012C18.054 6 18.0996 5.97597 18.1512 5.96997C18.2772 5.98317 18.402 6 18.5316 6H19.1196L18.2268 19.3597ZM15.6 10.8V16.8C15.6 17.4636 15.0624 18 14.4 18C13.7376 18 13.2 17.4636 13.2 16.8V10.8C13.2 10.1364 13.7376 9.6 14.4 9.6C15.0624 9.6 15.6 10.1364 15.6 10.8ZM10.8 10.8V16.8C10.8 17.4636 10.2624 18 9.6 18C8.9376 18 8.4 17.4636 8.4 16.8V10.8C8.4 10.1364 8.9376 9.6 9.6 9.6C10.2624 9.6 10.8 10.1364 10.8 10.8Z"
        fill="#797979"
      />
    </svg>
  );
};

export const EmailIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  width,
  height,
  fillColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={customClass}
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 1H19C20.1 1 21 1.9 21 3V15C21 16.1 20.1 17 19 17H3C1.9 17 1 16.1 1 15V3C1 1.9 1.9 1 3 1Z"
        stroke={fillColor ? fillColor : "#181818"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 3L11 10L1 3"
        stroke="#181818"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PasswordIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={customClass}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 10H3C1.89543 10 1 10.8954 1 12V19C1 20.1046 1.89543 21 3 21H17C18.1046 21 19 20.1046 19 19V12C19 10.8954 18.1046 10 17 10Z"
        stroke="#181818"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10V6C5 4.67392 5.52678 3.40215 6.46447 2.46447C7.40215 1.52678 8.67392 1 10 1C11.3261 1 12.5979 1.52678 13.5355 2.46447C14.4732 3.40215 15 4.67392 15 6V10"
        stroke="#181818"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EyeIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width={"18px"}
      height={"18px"}
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9C1 9 5 1 12 1C19 1 23 9 23 9C23 9 19 17 12 17C5 17 1 9 1 9Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseEyeIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="18px"
      height="18px"
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9811 7.11477C18.4051 6.15477 17.4451 4.85077 16.1091 3.70077L18.2791 1.53079C18.5721 1.23779 18.5721 0.76275 18.2791 0.46975C17.9861 0.17675 17.5111 0.17675 17.2181 0.46975L11.6851 6.00277L11.6831 6.00375L11.6821 6.00478L1.21714 16.4697C0.924136 16.7627 0.924136 17.2378 1.21714 17.5308C1.36314 17.6768 1.55513 17.7508 1.74713 17.7508C1.93913 17.7508 2.13113 17.6778 2.27713 17.5308L4.58713 15.2207C6.17113 16.2327 7.90412 16.7508 9.74912 16.7508C14.6961 16.7508 17.6551 13.0778 18.9801 10.8858C19.6781 9.72277 19.6781 8.27877 18.9811 7.11477ZM12.4991 9.00076C12.4991 10.5178 11.2651 11.7508 9.74912 11.7508C9.27112 11.7508 8.82013 11.6187 8.41813 11.3927L12.1401 7.67074C12.3671 8.07174 12.4991 8.52276 12.4991 9.00076ZM17.6971 10.1128C16.5371 12.0318 13.9621 15.2508 9.75113 15.2508C8.31013 15.2508 6.95314 14.8557 5.69214 14.1177L7.32712 12.4828C8.03012 12.9778 8.86514 13.2508 9.74814 13.2508C12.0911 13.2508 13.9981 11.3438 13.9981 9.00076C13.9981 8.11776 13.7251 7.28274 13.2301 6.57974L15.0471 4.76278C16.2791 5.80078 17.1661 7.00477 17.6951 7.88577C18.1061 8.57377 18.1061 9.42776 17.6971 10.1128ZM1.88013 12.7837C1.38213 12.1937 0.925129 11.5558 0.522129 10.8878C-0.173871 9.72178 -0.173878 8.27775 0.521122 7.11575C1.84612 4.92375 4.80514 1.25076 9.75214 1.25076C10.7081 1.25076 11.6321 1.38875 12.5771 1.67275C12.9731 1.79175 13.1991 2.20977 13.0791 2.60677C12.9601 3.00377 12.5421 3.22873 12.1451 3.10873C11.3421 2.86773 10.5591 2.75076 9.75113 2.75076C5.54113 2.75076 2.96512 5.96976 1.80512 7.88876C1.39612 8.57376 1.39613 9.42775 1.80713 10.1157C2.16813 10.7137 2.57813 11.2868 3.02613 11.8168C3.29313 12.1328 3.25314 12.6068 2.93714 12.8738C2.79614 12.9928 2.62514 13.0508 2.45414 13.0508C2.24014 13.0508 2.02813 12.9597 1.88013 12.7837ZM9.94013 5.43575C10.0031 5.84475 9.72314 6.22773 9.31314 6.29073C8.15314 6.46973 7.21913 7.40474 7.04013 8.56374C6.98313 8.93474 6.66414 9.19973 6.30014 9.19973C6.26214 9.19973 6.22312 9.19676 6.18512 9.19076C5.77512 9.12776 5.49514 8.74478 5.55814 8.33578C5.84014 6.50778 7.25815 5.09074 9.08515 4.80874C9.48815 4.74674 9.87613 5.02675 9.94013 5.43575Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const TranslationIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 26"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      // xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
    >
      <g clipPath="url(#clip0_22923_39362)">
        <path
          d="M22.3037 10.6992H12.8896C11.4053 10.6992 10.1943 11.9053 10.1943 13.3945V18.5117L7.75293 20.2549C7.5625 20.3916 7.44531 20.6162 7.44531 20.8506C7.44531 21.085 7.55762 21.3096 7.75293 21.4463L10.2236 23.209C10.4141 24.5078 11.5371 25.5039 12.8896 25.5039H22.3037C23.7881 25.5039 24.999 24.2979 24.999 22.8086V13.3896C24.999 11.9053 23.793 10.6992 22.3037 10.6992ZM19.1396 20.9873C18.9688 20.9873 18.832 20.9336 18.793 20.7822L18.4951 19.7373H16.6982L16.4004 20.7822C16.3613 20.9336 16.2295 20.9873 16.0537 20.9873C15.7803 20.9873 15.4092 20.8164 15.4092 20.5625C15.4092 20.5479 15.4189 20.5137 15.4238 20.4844L16.9375 15.5479C17.0059 15.3135 17.2988 15.2012 17.5869 15.2012C17.8848 15.2012 18.1777 15.3135 18.2461 15.5479L19.7598 20.4844C19.7695 20.5137 19.7744 20.5381 19.7744 20.5625C19.7842 20.8066 19.4131 20.9873 19.1396 20.9873Z"
          fill={fillColor}
        />
        <path
          d="M16.9141 18.9424H18.2812L17.5977 16.5352L16.9141 18.9424Z"
          fill="white"
        />
        <path
          d="M8.73535 13.3906C8.73535 12.4092 9.07715 11.501 9.65332 10.7881C8.81836 10.7881 8.04199 10.5244 7.40234 10.0801C6.7627 10.5244 5.98633 10.7881 5.15137 10.7881C4.92188 10.7881 4.73633 10.6025 4.73633 10.373C4.73633 10.1436 4.92188 9.95801 5.15137 9.95801C5.7373 9.95801 6.28418 9.79688 6.75293 9.51367C6.18652 8.90332 5.81055 8.11719 5.71777 7.24316H5.14648C4.91699 7.24316 4.73145 7.05762 4.73145 6.82813C4.73145 6.59863 4.91699 6.41309 5.14648 6.41309H6.98242V5.41211C6.98242 5.18262 7.16797 4.99707 7.39746 4.99707C7.62695 4.99707 7.8125 5.18262 7.8125 5.41211V6.41309H9.64844C9.87793 6.41309 10.0635 6.59863 10.0635 6.82813C10.0635 7.05762 9.87793 7.24316 9.64844 7.24316H9.08203C8.98926 8.11719 8.61328 8.90332 8.04688 9.51367C8.51562 9.79688 9.0625 9.95801 9.64844 9.95801C9.86816 9.95801 10.0439 10.1289 10.0586 10.3389C10.8008 9.64551 11.7969 9.22559 12.8906 9.22559H14.7998V7.48731L17.2412 5.74414C17.4316 5.60742 17.5488 5.38281 17.5488 5.14844C17.5488 4.91406 17.4365 4.68945 17.2412 4.55273L14.7705 2.79492C14.5752 1.49609 13.457 0.5 12.1045 0.5H2.69531C1.20605 0.5 0 1.70605 0 3.19531V12.6094C0 14.0938 1.20605 15.3047 2.69531 15.3047H8.73535V13.3906Z"
          fill={fillColor}
        />
        <path
          d="M7.4043 9.00684C7.8584 8.53809 8.16113 7.92773 8.25391 7.25391H6.55469C6.64258 7.92773 6.9502 8.53809 7.4043 9.00684Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22923_39362">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const NotificationIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
  iconRef,
  height,
  width,
}) => {
  return (
    <svg
      // width="26"
      // height="27"
      width={width}
      height={height}
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      ref={iconRef}
    >
      <path
        opacity="0.4"
        d="M12.8765 22.2257C13.4015 22.225 13.9133 22.0607 14.3407 21.7558C14.768 21.4508 15.0898 21.0203 15.2612 20.524L10.4832 20.5363C10.6571 21.0317 10.9811 21.4605 11.41 21.7633C11.8389 22.0661 12.3515 22.2277 12.8765 22.2257ZM18.7947 15.9251L18.7847 12.0373C18.7777 9.31005 16.9195 7.01737 14.4083 6.33289C14.1583 5.70788 13.5502 5.2686 12.833 5.27044C12.1158 5.27229 11.5099 5.71468 11.2631 6.34097C8.75552 7.03918 6.90906 9.34053 6.91607 12.0678L6.92605 15.9556L5.48264 17.4065C5.40396 17.4852 5.34165 17.5788 5.29928 17.6818C5.25692 17.7848 5.23534 17.8951 5.23578 18.0065L5.23796 18.8542C5.23854 19.0791 5.32841 19.2945 5.4878 19.453C5.6472 19.6116 5.86306 19.7004 6.0879 19.6998L19.6521 19.665C19.8769 19.6644 20.0923 19.5745 20.2509 19.4151C20.4095 19.2557 20.4982 19.0399 20.4977 18.815L20.4955 17.9673C20.4954 17.8559 20.4732 17.7457 20.4303 17.6429C20.3874 17.5402 20.3246 17.4469 20.2456 17.3685L18.7947 15.9251Z"
        fill="#181818"
      />
      <circle
        cx="17.8208"
        cy="7.71118"
        r="2.18692"
        transform="rotate(-0.23402 17.8208 7.71118)"
        fill="#46DFE3"
      />
    </svg>
  );
};
export const CheckIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <g clipPath="url(#clip0_3962_9229)">
        <rect
          x="0.75"
          y="0.75"
          width="18.5"
          height="18.5"
          rx="2.25"
          stroke={fillColor}
          strokeWidth="1.5"
        />
        <path
          d="M8.54553 14.9668C8.3478 14.9674 8.15192 14.9287 7.96925 14.853C7.78658 14.7773 7.62076 14.6661 7.4814 14.5258L4 11.0444L5.06414 9.98026L8.54553 13.4616L16.0411 5.9668L17.1053 7.03093L9.61042 14.5258C9.47092 14.6661 9.30497 14.7773 9.12217 14.853C8.93938 14.9287 8.74338 14.9674 8.54553 14.9668Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_3962_9229">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UncheckIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <g clipPath="url(#clip0_3962_9249)">
        <rect
          x="0.75"
          y="0.75"
          width="18.5"
          height="18.5"
          rx="2.25"
          stroke={fillColor}
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_3962_9249">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CloseIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill={fillColor} />
      <path
        d="M17.4309 7.56641L7.5625 17.4348"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.56908 7.56641L17.4375 17.4348"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RemoveTagCloseIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill={fillColor} />
      <path
        d="M17.4309 7.56641L7.5625 17.4348"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.56908 7.56641L17.4375 17.4348"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RemoveAttachmentIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <circle cx="4.5" cy="4.5" r="4.5" fill="#02BF90" />
      <path
        d="M5.75 3.25L3.25 5.75"
        stroke="white"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.25 3.25L5.75 5.75"
        stroke="white"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Attachments: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  fillColor1,
  customClass,
  height,
  width,
}) => {
  return (
    <svg
      width={width ?? "42"}
      height={height ?? "42"}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <rect width="42" height="42" rx="21" fill={fillColor1} />
      <path
        d="M28.5775 20.1782L21.6005 27.0952C20.5064 28.2019 19.0451 28.8784 17.4868 28.9997H17.0881C15.7322 29.0151 14.4266 28.4909 13.4637 27.5444C11.3434 25.4423 11.5518 21.8132 13.9258 19.4596L20.1779 13.2612C20.5313 12.9129 21.1021 12.9129 21.4555 13.2612C21.6271 13.4299 21.7236 13.6595 21.7236 13.899C21.7236 14.1385 21.6271 14.3682 21.4555 14.5368L15.1943 20.7442C13.518 22.3971 13.3096 24.8854 14.7232 26.2868C15.4295 26.9505 16.3913 27.2781 17.3599 27.1851C18.4808 27.0927 19.53 26.6013 20.3138 25.8017L27.3362 18.9116C28.3877 18.026 28.5326 16.4697 27.6624 15.4082C26.5947 14.5464 25.0277 14.6902 24.1376 15.7316L17.1606 22.6486C16.9325 22.8681 16.7911 23.1612 16.7619 23.475C16.7365 23.7047 16.8125 23.9339 16.9703 24.1039C17.4317 24.4339 18.0717 24.3556 18.4382 23.9242L25.7867 16.6389C26.1402 16.2906 26.7109 16.2906 27.0643 16.6389C27.2359 16.8076 27.3324 17.0372 27.3324 17.2767C27.3324 17.5162 27.2359 17.7458 27.0643 17.9145L19.7249 25.1908C18.6617 26.342 16.8605 26.4263 15.6927 25.3795C14.6344 24.2241 14.7154 22.4385 15.8739 21.382L22.8056 14.465C24.4051 12.7179 27.1254 12.5736 28.9037 14.1416C30.4843 15.9016 30.3387 18.5956 28.5775 20.1782Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CrossIcon: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  fillColor1,
  customClass,
  width = "20",
  height = "20",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <circle cx="10" cy="10" r="10" fill={fillColor1} />
      <path
        d="M13.9494 6.05273L6.05469 13.9475"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.05058 6.05273L13.9453 13.9475"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        d="M19.827 18.9843L14.9656 14.1229C16.2697 12.6236 17.0592 10.6676 17.0592 8.52961C17.0592 3.82346 13.2313 0 8.52961 0C3.82346 0 0 3.8279 0 8.52961C0 13.2313 3.8279 17.0592 8.52961 17.0592C10.6676 17.0592 12.6236 16.2697 14.1229 14.9656L18.9843 19.827C19.0996 19.9423 19.2548 20.0044 19.4056 20.0044C19.5564 20.0044 19.7117 19.9468 19.827 19.827C20.0577 19.5964 20.0577 19.2149 19.827 18.9843ZM1.19317 8.52961C1.19317 4.48436 4.48436 1.1976 8.52517 1.1976C12.5704 1.1976 15.8572 4.4888 15.8572 8.52961C15.8572 12.5704 12.5704 15.866 8.52517 15.866C4.48436 15.866 1.19317 12.5749 1.19317 8.52961Z"
        // fill="#353751"
        fill={fillColor}
      />
    </svg>
  );
};

export const SortDown: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.63392 6.67651C5.31368 7.09251 4.68632 7.09251 4.36608 6.67651L0.795348 2.038C0.39039 1.51194 0.765401 0.75 1.42927 0.75L8.57073 0.75C9.2346 0.75 9.60961 1.51194 9.20465 2.038L5.63392 6.67651Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export const EditIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M18.0724 10.9999C17.6396 10.9999 17.285 11.3498 17.285 11.7873V19.647C17.285 20.0798 16.9351 20.4344 16.4977 20.4344H2.35747C1.92465 20.4344 1.57011 20.0844 1.57011 19.647V3.9275C1.57011 3.49469 1.92005 3.14014 2.35747 3.14014H11.7873C12.2202 3.14014 12.5747 2.79021 12.5747 2.35279C12.5747 1.91537 12.2248 1.56543 11.7873 1.56543H2.35747C1.05441 1.57003 0 2.62905 0 3.9275V19.6424C0 20.9455 1.05441 21.9999 2.35747 21.9999H16.5023C17.8053 21.9999 18.8597 20.9455 18.8597 19.6424V11.7873C18.8597 11.3544 18.5098 10.9999 18.0724 10.9999Z"
        // fill={fillColor ? fillColor : "#CDD4D8"}
        fill={"#3D96E7"}
      />
      <path
        d="M21.1236 0.879495C20.5618 0.317755 19.7975 4.936e-05 18.9963 4.936e-05C18.1997 -0.00455507 17.4308 0.31315 16.8691 0.879495L6.51831 11.2302C6.43082 11.3177 6.36636 11.4236 6.32953 11.5387L4.75942 16.2537C4.62128 16.6635 4.8469 17.1101 5.25669 17.2482C5.33497 17.2759 5.42245 17.2897 5.50533 17.2897C5.58821 17.2897 5.6757 17.2759 5.75397 17.2482L10.4689 15.6781C10.584 15.6413 10.6899 15.5722 10.7774 15.4893L21.1282 5.13859C22.2977 3.95986 22.3023 2.05823 21.1236 0.879495Z"
        // fill="#CDD4D8"
        // fill={fillColor ? fillColor : "#CDD4D8"}
        fill={"#3D96E7"}
      />
    </svg>
  );
};
export const DropDownIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  height,
  width,
}) => {
  return (
    <svg
      width={width ?? "14"}
      height={height ?? "8"}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M2 0.000395298L7.293 5.2934L12.586 0.000395298L14 1.4144L8.707 6.7074C8.33194 7.08234 7.82333 7.29297 7.293 7.29297C6.76267 7.29297 6.25406 7.08234 5.879 6.7074L0.585998 1.4144L2 0.000395298Z"
        // fill="#797979"
        fill={fillColor}
      />
    </svg>
  );
};

export const DropDownIconForDataTable: React.FunctionComponent<
  ISvgComponent
> = ({ fillColor, handleClick, customClass }) => {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        d="M5.63392 6.17651C5.31368 6.59251 4.68632 6.59251 4.36608 6.17651L0.795348 1.538C0.39039 1.01194 0.765401 0.25 1.42927 0.25L8.57073 0.25C9.2346 0.25 9.60961 1.01194 9.20465 1.538L5.63392 6.17651Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export const CalculatorIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        d="M10.7812 0.515625H1.71973C0.770508 0.515625 0 1.28613 0 2.23535V13.7988C0 14.7451 0.770508 15.5156 1.71973 15.5156H10.7812C11.7305 15.5156 12.501 14.7451 12.501 13.7959V2.23535C12.501 1.28613 11.7305 0.515625 10.7812 0.515625ZM4.86328 12.2168C5.04785 12.4014 5.04785 12.6973 4.86328 12.8789C4.77246 12.9697 4.65234 13.0166 4.53223 13.0166C4.41211 13.0166 4.29199 12.9697 4.20117 12.8789L3.75 12.4277L3.29883 12.8789C3.20801 12.9697 3.08789 13.0166 2.96777 13.0166C2.84766 13.0166 2.72754 12.9697 2.63672 12.8789C2.45215 12.6943 2.45215 12.3984 2.63672 12.2168L3.08496 11.7686L2.63672 11.3145C2.45215 11.1299 2.45215 10.834 2.63672 10.6523C2.82129 10.4707 3.11719 10.4678 3.29883 10.6523L3.75 11.1035L4.20117 10.6523C4.38574 10.4678 4.68164 10.4678 4.86328 10.6523C5.04785 10.8369 5.04785 11.1328 4.86328 11.3145L4.41211 11.7656L4.86328 12.2168ZM4.53223 8.48438H4.21875V8.79785C4.21875 9.05566 4.00781 9.2666 3.75 9.2666C3.49219 9.2666 3.28125 9.05566 3.28125 8.79785V8.48438H2.96777C2.70996 8.48438 2.49902 8.27344 2.49902 8.01562C2.49902 7.75781 2.70996 7.54688 2.96777 7.54688H3.28125V7.2334C3.28125 6.97559 3.49219 6.76465 3.75 6.76465C4.00781 6.76465 4.21875 6.97559 4.21875 7.2334V7.54688H4.53223C4.79004 7.54688 5.00098 7.75781 5.00098 8.01562C5.00098 8.27344 4.79004 8.48438 4.53223 8.48438ZM9.53027 13.0166H7.96875C7.71094 13.0166 7.5 12.8057 7.5 12.5479C7.5 12.29 7.71094 12.0791 7.96875 12.0791H9.53027C9.78809 12.0791 9.99902 12.29 9.99902 12.5479C9.99902 12.8057 9.79102 13.0166 9.53027 13.0166ZM9.53027 11.4521H7.96875C7.71094 11.4521 7.5 11.2412 7.5 10.9834C7.5 10.7256 7.71094 10.5146 7.96875 10.5146H9.53027C9.78809 10.5146 9.99902 10.7256 9.99902 10.9834C9.99902 11.2412 9.79102 11.4521 9.53027 11.4521ZM9.53027 8.63965H7.96875C7.71094 8.63965 7.5 8.42871 7.5 8.1709C7.5 7.91309 7.71094 7.70215 7.96875 7.70215H9.53027C9.78809 7.70215 9.99902 7.91309 9.99902 8.1709C9.99902 8.42871 9.79102 8.63965 9.53027 8.63965ZM10.626 4.4209C10.626 5.02441 10.1367 5.51367 9.5332 5.51367H2.9707C2.36719 5.51367 1.87793 5.02441 1.87793 4.4209V3.4834C1.875 2.87988 2.36426 2.39062 2.96777 2.39062H9.53027C10.1338 2.39062 10.623 2.87988 10.623 3.4834V4.4209H10.626Z"
        fill="#3D96E7"
      />
    </svg>
  );
};

export const TypeIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="25"
      height="33"
      viewBox="0 0 25 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        d="M6.352 23.416V24.32H4.864V29H3.744V24.32H2.256V23.416H6.352ZM11.4092 24.568L8.66519 31.096H7.47319L8.43319 28.888L6.65719 24.568H7.91319L9.05719 27.664L10.2172 24.568H11.4092ZM13.1329 25.208C13.2769 25.0053 13.4743 24.8373 13.7249 24.704C13.9809 24.5653 14.2716 24.496 14.5969 24.496C14.9756 24.496 15.3169 24.5893 15.6209 24.776C15.9303 24.9627 16.1729 25.2293 16.3489 25.576C16.5303 25.9173 16.6209 26.3147 16.6209 26.768C16.6209 27.2213 16.5303 27.624 16.3489 27.976C16.1729 28.3227 15.9303 28.592 15.6209 28.784C15.3169 28.976 14.9756 29.072 14.5969 29.072C14.2716 29.072 13.9836 29.0053 13.7329 28.872C13.4876 28.7387 13.2876 28.5707 13.1329 28.368V31.112H12.0129V24.568H13.1329V25.208ZM15.4769 26.768C15.4769 26.5013 15.4209 26.272 15.3089 26.08C15.2023 25.8827 15.0583 25.7333 14.8769 25.632C14.7009 25.5307 14.5089 25.48 14.3009 25.48C14.0983 25.48 13.9063 25.5333 13.7249 25.64C13.5489 25.7413 13.4049 25.8907 13.2929 26.088C13.1863 26.2853 13.1329 26.5173 13.1329 26.784C13.1329 27.0507 13.1863 27.2827 13.2929 27.48C13.4049 27.6773 13.5489 27.8293 13.7249 27.936C13.9063 28.0373 14.0983 28.088 14.3009 28.088C14.5089 28.088 14.7009 28.0347 14.8769 27.928C15.0583 27.8213 15.2023 27.6693 15.3089 27.472C15.4209 27.2747 15.4769 27.04 15.4769 26.768ZM21.5548 26.688C21.5548 26.848 21.5441 26.992 21.5228 27.12H18.2828C18.3095 27.44 18.4215 27.6907 18.6188 27.872C18.8161 28.0533 19.0588 28.144 19.3468 28.144C19.7628 28.144 20.0588 27.9653 20.2348 27.608H21.4428C21.3148 28.0347 21.0695 28.3867 20.7068 28.664C20.3441 28.936 19.8988 29.072 19.3708 29.072C18.9441 29.072 18.5601 28.9787 18.2188 28.792C17.8828 28.6 17.6188 28.3307 17.4268 27.984C17.2401 27.6373 17.1468 27.2373 17.1468 26.784C17.1468 26.3253 17.2401 25.9227 17.4268 25.576C17.6135 25.2293 17.8748 24.9627 18.2108 24.776C18.5468 24.5893 18.9335 24.496 19.3708 24.496C19.7921 24.496 20.1681 24.5867 20.4988 24.768C20.8348 24.9493 21.0935 25.208 21.2748 25.544C21.4615 25.8747 21.5548 26.256 21.5548 26.688ZM20.3948 26.368C20.3895 26.08 20.2855 25.8507 20.0828 25.68C19.8801 25.504 19.6321 25.416 19.3388 25.416C19.0615 25.416 18.8268 25.5013 18.6348 25.672C18.4481 25.8373 18.3335 26.0693 18.2908 26.368H20.3948Z"
        fill={fillColor}
      />
      <path
        d="M24.0481 18.2164V1.78357C24.0481 0.801603 23.1997 0 22.1577 0H1.89045C0.848363 0 0 0.801603 0 1.78357V18.2164C0 19.1984 0.848363 20 1.89045 20H22.1577C23.1997 20 24.0481 19.2051 24.0481 18.2164ZM1.63661 18.2164V1.78357C1.63661 1.72345 1.73681 1.63661 1.89045 1.63661H22.1577C22.318 1.63661 22.4115 1.73013 22.4115 1.78357V18.2164C22.4115 18.2766 22.3113 18.3634 22.1577 18.3634H1.89045C1.73681 18.3634 1.63661 18.2766 1.63661 18.2164Z"
        fill={fillColor}
      />
      <path
        d="M5.89802 6.68667C6.46248 6.68667 6.92006 6.22908 6.92006 5.66462C6.92006 5.10016 6.46248 4.64258 5.89802 4.64258C5.33356 4.64258 4.87598 5.10016 4.87598 5.66462C4.87598 6.22908 5.33356 6.68667 5.89802 6.68667Z"
        fill={fillColor}
      />
      <path
        d="M10.0865 6.68667C10.651 6.68667 11.1085 6.22908 11.1085 5.66462C11.1085 5.10016 10.651 4.64258 10.0865 4.64258C9.52204 4.64258 9.06445 5.10016 9.06445 5.66462C9.06445 6.22908 9.52204 6.68667 10.0865 6.68667Z"
        fill={fillColor}
      />
      <path
        d="M14.2681 6.68667C14.8326 6.68667 15.2902 6.22908 15.2902 5.66462C15.2902 5.10016 14.8326 4.64258 14.2681 4.64258C13.7037 4.64258 13.2461 5.10016 13.2461 5.66462C13.2461 6.22908 13.7037 6.68667 14.2681 6.68667Z"
        fill={fillColor}
      />
      <path
        d="M18.4566 6.68667C19.0211 6.68667 19.4787 6.22908 19.4787 5.66462C19.4787 5.10016 19.0211 4.64258 18.4566 4.64258C17.8922 4.64258 17.4346 5.10016 17.4346 5.66462C17.4346 6.22908 17.8922 6.68667 18.4566 6.68667Z"
        fill={fillColor}
      />
      <path
        d="M7.99568 11.0226C8.56014 11.0226 9.01772 10.565 9.01772 10.0006C9.01772 9.4361 8.56014 8.97852 7.99568 8.97852C7.43122 8.97852 6.97363 9.4361 6.97363 10.0006C6.97363 10.565 7.43122 11.0226 7.99568 11.0226Z"
        fill={fillColor}
      />
      <path
        d="M12.1773 11.0226C12.7418 11.0226 13.1994 10.565 13.1994 10.0006C13.1994 9.4361 12.7418 8.97852 12.1773 8.97852C11.6129 8.97852 11.1553 9.4361 11.1553 10.0006C11.1553 10.565 11.6129 11.0226 12.1773 11.0226Z"
        fill={fillColor}
      />
      <path
        d="M16.3658 11.0226C16.9303 11.0226 17.3878 10.565 17.3878 10.0006C17.3878 9.4361 16.9303 8.97852 16.3658 8.97852C15.8013 8.97852 15.3438 9.4361 15.3438 10.0006C15.3438 10.565 15.8013 11.0226 16.3658 11.0226Z"
        fill={fillColor}
      />
      <path
        d="M16.9874 13.5195H7.0609C6.60666 13.5195 6.23926 13.8869 6.23926 14.3412C6.23926 14.7954 6.60666 15.1628 7.0609 15.1628H16.9874C17.4417 15.1628 17.8091 14.7954 17.8091 14.3412C17.8091 13.8869 17.4417 13.5195 16.9874 13.5195Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ScribeIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="26"
      height="33"
      viewBox="0 0 26 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M2.48 29.056C2.09067 29.056 1.73867 28.9893 1.424 28.856C1.11467 28.7227 0.869333 28.5307 0.688 28.28C0.506667 28.0293 0.413333 27.7333 0.408 27.392H1.608C1.624 27.6213 1.704 27.8027 1.848 27.936C1.99733 28.0693 2.2 28.136 2.456 28.136C2.71733 28.136 2.92267 28.0747 3.072 27.952C3.22133 27.824 3.296 27.6587 3.296 27.456C3.296 27.2907 3.24533 27.1547 3.144 27.048C3.04267 26.9413 2.91467 26.8587 2.76 26.8C2.61067 26.736 2.40267 26.6667 2.136 26.592C1.77333 26.4853 1.47733 26.3813 1.248 26.28C1.024 26.1733 0.829333 26.016 0.664 25.808C0.504 25.5947 0.424 25.312 0.424 24.96C0.424 24.6293 0.506667 24.3413 0.672 24.096C0.837333 23.8507 1.06933 23.664 1.368 23.536C1.66667 23.4027 2.008 23.336 2.392 23.336C2.968 23.336 3.43467 23.4773 3.792 23.76C4.15467 24.0373 4.35467 24.4267 4.392 24.928H3.16C3.14933 24.736 3.06667 24.5787 2.912 24.456C2.76267 24.328 2.56267 24.264 2.312 24.264C2.09333 24.264 1.91733 24.32 1.784 24.432C1.656 24.544 1.592 24.7067 1.592 24.92C1.592 25.0693 1.64 25.1947 1.736 25.296C1.83733 25.392 1.96 25.472 2.104 25.536C2.25333 25.5947 2.46133 25.664 2.728 25.744C3.09067 25.8507 3.38667 25.9573 3.616 26.064C3.84533 26.1707 4.04267 26.3307 4.208 26.544C4.37333 26.7573 4.456 27.0373 4.456 27.384C4.456 27.6827 4.37867 27.96 4.224 28.216C4.06933 28.472 3.84267 28.6773 3.544 28.832C3.24533 28.9813 2.89067 29.056 2.48 29.056ZM5.139 26.784C5.139 26.3253 5.23233 25.9253 5.419 25.584C5.60567 25.2373 5.86433 24.9707 6.195 24.784C6.52567 24.592 6.90433 24.496 7.331 24.496C7.88033 24.496 8.33367 24.6347 8.691 24.912C9.05367 25.184 9.29633 25.568 9.419 26.064H8.211C8.147 25.872 8.03767 25.7227 7.883 25.616C7.73367 25.504 7.547 25.448 7.323 25.448C7.003 25.448 6.74967 25.5653 6.563 25.8C6.37633 26.0293 6.283 26.3573 6.283 26.784C6.283 27.2053 6.37633 27.5333 6.563 27.768C6.74967 27.9973 7.003 28.112 7.323 28.112C7.77633 28.112 8.07233 27.9093 8.211 27.504H9.419C9.29633 27.984 9.05367 28.3653 8.691 28.648C8.32833 28.9307 7.875 29.072 7.331 29.072C6.90433 29.072 6.52567 28.9787 6.195 28.792C5.86433 28.6 5.60567 28.3333 5.419 27.992C5.23233 27.6453 5.139 27.2427 5.139 26.784ZM11.3595 25.256C11.5035 25.0213 11.6902 24.8373 11.9195 24.704C12.1542 24.5707 12.4208 24.504 12.7195 24.504V25.68H12.4235C12.0715 25.68 11.8048 25.7627 11.6235 25.928C11.4475 26.0933 11.3595 26.3813 11.3595 26.792V29H10.2395V24.568H11.3595V25.256ZM14.0419 24.04C13.8445 24.04 13.6792 23.9787 13.5459 23.856C13.4179 23.728 13.3539 23.5707 13.3539 23.384C13.3539 23.1973 13.4179 23.0427 13.5459 22.92C13.6792 22.792 13.8445 22.728 14.0419 22.728C14.2392 22.728 14.4019 22.792 14.5299 22.92C14.6632 23.0427 14.7299 23.1973 14.7299 23.384C14.7299 23.5707 14.6632 23.728 14.5299 23.856C14.4019 23.9787 14.2392 24.04 14.0419 24.04ZM14.5939 24.568V29H13.4739V24.568H14.5939ZM16.8204 25.216C16.9644 25.0027 17.1618 24.8293 17.4124 24.696C17.6684 24.5627 17.9591 24.496 18.2844 24.496C18.6631 24.496 19.0044 24.5893 19.3084 24.776C19.6178 24.9627 19.8604 25.2293 20.0364 25.576C20.2178 25.9173 20.3084 26.3147 20.3084 26.768C20.3084 27.2213 20.2178 27.624 20.0364 27.976C19.8604 28.3227 19.6178 28.592 19.3084 28.784C19.0044 28.976 18.6631 29.072 18.2844 29.072C17.9538 29.072 17.6631 29.008 17.4124 28.88C17.1671 28.7467 16.9698 28.576 16.8204 28.368V29H15.7004V23.08H16.8204V25.216ZM19.1644 26.768C19.1644 26.5013 19.1084 26.272 18.9964 26.08C18.8898 25.8827 18.7458 25.7333 18.5644 25.632C18.3884 25.5307 18.1964 25.48 17.9884 25.48C17.7858 25.48 17.5938 25.5333 17.4124 25.64C17.2364 25.7413 17.0924 25.8907 16.9804 26.088C16.8738 26.2853 16.8204 26.5173 16.8204 26.784C16.8204 27.0507 16.8738 27.2827 16.9804 27.48C17.0924 27.6773 17.2364 27.8293 17.4124 27.936C17.5938 28.0373 17.7858 28.088 17.9884 28.088C18.1964 28.088 18.3884 28.0347 18.5644 27.928C18.7458 27.8213 18.8898 27.6693 18.9964 27.472C19.1084 27.2747 19.1644 27.04 19.1644 26.768ZM25.2423 26.688C25.2423 26.848 25.2316 26.992 25.2103 27.12H21.9703C21.997 27.44 22.109 27.6907 22.3063 27.872C22.5036 28.0533 22.7463 28.144 23.0343 28.144C23.4503 28.144 23.7463 27.9653 23.9223 27.608H25.1303C25.0023 28.0347 24.757 28.3867 24.3943 28.664C24.0316 28.936 23.5863 29.072 23.0583 29.072C22.6316 29.072 22.2476 28.9787 21.9063 28.792C21.5703 28.6 21.3063 28.3307 21.1143 27.984C20.9276 27.6373 20.8343 27.2373 20.8343 26.784C20.8343 26.3253 20.9276 25.9227 21.1143 25.576C21.301 25.2293 21.5623 24.9627 21.8983 24.776C22.2343 24.5893 22.621 24.496 23.0583 24.496C23.4796 24.496 23.8556 24.5867 24.1863 24.768C24.5223 24.9493 24.781 25.208 24.9623 25.544C25.149 25.8747 25.2423 26.256 25.2423 26.688ZM24.0823 26.368C24.077 26.08 23.973 25.8507 23.7703 25.68C23.5676 25.504 23.3196 25.416 23.0263 25.416C22.749 25.416 22.5143 25.5013 22.3223 25.672C22.1356 25.8373 22.021 26.0693 21.9783 26.368H24.0823Z"
        fill="#BBBBBB"
      />
      <g clipPath="url(#clip0_1767_7490)">
        <path
          d="M16.7305 8.59375C16.7305 8.16406 16.3789 7.8125 15.9492 7.8125H7.90234C7.47266 7.8125 7.12109 8.16406 7.12109 8.59375C7.12109 9.02344 7.47266 9.375 7.90234 9.375H15.9492C16.3789 9.375 16.7305 9.02344 16.7305 8.59375Z"
          fill="#BBBBBB"
        />
        <path
          d="M7.90234 10.9375C7.47266 10.9375 7.12109 11.2891 7.12109 11.7188C7.12109 12.1484 7.47266 12.5 7.90234 12.5H12.7891C13.2188 12.5 13.5703 12.1484 13.5703 11.7188C13.5703 11.2891 13.2188 10.9375 12.7891 10.9375H7.90234Z"
          fill="#BBBBBB"
        />
        <path
          d="M9.73828 18.4375H7.125C6.26172 18.4375 5.5625 17.7383 5.5625 16.875V3.125C5.5625 2.26172 6.26172 1.5625 7.125 1.5625H16.7305C17.5938 1.5625 18.293 2.26172 18.293 3.125V7.92969C18.293 8.35938 18.6445 8.71094 19.0742 8.71094C19.5039 8.71094 19.8555 8.35938 19.8555 7.92969V3.125C19.8555 1.40234 18.4531 0 16.7305 0H7.125C5.40234 0 4 1.40234 4 3.125V16.875C4 18.5977 5.40234 20 7.125 20H9.73828C10.168 20 10.5195 19.6484 10.5195 19.2188C10.5195 18.7891 10.168 18.4375 9.73828 18.4375Z"
          fill="#BBBBBB"
        />
        <path
          d="M21.2387 11.3125C20.3246 10.3984 18.8363 10.3984 17.9262 11.3125L13.6371 15.5898C13.5473 15.6797 13.477 15.793 13.4418 15.9141L12.5082 18.9883C12.4262 19.2617 12.4965 19.5586 12.6957 19.7617C12.8441 19.9141 13.0473 19.9961 13.2543 19.9961C13.3246 19.9961 13.3949 19.9883 13.4613 19.9687L16.6137 19.0937C16.7426 19.0586 16.8637 18.9883 16.9574 18.8945L21.2387 14.6211C22.1527 13.7109 22.1527 12.2266 21.2387 11.3125ZM16.0004 17.6484L14.4145 18.0859L14.8793 16.5586L17.7738 13.6719L18.8793 14.7773L16.0004 17.6484ZM20.1332 13.5195L19.9809 13.6719L18.8754 12.5664L19.0277 12.4141C19.3324 12.1094 19.8285 12.1094 20.1332 12.4141C20.4379 12.7187 20.4379 13.2148 20.1332 13.5195Z"
          fill="#BBBBBB"
        />
        <path
          d="M15.9492 4.6875H7.90234C7.47266 4.6875 7.12109 5.03906 7.12109 5.46875C7.12109 5.89844 7.47266 6.25 7.90234 6.25H15.9492C16.3789 6.25 16.7305 5.89844 16.7305 5.46875C16.7305 5.03906 16.3789 4.6875 15.9492 4.6875Z"
          fill="#BBBBBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_1767_7490">
          <rect
            width="17.9258"
            height="20"
            fill="white"
            transform="translate(4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PhoneIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  width,
  height,
  handleClick,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9381 5C14.9149 5.19057 15.8125 5.66826 16.5162 6.37194C17.2199 7.07561 17.6976 7.97326 17.8881 8.95M13.9381 1C15.9674 1.22544 17.8597 2.13417 19.3044 3.57701C20.749 5.01984 21.6601 6.91101 21.8881 8.94M20.8881 16.92V19.92C20.8892 20.1985 20.8322 20.4742 20.7206 20.7293C20.6091 20.9845 20.4454 21.2136 20.2402 21.4019C20.035 21.5901 19.7927 21.7335 19.5289 21.8227C19.265 21.9119 18.9855 21.9451 18.7081 21.92C15.631 21.5856 12.6751 20.5341 10.0781 18.85C7.66194 17.3147 5.61345 15.2662 4.07812 12.85C2.38809 10.2412 1.33636 7.27099 1.00812 4.18C0.983127 3.90347 1.01599 3.62476 1.10462 3.36162C1.19324 3.09849 1.33569 2.85669 1.52288 2.65162C1.71008 2.44655 1.93792 2.28271 2.19191 2.17052C2.44589 2.05833 2.72046 2.00026 2.99812 2H5.99812C6.48342 1.99522 6.95391 2.16708 7.32188 2.48353C7.68985 2.79999 7.93019 3.23945 7.99812 3.72C8.12474 4.68007 8.35957 5.62273 8.69812 6.53C8.83266 6.88792 8.86178 7.27691 8.78202 7.65088C8.70227 8.02485 8.51698 8.36811 8.24812 8.64L6.97812 9.91C8.40167 12.4135 10.4746 14.4864 12.9781 15.91L14.2481 14.64C14.52 14.3711 14.8633 14.1858 15.2372 14.1061C15.6112 14.0263 16.0002 14.0555 16.3581 14.19C17.2654 14.5286 18.2081 14.7634 19.1681 14.89C19.6539 14.9585 20.0975 15.2032 20.4146 15.5775C20.7318 15.9518 20.9003 16.4296 20.8881 16.92Z"
        stroke="#181818"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Error: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0C5.388 0 0 5.388 0 12C0 18.612 5.388 24 12 24C18.612 24 24 18.612 24 12C24 5.388 18.612 0 12 0ZM12 18C11.34 18 10.8 17.46 10.8 16.8C10.8 16.14 11.34 15.6 12 15.6C12.66 15.6 13.2 16.14 13.2 16.8C13.2 17.46 12.66 18 12 18ZM13.2 12C13.2 12.66 12.66 13.2 12 13.2C11.34 13.2 10.8 12.66 10.8 12V7.2C10.8 6.54 11.34 6 12 6C12.66 6 13.2 6.54 13.2 7.2V12Z"
        fill="#B11313"
      />
    </svg>
  );
};

export const Check: React.FunctionComponent<ISvgComponent> = ({
  width,
  height,
}) => {
  return (
    <svg
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0C5.388 0 0 5.388 0 12C0 18.612 5.388 24 12 24C18.612 24 24 18.612 24 12C24 5.388 18.612 0 12 0ZM17.652 10.452L11.652 16.452C11.412 16.68 11.112 16.8 10.8 16.8C10.488 16.8 10.188 16.68 9.94801 16.452L6.34801 12.852C5.88001 12.384 5.88001 11.616 6.34801 11.148C6.81601 10.68 7.58399 10.68 8.05199 11.148L10.8 13.9081L15.948 8.74805C16.416 8.28005 17.184 8.28005 17.652 8.74805C18.12 9.21605 18.12 9.98395 17.652 10.452Z"
        fill="#02BF90"
      />
    </svg>
  );
};

export const LogoutIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M7.79487 15.3846C7.79487 15.7243 7.51918 16 7.17949 16H3.89744C1.74851 16 0 14.2515 0 12.1026V3.89744C0 1.74851 1.74851 0 3.89744 0H7.17949C7.51918 0 7.79487 0.275692 7.79487 0.615385C7.79487 0.955077 7.51918 1.23077 7.17949 1.23077H3.89744C2.42708 1.23077 1.23077 2.42708 1.23077 3.89744V12.1026C1.23077 13.5729 2.42708 14.7692 3.89744 14.7692H7.17949C7.51918 14.7692 7.79487 15.0449 7.79487 15.3846ZM14.1785 7.5651L10.8964 4.28305C10.656 4.04264 10.2663 4.04264 10.0258 4.28305C9.78543 4.52346 9.78543 4.91324 10.0258 5.15365L12.2576 7.38542H5.53846C5.19877 7.38542 4.92308 7.66111 4.92308 8.0008C4.92308 8.34049 5.19877 8.61619 5.53846 8.61619H12.2576L10.0258 10.848C9.78543 11.0884 9.78543 11.4781 10.0258 11.7185C10.1456 11.8383 10.3032 11.899 10.4607 11.899C10.6183 11.899 10.7758 11.8392 10.8956 11.7185L14.1776 8.4365C14.4189 8.19445 14.4189 7.80551 14.1785 7.5651Z"
        // fill="#181818"
        fill={fillColor}
      />
    </svg>
  );
};

export const Warning: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg width="1792" height="1792" xmlns="http://www.w3.org/2000/svg">
      <g>
        <title>background</title>
        <rect
          fill="none"
          id="canvas_background"
          height="402"
          width="582"
          y="-1"
          x="-1"
        />
      </g>
      <g>
        <title>Layer 1</title>
        <path
          fill="#ffffff"
          id="svg_1"
          d="m1024,1375l0,-190q0,-14 -9.5,-23.5t-22.5,-9.5l-192,0q-13,0 -22.5,9.5t-9.5,23.5l0,190q0,14 9.5,23.5t22.5,9.5l192,0q13,0 22.5,-9.5t9.5,-23.5zm-2,-374l18,-459q0,-12 -10,-19q-13,-11 -24,-11l-220,0q-11,0 -24,11q-10,7 -10,21l17,457q0,10 10,16.5t24,6.5l185,0q14,0 23.5,-6.5t10.5,-16.5zm-14,-934l768,1408q35,63 -2,126q-17,29 -46.5,46t-63.5,17l-1536,0q-34,0 -63.5,-17t-46.5,-46q-37,-63 -2,-126l768,-1408q17,-31 47,-49t65,-18t65,18t47,49z"
        />
      </g>
    </svg>
  );
};

export const DashboardIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M19.3828 27.3477H10.6172L11.3555 23.082H18.6445L19.3828 27.3477Z"
        fill="#67CDDF"
      />
      <path
        d="M19.3828 27.3477H17.625L16.8867 23.082H18.6445L19.3828 27.3477Z"
        fill="#78E7DC"
      />
      <path
        d="M30 3.60215V21.6936C30 22.702 29.1797 23.5223 28.1713 23.5223H1.82871C0.945117 23.5223 0.205664 22.8924 0.0369141 22.0574C0.0123047 21.9402 0 21.8184 0 21.6936V3.60215C0 2.59375 0.820312 1.77344 1.82871 1.77344H28.1713C29.1797 1.77344 30 2.59375 30 3.60215Z"
        fill="#EAEFFE"
      />
      <path
        d="M30 3.60215V21.6936C30 22.702 29.1796 23.5223 28.1712 23.5223H1.82866C0.945068 23.5223 0.205615 22.8924 0.0368652 22.0574H26.7064C27.7166 22.0574 28.5351 21.2389 28.5351 20.2287V3.60215C28.5351 2.59199 27.7166 1.77344 26.7064 1.77344H28.1712C29.1796 1.77344 30 2.59375 30 3.60215Z"
        fill="#67CDDF"
      />
      <path
        d="M30 20.7383V21.6928C30 22.7012 29.1797 23.5215 28.1713 23.5215H1.82871C0.945117 23.5215 0.205664 22.8916 0.0369141 22.0566C0.0123047 21.9395 0 21.8176 0 21.6928V20.7383H30Z"
        fill="#78E7DC"
      />
      <path
        d="M28.463 20.7383H30V21.6928C30 22.7012 29.1796 23.5215 28.1712 23.5215H1.82866C0.945068 23.5215 0.205615 22.8916 0.0368652 22.0566H26.7064C27.539 22.0566 28.2421 21.5 28.463 20.7383Z"
        fill="#67CDDF"
      />
      <path
        d="M26.9513 15.6338H25.4366L24.1642 13.1328C24.0892 12.9854 23.9379 12.8926 23.7725 12.8926C23.6071 12.8926 23.4558 12.9854 23.3808 13.1328L21.3069 17.2088L19.5569 13.7691C19.4819 13.6217 19.3305 13.5289 19.1652 13.5289C18.9998 13.5289 18.8485 13.6217 18.7735 13.7691L17.8248 15.6337H16.3101C16.0674 15.6337 15.8706 15.8305 15.8706 16.0732C15.8706 16.3159 16.0674 16.5126 16.3101 16.5126H18.0942C18.2596 16.5126 18.4109 16.4198 18.4859 16.2724L19.1652 14.9375L20.9152 18.3772C20.9902 18.5246 21.1416 18.6174 21.3069 18.6174C21.4723 18.6174 21.6236 18.5246 21.6986 18.3772L23.7725 14.3012L24.7754 16.2725C24.8504 16.4199 25.0018 16.5127 25.1671 16.5127H26.9513C27.194 16.5127 27.3908 16.3159 27.3908 16.0732C27.3908 15.8305 27.194 15.6338 26.9513 15.6338Z"
        fill="#002C5A"
      />
      <path
        d="M18.5907 6.23242H16.3103C16.1485 6.23242 16.0173 6.36361 16.0173 6.52539V11.1516C16.0173 11.3134 16.1485 11.4446 16.3103 11.4446H18.5907C18.7525 11.4446 18.8837 11.3134 18.8837 11.1516V6.52539C18.8837 6.36361 18.7525 6.23242 18.5907 6.23242Z"
        fill="#67CDDF"
      />
      <path
        d="M22.7865 7.48828H20.5061C20.3443 7.48828 20.2131 7.61947 20.2131 7.78125V11.1504C20.2131 11.3122 20.3443 11.4434 20.5061 11.4434H22.7865C22.9483 11.4434 23.0795 11.3122 23.0795 11.1504V7.78125C23.0795 7.61947 22.9483 7.48828 22.7865 7.48828Z"
        fill="#07C3AA"
      />
      <path
        d="M26.9513 5.07227H24.6709C24.5091 5.07227 24.3779 5.20346 24.3779 5.36523V11.1513C24.3779 11.3131 24.5091 11.4443 24.6709 11.4443H26.9513C27.1131 11.4443 27.2443 11.3131 27.2443 11.1513V5.36523C27.2443 5.20346 27.1131 5.07227 26.9513 5.07227Z"
        fill="#2CDDDD"
      />
      <path
        d="M20.4026 26.4688H9.59766C9.11227 26.4688 8.71875 26.8623 8.71875 27.3477C8.71875 27.833 9.11227 28.2266 9.59766 28.2266H20.4027C20.8881 28.2266 21.2816 27.833 21.2816 27.3477C21.2815 26.8622 20.8881 26.4688 20.4026 26.4688Z"
        fill="#67CDDF"
      />
      <path
        d="M13.002 9.89648H3.04102C2.79832 9.89648 2.60156 10.0932 2.60156 10.3359C2.60156 10.5786 2.79832 10.7754 3.04102 10.7754H13.002C13.2446 10.7754 13.4414 10.5786 13.4414 10.3359C13.4414 10.0932 13.2446 9.89648 13.002 9.89648Z"
        fill="#002C5A"
      />
      <path
        d="M3.04102 13.1094H4.82355C5.06625 13.1094 5.26301 12.9126 5.26301 12.6699C5.26301 12.4272 5.06625 12.2305 4.82355 12.2305H3.04102C2.79832 12.2305 2.60156 12.4272 2.60156 12.6699C2.60156 12.9126 2.79832 13.1094 3.04102 13.1094Z"
        fill="#002C5A"
      />
      <path
        d="M13.002 12.2305H6.83716C6.59446 12.2305 6.39771 12.4272 6.39771 12.6699C6.39771 12.9126 6.59446 13.1094 6.83716 13.1094H13.002C13.2447 13.1094 13.4414 12.9126 13.4414 12.6699C13.4414 12.4272 13.2447 12.2305 13.002 12.2305Z"
        fill="#002C5A"
      />
      <path
        d="M3.04102 5.80469H13.002C13.2446 5.80469 13.4414 5.60793 13.4414 5.36523C13.4414 5.12254 13.2446 4.92578 13.002 4.92578H3.04102C2.79832 4.92578 2.60156 5.12254 2.60156 5.36523C2.60156 5.60793 2.79832 5.80469 3.04102 5.80469Z"
        fill="#002C5A"
      />
      <path
        d="M3.04102 8.13867H9.21809C9.46078 8.13867 9.65754 7.94191 9.65754 7.69922C9.65754 7.45652 9.46078 7.25977 9.21809 7.25977H3.04102C2.79832 7.25977 2.60156 7.45652 2.60156 7.69922C2.60156 7.94191 2.79832 8.13867 3.04102 8.13867Z"
        fill="#002C5A"
      />
      <path
        d="M13.002 7.25977H11.2317C10.989 7.25977 10.7922 7.45652 10.7922 7.69922C10.7922 7.94191 10.989 8.13867 11.2317 8.13867H13.002C13.2447 8.13867 13.4414 7.94191 13.4414 7.69922C13.4414 7.45652 13.2447 7.25977 13.002 7.25977Z"
        fill="#002C5A"
      />
      <path
        d="M13.002 14.5371H3.04102C2.79832 14.5371 2.60156 14.7339 2.60156 14.9766C2.60156 15.2193 2.79832 15.416 3.04102 15.416H13.002C13.2446 15.416 13.4414 15.2193 13.4414 14.9766C13.4414 14.7339 13.2446 14.5371 13.002 14.5371Z"
        fill="#002C5A"
      />
      <path
        d="M7.72852 16.8594H3.04102C2.79832 16.8594 2.60156 17.0561 2.60156 17.2988C2.60156 17.5415 2.79832 17.7383 3.04102 17.7383H7.72852C7.97121 17.7383 8.16797 17.5415 8.16797 17.2988C8.16797 17.0561 7.97121 16.8594 7.72852 16.8594Z"
        fill="#002C5A"
      />
      <path
        d="M21.2815 27.3477C21.2815 27.8328 20.8877 28.2266 20.4026 28.2266H18.6448C19.1299 28.2266 19.5237 27.8328 19.5237 27.3477C19.5237 26.8619 19.1299 26.4688 18.6448 26.4688H20.4026C20.8877 26.4688 21.2815 26.8619 21.2815 27.3477Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const PharmacyPOSIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="33"
      height="30"
      viewBox="0 0 33 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9483 12.9041C28.6658 12.9041 32.4962 16.7344 32.4962 21.452C32.4962 26.1696 28.6658 30 23.9483 30C19.2304 30 15.4004 26.1696 15.4004 21.452C15.4004 16.7344 19.2304 12.9041 23.9483 12.9041ZM25.4509 19.9494V16.8191H22.4457V19.9494H19.315V22.9546H22.4457V26.0853H25.4509V22.9546H28.5812V19.9494H25.4509Z"
        fill={fillColor ? fillColor : "#67cddf"}
      />
      <path
        d="M15.2384 8.09241C16.1878 8.09241 16.9574 7.32282 16.9574 6.37347C16.9574 5.42413 16.1878 4.65454 15.2384 4.65454C14.2891 4.65454 13.5195 5.42413 13.5195 6.37347C13.5195 7.32282 14.2891 8.09241 15.2384 8.09241Z"
        fill={fillColor ? fillColor : "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.16899e-06V26.0853H15.4907C14.7348 24.7093 14.3051 23.1305 14.3051 21.452C14.3051 16.9354 17.4172 13.1401 21.6116 12.0949V2.16899e-06C6.94537 0.000230396 6.39818 -2.47062e-05 0 2.16899e-06ZM3.16679 18.4417H8.2608C8.56285 18.4417 8.80799 18.1966 8.80799 17.8945C8.80799 17.5928 8.56285 17.3473 8.2608 17.3473H3.16679C2.86474 17.3473 2.6196 17.5928 2.6196 17.8945C2.6196 18.1966 2.86474 18.4417 3.16679 18.4417ZM3.16679 14.8802H14.7936C15.0953 14.8802 15.3408 14.635 15.3408 14.333C15.3408 14.0309 15.0953 13.7858 14.7936 13.7858H3.16679C2.86474 13.7858 2.6196 14.0309 2.6196 14.333C2.6196 14.635 2.86474 14.8802 3.16679 14.8802ZM3.16679 12.0333H14.7936C15.0953 12.0333 15.3408 11.7881 15.3408 11.4861C15.3408 11.1844 15.0953 10.9389 14.7936 10.9389H3.16679C2.86474 10.9389 2.6196 11.1844 2.6196 11.4861C2.6196 11.7881 2.86474 12.0333 3.16679 12.0333ZM15.2383 3.56044C13.6857 3.56044 12.4253 4.82082 12.4253 6.37341C12.4253 7.92599 13.6857 9.18674 15.2383 9.18674C16.7908 9.18674 18.0516 7.92599 18.0516 6.37341C18.0516 4.82082 16.7908 3.56044 15.2383 3.56044Z"
        fill={fillColor ? fillColor : "white"}
      />
    </svg>
  );
};

export const MedicalCenterSetupIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0753 20.4593C16.3789 20.4593 17.4354 21.5159 17.4354 22.8195C17.4354 24.1231 16.3789 25.1797 15.0753 25.1797C13.7716 25.1797 12.7151 24.1231 12.7151 22.8195C12.7151 21.5159 13.7716 20.4593 15.0753 20.4593ZM15.0753 15.6389C11.1096 15.6389 7.89475 18.8537 7.89475 22.8194C7.89475 26.7851 11.1096 30 15.0753 30C19.0409 30 22.2558 26.7851 22.2558 22.8195C22.2558 18.8537 19.0409 15.6389 15.0753 15.6389ZM20.0753 23.4961L19.2467 23.8151C19.1416 24.2566 18.9666 24.6782 18.7287 25.0646L19.0893 25.8765L18.1324 26.8335L17.3207 26.473C16.9343 26.711 16.5124 26.8861 16.0708 26.9911L15.7519 27.8195H14.3986L14.0797 26.9909C13.6382 26.8859 13.2166 26.7109 12.8302 26.4729L12.0183 26.8336L11.0613 25.8766L11.4218 25.0649C11.1838 24.6785 11.0088 24.2567 10.9036 23.8151L10.0753 23.4961V22.1428L10.9038 21.8239C11.0088 21.3824 11.1839 20.9607 11.4218 20.5742L11.0613 19.7624L12.0182 18.8054L12.8301 19.166C13.2165 18.9281 13.6382 18.7531 14.0796 18.648L14.3986 17.8194H15.7519L16.0708 18.648C16.5123 18.7531 16.9339 18.9281 17.3203 19.166L18.1323 18.8054L19.0893 19.7623L18.7288 20.574C18.9668 20.9605 19.1418 21.3822 19.2469 21.8239L20.0753 22.1428V23.4961ZM18.4958 1.4168C16.6067 -0.472266 13.5439 -0.472266 11.6548 1.4168C9.76569 3.30586 9.76569 6.36868 11.6548 8.2578C13.5438 10.1469 16.6066 10.1469 18.4958 8.2578C20.3848 6.36868 20.3848 3.30586 18.4958 1.4168ZM17.9614 6.08399H16.3219V7.72349H13.8285V6.08399H12.189V3.59055H13.8285V1.95111H16.3219V3.59061H17.9614V6.08399ZM19.2029 8.96486C16.9235 11.2442 13.2271 11.2442 10.9477 8.96486C10.822 8.83918 10.7037 8.70899 10.5919 8.57518V15.9766C11.1347 15.6202 11.7224 15.3268 12.3447 15.1064V14.7439C12.3447 14.4685 12.5693 14.2439 12.8447 14.2439H13.9274C14.1759 14.2439 14.3831 14.4269 14.4211 14.665C14.6369 14.6479 14.8551 14.6389 15.0753 14.6389C15.2955 14.6389 15.5136 14.6479 15.7294 14.665C15.7674 14.4269 15.9746 14.2439 16.2232 14.2439H17.3058C17.5812 14.2439 17.8058 14.4685 17.8058 14.7439V15.1064C18.4281 15.3269 19.0159 15.6202 19.5587 15.9766V8.57518C19.4468 8.70899 19.3285 8.83918 19.2029 8.96486ZM14.4273 12.448C14.4273 12.7234 14.2027 12.948 13.9273 12.948H12.8446C12.5693 12.948 12.3446 12.7234 12.3446 12.448V11.3653C12.3446 11.0899 12.5693 10.8653 12.8446 10.8653H13.9273C14.2027 10.8653 14.4273 11.0899 14.4273 11.3653V12.448ZM17.8058 12.448C17.8058 12.7234 17.5812 12.948 17.3058 12.948H16.2232C15.9478 12.948 15.7232 12.7234 15.7232 12.448V11.3653C15.7232 11.0899 15.9478 10.8653 16.2232 10.8653H17.3058C17.5812 10.8653 17.8058 11.0899 17.8058 11.3653V12.448ZM28.5255 9.46886H20.5586V16.7491C21.5814 17.6734 22.3693 18.8525 22.8226 20.1864H23.7066C23.982 20.1864 24.2066 20.411 24.2066 20.6864V21.7691C24.2066 22.0444 23.982 22.2691 23.7066 22.2691H23.2369C23.249 22.451 23.2558 22.6345 23.2558 22.8195C23.2558 24.0366 22.9896 25.1914 22.5129 26.2295H28.5256C28.8693 26.2295 29.1506 25.9482 29.1506 25.6045V10.0939C29.1505 9.75011 28.8693 9.46886 28.5255 9.46886ZM24.2066 18.3905C24.2066 18.6659 23.982 18.8905 23.7066 18.8905H22.624C22.3486 18.8905 22.124 18.6659 22.124 18.3905V17.3078C22.124 17.0324 22.3486 16.8078 22.624 16.8078H23.7067C23.9821 16.8078 24.2067 17.0324 24.2067 17.3078V18.3905H24.2066ZM24.2066 15.012C24.2066 15.2874 23.982 15.512 23.7066 15.512H22.624C22.3486 15.512 22.124 15.2874 22.124 15.012V13.9294C22.124 13.654 22.3486 13.4294 22.624 13.4294H23.7067C23.9821 13.4294 24.2067 13.654 24.2067 13.9294V15.012H24.2066ZM27.5852 21.769C27.5852 22.0444 27.3606 22.269 27.0852 22.269H26.0025C25.7271 22.269 25.5025 22.0444 25.5025 21.769V20.6863C25.5025 20.4109 25.7271 20.1863 26.0025 20.1863H27.0852C27.3606 20.1863 27.5852 20.4109 27.5852 20.6863V21.769ZM27.5852 18.3905C27.5852 18.6659 27.3606 18.8905 27.0852 18.8905H26.0025C25.7271 18.8905 25.5025 18.6659 25.5025 18.3905V17.3078C25.5025 17.0324 25.7271 16.8078 26.0025 16.8078H27.0852C27.3606 16.8078 27.5852 17.0324 27.5852 17.3078V18.3905ZM27.5852 15.012C27.5852 15.2874 27.3606 15.512 27.0852 15.512H26.0025C25.7271 15.512 25.5025 15.2874 25.5025 15.012V13.9294C25.5025 13.654 25.7271 13.4294 26.0025 13.4294H27.0852C27.3606 13.4294 27.5852 13.654 27.5852 13.9294V15.012ZM1.625 9.46886C1.28125 9.46886 1 9.75011 1 10.0939V25.6045C1 25.9482 1.28125 26.2295 1.625 26.2295H7.63769C7.161 25.1914 6.89482 24.0366 6.89482 22.8195C6.89482 22.6344 6.90157 22.451 6.91369 22.269H6.44394C6.16857 22.269 5.94394 22.0444 5.94394 21.769V20.6863C5.94394 20.4109 6.16857 20.1863 6.44394 20.1863H7.328C7.78125 18.8525 8.56925 17.6734 9.592 16.749V9.46886H1.625ZM4.648 21.769C4.648 22.0444 4.42338 22.269 4.148 22.269H3.06538C2.79 22.269 2.56538 22.0444 2.56538 21.769V20.6863C2.56538 20.4109 2.79 20.1863 3.06538 20.1863H4.148C4.42338 20.1863 4.648 20.4109 4.648 20.6863V21.769ZM4.648 18.3905C4.648 18.6659 4.42338 18.8905 4.148 18.8905H3.06538C2.79 18.8905 2.56538 18.6659 2.56538 18.3905V17.3078C2.56538 17.0324 2.79 16.8078 3.06538 16.8078H4.148C4.42338 16.8078 4.648 17.0324 4.648 17.3078V18.3905ZM4.648 15.012C4.648 15.2874 4.42338 15.512 4.148 15.512H3.06538C2.79 15.512 2.56538 15.2874 2.56538 15.012V13.9294C2.56538 13.654 2.79 13.4294 3.06538 13.4294H4.148C4.42338 13.4294 4.648 13.654 4.648 13.9294V15.012ZM8.0265 18.3905C8.0265 18.6659 7.80188 18.8905 7.5265 18.8905H6.44382C6.16844 18.8905 5.94382 18.6659 5.94382 18.3905V17.3078C5.94382 17.0324 6.16844 16.8078 6.44382 16.8078H7.5265C7.80188 16.8078 8.0265 17.0324 8.0265 17.3078V18.3905ZM8.0265 15.012C8.0265 15.2874 7.80188 15.512 7.5265 15.512H6.44382C6.16844 15.512 5.94382 15.2874 5.94382 15.012V13.9294C5.94382 13.654 6.16844 13.4294 6.44382 13.4294H7.5265C7.80188 13.4294 8.0265 13.654 8.0265 13.9294V15.012Z"
        fill={fillColor ? fillColor : "#EAEFFE"}
      />
    </svg>
  );
};

export const ViewAppointmentIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4 10.8C15.0976 10.8 10.8 15.0976 10.8 20.4C10.8 25.7024 15.0976 30 20.4 30C25.7024 30 30 25.7024 30 20.4C30 15.0976 25.7024 10.8 20.4 10.8ZM23.6 21.6H21.6V23.6C21.6 24.2624 21.0624 24.8 20.4 24.8C19.7376 24.8 19.2 24.2624 19.2 23.6V21.6H17.2C16.5376 21.6 16 21.0624 16 20.4C16 19.7376 16.5376 19.2 17.2 19.2H19.2V17.2C19.2 16.5376 19.7376 16 20.4 16C21.0624 16 21.6 16.5376 21.6 17.2V19.2H23.6C24.2624 19.2 24.8 19.7376 24.8 20.4C24.8 21.0624 24.2624 21.6 23.6 21.6ZM8.8 1.6H6.4V1.2C6.4 0.544 6.944 0 7.6 0C8.256 0 8.8 0.544 8.8 1.2V1.6ZM8.4 20.4C8.4 23.28 9.424 25.92 11.12 28H4.4C1.968 28 0 26.032 0 23.6V12H11.84C9.712 14.16 8.4 17.12 8.4 20.4ZM15.216 9.6H0V6C0 3.568 1.968 1.6 4.4 1.6H6.4V4.4C6.4 5.056 6.944 5.6 7.6 5.6C8.256 5.6 8.8 5.056 8.8 4.4V1.6H19.2V4.4C19.2 5.056 19.744 5.6 20.4 5.6C21.056 5.6 21.6 5.056 21.6 4.4V1.6H23.408C25.84 1.6 27.808 3.568 27.808 6V9.6H25.6C24.032 8.832 22.272 8.4 20.4 8.4C18.544 8.4 16.784 8.816 15.216 9.6ZM21.6 1.6H19.2V1.2C19.2 0.544 19.744 0 20.4 0C21.056 0 21.6 0.544 21.6 1.2V1.6Z"
        // fill={fillColor}
        fill={fillColor ? fillColor : "#EAEFFE"}
      />
    </svg>
  );
};

export const SetupIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9211 0H5.07886C2.27129 0 0 2.27129 0 5.07886V6.92744H29.9937V5.07886C29.9937 2.27129 27.7224 0 24.9211 0ZM4.61199 4.61199C3.97476 4.61199 3.46372 4.10095 3.46372 3.46372C3.46372 2.8265 3.97476 2.30915 4.61199 2.30915C5.24921 2.30915 5.76656 2.8265 5.76656 3.46372C5.76656 4.10095 5.24921 4.61199 4.61199 4.61199ZM8.07571 4.61199C7.43849 4.61199 6.92113 4.09464 6.92113 3.45741C6.92113 2.82019 7.43849 2.30284 8.07571 2.30284C8.71293 2.30284 9.23028 2.82019 9.23028 3.45741C9.23028 4.09464 8.71293 4.61199 8.07571 4.61199Z"
        fill={fillColor}
      />
      <path
        d="M16.9083 21.5142C17.9557 20.4606 17.9493 18.7571 16.8957 17.7098C15.8421 16.6625 14.1386 16.6688 13.0913 17.7224C12.044 18.776 12.0503 20.4795 13.1039 21.5268C14.1702 22.53 15.8421 22.5237 16.9083 21.5142Z"
        fill={fillColor}
      />
      <path
        d="M0 24.9211C0 27.7224 2.27129 30 5.07886 30H24.9211C27.7224 30 30 27.7287 30 24.9211V9.23027H0V24.9211ZM9.23028 18.4606H10.1514C10.2713 17.9432 10.4795 17.4511 10.7571 17.0031L10.1136 16.3596C9.653 15.918 9.64038 15.1861 10.0883 14.7255C10.5363 14.265 11.2618 14.2524 11.7224 14.7003C11.735 14.7066 11.7413 14.7192 11.7476 14.7255L12.3975 15.3754C12.8454 15.0978 13.3375 14.8959 13.8549 14.776V13.8549C13.8549 13.2177 14.3722 12.7003 15.0095 12.7003C15.6467 12.7003 16.164 13.2177 16.164 13.8549V14.776C16.6814 14.8959 17.1735 15.1041 17.6214 15.3817L18.265 14.7382C18.7066 14.2776 19.4385 14.265 19.8991 14.7129C20.3596 15.1609 20.3722 15.8864 19.9243 16.347C19.918 16.3596 19.9054 16.3659 19.8991 16.3722L19.2429 17.0031C19.5205 17.4511 19.7224 17.9432 19.8423 18.4606H20.7634C21.4006 18.4606 21.918 18.9779 21.918 19.6151C21.918 20.2524 21.4006 20.7697 20.7634 20.7697H19.8423C19.7224 21.2871 19.5142 21.7792 19.2366 22.2271L19.8801 22.8706C20.3407 23.3123 20.3533 24.0442 19.9054 24.5047C19.4637 24.9653 18.7319 24.9779 18.2713 24.53C18.2587 24.5236 18.2524 24.511 18.2461 24.5047L17.5962 23.8549C17.1483 24.1325 16.6561 24.3344 16.1388 24.4542V25.3754C16.1388 26.0126 15.6215 26.53 14.9842 26.53C14.347 26.53 13.8297 26.0126 13.8297 25.3754V24.4542C13.3123 24.3344 12.8202 24.1262 12.3722 23.8486L11.735 24.4984C11.3123 24.9716 10.5804 25.0158 10.1073 24.593C9.63407 24.1703 9.5899 23.4385 10.0126 22.9653C10.0442 22.9337 10.0694 22.9022 10.1009 22.877L10.7508 22.2271C10.4732 21.7729 10.2713 21.2807 10.1514 20.7697H9.23028C8.59306 20.7697 8.07571 20.2524 8.07571 19.6151C8.07571 18.9779 8.59306 18.4606 9.23028 18.4606Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AppConfigIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8536 23.7326H1.87425V3.68285H15.8536V5.18106H17.7338V3.27099C17.7338 1.47433 16.2595 0 14.4628 0H3.27099C1.47433 0 0 1.47433 0 3.27099V26.729C0 28.5316 1.47433 30 3.27099 30H14.4568C16.2535 30 17.7338 28.5257 17.7338 26.729V23.6968H15.8595C15.8536 23.6968 15.8536 23.7326 15.8536 23.7326ZM8.86391 28.3645C8.03422 28.3645 7.3657 27.696 7.3657 26.8663C7.3657 26.0366 8.03422 25.3681 8.86391 25.3681C9.69359 25.3681 10.3681 26.0366 10.3681 26.8663C10.3621 27.696 9.69359 28.3645 8.86391 28.3645Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
      <path
        d="M7.67608 5.69439H3.4799V8.2491H7.67608V5.69439Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
      <path
        d="M7.67608 12.2423H3.4799V14.7971H7.67608V12.2423Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
      <path
        d="M7.67608 19.0947H3.4799V21.6494H7.67608V19.0947Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
      <path
        d="M22.5567 13.3645C22.4075 12.5885 22.109 11.8723 21.6852 11.2455L23.1894 9.74135L21.6554 8.21329L20.1512 9.71747C19.5245 9.2877 18.8082 8.99522 18.0322 8.846V6.71508H15.8595V8.846C15.0836 8.99522 14.3733 9.29367 13.7405 9.71747L12.2423 8.21329L10.7083 9.74731L12.2125 11.2515C11.7887 11.8782 11.4903 12.5945 11.341 13.3705H9.21011V15.5432H11.341C11.4903 16.3132 11.7887 17.0294 12.2125 17.6622L10.7023 19.1604L12.2364 20.6884L13.7405 19.1842C14.3673 19.614 15.0836 19.9065 15.8595 20.0617V22.1866H18.0322V20.0557C18.8022 19.9065 19.5185 19.608 20.1512 19.1842L21.6554 20.6884L23.1894 19.1604L21.6852 17.6562C22.109 17.0294 22.4075 16.3132 22.5567 15.5372H24.6876V13.3645H22.5567ZM16.9459 16.8146C15.6387 16.8146 14.5762 15.7581 14.5762 14.4509C14.5762 13.1437 15.6387 12.0812 16.9459 12.0812C18.2531 12.0812 19.3096 13.1437 19.3096 14.4509C19.3096 15.7581 18.2531 16.8146 16.9459 16.8146Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const ManageUsersIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none">
      <path
        d="M19.265 23.9162H2.27756V3.86644H19.265V5.36465H21.5498V3.45458C21.5498 1.65793 19.7582 0.183594 17.575 0.183594H3.97485C1.79159 0.183594 0 1.65793 0 3.45458V26.9126C0 28.7152 1.79159 30.1836 3.97485 30.1836H17.5677C19.751 30.1836 21.5498 28.7093 21.5498 26.9126V23.8804H19.2722C19.265 23.8804 19.265 23.9162 19.265 23.9162ZM10.7713 28.5481C9.76306 28.5481 8.95068 27.8796 8.95068 27.0499C8.95068 26.2202 9.76306 25.5517 10.7713 25.5517C11.7795 25.5517 12.5991 26.2202 12.5991 27.0499C12.5919 27.8796 11.7795 28.5481 10.7713 28.5481Z"
        fill="#67CDDF"
      />
      <path d="M9.32785 5.87798H4.22872V8.4327H9.32785V5.87798Z" fill="white" />
      <path
        d="M9.32785 12.4259H4.22872V14.9806H9.32785V12.4259Z"
        fill="white"
      />
      <path d="M9.32785 19.2783H4.22872V21.833H9.32785V19.2783Z" fill="white" />
      <path
        d="M27.4105 13.5481C27.2292 12.7721 26.8665 12.0559 26.3515 11.4291L28.1794 9.92494L26.3153 8.39688L24.4874 9.90106C23.7258 9.4713 22.8554 9.17882 21.9125 9.02959V6.89868H19.2722V9.02959C18.3293 9.17882 17.4662 9.47727 16.6973 9.90106L14.8767 8.39688L13.0126 9.93091L14.8404 11.4351C14.3254 12.0618 13.9628 12.7781 13.7814 13.5541H11.192V15.7268H13.7814C13.9628 16.4968 14.3254 17.213 14.8404 17.8458L13.0053 19.344L14.8694 20.872L16.6973 19.3678C17.4589 19.7976 18.3293 20.0901 19.2722 20.2453V22.3702H21.9125V20.2393C22.8482 20.0901 23.7186 19.7916 24.4874 19.3678L26.3153 20.872L28.1794 19.344L26.3515 17.8398C26.8665 17.213 27.2292 16.4968 27.4105 15.7208H30V13.5481H27.4105ZM20.5924 16.9982C19.0039 16.9982 17.7128 15.9417 17.7128 14.6344C17.7128 13.3272 19.0039 12.2648 20.5924 12.2648C22.1809 12.2648 23.4647 13.3272 23.4647 14.6344C23.4647 15.9417 22.1809 16.9982 20.5924 16.9982Z"
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const UserGroupIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M22.9549 24.2752V27.7977C22.9549 28.2841 22.5606 28.6784 22.0743 28.6784H15.0293V16.3496C19.3996 16.3496 22.9549 19.905 22.9549 24.2752Z"
        fill="#67CDDF"
      />
      <path
        d="M6.16432 18.1407C8.10164 18.1407 9.67215 16.5701 9.67215 14.6328C9.67215 12.6955 8.10164 11.125 6.16432 11.125C4.227 11.125 2.65649 12.6955 2.65649 14.6328C2.65649 16.5701 4.227 18.1407 6.16432 18.1407Z"
        fill="#FFDDCE"
      />
      <path
        d="M9.45616 19.0665C8.17984 20.4315 7.39726 22.2638 7.39726 24.2757V27.5047L7.10372 27.7982H0.880626C0.394521 27.7982 0 27.4037 0 26.9176V24.2757C0 20.8765 2.76517 18.1113 6.16438 18.1113C7.37378 18.1113 8.50333 18.4618 9.45616 19.0665Z"
        fill="#78E7DC"
      />
      <path
        d="M15.0294 16.3492C17.4611 16.3492 19.4325 14.3779 19.4325 11.9461C19.4325 9.51432 17.4611 7.54297 15.0294 7.54297C12.5976 7.54297 10.6262 9.51432 10.6262 11.9461C10.6262 14.3779 12.5976 16.3492 15.0294 16.3492Z"
        fill="#D69A8B"
      />
      <path
        d="M19.4324 11.9461C19.4324 14.3737 17.4569 16.3492 15.0293 16.3492V7.54297C17.4569 7.54297 19.4324 9.51851 19.4324 11.9461Z"
        fill="#C28678"
      />
      <path
        d="M23.8357 18.1407C25.773 18.1407 27.3435 16.5701 27.3435 14.6328C27.3435 12.6955 25.773 11.125 23.8357 11.125C21.8984 11.125 20.3279 12.6955 20.3279 14.6328C20.3279 16.5701 21.8984 18.1407 23.8357 18.1407Z"
        fill="#FFCCBD"
      />
      <path
        d="M30 24.2757V26.9176C30 27.4037 29.6055 27.7982 29.1194 27.7982H22.955L22.6614 27.5047V24.2757C22.6614 22.2526 21.87 20.4109 20.5808 19.0436C21.526 18.4524 22.6415 18.1113 23.8356 18.1113C27.2348 18.1113 30 20.8765 30 24.2757Z"
        fill="#27BDF3"
      />
      <path
        d="M14.9831 16.3497C10.6097 16.3749 7.10376 19.989 7.10376 24.3624V27.7978C7.10376 28.2841 7.49805 28.6784 7.98439 28.6784H22.0744C22.5607 28.6784 22.955 28.2841 22.955 27.7978V24.2753C22.955 19.8896 19.3745 16.3246 14.9831 16.3497Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const InfoIcon: FC<ISvgComponent> = ({
  fillColor,
  mouseEnter,
  mouseLeave,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      className={customClass}
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <g clipPath="url(#clip0_5479_8992)">
        <path
          d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61384 17.0484 4.32616 15.3611 2.63889C13.6738 0.951621 11.3862 0.00258081 9 0V0ZM9 16.5C7.51664 16.5 6.0666 16.0601 4.83323 15.236C3.59986 14.4119 2.63856 13.2406 2.07091 11.8701C1.50325 10.4997 1.35473 8.99168 1.64411 7.53682C1.9335 6.08197 2.64781 4.74559 3.6967 3.6967C4.7456 2.64781 6.08197 1.9335 7.53683 1.64411C8.99168 1.35472 10.4997 1.50325 11.8701 2.0709C13.2406 2.63856 14.4119 3.59985 15.236 4.83322C16.0601 6.06659 16.5 7.51664 16.5 9C16.4978 10.9885 15.7069 12.8948 14.3009 14.3009C12.8948 15.7069 10.9885 16.4978 9 16.5Z"
          // fill={fillColor}
          fill="#02BF90"
        />
        <path
          d="M9 7.5H8.25C8.05109 7.5 7.86032 7.57902 7.71967 7.71967C7.57902 7.86032 7.5 8.05109 7.5 8.25C7.5 8.44891 7.57902 8.63968 7.71967 8.78033C7.86032 8.92098 8.05109 9 8.25 9H9V13.5C9 13.6989 9.07901 13.8897 9.21967 14.0303C9.36032 14.171 9.55108 14.25 9.75 14.25C9.94891 14.25 10.1397 14.171 10.2803 14.0303C10.421 13.8897 10.5 13.6989 10.5 13.5V9C10.5 8.60218 10.342 8.22064 10.0607 7.93934C9.77935 7.65804 9.39782 7.5 9 7.5Z"
          // fill={fillColor}
          fill="#02BF90"
        />
        <path
          d="M9 6C9.62132 6 10.125 5.49632 10.125 4.875C10.125 4.25368 9.62132 3.75 9 3.75C8.37868 3.75 7.875 4.25368 7.875 4.875C7.875 5.49632 8.37868 6 9 6Z"
          // fill={fillColor}
          fill="#02BF90"
        />
      </g>
      <defs>
        <clipPath id="clip0_5479_8992">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PatientEMRIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M5.02802 27.8301H2.03643C1.465 27.8301 1.00562 27.3477 1.00562 26.7418V2.83594H4.00281V26.7418C4.00281 27.3477 4.4622 27.8301 5.02802 27.8301Z"
        fill="#D5DCF8"
      />
      <path
        d="M27.0391 2.83594V26.7418C27.0391 27.3477 26.5741 27.8301 26.0083 27.8301H5.02788C4.45645 27.8301 3.99707 27.3477 3.99707 26.7418V2.83594H27.0391Z"
        fill="#EAEFFE"
      />
      <path
        d="M6.21024 17.4877H3.82368C3.34749 17.4877 2.96094 17.0818 2.96094 16.5818V6.04651C2.96094 5.54651 3.34749 5.14062 3.82368 5.14062H6.21024C5.73965 5.14062 5.35309 5.54651 5.35309 6.04651V16.5818C5.35309 17.0818 5.73405 17.4877 6.21024 17.4877Z"
        fill="#F8F2F2"
      />
      <path
        d="M14.72 6.04651V16.5818C14.72 17.0818 14.3334 17.4877 13.8572 17.4877H6.21017C5.73958 17.4877 5.35303 17.0818 5.35303 16.5818V6.04651C5.35303 5.54651 5.73958 5.14062 6.21017 5.14062H13.8572C14.3334 5.14062 14.72 5.54651 14.72 6.04651Z"
        fill="white"
      />
      <path
        d="M5.02801 0C4.46218 0 4.0028 0.488235 4.0028 1.08824V2.83529H1V1.08824C1 0.488235 1.46499 0 2.03641 0H5.02801Z"
        fill="#67CDDF"
      />
      <path
        d="M27.0391 1.08824V2.83529H4.00269V1.08824C4.00269 0.488235 4.46207 0 5.0279 0H26.0027C26.5741 0 27.0391 0.488235 27.0391 1.08824Z"
        fill="#78E7DC"
      />
      <path
        d="M25.0057 1.41861C24.9945 1.97744 24.2102 1.97744 24.2046 1.41861C24.2158 0.865671 25.0001 0.865671 25.0057 1.41861Z"
        fill="#44569B"
      />
      <path
        d="M22.787 1.41861C22.7758 1.97744 21.9914 1.97744 21.9858 1.41861C21.997 0.865671 22.7814 0.865671 22.787 1.41861Z"
        fill="#44569B"
      />
      <path
        d="M20.5741 1.41861C20.5629 1.97744 19.7786 1.97744 19.7729 1.41861C19.7786 0.865671 20.5629 0.865671 20.5741 1.41861Z"
        fill="#44569B"
      />
      <path
        d="M29.0002 3.25816V28.9111C29.0002 29.5111 28.5352 29.9993 27.9693 29.9993H3.99175C3.42032 29.9993 2.96094 29.5111 2.96094 28.9111V27.8287H26.0086C26.58 27.8287 27.0394 27.3405 27.0394 26.7405V2.16992H27.9637C28.5352 2.16992 29.0002 2.65816 29.0002 3.25816Z"
        fill="#67CDDF"
      />
      <path
        d="M19.3306 7.14612H20.395V6.02847C20.395 5.59318 20.7312 5.24023 21.1457 5.24023C21.5603 5.24023 21.8964 5.59318 21.8964 6.02847V7.14612H22.9609C23.3754 7.14612 23.7116 7.49906 23.7116 7.93435C23.7116 8.36965 23.3754 8.72259 22.9609 8.72259H21.8964V9.84023C21.8964 10.2755 21.5603 10.6285 21.1457 10.6285C20.7312 10.6285 20.395 10.2755 20.395 9.84023V8.72259H19.3306C18.339 8.69318 18.339 7.16965 19.3306 7.14612Z"
        fill="#07C3AA"
      />
      <path
        d="M10.7423 9.73509V9.49392C10.1708 9.29392 8.81508 9.01745 8.3445 8.61156C8.06438 8.78804 7.66102 8.89392 7.3473 8.98804C6.5966 9.21157 6.79267 10.2116 6.99996 10.7763C6.08119 9.50568 6.31648 7.50568 7.68343 7.24098C8.47335 6.1998 9.80668 6.16451 10.6078 7.0998C11.4425 8.07627 11.4313 9.79392 10.5406 10.788C10.675 10.4645 10.7423 10.1057 10.7423 9.73509Z"
        fill="#824234"
      />
      <path
        d="M10.7423 9.49368C10.8151 10.6878 10.1428 12.0231 8.99995 12.3231C8.08119 12.4466 7.33049 11.6054 7.00556 10.776C6.79827 10.2113 6.6022 9.20545 7.34729 8.9878C7.66662 8.89368 8.06438 8.7878 8.34449 8.61133C8.80948 9.01133 10.1764 9.29368 10.7423 9.49368Z"
        fill="#F6C9AF"
      />
      <path
        d="M12.972 17.4888H4.70312L4.97203 14.6124C5.01125 14.2418 5.22974 13.9124 5.57147 13.7241C5.67791 13.6712 6.12609 13.4124 6.24374 13.3477C7.69472 15.0124 10.1821 14.9241 11.4706 13.3653C11.5883 13.43 12.0028 13.6653 12.1149 13.7241C12.4566 13.9124 12.6751 14.2477 12.7143 14.6124L12.972 17.4888Z"
        fill="#67CDDF"
      />
      <path
        d="M9.93549 13.0357C9.35286 13.4592 8.26602 13.4416 7.7002 13.0063C7.72821 12.771 7.83465 11.9592 7.84025 11.9592C8.40608 12.4769 9.25762 12.4592 9.78983 11.9004L9.79543 11.9474L9.93549 13.0357Z"
        fill="#F6C9AF"
      />
      <path
        d="M11.4649 13.3657C11.1568 13.1951 10.8487 13.0245 10.5406 12.848C10.3053 12.7068 10.1148 12.901 9.93552 13.0362C9.6442 13.2304 9.25765 13.348 8.84308 13.348C8.4005 13.348 8.00274 13.2186 7.70022 13.0127C7.54336 12.8715 7.34728 12.7245 7.14 12.848C6.84308 13.0127 6.53496 13.1892 6.23804 13.3539C7.08398 14.2833 8.27165 14.7304 9.42571 14.5362V16.301C9.66661 16.2127 10.2324 16.2186 10.4453 16.301V14.1833C10.8823 13.9421 11.2184 13.6362 11.4649 13.3657Z"
        fill="#4C9CED"
      />
      <path
        d="M25.2745 12.8522H17.0168C16.6079 12.8463 16.6023 12.1992 17.0168 12.1934H25.2689C25.6835 12.1992 25.6891 12.8463 25.2745 12.8522Z"
        fill="#002C5A"
      />
      <path
        d="M25.2745 15.2994H17.0168C16.6079 15.2936 16.6023 14.6465 17.0168 14.6406H25.2689C25.6835 14.6406 25.6891 15.2877 25.2745 15.2994Z"
        fill="#002C5A"
      />
      <path
        d="M25.2745 17.7409H17.0168C16.6079 17.735 16.6023 17.0879 17.0168 17.082H25.2689C25.6835 17.0879 25.6891 17.735 25.2745 17.7409Z"
        fill="#002C5A"
      />
      <path
        d="M25.2744 20.235H2.96071C2.55735 20.2291 2.54054 19.5821 2.96071 19.5762H25.2744C25.6778 19.5821 25.6946 20.2291 25.2744 20.235Z"
        fill="#002C5A"
      />
      <path
        d="M25.2744 22.735H2.96071C2.55735 22.7291 2.54054 22.0821 2.96071 22.0762H25.2744C25.6778 22.0762 25.6946 22.7232 25.2744 22.735Z"
        fill="#002C5A"
      />
    </svg>
  );
};

export const AddIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <path
        d="M20.5685 8.25H14.6918V2.75C14.6918 2.02065 14.3822 1.32118 13.8312 0.805456C13.2801 0.289731 12.5327 0 11.7534 0C10.9741 0 10.2267 0.289731 9.67569 0.805456C9.12464 1.32118 8.81507 2.02065 8.81507 2.75V8.25H2.93836C2.15906 8.25 1.41167 8.53973 0.860624 9.05546C0.309576 9.57118 0 10.2707 0 11C0 11.7293 0.309576 12.4288 0.860624 12.9445C1.41167 13.4603 2.15906 13.75 2.93836 13.75H8.81507V19.25C8.81507 19.9793 9.12464 20.6788 9.67569 21.1945C10.2267 21.7103 10.9741 22 11.7534 22C12.5327 22 13.2801 21.7103 13.8312 21.1945C14.3822 20.6788 14.6918 19.9793 14.6918 19.25V13.75H20.5685C21.3478 13.75 22.0952 13.4603 22.6462 12.9445C23.1973 12.4288 23.5068 11.7293 23.5068 11C23.5068 10.2707 23.1973 9.57118 22.6462 9.05546C22.0952 8.53973 21.3478 8.25 20.5685 8.25Z"
        // fill="#CDD4D8"
        fill={fillColor}
      />
    </svg>
  );
};
export const FormsIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3.56322V15.5614C16 16.9813 14.9255 18.1324 13.6 18.1324H2.4C1.07452 18.1324 0 16.9813 0 15.5614V3.56322C0 2.14328 1.07452 0.992188 2.4 0.992188H13.6C14.9255 0.992188 16 2.14328 16 3.56322ZM7.20039 4.41992H12.0004C12.4422 4.41992 12.8004 4.80362 12.8004 5.27693C12.8004 5.75025 12.4422 6.13394 12.0004 6.13394H7.20039C6.75856 6.13394 6.40039 5.75025 6.40039 5.27693C6.40039 4.80362 6.75856 4.41992 7.20039 4.41992ZM4.79923 5.27735C4.79797 5.16536 4.77623 5.05472 4.73523 4.95169C4.69472 4.84783 4.6379 4.75218 4.56723 4.66888C4.48947 4.59318 4.40018 4.53231 4.30323 4.4889C4.00531 4.3547 3.66128 4.4257 3.43123 4.66888C3.36057 4.75218 3.30375 4.84783 3.26323 4.95169C3.22224 5.05472 3.2005 5.16536 3.19923 5.27735C3.198 5.50515 3.28148 5.7241 3.43123 5.88583C3.58454 6.04244 3.78742 6.13121 3.99923 6.13436C4.10417 6.13726 4.20829 6.11378 4.30323 6.0658C4.40018 6.0224 4.48947 5.96153 4.56723 5.88583C4.71342 5.7216 4.79629 5.50426 4.79923 5.27735ZM4.30323 8.77406C4.00531 8.63986 3.66128 8.71086 3.43123 8.95403C3.35715 9.03448 3.29988 9.13088 3.26323 9.23685C3.22224 9.33988 3.2005 9.45052 3.19923 9.56251C3.198 9.79031 3.28148 10.0093 3.43123 10.171C3.58454 10.3276 3.78742 10.4164 3.99923 10.4195C4.10377 10.4182 4.20705 10.3949 4.30323 10.351C4.40018 10.3076 4.48947 10.2467 4.56723 10.171L4.66323 10.0424C4.69351 9.99466 4.71772 9.94279 4.73523 9.88817C4.76387 9.8406 4.78546 9.78856 4.79923 9.73391C4.80316 9.67686 4.80316 9.61957 4.79923 9.56251C4.79629 9.3356 4.71342 9.11827 4.56723 8.95403C4.48947 8.87833 4.40018 8.81746 4.30323 8.77406ZM7.20039 8.70508H12.0004C12.4422 8.70508 12.8004 9.08877 12.8004 9.56209C12.8004 10.0354 12.4422 10.4191 12.0004 10.4191H7.20039C6.75856 10.4191 6.40039 10.0354 6.40039 9.56209C6.40039 9.08877 6.75856 8.70508 7.20039 8.70508ZM4.5674 13.2392C4.48964 13.1635 4.40035 13.1026 4.3034 13.0592C4.00549 12.925 3.66145 12.996 3.4314 13.2392C3.35857 13.3207 3.30148 13.4168 3.2634 13.522C3.17782 13.7294 3.17782 13.9659 3.2634 14.1733C3.30148 14.2785 3.35857 14.3746 3.4314 14.4561C3.58471 14.6127 3.78759 14.7015 3.9994 14.7047C4.10395 14.7033 4.20723 14.68 4.3034 14.6361C4.40035 14.5927 4.48964 14.5318 4.5674 14.4561C4.64024 14.3746 4.69733 14.2785 4.7354 14.1733C4.82099 13.9659 4.82099 13.7294 4.7354 13.522C4.69733 13.4168 4.64024 13.3207 4.5674 13.2392ZM7.20039 12.9902H12.0004C12.4422 12.9902 12.8004 13.3739 12.8004 13.8472C12.8004 14.3206 12.4422 14.7043 12.0004 14.7043H7.20039C6.75856 14.7043 6.40039 14.3206 6.40039 13.8472C6.40039 13.3739 6.75856 12.9902 7.20039 12.9902ZM13.5996 2.70703C14.0414 2.70703 14.3996 3.09073 14.3996 3.56404V15.5622C14.3996 16.0355 14.0414 16.4192 13.5996 16.4192H2.39961C1.95778 16.4192 1.59961 16.0355 1.59961 15.5622V3.56404C1.59961 3.09073 1.95778 2.70703 2.39961 2.70703H13.5996Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const StickerIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8 0H19.2C21.8509 0 24 2.18883 24 4.88889V8.76529C24 8.79731 23.9994 8.82921 23.9982 8.86111H19.2C14.7265 8.86111 11.1 12.5548 11.1 17.1111V21.9982C11.0687 21.9994 11.0374 22 11.0059 22H4.8C2.14903 22 0 19.8111 0 17.1111V4.88889C0 2.18883 2.14903 0 4.8 0ZM12.9 21.0833L23.1 10.6944H19.2C15.7206 10.6944 12.9 13.5673 12.9 17.1111V21.0833Z"
        fill={fillColor}
      />
    </svg>
    // <svg
    //   width="26"
    //   height="26"
    //   viewBox="0 0 24 22"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   className={customClass}
    //   onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
    //   onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    // >
    //   <path
    //     d="M20.5685 8.25H14.6918V2.75C14.6918 2.02065 14.3822 1.32118 13.8312 0.805456C13.2801 0.289731 12.5327 0 11.7534 0C10.9741 0 10.2267 0.289731 9.67569 0.805456C9.12464 1.32118 8.81507 2.02065 8.81507 2.75V8.25H2.93836C2.15906 8.25 1.41167 8.53973 0.860624 9.05546C0.309576 9.57118 0 10.2707 0 11C0 11.7293 0.309576 12.4288 0.860624 12.9445C1.41167 13.4603 2.15906 13.75 2.93836 13.75H8.81507V19.25C8.81507 19.9793 9.12464 20.6788 9.67569 21.1945C10.2267 21.7103 10.9741 22 11.7534 22C12.5327 22 13.2801 21.7103 13.8312 21.1945C14.3822 20.6788 14.6918 19.9793 14.6918 19.25V13.75H20.5685C21.3478 13.75 22.0952 13.4603 22.6462 12.9445C23.1973 12.4288 23.5068 11.7293 23.5068 11C23.5068 10.2707 23.1973 9.57118 22.6462 9.05546C22.0952 8.53973 21.3478 8.25 20.5685 8.25Z"
    //     // fill="#CDD4D8"
    //     fill={fillColor}
    //   />
    // </svg>
  );
};
export const AddButtonIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <circle cx="12.9912" cy="12.5" r="12.5" fill={fillColor} />
      <path
        d="M12.9912 5.20898V19.7923"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M5.69824 12.502L20.2816 12.502"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PolygonIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 4.13397C8.16667 4.51887 8.16667 5.48113 7.5 5.86603L1.5 9.33013C0.833334 9.71503 -4.47338e-07 9.2339 -4.13689e-07 8.4641L-1.10848e-07 1.5359C-7.71986e-08 0.766098 0.833333 0.284973 1.5 0.669873L7.5 4.13397Z"
        fill="#BBBBBB"
      />
    </svg>
  );
};

export const SaveIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <path
        d="M21.1885 4.84478L17.0927 0.748975C16.6532 0.309435 16.057 0.0625033 15.4354 0.0625H2.34375C1.04932 0.0625 0 1.11182 0 2.40625V19.5938C0 20.8882 1.04932 21.9375 2.34375 21.9375H19.5312C20.8257 21.9375 21.875 20.8882 21.875 19.5938V6.50205C21.875 5.88045 21.6281 5.28431 21.1885 4.84478V4.84478ZM10.9375 18.8125C9.21162 18.8125 7.8125 17.4134 7.8125 15.6875C7.8125 13.9616 9.21162 12.5625 10.9375 12.5625C12.6634 12.5625 14.0625 13.9616 14.0625 15.6875C14.0625 17.4134 12.6634 18.8125 10.9375 18.8125ZM15.625 3.94336V8.85156C15.625 9.17515 15.3626 9.4375 15.0391 9.4375H3.71094C3.38735 9.4375 3.125 9.17515 3.125 8.85156V3.77344C3.125 3.44985 3.38735 3.1875 3.71094 3.1875H14.8691C15.0246 3.1875 15.1736 3.24922 15.2834 3.35913L15.4534 3.52905C15.5078 3.58345 15.551 3.64804 15.5804 3.71913C15.6099 3.79022 15.625 3.86641 15.625 3.94336V3.94336Z"
        // fill="#CDD4D8"
        fill={fillColor}
      />
    </svg>
  );
};

export const DeleteIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
  handleClick,
}) => {
  return (
    <svg
      width={"26"}
      height={"26"}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M22 4.67539C22 5.28369 21.5072 5.77539 20.9 5.77539H1.1C0.4928 5.77539 0 5.28369 0 4.67539C0 4.06709 0.4928 3.57539 1.1 3.57539H5.01492C5.48902 3.57539 5.9081 3.2739 6.0588 2.8229L6.40637 1.7801C6.70667 0.880303 7.54601 0.275391 8.49311 0.275391H13.508C14.4562 0.275391 15.2955 0.880328 15.5947 1.77903L15.9423 2.82397C16.0919 3.27277 16.5121 3.57539 16.9862 3.57539H20.9C21.5072 3.57539 22 4.06709 22 4.67539ZM19.03 8.00842L18.359 18.1284C18.216 20.1524 16.522 21.7254 14.509 21.7254H7.491C5.478 21.7254 3.784 20.1524 3.641 18.1394L2.97001 8.00842C2.95901 7.86542 3.01402 7.71129 3.11302 7.60129C3.22302 7.49129 3.36601 7.42539 3.52001 7.42539H18.48C18.634 7.42539 18.777 7.49129 18.887 7.60129C18.986 7.71129 19.041 7.86542 19.03 8.00842ZM9.9 11.2754C9.9 10.6704 9.405 10.1754 8.8 10.1754C8.195 10.1754 7.7 10.6704 7.7 11.2754V16.7754C7.7 17.3804 8.195 17.8754 8.8 17.8754C9.405 17.8754 9.9 17.3804 9.9 16.7754V11.2754ZM14.3 11.2754C14.3 10.6704 13.805 10.1754 13.2 10.1754C12.595 10.1754 12.1 10.6704 12.1 11.2754V16.7754C12.1 17.3804 12.595 17.8754 13.2 17.8754C13.805 17.8754 14.3 17.3804 14.3 16.7754V11.2754Z"
        // fill="#CDD4D8"
        // fill={fillColor}
        fill="#B11313"
      />
    </svg>
  );
};
export const PatientEmrDeleteIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
  handleClick,
  height,
  width,
}) => {
  return (
    <svg
      width={width || "26"}
      height={height || "26"}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M22 4.67539C22 5.28369 21.5072 5.77539 20.9 5.77539H1.1C0.4928 5.77539 0 5.28369 0 4.67539C0 4.06709 0.4928 3.57539 1.1 3.57539H5.01492C5.48902 3.57539 5.9081 3.2739 6.0588 2.8229L6.40637 1.7801C6.70667 0.880303 7.54601 0.275391 8.49311 0.275391H13.508C14.4562 0.275391 15.2955 0.880328 15.5947 1.77903L15.9423 2.82397C16.0919 3.27277 16.5121 3.57539 16.9862 3.57539H20.9C21.5072 3.57539 22 4.06709 22 4.67539ZM19.03 8.00842L18.359 18.1284C18.216 20.1524 16.522 21.7254 14.509 21.7254H7.491C5.478 21.7254 3.784 20.1524 3.641 18.1394L2.97001 8.00842C2.95901 7.86542 3.01402 7.71129 3.11302 7.60129C3.22302 7.49129 3.36601 7.42539 3.52001 7.42539H18.48C18.634 7.42539 18.777 7.49129 18.887 7.60129C18.986 7.71129 19.041 7.86542 19.03 8.00842ZM9.9 11.2754C9.9 10.6704 9.405 10.1754 8.8 10.1754C8.195 10.1754 7.7 10.6704 7.7 11.2754V16.7754C7.7 17.3804 8.195 17.8754 8.8 17.8754C9.405 17.8754 9.9 17.3804 9.9 16.7754V11.2754ZM14.3 11.2754C14.3 10.6704 13.805 10.1754 13.2 10.1754C12.595 10.1754 12.1 10.6704 12.1 11.2754V16.7754C12.1 17.3804 12.595 17.8754 13.2 17.8754C13.805 17.8754 14.3 17.3804 14.3 16.7754V11.2754Z"
        // fill="#CDD4D8"
        fill={fillColor ? fillColor : "#CDD4D8"}
        // fill="#B11313"
      />
    </svg>
  );
};

export const PrintFormIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <path d="M17.4163 0H4.58301V4.58333H17.4163V0Z" fill={fillColor} />
      <path d="M16.5 13.75H5.5V22H16.5V13.75Z" fill={fillColor} />
      <path
        d="M19.25 6.41602H2.75C2.02065 6.41602 1.32118 6.70575 0.805456 7.22147C0.289731 7.7372 0 8.43667 0 9.16602L0 18.3327H3.66667V11.916H18.3333V18.3327H22V9.16602C22 8.43667 21.7103 7.7372 21.1945 7.22147C20.6788 6.70575 19.9793 6.41602 19.25 6.41602ZM17.4167 10.0827H13.75V8.24935H17.4167V10.0827Z"
        // fill="#CDD4D8"
        fill={fillColor}
      />
    </svg>
  );
};

export const NationalIdCardIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <g clipPath="url(#clip0_7072_5189)">
        <path
          d="M19.25 3.66667H13.75V2.75C13.75 2.02065 13.4603 1.32118 12.9445 0.805456C12.4288 0.289731 11.7293 0 11 0C10.2707 0 9.57118 0.289731 9.05546 0.805456C8.53973 1.32118 8.25 2.02065 8.25 2.75V3.66667H2.75C2.02065 3.66667 1.32118 3.9564 0.805456 4.47212C0.289731 4.98785 0 5.68732 0 6.41667L0 22H22V6.41667C22 5.68732 21.7103 4.98785 21.1945 4.47212C20.6788 3.9564 19.9793 3.66667 19.25 3.66667ZM9.16667 17.4167H2.75V8.25H9.16667V17.4167ZM10.0833 2.75C10.0833 2.50688 10.1799 2.27373 10.3518 2.10182C10.5237 1.92991 10.7569 1.83333 11 1.83333C11.2431 1.83333 11.4763 1.92991 11.6482 2.10182C11.8201 2.27373 11.9167 2.50688 11.9167 2.75V5.5H10.0833V2.75ZM17.4167 17.4167H11.9167V15.5833H17.4167V17.4167ZM19.25 13.75H11.9167V11.9167H19.25V13.75ZM19.25 10.0833H11.9167V8.25H19.25V10.0833ZM7.33333 15.5833H4.58333V10.0833H7.33333V15.5833Z"
          // fill="#CDD4D8"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_7072_5189">
          <rect width="22" height="22" fill={fillColor} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LabelIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <g clipPath="url(#clip0_7072_5164)">
        <path
          d="M20.4716 9.08959L12.9105 1.5285C11.9379 0.555869 10.5947 0 9.22842 0H4.05263C1.81789 0 0 1.81789 0 4.05263V9.22839C0 10.6179 0.544219 11.9262 1.52843 12.9104L9.08948 20.4715C10.0737 21.4557 11.3821 22 12.7716 22C14.1726 22 15.4811 21.4557 16.4653 20.4715L20.4716 16.4652C22.5095 14.4273 22.5095 11.1275 20.4716 9.08959ZM5.78947 7.52632C4.82842 7.52632 4.05263 6.75053 4.05263 5.78947C4.05263 4.82842 4.82842 4.05263 5.78947 4.05263C6.75053 4.05263 7.52632 4.82842 7.52632 5.78947C7.52632 6.75053 6.75053 7.52632 5.78947 7.52632Z"
          // fill="#CDD4D8"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_7072_5164">
          <rect width="22" height="22" fill={fillColor} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VipIcon: FC<ISvgComponent> = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4725 21.2041C23.5311 21.5779 23.2772 21.9323 22.8996 21.9903C22.867 21.9967 22.828 21.9967 22.7954 21.9967H2.20949C1.82537 21.9967 1.51938 21.681 1.51938 21.3072C1.51938 21.275 1.51938 21.2363 1.52589 21.2041L2.0923 17.879C2.12485 17.6792 2.30063 17.531 2.50896 17.5375H22.4959C22.7043 17.5375 22.8801 17.6792 22.9126 17.879L23.4725 21.2041ZM22.9061 4.85556L19.436 6.93054C18.811 7.3043 17.9907 7.12386 17.5871 6.51812L13.6418 0.608925C13.2251 -0.0161486 12.3788 -0.183694 11.7472 0.228726C11.5975 0.33183 11.4608 0.460711 11.3631 0.608925L7.41782 6.50523C7.01417 7.12386 6.18735 7.3043 5.55584 6.91765L2.09881 4.85556C1.44777 4.46247 0.601412 4.66224 0.204277 5.30664C0.021985 5.60307 -0.0431192 5.95105 0.0284954 6.28614L2.04021 15.1467C2.08579 15.3336 2.25506 15.4689 2.45037 15.4689H22.561C22.7564 15.4689 22.9256 15.3336 22.9712 15.1467L24.9829 6.28614C25.1327 5.55151 24.6509 4.82978 23.9022 4.68157C23.5571 4.61713 23.1991 4.67512 22.9061 4.85556Z"
        fill="url(#paint0_linear_192_1386)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_192_1386"
          x1="0.719717"
          y1="0.00294469"
          x2="26.6113"
          y2="0.733632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5936F1" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DiabetesIcon: FC<ISvgComponent> = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_194_1392)">
        <path
          d="M3.72902 24.8602H13.6731C14.2894 24.8602 14.8902 24.7048 15.434 24.4147C15.6308 24.3008 15.7033 24.047 15.5894 23.8502C15.5739 23.8243 15.5583 23.7984 15.5376 23.7777C14.5173 22.6849 13.9476 21.2451 13.9476 19.7483C13.9476 17.7906 15.4806 14.9938 17.1639 13.238C17.3192 13.0827 17.4021 12.8755 17.4021 12.658V9.6851C17.4643 7.59789 15.8225 5.86285 13.7352 5.8007C13.7145 5.8007 13.6938 5.8007 13.6731 5.8007H10.7727V1.24301C10.7727 0.559354 10.2134 0 9.52973 0H7.87238C7.18873 0 6.62938 0.559354 6.62938 1.24301V5.8007H3.72902C1.67288 5.80588 0.0051792 7.47359 0 9.52973V21.1311C0.0051792 23.1873 1.67288 24.855 3.72902 24.8602ZM6.62938 21.2347C6.62938 21.6905 6.26165 22.0634 5.80588 22.0686C5.66087 22.0686 5.51585 22.0323 5.38637 21.9598L3.92065 21.1104C3.52704 20.8825 3.39238 20.375 3.62026 19.9762C3.69277 19.8519 3.79635 19.7483 3.92065 19.6758L5.38637 18.8316C5.78517 18.6037 6.28755 18.7383 6.52061 19.1371C6.59312 19.2614 6.62938 19.4065 6.62938 19.5515V21.2347ZM12.0157 21.9391C11.6169 22.167 11.1146 22.0323 10.8815 21.6335C10.809 21.5092 10.7727 21.3642 10.7727 21.2192V19.5411C10.7727 19.0854 11.1456 18.7125 11.6014 18.7125C11.7464 18.7125 11.8914 18.7487 12.0157 18.8212L13.1241 19.4634C13.093 20.0487 13.1448 20.6339 13.2743 21.2088L12.0157 21.9391ZM7.45805 2.76569H9.94407V5.8007H7.45805V2.76569ZM3.31469 10.7261C3.31469 9.8353 4.0346 9.11539 4.92542 9.11539H12.4767C13.3675 9.11539 14.0874 9.8353 14.0874 10.7261V14.9627C14.0874 15.8535 13.3675 16.5734 12.4767 16.5734H4.92542C4.0346 16.5734 3.31469 15.8535 3.31469 14.9627V10.7261Z"
          fill="black"
        />
        <path
          d="M3.72902 24.8602H13.6731C14.2894 24.8602 14.8902 24.7048 15.434 24.4147C15.6308 24.3008 15.7033 24.047 15.5894 23.8502C15.5739 23.8243 15.5583 23.7984 15.5376 23.7777C14.5173 22.6849 13.9476 21.2451 13.9476 19.7483C13.9476 17.7906 15.4806 14.9938 17.1639 13.238C17.3192 13.0827 17.4021 12.8755 17.4021 12.658V9.6851C17.4643 7.59789 15.8225 5.86285 13.7352 5.8007C13.7145 5.8007 13.6938 5.8007 13.6731 5.8007H10.7727V1.24301C10.7727 0.559354 10.2134 0 9.52973 0H7.87238C7.18873 0 6.62938 0.559354 6.62938 1.24301V5.8007H3.72902C1.67288 5.80588 0.0051792 7.47359 0 9.52973V21.1311C0.0051792 23.1873 1.67288 24.855 3.72902 24.8602ZM6.62938 21.2347C6.62938 21.6905 6.26165 22.0634 5.80588 22.0686C5.66087 22.0686 5.51585 22.0323 5.38637 21.9598L3.92065 21.1104C3.52704 20.8825 3.39238 20.375 3.62026 19.9762C3.69277 19.8519 3.79635 19.7483 3.92065 19.6758L5.38637 18.8316C5.78517 18.6037 6.28755 18.7383 6.52061 19.1371C6.59312 19.2614 6.62938 19.4065 6.62938 19.5515V21.2347ZM12.0157 21.9391C11.6169 22.167 11.1146 22.0323 10.8815 21.6335C10.809 21.5092 10.7727 21.3642 10.7727 21.2192V19.5411C10.7727 19.0854 11.1456 18.7125 11.6014 18.7125C11.7464 18.7125 11.8914 18.7487 12.0157 18.8212L13.1241 19.4634C13.093 20.0487 13.1448 20.6339 13.2743 21.2088L12.0157 21.9391ZM7.45805 2.76569H9.94407V5.8007H7.45805V2.76569ZM3.31469 10.7261C3.31469 9.8353 4.0346 9.11539 4.92542 9.11539H12.4767C13.3675 9.11539 14.0874 9.8353 14.0874 10.7261V14.9627C14.0874 15.8535 13.3675 16.5734 12.4767 16.5734H4.92542C4.0346 16.5734 3.31469 15.8535 3.31469 14.9627V10.7261Z"
          fill="url(#paint0_linear_194_1392)"
        />
        <path
          d="M20.2352 12.4874C19.9866 12.4097 19.7225 12.4201 19.4843 12.5133C17.7544 13.1555 14.7764 17.2316 14.7764 19.7486C14.8023 22.5713 17.1122 24.8398 19.9349 24.8139C22.7213 24.788 24.9794 22.5351 25.0001 19.7486C25.0001 17.1332 21.991 13.0105 20.2352 12.4874ZM20.7169 23.2032C20.489 23.2032 20.3026 23.0167 20.3026 22.7888C20.3026 22.561 20.489 22.3745 20.7169 22.3745C20.9448 22.3745 21.1312 22.561 21.1312 22.7888C21.1312 23.0167 20.9448 23.2032 20.7169 23.2032ZM22.5141 19.7486C22.5141 19.5208 22.7005 19.3343 22.9284 19.3343C23.1563 19.3343 23.3428 19.5208 23.3428 19.7486C23.3428 20.6343 23.0061 21.4837 22.4002 22.1207C22.2396 22.2865 21.9806 22.2968 21.8097 22.1363C21.644 21.9809 21.6388 21.7167 21.7942 21.551C22.2603 21.0693 22.5141 20.4219 22.5141 19.7486Z"
          fill="black"
        />
        <path
          d="M20.2352 12.4874C19.9866 12.4097 19.7225 12.4201 19.4843 12.5133C17.7544 13.1555 14.7764 17.2316 14.7764 19.7486C14.8023 22.5713 17.1122 24.8398 19.9349 24.8139C22.7213 24.788 24.9794 22.5351 25.0001 19.7486C25.0001 17.1332 21.991 13.0105 20.2352 12.4874ZM20.7169 23.2032C20.489 23.2032 20.3026 23.0167 20.3026 22.7888C20.3026 22.561 20.489 22.3745 20.7169 22.3745C20.9448 22.3745 21.1312 22.561 21.1312 22.7888C21.1312 23.0167 20.9448 23.2032 20.7169 23.2032ZM22.5141 19.7486C22.5141 19.5208 22.7005 19.3343 22.9284 19.3343C23.1563 19.3343 23.3428 19.5208 23.3428 19.7486C23.3428 20.6343 23.0061 21.4837 22.4002 22.1207C22.2396 22.2865 21.9806 22.2968 21.8097 22.1363C21.644 21.9809 21.6388 21.7167 21.7942 21.551C22.2603 21.0693 22.5141 20.4219 22.5141 19.7486Z"
          fill="url(#paint1_linear_194_1392)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_194_1392"
          x1="0.500829"
          y1="1.69632e-05"
          x2="18.5269"
          y2="0.3132"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47D0C5" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_194_1392"
          x1="15.0706"
          y1="12.4356"
          x2="25.6586"
          y2="12.6526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47D0C5" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
        <clipPath id="clip0_194_1392">
          <rect width="25" height="24.8602" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BloodPressureIcon: FC<ISvgComponent> = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_194_1397)">
        <path
          d="M11.923 18.4151C11.5623 18.4151 11.2219 18.2373 11.0238 17.9325L9.17971 15.1638H7.58963C6.99018 15.1638 6.50757 14.6761 6.50757 14.0818C6.50757 13.4874 6.99526 12.9997 7.58963 12.9997H9.75376C10.1144 12.9997 10.4548 13.1826 10.6529 13.4823L11.7858 15.1791L14.2039 10.3479C14.3817 9.99227 14.7373 9.76366 15.1336 9.74842C15.5502 9.73826 15.9007 9.93638 16.1039 10.2717L19.0402 15.1638H20.5947C21.1942 15.1638 21.6768 15.6515 21.6768 16.2459C21.6768 16.8403 21.1891 17.3279 20.5947 17.3279H18.4255C18.0445 17.3279 17.694 17.1298 17.4958 16.8047L15.2606 13.081L12.8933 17.8156C12.7205 18.1611 12.3751 18.3897 11.989 18.4151C11.9687 18.4151 11.9433 18.4151 11.923 18.4151Z"
          fill="black"
        />
        <path
          d="M11.923 18.4151C11.5623 18.4151 11.2219 18.2373 11.0238 17.9325L9.17971 15.1638H7.58963C6.99018 15.1638 6.50757 14.6761 6.50757 14.0818C6.50757 13.4874 6.99526 12.9997 7.58963 12.9997H9.75376C10.1144 12.9997 10.4548 13.1826 10.6529 13.4823L11.7858 15.1791L14.2039 10.3479C14.3817 9.99227 14.7373 9.76366 15.1336 9.74842C15.5502 9.73826 15.9007 9.93638 16.1039 10.2717L19.0402 15.1638H20.5947C21.1942 15.1638 21.6768 15.6515 21.6768 16.2459C21.6768 16.8403 21.1891 17.3279 20.5947 17.3279H18.4255C18.0445 17.3279 17.694 17.1298 17.4958 16.8047L15.2606 13.081L12.8933 17.8156C12.7205 18.1611 12.3751 18.3897 11.989 18.4151C11.9687 18.4151 11.9433 18.4151 11.923 18.4151Z"
          fill="url(#paint0_linear_194_1397)"
        />
        <path
          d="M18.4256 19.4975C17.2876 19.4975 16.2259 18.8929 15.6417 17.9175L15.4334 17.5823L14.8288 18.7862C14.3208 19.8277 13.2794 20.5084 12.1313 20.5744L11.923 20.5846C10.8308 20.5846 9.81985 20.041 9.21532 19.1317L8.01133 17.3333H7.58968C5.80148 17.3333 4.33841 15.8703 4.33841 14.0821C4.33841 12.2939 5.80148 10.8308 7.58968 10.8308H9.75381C10.3177 10.8308 10.8613 10.973 11.3337 11.2423L12.2634 9.37788C12.7968 8.31614 13.8585 7.62016 15.0473 7.57952C15.5147 7.56936 15.9668 7.64556 16.3783 7.81829C13.8179 3.76944 10.5565 0.45721 10.3279 0.228605C10.0231 -0.0762016 9.48456 -0.0762016 9.17976 0.228605C8.79875 0.604533 0 9.56077 0 16.17C0 21.5905 4.37905 26 9.75381 26C13.9703 26 17.5772 23.2821 18.9336 19.4975H18.4256Z"
          fill="black"
        />
        <path
          d="M18.4256 19.4975C17.2876 19.4975 16.2259 18.8929 15.6417 17.9175L15.4334 17.5823L14.8288 18.7862C14.3208 19.8277 13.2794 20.5084 12.1313 20.5744L11.923 20.5846C10.8308 20.5846 9.81985 20.041 9.21532 19.1317L8.01133 17.3333H7.58968C5.80148 17.3333 4.33841 15.8703 4.33841 14.0821C4.33841 12.2939 5.80148 10.8308 7.58968 10.8308H9.75381C10.3177 10.8308 10.8613 10.973 11.3337 11.2423L12.2634 9.37788C12.7968 8.31614 13.8585 7.62016 15.0473 7.57952C15.5147 7.56936 15.9668 7.64556 16.3783 7.81829C13.8179 3.76944 10.5565 0.45721 10.3279 0.228605C10.0231 -0.0762016 9.48456 -0.0762016 9.17976 0.228605C8.79875 0.604533 0 9.56077 0 16.17C0 21.5905 4.37905 26 9.75381 26C13.9703 26 17.5772 23.2821 18.9336 19.4975H18.4256Z"
          fill="url(#paint1_linear_194_1397)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_194_1397"
          x1="6.50757"
          y1="9.74805"
          x2="22.6874"
          y2="11.2862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE6587" />
          <stop offset="1" stopColor="#F52D6A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_194_1397"
          x1="0"
          y1="0"
          x2="20.3456"
          y2="0.804767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE6587" />
          <stop offset="1" stopColor="#F52D6A" />
        </linearGradient>
        <clipPath id="clip0_194_1397">
          <rect width="21.6768" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AssignedVipIcon: FC<ISvgComponent> = () => {
  return (
    <svg
      width="126"
      height="84"
      viewBox="0 0 126 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_5727_9088)">
        <g clipPath="url(#clip0_5727_9088)">
          <rect
            x="17"
            y="13"
            width="92"
            height="50"
            rx="8"
            fill="url(#paint0_linear_5727_9088)"
            shapeRendering="crispEdges"
          />
          <g filter="url(#filter1_b_5727_9088)">
            <rect
              x="23.9131"
              y="-50"
              width="59.6029"
              height="110.05"
              transform="rotate(38.7702 23.9131 -50)"
              fill="url(#paint1_linear_5727_9088)"
              fillOpacity="0.6"
            />
          </g>
          <path
            d="M60.4725 48.2041C60.5311 48.5779 60.2772 48.9323 59.8996 48.9903C59.867 48.9967 59.828 48.9967 59.7954 48.9967H39.2095C38.8254 48.9967 38.5194 48.681 38.5194 48.3072C38.5194 48.275 38.5194 48.2363 38.5259 48.2041L39.0923 44.879C39.1248 44.6792 39.3006 44.531 39.509 44.5375H59.4959C59.7043 44.5375 59.8801 44.6792 59.9126 44.879L60.4725 48.2041ZM59.9061 31.8556L56.436 33.9305C55.811 34.3043 54.9907 34.1239 54.5871 33.5181L50.6418 27.6089C50.2251 26.9839 49.3788 26.8163 48.7472 27.2287C48.5975 27.3318 48.4608 27.4607 48.3631 27.6089L44.4178 33.5052C44.0142 34.1239 43.1873 34.3043 42.5558 33.9177L39.0988 31.8556C38.4478 31.4625 37.6014 31.6622 37.2043 32.3066C37.022 32.6031 36.9569 32.951 37.0285 33.2861L39.0402 42.1467C39.0858 42.3336 39.2551 42.4689 39.4504 42.4689H59.561C59.7564 42.4689 59.9256 42.3336 59.9712 42.1467L61.9829 33.2861C62.1327 32.5515 61.6509 31.8298 60.9022 31.6816C60.5571 31.6171 60.1991 31.6751 59.9061 31.8556Z"
            fill="white"
          />
          <path
            d="M81.758 33.0689L77.525 45.0029H73.887L69.654 33.0689H72.748L75.706 42.0789L78.681 33.0689H81.758ZM86.5599 33.0689V45.0029H83.6529V33.0689H86.5599ZM98.4416 36.9109C98.4416 37.6023 98.283 38.2369 97.9656 38.8149C97.6483 39.3816 97.161 39.8406 96.5036 40.1919C95.8463 40.5433 95.0303 40.7189 94.0556 40.7189H92.2536V45.0029H89.3466V33.0689H94.0556C95.0076 33.0689 95.8123 33.2333 96.4696 33.5619C97.127 33.8906 97.62 34.3439 97.9486 34.9219C98.2773 35.4999 98.4416 36.1629 98.4416 36.9109ZM93.8346 38.4069C94.39 38.4069 94.8036 38.2766 95.0756 38.0159C95.3476 37.7553 95.4836 37.3869 95.4836 36.9109C95.4836 36.4349 95.3476 36.0666 95.0756 35.8059C94.8036 35.5453 94.39 35.4149 93.8346 35.4149H92.2536V38.4069H93.8346Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5727_9088"
          x="0"
          y="0"
          width="126"
          height="84"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5727_9088"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5727_9088"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_5727_9088"
          x="-47"
          y="-52"
          width="119.383"
          height="127.125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_5727_9088"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_5727_9088"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5727_9088"
          x1="17"
          y1="13"
          x2="110.493"
          y2="65.1346"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C4DDA" stopOpacity="0.6" />
          <stop offset="1" stopColor="#522ED2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5727_9088"
          x1="81.5096"
          y1="10.0107"
          x2="26.3132"
          y2="-0.922311"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.541667" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_5727_9088">
          <rect x="17" y="13" width="92" height="50" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DropDownArrowIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
  width,
  height,
}) => {
  return (
    <svg
      width={width ?? "14"}
      height={height ?? "8"}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M12 7.29257L6.707 1.99957L1.414 7.29257L0 5.87857L5.293 0.585573C5.66806 0.210631 6.17667 0 6.707 0C7.23733 0 7.74594 0.210631 8.121 0.585573L13.414 5.87857L12 7.29257Z"
        // fill="#797979"
        fill={fillColor}
      />
    </svg>
  );
};

export const MedicalHistoryIcon: FC<ISvgComponent> = ({ handleClick }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <path
        d="M38.8281 40H1.17188C0.523438 40 0 39.4766 0 38.8281V13.6719C0 13.0234 0.523438 12.5 1.17188 12.5H12.9688C13.3594 12.5 13.7266 12.6953 13.9453 13.0234L16.7188 17.1875H38.8281C39.4766 17.1875 40 17.7109 40 18.3594V38.8281C40 39.4766 39.4766 40 38.8281 40ZM30.5469 11.3281C30.5469 10.6797 30.0234 10.1562 29.375 10.1562H19.2188C18.5703 10.1562 18.0469 10.6797 18.0469 11.3281C18.0469 11.9766 18.5703 12.5 19.2188 12.5H29.375C30.0234 12.5 30.5469 11.9766 30.5469 11.3281ZM30.5469 5.85938C30.5469 5.21094 30.0234 4.6875 29.375 4.6875H10.625C9.97656 4.6875 9.45312 5.21094 9.45312 5.85938C9.45312 6.50781 9.97656 7.03125 10.625 7.03125H29.375C30.0234 7.03125 30.5469 6.50781 30.5469 5.85938Z"
        fill="url(#paint0_linear_63_605)"
      />
      <path
        d="M15.7031 26.25C15.7031 25.6016 16.2266 25.0781 16.875 25.0781H18.8281V23.125C18.8281 22.4766 19.3516 21.9531 20 21.9531C20.6484 21.9531 21.1719 22.4766 21.1719 23.125V25.0781H23.125C23.7734 25.0781 24.2969 25.6016 24.2969 26.25C24.2969 26.8984 23.7734 27.4219 23.125 27.4219H21.1719V29.375C21.1719 30.0234 20.6484 30.5469 20 30.5469C19.3516 30.5469 18.8281 30.0234 18.8281 29.375V27.4219H16.875C16.2266 27.4219 15.7031 26.8984 15.7031 26.25ZM25.4688 32.8906H14.5312C13.8828 32.8906 13.3594 33.4141 13.3594 34.0625C13.3594 34.7109 13.8828 35.2344 14.5312 35.2344H25.4688C26.1172 35.2344 26.6406 34.7109 26.6406 34.0625C26.6406 33.4141 26.1172 32.8906 25.4688 32.8906ZM35.2344 1.17188V17.1875H16.7188L13.9453 13.0234C13.7266 12.6953 13.3594 12.5 12.9688 12.5H4.76562V1.17188C4.76562 0.523438 5.28906 0 5.9375 0H34.0625C34.7109 0 35.2344 0.523438 35.2344 1.17188ZM30.5469 11.3281C30.5469 10.6797 30.0234 10.1562 29.375 10.1562H19.2188C18.5703 10.1562 18.0469 10.6797 18.0469 11.3281C18.0469 11.9766 18.5703 12.5 19.2188 12.5H29.375C30.0234 12.5 30.5469 11.9766 30.5469 11.3281ZM30.5469 5.85938C30.5469 5.21094 30.0234 4.6875 29.375 4.6875H10.625C9.97656 4.6875 9.45312 5.21094 9.45312 5.85938C9.45312 6.50781 9.97656 7.03125 10.625 7.03125H29.375C30.0234 7.03125 30.5469 6.50781 30.5469 5.85938Z"
        fill="url(#paint1_linear_63_605)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_63_605"
          x1="1.15108"
          y1="4.68752"
          x2="42.5609"
          y2="5.85163"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5936F1" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_63_605"
          x1="20"
          y1="35.2344"
          x2="20"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADDCFF" />
          <stop offset="0.5028" stopColor="#EAF6FF" />
          <stop offset="1" stopColor="#EAF6FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DropdownGreen: FC<ISvgComponent> = ({
  handleClick,
  fillColor,
}) => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <circle cx="13" cy="13.9922" r="13" fill={fillColor} />
      <path
        d="M7.41406 12.0004L12.7071 17.2934L18.0001 12.0004L19.4141 13.4144L14.1211 18.7074C13.746 19.0823 13.2374 19.293 12.7071 19.293C12.1767 19.293 11.6681 19.0823 11.2931 18.7074L6.00006 13.4144L7.41406 12.0004Z"
        fill="white"
      />
    </svg>
  );
};

export const ShareIcon: FC<ISvgComponent> = ({
  customClass,
  fillColor,
  handleClick,
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      className={customClass}
    >
      <path
        d="M12.8887 9.77816C12.3847 9.77858 11.8883 9.90163 11.4424 10.1367C10.9965 10.3718 10.6145 10.7118 10.3294 11.1275L5.99007 9.16817C6.29828 8.42392 6.29948 7.58796 5.99341 6.84283L10.3267 4.8735C10.7493 5.48467 11.377 5.92414 12.0958 6.1122C12.8146 6.30025 13.5771 6.22443 14.2448 5.8985C14.9126 5.57256 15.4414 5.0181 15.7353 4.33568C16.0292 3.65325 16.0689 2.88808 15.847 2.17895C15.6251 1.46982 15.1564 0.863696 14.5259 0.470535C13.8954 0.0773743 13.1449 -0.0767867 12.4104 0.0360157C11.676 0.148818 11.0063 0.521112 10.5229 1.08537C10.0394 1.64962 9.77425 2.36846 9.77541 3.1115C9.77823 3.28736 9.79607 3.46267 9.82874 3.6355L5.22207 5.72883C4.77963 5.31431 4.22574 5.03806 3.62845 4.93401C3.03117 4.82996 2.41649 4.90264 1.85994 5.14314C1.3034 5.38363 0.829222 5.78146 0.495669 6.28774C0.162117 6.79402 -0.0162843 7.38671 -0.0176164 7.993C-0.0189485 8.59928 0.156846 9.19275 0.488171 9.70049C0.819496 10.2082 1.29192 10.6081 1.8474 10.8511C2.40289 11.094 3.01724 11.1694 3.61498 11.068C4.21272 10.9666 4.76782 10.6927 5.21207 10.2802L9.83074 12.3655C9.79866 12.5382 9.78104 12.7132 9.77807 12.8888C9.77794 13.5043 9.96032 14.1059 10.3021 14.6176C10.644 15.1294 11.1299 15.5283 11.6984 15.7639C12.267 15.9994 12.8926 16.0611 13.4962 15.9411C14.0998 15.8211 14.6543 15.5247 15.0895 15.0895C15.5246 14.6544 15.821 14.0999 15.941 13.4963C16.061 12.8927 15.9993 12.2671 15.7638 11.6985C15.5282 11.13 15.1293 10.6441 14.6176 10.3022C14.1058 9.96041 13.5042 9.77803 12.8887 9.77816ZM12.8887 1.3335C13.2404 1.33337 13.5842 1.43753 13.8767 1.63282C14.1692 1.82811 14.3972 2.10575 14.5319 2.43063C14.6665 2.7555 14.7019 3.11302 14.6333 3.45796C14.5648 3.8029 14.3955 4.11977 14.1469 4.3685C13.8982 4.61722 13.5814 4.78663 13.2365 4.85529C12.8916 4.92394 12.5341 4.88877 12.2091 4.75422C11.8842 4.61967 11.6065 4.39178 11.4111 4.09937C11.2157 3.80697 11.1114 3.46318 11.1114 3.1115C11.1118 2.64017 11.2991 2.18823 11.6323 1.85489C11.9655 1.52154 12.4174 1.33403 12.8887 1.3335ZM3.11141 9.77816C2.75972 9.7783 2.4159 9.67413 2.12342 9.47884C1.83094 9.28355 1.60295 9.00591 1.46827 8.68104C1.3336 8.35616 1.29829 7.99865 1.36682 7.6537C1.43535 7.30876 1.60464 6.99189 1.85327 6.74317C2.1019 6.49444 2.41871 6.32504 2.76362 6.25638C3.10854 6.18772 3.46607 6.22289 3.791 6.35744C4.11592 6.492 4.39365 6.71989 4.58905 7.01229C4.78444 7.3047 4.88874 7.64848 4.88874 8.00016C4.88821 8.47144 4.70081 8.92327 4.36763 9.25658C4.03445 9.58989 3.58268 9.77746 3.11141 9.77816ZM12.8887 14.6668C12.5371 14.6668 12.1933 14.5626 11.9009 14.3672C11.6085 14.1718 11.3807 13.8941 11.2461 13.5692C11.1115 13.2444 11.0763 12.8869 11.1449 12.542C11.2135 12.1971 11.3828 11.8803 11.6315 11.6316C11.8802 11.3829 12.197 11.2136 12.5419 11.145C12.8868 11.0764 13.2443 11.1116 13.5692 11.2462C13.894 11.3807 14.1717 11.6086 14.3671 11.901C14.5625 12.1934 14.6667 12.5372 14.6667 12.8888C14.6664 13.3603 14.4789 13.8123 14.1456 14.1457C13.8122 14.479 13.3602 14.6665 12.8887 14.6668Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ClockIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00003 16C6.41778 16 4.87106 15.5308 3.55547 14.6518C2.23988 13.7727 1.2145 12.5233 0.608998 11.0615C0.0034968 9.59966 -0.15493 7.99113 0.153752 6.43928C0.462434 4.88743 1.22436 3.46197 2.34318 2.34315C3.462 1.22433 4.88746 0.462403 6.43931 0.153721C7.99116 -0.15496 9.59969 0.00346629 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87103 16 6.41775 16 8C15.9977 10.121 15.1541 12.1545 13.6544 13.6543C12.1546 15.1541 10.1211 15.9977 8.00003 16ZM8.00003 1.33334C6.68149 1.33334 5.39256 1.72433 4.29623 2.45687C3.1999 3.18941 2.34542 4.23061 1.84084 5.44878C1.33625 6.66695 1.20423 8.0074 1.46147 9.3006C1.7187 10.5938 2.35364 11.7817 3.28599 12.714C4.21834 13.6464 5.40622 14.2813 6.69943 14.5386C7.99264 14.7958 9.33308 14.6638 10.5513 14.1592C11.7694 13.6546 12.8106 12.8001 13.5432 11.7038C14.2757 10.6075 14.6667 9.31854 14.6667 8C14.6648 6.23249 13.9618 4.53792 12.7119 3.2881C11.4621 2.03828 9.76755 1.33528 8.00003 1.33334Z"
        fill={fillColor}
      />
      <path
        d="M5.298 10.3987L4.59067 9.268L7.33333 7.55V4H8.66667V8.28866L5.298 10.3987Z"
        fill="#181818"
      />
    </svg>
  );
};

export const NotesIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.162C12.0009 3.81159 11.9323 3.46447 11.7982 3.14074C11.6641 2.81701 11.4671 2.52309 11.2187 2.276L9.724 0.781333C9.22311 0.282559 8.54553 0.00175163 7.83867 0L2 0C1.46957 0 0.960859 0.210714 0.585787 0.585786C0.210714 0.960859 0 1.46957 0 2V16H12V4.162ZM10.276 3.21867C10.3095 3.25504 10.3409 3.29333 10.37 3.33333H8.66667V1.63C8.70667 1.65909 8.74496 1.69048 8.78133 1.724L10.276 3.21867ZM1.33333 14.6667V2C1.33333 1.82319 1.40357 1.65362 1.5286 1.5286C1.65362 1.40357 1.82319 1.33333 2 1.33333H7.33333V4.66667H10.6667V14.6667H1.33333ZM3.33333 6H8.66667V7.33333H3.33333V6ZM3.33333 8.66667H8.66667V10H3.33333V8.66667ZM7.34533 11.2093L8.65533 11.4533C8.528 12.1513 7.98533 13.3333 6.75667 13.3333C6.27442 13.3329 5.80697 13.1667 5.43267 12.8627C5.22333 12.714 5.15 12.6667 4.99133 12.6667C4.75267 12.7572 4.54205 12.9089 4.38067 13.1067L3.38067 12.2287C3.78392 11.736 4.36 11.4157 4.99133 11.3333C5.43455 11.3386 5.86274 11.4948 6.20533 11.776C6.35475 11.9168 6.55139 11.9967 6.75667 12C7.172 12 7.34333 11.218 7.34533 11.2093Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const EmailBlue: FC<ISvgComponent> = ({ handleClick }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M0 5C0 2.23858 2.23858 0 5 0H17C19.7614 0 22 2.23858 22 5V17C22 19.7614 19.7614 22 17 22H5C2.23858 22 0 19.7614 0 17V5Z"
        fill="url(#paint0_linear_7641_12649)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4529 6H4.54708C4.46954 6 4.392 6.0182 4.32308 6.05005L10.6338 12.2375C10.8406 12.4468 11.168 12.4468 11.3748 12.2375L17.6855 6.05005C17.608 6.0182 17.5348 6 17.4529 6ZM17.9354 6.30027C17.9785 6.38671 18 6.47771 18 6.5778V15.4313C18 15.5041 17.9871 15.5769 17.9612 15.6451L13.184 10.9591L17.9354 6.30027ZM4.54708 16C4.448 16 4.34892 15.9727 4.26708 15.9181L9.07446 11.2047L10.4012 12.5059C10.7415 12.838 11.2714 12.838 11.6117 12.5059L12.9385 11.2047L17.7458 15.9181C17.6597 15.9727 17.5649 16 17.4658 16H4.54708ZM4 15.4268V6.57325C4 6.47771 4.02154 6.38217 4.06892 6.29572L8.82031 10.9545L4.03877 15.6406C4.01292 15.5723 4 15.4995 4 15.4268Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7641_12649"
          x1="11"
          y1="0"
          x2="11"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E52EE" />
          <stop offset="1" stopColor="#19E4FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LinkIcon: FC<ISvgComponent> = ({ handleClick }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <path
        d="M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z"
        fill="url(#paint0_linear_7641_12650)"
      />
      <path
        d="M8.24698 15.4441C8.01912 15.6718 7.71953 15.7941 7.39884 15.7941C7.07815 15.7941 6.77856 15.6676 6.5507 15.4441C6.32284 15.2164 6.20047 14.9171 6.20047 14.5966C6.20047 14.2762 6.32706 13.9768 6.5507 13.7491L9.81245 10.4898C9.60991 10.4392 9.40737 10.4013 9.20061 10.4013C8.58877 10.4013 7.9727 10.6374 7.50433 11.1054L5.70256 12.9058C4.76581 13.8419 4.76581 15.364 5.70256 16.2959C6.17094 16.7639 6.787 17 7.39884 17C8.01068 17 8.62674 16.7639 9.09512 16.2959L10.8969 14.4954C11.5214 13.8714 11.7197 12.9859 11.5087 12.1848L8.24698 15.4441Z"
        fill="white"
      />
      <path
        d="M8.77443 13.2178C9.00229 13.4455 9.39471 13.4455 9.62257 13.2178L13.2219 9.62122C13.4582 9.3851 13.4582 9.00984 13.2219 8.77372C13.108 8.65987 12.9603 8.59663 12.7957 8.59663C12.6311 8.59663 12.4835 8.65987 12.3695 8.77372L8.77021 12.3703C8.54235 12.6065 8.54235 12.9859 8.77443 13.2178Z"
        fill="white"
      />
      <path
        d="M16.298 5.70415C15.8296 5.23612 15.2135 5 14.6017 5C13.9898 5 13.3738 5.23612 12.9054 5.70415L11.1036 7.50457C10.4791 8.1286 10.2808 9.01405 10.4918 9.81518L11.9518 8.35207L13.7535 6.55165C13.9814 6.32396 14.281 6.20169 14.6017 6.20169C14.9224 6.20169 15.222 6.32818 15.4498 6.55165C15.6777 6.77934 15.8001 7.07871 15.8001 7.39916C15.8001 7.71961 15.6735 8.01897 15.4498 8.24666L12.1839 11.5102C12.3864 11.5608 12.5889 11.5987 12.7957 11.5987C13.4075 11.5987 14.0236 11.3626 14.492 10.8946L16.2937 9.09417C17.2347 8.15812 17.2347 6.6402 16.298 5.70415Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7641_12650"
          x1="11"
          y1="0"
          x2="11"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7293CC" />
          <stop offset="1" stopColor="#4B61B0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const YearNode: FC<ISvgComponent> = ({ customClass, handleClick }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={handleClick}
    >
      <circle
        cx="9"
        cy="9"
        r="8.5"
        fill="url(#paint0_linear_35_234)"
        stroke="#CDD4D8"
      />
      <circle cx="9.00001" cy="8.99961" r="5.4" fill="white" />
      <circle cx="8.99999" cy="8.9998" r="2.7" fill="#02BF90" />
      <defs>
        <linearGradient
          id="paint0_linear_35_234"
          x1="0.517985"
          y1="1.22822e-05"
          x2="19.1557"
          y2="0.462552"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5936F1" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CallIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9163 18.1996C24.8851 18.0196 24.8476 17.8607 24.8088 17.7232C24.5576 16.8257 23.7801 16.143 22.8275 15.983L17.4134 15.0817C16.5058 14.9355 15.5907 15.283 15.032 15.9931C14.9595 16.0843 14.8894 16.1793 14.7494 16.3343C12.0142 15.1454 9.85286 12.9829 8.71029 10.184C8.83904 10.0977 8.96283 10.0052 9.08034 9.90898C9.77663 9.3477 10.1217 8.4477 9.98166 7.56264L9.14282 2.24338C8.99656 1.31207 8.35652 0.550905 7.47272 0.258386C7.28145 0.194632 7.05645 0.134674 6.79518 0.0871711C5.12007 -0.210348 3.40616 0.260893 2.08982 1.39097C0.713485 2.57355 -0.0465438 4.28969 0.00220942 6.10105C0.279728 16.418 8.58031 24.72 18.8985 24.9988C18.9522 25 19.0072 25 19.061 25C20.7974 25 22.4387 24.2485 23.5838 22.9234C24.7239 21.6059 25.2089 19.8835 24.9163 18.1996ZM21.6924 21.2897C21.0036 22.0873 20.031 22.5223 18.9647 22.5011C9.97537 22.2585 2.74237 15.0254 2.49986 6.03483C2.47235 4.97976 2.91618 3.97994 3.71873 3.2899C4.32127 2.77236 5.04255 2.49974 5.7901 2.49974C5.97511 2.49974 6.1614 2.51729 6.34891 2.5498C6.47767 2.5748 6.58889 2.60217 6.67265 2.63342L7.50522 7.97007C7.44272 8.02008 7.37769 8.06754 7.30768 8.11504C6.26386 8.82509 5.87759 10.1128 6.37012 11.2467C7.81146 14.5644 10.4329 17.1855 13.7494 18.6281C14.8819 19.1207 16.1721 18.7359 16.8834 17.6921L16.9996 17.5483L22.3999 18.3995C22.4187 18.467 22.4362 18.5421 22.4512 18.6296C22.6162 19.571 22.3399 20.5422 21.6924 21.2897Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ReceiptMenu: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <path
        d="M20.25 12.413V20.519C20.25 20.9545 19.8134 21.3086 19.2766 21.3086H10.2859C9.74906 21.3086 9.3125 20.9545 9.3125 20.519V9.84814C9.3125 9.4127 9.74906 9.05859 10.2859 9.05859H16.1145L20.25 12.413Z"
        fill="#67CDDF"
      />
      <path
        d="M12.7461 15.2246H17.5777V15.7294H12.7461V15.2246Z"
        fill="white"
      />
      <path
        d="M11.6488 15.758C11.8411 15.758 11.9969 15.6316 11.9969 15.4757C11.9969 15.3198 11.8411 15.1934 11.6488 15.1934C11.4566 15.1934 11.3008 15.3198 11.3008 15.4757C11.3008 15.6316 11.4566 15.758 11.6488 15.758Z"
        fill="white"
      />
      <path d="M12.7461 16.6602H17.5777V17.165H12.7461V16.6602Z" fill="white" />
      <path
        d="M11.6488 17.1936C11.8411 17.1936 11.9969 17.0672 11.9969 16.9112C11.9969 16.7553 11.8411 16.6289 11.6488 16.6289C11.4566 16.6289 11.3008 16.7553 11.3008 16.9112C11.3008 17.0672 11.4566 17.1936 11.6488 17.1936Z"
        fill="white"
      />
      <path
        d="M12.7461 18.0957H17.5777V18.6005H12.7461V18.0957Z"
        fill="white"
      />
      <path
        d="M11.6488 18.6291C11.8411 18.6291 11.9969 18.5027 11.9969 18.3468C11.9969 18.1909 11.8411 18.0645 11.6488 18.0645C11.4566 18.0645 11.3008 18.1909 11.3008 18.3468C11.3008 18.5027 11.4566 18.6291 11.6488 18.6291Z"
        fill="white"
      />
      <path
        d="M20.2502 12.413H17.0881C16.5513 12.413 16.1147 12.0589 16.1147 11.6234V9.05859L20.2502 12.413Z"
        fill="#07C3AA"
      />
      <path
        d="M29 5.28516C29 7.54922 27.1078 9.38672 24.8438 9.38672H5.15625C2.89219 9.38672 1 7.54922 1 5.28516C1 3.02109 2.89219 1.18359 5.15625 1.18359H24.8438C27.1078 1.18359 29 3.02109 29 5.28516Z"
        fill="#67CDDF"
      />
      <path
        d="M23.2031 4.46484H6.79688C6.33745 4.46484 5.97656 4.82573 5.97656 5.28516V26.7227C5.97656 26.9359 6.05859 27.1492 6.22271 27.2968L7.86334 28.9374C8.17505 29.2656 8.69995 29.2656 9.01172 28.9374L10.0782 27.8874L11.1446 28.9374C11.4564 29.2656 11.9813 29.2656 12.293 28.9374L13.3595 27.8874L14.4259 28.9374C14.5734 29.1016 14.7867 29.1836 15 29.1836C15.2133 29.1836 15.4266 29.1016 15.5742 28.9374L16.6406 27.8874L17.7071 28.9374C18.0188 29.2656 18.5437 29.2656 18.8555 28.9374L19.9219 27.8874L20.9884 28.9374C21.1359 29.1016 21.3492 29.1836 21.5625 29.1836C21.7758 29.1836 21.9891 29.1016 22.1367 28.9374L23.7773 27.2968C23.9414 27.1492 24.0234 26.9359 24.0234 26.7227V5.28516C24.0234 4.82573 23.6626 4.46484 23.2031 4.46484Z"
        fill="#EAEFFE"
      />
      <path
        d="M25.6641 5.28516C25.6641 5.74448 25.3032 6.10547 24.8438 6.10547H5.15625C4.69682 6.10547 4.33594 5.74448 4.33594 5.28516C4.33594 4.82573 4.69682 4.46484 5.15625 4.46484H24.8438C25.3032 4.46484 25.6641 4.82573 25.6641 5.28516Z"
        fill="#07C3AA"
      />
      <path
        d="M20.7422 10.207C20.7422 10.6664 20.3813 11.0273 19.9219 11.0273H10.0781C9.6187 11.0273 9.25781 10.6664 9.25781 10.207C9.25781 9.7476 9.6187 9.38672 10.0781 9.38672H19.9219C20.3813 9.38672 20.7422 9.7476 20.7422 10.207Z"
        fill="#002C5A"
      />
      <path
        d="M19.9219 15.9492H16.6406C16.1872 15.9492 15.8203 15.5823 15.8203 15.1289C15.8203 14.6755 16.1872 14.3086 16.6406 14.3086H19.9219C20.3753 14.3086 20.7422 14.6755 20.7422 15.1289C20.7422 15.5823 20.3753 15.9492 19.9219 15.9492Z"
        fill="#002C5A"
      />
      <path
        d="M19.9219 19.2305H16.6406C16.1872 19.2305 15.8203 18.8636 15.8203 18.4102C15.8203 17.9567 16.1872 17.5898 16.6406 17.5898H19.9219C20.3753 17.5898 20.7422 17.9567 20.7422 18.4102C20.7422 18.8636 20.3753 19.2305 19.9219 19.2305Z"
        fill="#002C5A"
      />
      <path
        d="M19.9219 22.5117H16.6406C16.1872 22.5117 15.8203 22.1448 15.8203 21.6914C15.8203 21.238 16.1872 20.8711 16.6406 20.8711H19.9219C20.3753 20.8711 20.7422 21.238 20.7422 21.6914C20.7422 22.1448 20.3753 22.5117 19.9219 22.5117Z"
        fill="#002C5A"
      />
      <path
        d="M20.7422 10.207C20.7422 10.6664 20.3813 11.0273 19.9219 11.0273H15V9.38672H19.9219C20.3813 9.38672 20.7422 9.7476 20.7422 10.207Z"
        fill="#002C5A"
      />
    </svg>
  );
};

export const InvoiceMenu: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.0568 15.9376C28.1555 15.8389 28.2851 15.7834 28.4207 15.7895C28.7106 15.7895 28.945 16.0239 28.945 16.3138V26.9162C28.7723 26.8668 28.5996 26.8422 28.4207 26.8422H27.8965V16.3138C27.8965 16.1719 27.952 16.0362 28.0568 15.9376Z"
        fill={fillColor}
      />
      <path
        d="M9.99811 19.4707V24.7318H2.63379V19.4707H8.42533H9.99811Z"
        fill={fillColor}
      />
      <path
        d="M2.63379 25.7871H26.8423V26.8418H2.63379V25.7871Z"
        fill={fillColor}
      />
      <path
        d="M11.577 18.416H26.8422V24.7318H11.0527V18.9403C11.0527 18.6504 11.2871 18.416 11.577 18.416Z"
        fill={fillColor}
      />
      <path
        d="M7.37064 16.3145C7.66052 16.3145 7.8949 16.5488 7.8949 16.8387V18.4177H2.63379V16.3145H7.37064Z"
        fill={fillColor}
      />
      <path
        d="M0.684776 12.2559C0.783461 12.1572 0.912984 12.1017 1.04867 12.1079C1.33856 12.1079 1.57294 12.3423 1.57294 12.6321V26.8427H1.04867C0.869809 26.8427 0.690944 26.8674 0.524414 26.9167V12.626C0.524414 12.4841 0.586092 12.3484 0.684776 12.2559Z"
        fill={fillColor}
      />
      <path
        d="M1.05469 30C1.63718 30 2.10938 29.5278 2.10938 28.9453C2.10938 28.3628 1.63718 27.8906 1.05469 27.8906C0.472201 27.8906 0 28.3628 0 28.9453C0 29.5278 0.472201 30 1.05469 30Z"
        fill={fillColor}
      />
      <path
        d="M3.15805 28.9453C3.15805 28.5752 3.0532 28.2113 2.86816 27.8906H26.6141C26.4229 28.2113 26.3242 28.5752 26.3242 28.9453H3.15805Z"
        fill={fillColor}
      />
      <path
        d="M28.4209 30C29.0034 30 29.4756 29.5278 29.4756 28.9453C29.4756 28.3628 29.0034 27.8906 28.4209 27.8906C27.8384 27.8906 27.3662 28.3628 27.3662 28.9453C27.3662 29.5278 27.8384 30 28.4209 30Z"
        fill={fillColor}
      />
      <path
        d="M29.5809 8.83225L22.0809 15.4688C21.5628 15.9252 20.7733 15.8758 20.3169 15.3578C20.1133 15.1295 20.0023 14.8335 20.0023 14.5251V10.5222C13.742 10.5222 10.4731 12.3602 8.97434 13.6061C8.72763 13.8096 8.36373 13.7788 8.16019 13.5321C8.05534 13.4026 8.006 13.2422 8.03067 13.0757C8.79547 8.345 12.9155 4.73068 20.0023 4.73068V1.25206C20.0023 0.561267 20.5574 0 21.2482 0C21.5566 0 21.8465 0.11102 22.0809 0.314556L29.5809 6.95108C30.099 7.41366 30.1483 8.21548 29.6796 8.73357C29.6487 8.77057 29.6117 8.80141 29.5809 8.83225Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CalanderIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M12.75 0.85C12.75 0.37995 12.3692 0 11.9 0C11.4308 0 11.05 0.37995 11.05 0.85H5.95C5.95 0.37995 5.5692 0 5.1 0C4.6308 0 4.25 0.37995 4.25 0.85C1.90655 0.85 0 2.75655 0 5.1V12.75C0 15.0935 1.90655 17 4.25 17H12.75C15.0935 17 17 15.0935 17 12.75V5.1C17 2.75655 15.0935 0.85 12.75 0.85ZM4.25 2.55V3.4C4.25 3.87005 4.6308 4.25 5.1 4.25C5.5692 4.25 5.95 3.87005 5.95 3.4V2.55H11.05V3.4C11.05 3.87005 11.4308 4.25 11.9 4.25C12.3692 4.25 12.75 3.87005 12.75 3.4V2.55C14.1559 2.55 15.3 3.6941 15.3 5.1H1.7C1.7 3.6941 2.8441 2.55 4.25 2.55ZM12.75 15.3H4.25C2.8441 15.3 1.7 14.1559 1.7 12.75V6.8H15.3V12.75C15.3 14.1559 14.1559 15.3 12.75 15.3ZM12.75 9.35C12.75 9.8192 12.3692 10.2 11.9 10.2C11.4308 10.2 11.05 9.8192 11.05 9.35C11.05 8.8808 11.4308 8.5 11.9 8.5C12.3692 8.5 12.75 8.8808 12.75 9.35ZM9.35 9.35C9.35 9.8192 8.9692 10.2 8.5 10.2C8.0308 10.2 7.65 9.8192 7.65 9.35C7.65 8.8808 8.0308 8.5 8.5 8.5C8.9692 8.5 9.35 8.8808 9.35 9.35ZM5.95 9.35C5.95 9.8192 5.5692 10.2 5.1 10.2C4.6308 10.2 4.25 9.8192 4.25 9.35C4.25 8.8808 4.6308 8.5 5.1 8.5C5.5692 8.5 5.95 8.8808 5.95 9.35ZM12.75 12.75C12.75 13.2192 12.3692 13.6 11.9 13.6C11.4308 13.6 11.05 13.2192 11.05 12.75C11.05 12.2808 11.4308 11.9 11.9 11.9C12.3692 11.9 12.75 12.2808 12.75 12.75ZM9.35 12.75C9.35 13.2192 8.9692 13.6 8.5 13.6C8.0308 13.6 7.65 13.2192 7.65 12.75C7.65 12.2808 8.0308 11.9 8.5 11.9C8.9692 11.9 9.35 12.2808 9.35 12.75ZM5.95 12.75C5.95 13.2192 5.5692 13.6 5.1 13.6C4.6308 13.6 4.25 13.2192 4.25 12.75C4.25 12.2808 4.6308 11.9 5.1 11.9C5.5692 11.9 5.95 12.2808 5.95 12.75Z"
        fill="#0BD26E"
      />
    </svg>
  );
};
export const QrcodeImgDot: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="4" fill="#02BF90" />
    </svg>
  );
};

export const QrcodeImg: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M0.798687 5.59831C1.24115 5.59831 1.59737 5.23834 1.59737 4.79962V2.39981C1.59737 1.95735 1.95735 1.60112 2.39606 1.60112H4.79587C5.23834 1.60112 5.59456 1.24115 5.59456 0.802437C5.59456 0.363721 5.24208 0 4.79962 0H2.39981C1.07616 0 0 1.07616 0 2.39981V4.79962C0 5.24209 0.359971 5.59831 0.798687 5.59831Z"
        fill="#0BD26E"
      />
      <path
        d="M15.1975 10.398C14.755 10.398 14.3988 10.7579 14.3988 11.1966V13.5965C14.3988 14.0389 14.0388 14.3951 13.6001 14.3951H11.2003C10.7578 14.3951 10.4016 14.7551 10.4016 15.1938C10.4016 15.6325 10.7616 15.9925 11.2003 15.9925H13.6001C14.9238 15.9925 15.9999 14.9164 15.9999 13.5927V11.1929C15.9999 10.7579 15.64 10.398 15.1975 10.398Z"
        fill="#0BD26E"
      />
      <path
        d="M4.79962 14.3989H2.39981C1.95735 14.3989 1.60112 14.0389 1.60112 13.6002V11.2004C1.60112 10.7579 1.24115 10.4017 0.802436 10.4017C0.363721 10.4017 0 10.7579 0 11.2004V13.6002C0 14.9238 1.07616 16 2.39981 16H4.79962C5.24208 16 5.59831 15.64 5.59831 15.2013C5.59831 14.7626 5.24208 14.3989 4.79962 14.3989Z"
        fill="#0BD26E"
      />
      <path
        d="M13.6001 0H11.2003C10.7578 0 10.4016 0.359972 10.4016 0.798687C10.4016 1.2374 10.7616 1.59737 11.2003 1.59737H13.6001C14.0426 1.59737 14.3988 1.95735 14.3988 2.39606V4.79587C14.3988 5.23834 14.7588 5.59456 15.1975 5.59456C15.6362 5.59456 15.9962 5.23459 15.9962 4.79587V2.39981C15.9999 1.07616 14.9238 0 13.6001 0Z"
        fill="#0BD26E"
      />
      <path
        d="M15.1975 7.19943H0.798687C0.359971 7.19943 0 7.5594 0 7.99812C0 8.44058 0.359971 8.79681 0.798687 8.79681H15.1975C15.64 8.79681 15.9962 8.43683 15.9962 7.99812C16 7.5594 15.64 7.19943 15.1975 7.19943Z"
        fill="#0BD26E"
      />
    </svg>
  );
};

export const AlarmIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <rect width="20" height="20" rx="5.22876" fill="#02BF90" />
      <path
        d="M5.81422 8.00105C6.37829 7.13986 7.25805 6.50478 8.28724 6.25595C8.36654 6.23695 8.43186 6.1808 8.46245 6.10543C8.49325 6.02984 8.48582 5.9442 8.44257 5.87495C8.11312 5.34976 7.53026 5 6.86438 5C5.83497 5 5 5.83453 5 6.86394C5 7.30087 5.15096 7.70219 5.40307 8.01962C5.45353 8.08363 5.53174 8.11902 5.61323 8.11531C5.69472 8.11159 5.76965 8.06899 5.81422 8.00105Z"
        fill="white"
      />
      <path
        d="M12.5437 5C11.8809 5 11.3 5.34648 10.9699 5.86818C10.9262 5.93721 10.9185 6.02351 10.9493 6.09953C10.9804 6.17578 11.0459 6.2317 11.1261 6.25049C12.1581 6.49342 13.0409 7.12413 13.6098 7.98248C13.655 8.05064 13.7304 8.0928 13.8123 8.09564C13.8942 8.0987 13.972 8.062 14.0223 7.99712C14.2637 7.6834 14.4081 7.29104 14.4081 6.86416C14.4074 5.83453 13.5731 5 12.5437 5Z"
        fill="white"
      />
      <path
        d="M13.8261 10.7095C13.8261 9.98983 13.6389 9.31347 13.3125 8.72492C12.7076 7.63478 11.6212 6.85115 10.3425 6.65497C10.1387 6.62373 9.93179 6.60254 9.71922 6.60254C9.49726 6.60254 9.28098 6.62526 9.06842 6.65934C7.7952 6.8636 6.71424 7.65051 6.11565 8.74196C5.79516 9.32657 5.6123 9.99682 5.6123 10.7095C5.6123 11.9298 6.15038 13.0245 6.99803 13.7769L6.65198 14.2643C6.50299 14.4743 6.55236 14.7648 6.7623 14.9142C6.84423 14.9724 6.93839 15.0005 7.03167 15.0005C7.1776 15.0005 7.32135 14.9322 7.41202 14.8044L7.75785 14.3172C8.34093 14.6355 9.00921 14.8168 9.71922 14.8168C10.429 14.8168 11.0973 14.6355 11.6804 14.3172L12.0262 14.8044C12.1171 14.9324 12.2606 15.0005 12.4066 15.0005C12.4998 15.0005 12.5938 14.9724 12.6757 14.9142C12.8856 14.7648 12.9352 14.4743 12.7862 14.2643L12.4402 13.7769C13.2878 13.0245 13.8261 11.9298 13.8261 10.7095ZM9.71944 13.6679C8.08795 13.6679 6.76099 12.3409 6.76099 10.7095C6.76099 10.2009 6.8901 9.72221 7.11687 9.30364C7.54856 8.50755 8.3359 7.93408 9.2635 7.78968C9.4125 7.76652 9.56389 7.75079 9.71944 7.75079C9.86581 7.75079 10.0089 7.76499 10.1498 7.78574C11.0853 7.92294 11.8811 8.49641 12.3179 9.29599C12.5472 9.7161 12.6777 10.1974 12.6777 10.7092C12.6777 12.3409 11.3507 13.6679 9.71944 13.6679Z"
        fill="white"
      />
      <path
        d="M11.3761 11.4013L10.2475 10.7044C10.2242 10.5724 10.1527 10.4586 10.0524 10.378L10.104 8.96191C10.1103 8.78102 9.96921 8.62919 9.78854 8.62241C9.6083 8.61411 9.45582 8.75699 9.44904 8.93788L9.39727 10.3555C9.25723 10.4542 9.16504 10.6168 9.16504 10.8014C9.16504 11.1031 9.4095 11.3473 9.7112 11.3473C9.79706 11.3473 9.87723 11.3257 9.94933 11.2905L11.0318 11.9595C11.0856 11.9922 11.1452 12.0082 11.2038 12.0082C11.3136 12.0082 11.4207 11.9531 11.4829 11.8529C11.5782 11.6984 11.5301 11.4965 11.3761 11.4013Z"
        fill="white"
      />
    </svg>
  );
};

export const TodoCheckIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <rect width="20" height="20" rx="6" fill="#02BF90" />
      <path
        d="M5.90909 11.3636L7.324 12.4248C7.75269 12.7463 8.35863 12.6728 8.69796 12.2581L13 7"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const TodoUnCheckIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <rect
        x="1"
        y="1"
        width="18"
        height="18"
        rx="5"
        stroke="#181818"
        strokeWidth="2"
      />
    </svg>
  );
};

export const RatingStarIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        d="M6 0L7.854 3.94953L12 4.58675L9 7.65931L9.708 12L6 9.94953L2.292 12L3 7.65931L0 4.58675L4.146 3.94953L6 0Z"
        fill="#FFA873"
      />
    </svg>
  );
};

export const NoImageIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="270"
      height="200"
      viewBox="0 0 292 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
    >
      <rect width="292" height="219" rx="17" fill="#CDD4D8" />
      <path
        d="M78.515 123H73.195L61.149 104.798V123H55.829V96.438H61.149L73.195 114.678V96.438H78.515V123ZM93.1204 123.342C91.0937 123.342 89.2697 122.899 87.6484 122.012C86.0271 121.1 84.7477 119.821 83.8104 118.174C82.8984 116.527 82.4424 114.627 82.4424 112.474C82.4424 110.321 82.9111 108.421 83.8484 106.774C84.8111 105.127 86.1157 103.861 87.7624 102.974C89.4091 102.062 91.2457 101.606 93.2724 101.606C95.2991 101.606 97.1357 102.062 98.7824 102.974C100.429 103.861 101.721 105.127 102.658 106.774C103.621 108.421 104.102 110.321 104.102 112.474C104.102 114.627 103.608 116.527 102.62 118.174C101.658 119.821 100.34 121.1 98.6684 122.012C97.0217 122.899 95.1724 123.342 93.1204 123.342ZM93.1204 118.706C94.0831 118.706 94.9824 118.478 95.8184 118.022C96.6797 117.541 97.3637 116.831 97.8704 115.894C98.3771 114.957 98.6304 113.817 98.6304 112.474C98.6304 110.473 98.0984 108.94 97.0344 107.876C95.9957 106.787 94.7164 106.242 93.1964 106.242C91.6764 106.242 90.3971 106.787 89.3584 107.876C88.3451 108.94 87.8384 110.473 87.8384 112.474C87.8384 114.475 88.3324 116.021 89.3204 117.11C90.3337 118.174 91.6004 118.706 93.1204 118.706ZM122.38 96.476V123H117.06V96.476H122.38ZM153.78 101.644C156.364 101.644 158.441 102.442 160.012 104.038C161.608 105.609 162.406 107.813 162.406 110.65V123H157.086V111.372C157.086 109.725 156.668 108.471 155.832 107.61C154.996 106.723 153.856 106.28 152.412 106.28C150.968 106.28 149.815 106.723 148.954 107.61C148.118 108.471 147.7 109.725 147.7 111.372V123H142.38V111.372C142.38 109.725 141.962 108.471 141.126 107.61C140.29 106.723 139.15 106.28 137.706 106.28C136.236 106.28 135.071 106.723 134.21 107.61C133.374 108.471 132.956 109.725 132.956 111.372V123H127.636V101.948H132.956V104.494C133.64 103.607 134.514 102.911 135.578 102.404C136.667 101.897 137.858 101.644 139.15 101.644C140.796 101.644 142.266 101.999 143.558 102.708C144.85 103.392 145.85 104.38 146.56 105.672C147.244 104.456 148.232 103.481 149.524 102.746C150.841 102.011 152.26 101.644 153.78 101.644ZM166.086 112.398C166.086 110.27 166.504 108.383 167.34 106.736C168.201 105.089 169.354 103.823 170.798 102.936C172.267 102.049 173.901 101.606 175.7 101.606C177.271 101.606 178.639 101.923 179.804 102.556C180.995 103.189 181.945 103.987 182.654 104.95V101.948H188.012V123H182.654V119.922C181.97 120.91 181.02 121.733 179.804 122.392C178.613 123.025 177.233 123.342 175.662 123.342C173.889 123.342 172.267 122.886 170.798 121.974C169.354 121.062 168.201 119.783 167.34 118.136C166.504 116.464 166.086 114.551 166.086 112.398ZM182.654 112.474C182.654 111.182 182.401 110.08 181.894 109.168C181.387 108.231 180.703 107.521 179.842 107.04C178.981 106.533 178.056 106.28 177.068 106.28C176.08 106.28 175.168 106.521 174.332 107.002C173.496 107.483 172.812 108.193 172.28 109.13C171.773 110.042 171.52 111.131 171.52 112.398C171.52 113.665 171.773 114.779 172.28 115.742C172.812 116.679 173.496 117.401 174.332 117.908C175.193 118.415 176.105 118.668 177.068 118.668C178.056 118.668 178.981 118.427 179.842 117.946C180.703 117.439 181.387 116.73 181.894 115.818C182.401 114.881 182.654 113.766 182.654 112.474ZM201.454 101.606C203.025 101.606 204.405 101.923 205.596 102.556C206.787 103.164 207.724 103.962 208.408 104.95V101.948H213.766V123.152C213.766 125.103 213.373 126.838 212.588 128.358C211.803 129.903 210.625 131.119 209.054 132.006C207.483 132.918 205.583 133.374 203.354 133.374C200.365 133.374 197.907 132.677 195.982 131.284C194.082 129.891 193.005 127.991 192.752 125.584H198.034C198.313 126.547 198.908 127.307 199.82 127.864C200.757 128.447 201.885 128.738 203.202 128.738C204.747 128.738 206.001 128.269 206.964 127.332C207.927 126.42 208.408 125.027 208.408 123.152V119.884C207.724 120.872 206.774 121.695 205.558 122.354C204.367 123.013 202.999 123.342 201.454 123.342C199.681 123.342 198.059 122.886 196.59 121.974C195.121 121.062 193.955 119.783 193.094 118.136C192.258 116.464 191.84 114.551 191.84 112.398C191.84 110.27 192.258 108.383 193.094 106.736C193.955 105.089 195.108 103.823 196.552 102.936C198.021 102.049 199.655 101.606 201.454 101.606ZM208.408 112.474C208.408 111.182 208.155 110.08 207.648 109.168C207.141 108.231 206.457 107.521 205.596 107.04C204.735 106.533 203.81 106.28 202.822 106.28C201.834 106.28 200.922 106.521 200.086 107.002C199.25 107.483 198.566 108.193 198.034 109.13C197.527 110.042 197.274 111.131 197.274 112.398C197.274 113.665 197.527 114.779 198.034 115.742C198.566 116.679 199.25 117.401 200.086 117.908C200.947 118.415 201.859 118.668 202.822 118.668C203.81 118.668 204.735 118.427 205.596 117.946C206.457 117.439 207.141 116.73 207.648 115.818C208.155 114.881 208.408 113.766 208.408 112.474ZM238.532 112.018C238.532 112.778 238.481 113.462 238.38 114.07H222.99C223.117 115.59 223.649 116.781 224.586 117.642C225.523 118.503 226.676 118.934 228.044 118.934C230.02 118.934 231.426 118.085 232.262 116.388H238C237.392 118.415 236.227 120.087 234.504 121.404C232.781 122.696 230.666 123.342 228.158 123.342C226.131 123.342 224.307 122.899 222.686 122.012C221.09 121.1 219.836 119.821 218.924 118.174C218.037 116.527 217.594 114.627 217.594 112.474C217.594 110.295 218.037 108.383 218.924 106.736C219.811 105.089 221.052 103.823 222.648 102.936C224.244 102.049 226.081 101.606 228.158 101.606C230.159 101.606 231.945 102.037 233.516 102.898C235.112 103.759 236.341 104.988 237.202 106.584C238.089 108.155 238.532 109.966 238.532 112.018ZM233.022 110.498C232.997 109.13 232.503 108.041 231.54 107.23C230.577 106.394 229.399 105.976 228.006 105.976C226.689 105.976 225.574 106.381 224.662 107.192C223.775 107.977 223.231 109.079 223.028 110.498H233.022Z"
        fill="#797979"
      />
    </svg>
  );
};

export const PreviousIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.81081 14.949C9.06194 15.1894 9.06194 15.5791 8.81081 15.8195C8.68568 15.9393 8.52109 16 8.35653 16C8.19196 16 8.02738 15.9401 7.90224 15.8195L0.188348 8.43519C-0.0627825 8.19479 -0.0627825 7.80503 0.188348 7.56463L7.90224 0.180301C8.15337 -0.0601002 8.56052 -0.0601002 8.81165 0.180301C9.06278 0.420702 9.06278 0.810459 8.81165 1.05086L1.552 8.00031L8.81081 14.949Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const NextIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.81154 8.43557L1.09701 15.8195C0.971866 15.9393 0.807265 16 0.642688 16C0.478111 16 0.31351 15.9401 0.188363 15.8195C-0.0627877 15.5791 -0.0627877 15.1894 0.188363 14.949L7.44862 7.99991L0.188363 1.05081C-0.0627877 0.810418 -0.0627877 0.420681 0.188363 0.180292C0.439514 -0.0600972 0.846699 -0.0600972 1.09785 0.180292L8.81238 7.56425C9.06267 7.80546 9.06269 8.19518 8.81154 8.43557Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const SelectImageIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="350"
      height="200"
      viewBox="0 0 292 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
    >
      <rect width="292" height="219" rx="17" fill="#CDD4D8" />
      <path
        d="M31.9597 123.266C30.1104 123.266 28.4384 122.949 26.9437 122.316C25.4744 121.683 24.309 120.771 23.4477 119.58C22.5864 118.389 22.143 116.983 22.1177 115.362H27.8177C27.8937 116.451 28.2737 117.313 28.9577 117.946C29.667 118.579 30.6297 118.896 31.8457 118.896C33.087 118.896 34.0624 118.605 34.7717 118.022C35.481 117.414 35.8357 116.629 35.8357 115.666C35.8357 114.881 35.595 114.235 35.1137 113.728C34.6324 113.221 34.0244 112.829 33.2897 112.55C32.5804 112.246 31.5924 111.917 30.3257 111.562C28.603 111.055 27.197 110.561 26.1077 110.08C25.0437 109.573 24.119 108.826 23.3337 107.838C22.5737 106.825 22.1937 105.482 22.1937 103.81C22.1937 102.239 22.5864 100.871 23.3717 99.706C24.157 98.5407 25.259 97.654 26.6777 97.046C28.0964 96.4127 29.7177 96.096 31.5417 96.096C34.2777 96.096 36.4944 96.7673 38.1917 98.11C39.9144 99.4273 40.8644 101.277 41.0417 103.658H35.1897C35.139 102.746 34.7464 101.999 34.0117 101.416C33.3024 100.808 32.3524 100.504 31.1617 100.504C30.123 100.504 29.287 100.77 28.6537 101.302C28.0457 101.834 27.7417 102.607 27.7417 103.62C27.7417 104.329 27.9697 104.925 28.4257 105.406C28.907 105.862 29.4897 106.242 30.1737 106.546C30.883 106.825 31.871 107.154 33.1377 107.534C34.8604 108.041 36.2664 108.547 37.3557 109.054C38.445 109.561 39.3824 110.321 40.1677 111.334C40.953 112.347 41.3457 113.677 41.3457 115.324C41.3457 116.743 40.9784 118.06 40.2437 119.276C39.509 120.492 38.4324 121.467 37.0137 122.202C35.595 122.911 33.9104 123.266 31.9597 123.266ZM65.5279 112.018C65.5279 112.778 65.4773 113.462 65.3759 114.07H49.9859C50.1126 115.59 50.6446 116.781 51.5819 117.642C52.5193 118.503 53.6719 118.934 55.0399 118.934C57.0159 118.934 58.4219 118.085 59.2579 116.388H64.9959C64.3879 118.415 63.2226 120.087 61.4999 121.404C59.7773 122.696 57.6619 123.342 55.1539 123.342C53.1273 123.342 51.3033 122.899 49.6819 122.012C48.0859 121.1 46.8319 119.821 45.9199 118.174C45.0333 116.527 44.5899 114.627 44.5899 112.474C44.5899 110.295 45.0333 108.383 45.9199 106.736C46.8066 105.089 48.0479 103.823 49.6439 102.936C51.2399 102.049 53.0766 101.606 55.1539 101.606C57.1553 101.606 58.9413 102.037 60.5119 102.898C62.1079 103.759 63.3366 104.988 64.1979 106.584C65.0846 108.155 65.5279 109.966 65.5279 112.018ZM60.0179 110.498C59.9926 109.13 59.4986 108.041 58.5359 107.23C57.5733 106.394 56.3953 105.976 55.0019 105.976C53.6846 105.976 52.5699 106.381 51.6579 107.192C50.7713 107.977 50.2266 109.079 50.0239 110.498H60.0179ZM74.7311 94.88V123H69.4111V94.88H74.7311ZM99.5572 112.018C99.5572 112.778 99.5066 113.462 99.4052 114.07H84.0152C84.1419 115.59 84.6739 116.781 85.6112 117.642C86.5486 118.503 87.7012 118.934 89.0692 118.934C91.0452 118.934 92.4512 118.085 93.2872 116.388H99.0252C98.4172 118.415 97.2519 120.087 95.5292 121.404C93.8066 122.696 91.6912 123.342 89.1832 123.342C87.1566 123.342 85.3326 122.899 83.7112 122.012C82.1152 121.1 80.8612 119.821 79.9492 118.174C79.0626 116.527 78.6192 114.627 78.6192 112.474C78.6192 110.295 79.0626 108.383 79.9492 106.736C80.8359 105.089 82.0772 103.823 83.6732 102.936C85.2692 102.049 87.1059 101.606 89.1832 101.606C91.1846 101.606 92.9706 102.037 94.5412 102.898C96.1372 103.759 97.3659 104.988 98.2272 106.584C99.1139 108.155 99.5572 109.966 99.5572 112.018ZM94.0472 110.498C94.0219 109.13 93.5279 108.041 92.5652 107.23C91.6026 106.394 90.4246 105.976 89.0312 105.976C87.7139 105.976 86.5992 106.381 85.6872 107.192C84.8006 107.977 84.2559 109.079 84.0532 110.498H94.0472ZM102.072 112.474C102.072 110.295 102.516 108.395 103.402 106.774C104.289 105.127 105.518 103.861 107.088 102.974C108.659 102.062 110.458 101.606 112.484 101.606C115.094 101.606 117.247 102.265 118.944 103.582C120.667 104.874 121.82 106.698 122.402 109.054H116.664C116.36 108.142 115.841 107.433 115.106 106.926C114.397 106.394 113.51 106.128 112.446 106.128C110.926 106.128 109.723 106.685 108.836 107.8C107.95 108.889 107.506 110.447 107.506 112.474C107.506 114.475 107.95 116.033 108.836 117.148C109.723 118.237 110.926 118.782 112.446 118.782C114.6 118.782 116.006 117.819 116.664 115.894H122.402C121.82 118.174 120.667 119.985 118.944 121.328C117.222 122.671 115.068 123.342 112.484 123.342C110.458 123.342 108.659 122.899 107.088 122.012C105.518 121.1 104.289 119.833 103.402 118.212C102.516 116.565 102.072 114.653 102.072 112.474ZM132.494 106.318V116.502C132.494 117.211 132.658 117.731 132.988 118.06C133.342 118.364 133.925 118.516 134.736 118.516H137.206V123H133.862C129.378 123 127.136 120.821 127.136 116.464V106.318H124.628V101.948H127.136V96.742H132.494V101.948H137.206V106.318H132.494ZM155.407 96.476V123H150.087V96.476H155.407ZM186.807 101.644C189.391 101.644 191.468 102.442 193.039 104.038C194.635 105.609 195.433 107.813 195.433 110.65V123H190.113V111.372C190.113 109.725 189.695 108.471 188.859 107.61C188.023 106.723 186.883 106.28 185.439 106.28C183.995 106.28 182.842 106.723 181.981 107.61C181.145 108.471 180.727 109.725 180.727 111.372V123H175.407V111.372C175.407 109.725 174.989 108.471 174.153 107.61C173.317 106.723 172.177 106.28 170.733 106.28C169.264 106.28 168.098 106.723 167.237 107.61C166.401 108.471 165.983 109.725 165.983 111.372V123H160.663V101.948H165.983V104.494C166.667 103.607 167.541 102.911 168.605 102.404C169.694 101.897 170.885 101.644 172.177 101.644C173.824 101.644 175.293 101.999 176.585 102.708C177.877 103.392 178.878 104.38 179.587 105.672C180.271 104.456 181.259 103.481 182.551 102.746C183.868 102.011 185.287 101.644 186.807 101.644ZM199.113 112.398C199.113 110.27 199.531 108.383 200.367 106.736C201.229 105.089 202.381 103.823 203.825 102.936C205.295 102.049 206.929 101.606 208.727 101.606C210.298 101.606 211.666 101.923 212.831 102.556C214.022 103.189 214.972 103.987 215.681 104.95V101.948H221.039V123H215.681V119.922C214.997 120.91 214.047 121.733 212.831 122.392C211.641 123.025 210.26 123.342 208.689 123.342C206.916 123.342 205.295 122.886 203.825 121.974C202.381 121.062 201.229 119.783 200.367 118.136C199.531 116.464 199.113 114.551 199.113 112.398ZM215.681 112.474C215.681 111.182 215.428 110.08 214.921 109.168C214.415 108.231 213.731 107.521 212.869 107.04C212.008 106.533 211.083 106.28 210.095 106.28C209.107 106.28 208.195 106.521 207.359 107.002C206.523 107.483 205.839 108.193 205.307 109.13C204.801 110.042 204.547 111.131 204.547 112.398C204.547 113.665 204.801 114.779 205.307 115.742C205.839 116.679 206.523 117.401 207.359 117.908C208.221 118.415 209.133 118.668 210.095 118.668C211.083 118.668 212.008 118.427 212.869 117.946C213.731 117.439 214.415 116.73 214.921 115.818C215.428 114.881 215.681 113.766 215.681 112.474ZM234.481 101.606C236.052 101.606 237.433 101.923 238.623 102.556C239.814 103.164 240.751 103.962 241.435 104.95V101.948H246.793V123.152C246.793 125.103 246.401 126.838 245.615 128.358C244.83 129.903 243.652 131.119 242.081 132.006C240.511 132.918 238.611 133.374 236.381 133.374C233.392 133.374 230.935 132.677 229.009 131.284C227.109 129.891 226.033 127.991 225.779 125.584H231.061C231.34 126.547 231.935 127.307 232.847 127.864C233.785 128.447 234.912 128.738 236.229 128.738C237.775 128.738 239.029 128.269 239.991 127.332C240.954 126.42 241.435 125.027 241.435 123.152V119.884C240.751 120.872 239.801 121.695 238.585 122.354C237.395 123.013 236.027 123.342 234.481 123.342C232.708 123.342 231.087 122.886 229.617 121.974C228.148 121.062 226.983 119.783 226.121 118.136C225.285 116.464 224.867 114.551 224.867 112.398C224.867 110.27 225.285 108.383 226.121 106.736C226.983 105.089 228.135 103.823 229.579 102.936C231.049 102.049 232.683 101.606 234.481 101.606ZM241.435 112.474C241.435 111.182 241.182 110.08 240.675 109.168C240.169 108.231 239.485 107.521 238.623 107.04C237.762 106.533 236.837 106.28 235.849 106.28C234.861 106.28 233.949 106.521 233.113 107.002C232.277 107.483 231.593 108.193 231.061 109.13C230.555 110.042 230.301 111.131 230.301 112.398C230.301 113.665 230.555 114.779 231.061 115.742C231.593 116.679 232.277 117.401 233.113 117.908C233.975 118.415 234.887 118.668 235.849 118.668C236.837 118.668 237.762 118.427 238.623 117.946C239.485 117.439 240.169 116.73 240.675 115.818C241.182 114.881 241.435 113.766 241.435 112.474ZM271.559 112.018C271.559 112.778 271.509 113.462 271.407 114.07H256.017C256.144 115.59 256.676 116.781 257.613 117.642C258.551 118.503 259.703 118.934 261.071 118.934C263.047 118.934 264.453 118.085 265.289 116.388H271.027C270.419 118.415 269.254 120.087 267.531 121.404C265.809 122.696 263.693 123.342 261.185 123.342C259.159 123.342 257.335 122.899 255.713 122.012C254.117 121.1 252.863 119.821 251.951 118.174C251.065 116.527 250.621 114.627 250.621 112.474C250.621 110.295 251.065 108.383 251.951 106.736C252.838 105.089 254.079 103.823 255.675 102.936C257.271 102.049 259.108 101.606 261.185 101.606C263.187 101.606 264.973 102.037 266.543 102.898C268.139 103.759 269.368 104.988 270.229 106.584C271.116 108.155 271.559 109.966 271.559 112.018ZM266.049 110.498C266.024 109.13 265.53 108.041 264.567 107.23C263.605 106.394 262.427 105.976 261.033 105.976C259.716 105.976 258.601 106.381 257.689 107.192C256.803 107.977 256.258 109.079 256.055 110.498H266.049Z"
        fill="#797979"
      />
    </svg>
  );
};

export const OnlineDoctorIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <circle
        cx="8"
        cy="8"
        r="6.5"
        fill="#02BF90"
        stroke="#EAEAEA"
        strokeWidth="3"
      />
    </svg>
  );
};

export const OfflineDoctorIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <circle
        cx="8"
        cy="8"
        r="6.5"
        fill="#797979"
        stroke="#EAEAEA"
        strokeWidth="3"
      />
    </svg>
  );
};

export const ResetIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9031 16L12.0188 15.1156L13.6031 13.5312H5.625C3.2125 13.5312 1.25 11.5688 1.25 9.15625V8H2.5V9.15625C2.5 10.8781 3.90313 12.2812 5.625 12.2812H13.6062L12.0219 10.6969L12.9062 9.8125L16 12.9062L12.9031 16ZM14.7469 8H13.4969V6.84375C13.4969 5.12187 12.0938 3.71875 10.3719 3.71875H2.39375L3.97813 5.30312L3.09375 6.1875L0 3.09375L3.09375 0L3.97813 0.884375L2.39375 2.46875H10.375C12.7875 2.46875 14.75 4.43125 14.75 6.84375V8H14.7469Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const WhatsappSearchIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
}) => {
  return (
    <svg
      className={customClass}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.375 0C14.343 0 18.375 4.032 18.375 9C18.375 13.968 14.343 18 9.375 18C4.407 18 0.375 13.968 0.375 9C0.375 4.032 4.407 0 9.375 0ZM9.375 16C13.242 16 16.375 12.867 16.375 9C16.375 5.132 13.242 2 9.375 2C5.507 2 2.375 5.132 2.375 9C2.375 12.867 5.507 16 9.375 16ZM17.86 16.071L20.689 18.899L19.274 20.314L16.446 17.485L17.86 16.071Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const SendIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1041 0.89627C18.3391 0.13127 17.2571 -0.169708 16.2041 0.0932916L3.0911 3.37125C1.2291 3.83625 -0.0128989 5.43833 0.000101084 7.35733C0.0141011 9.27633 1.2781 10.8613 3.1461 11.3003L7.64109 12.3582L8.69908 16.8523C9.13808 18.7213 10.7231 19.9853 12.6421 19.9983C12.6521 19.9983 12.6631 19.9983 12.6731 19.9983C14.5781 19.9983 16.1661 18.7602 16.6301 16.9082L19.9081 3.79422C20.1701 2.74622 19.8701 1.66227 19.1041 0.89627ZM17.9671 3.31229L14.6891 16.4253C14.3961 17.5953 13.4451 18.0343 12.6561 18.0003C11.8651 17.9943 10.9221 17.5703 10.6461 16.3963L9.57408 11.8412L13.7081 7.70828C14.0991 7.31728 14.0991 6.68522 13.7081 6.29422C13.3171 5.90322 12.6851 5.90322 12.2941 6.29422L8.16007 10.4273L3.60508 9.35525C2.43108 9.07925 2.00608 8.13624 2.00108 7.34524C1.99608 6.55424 2.40713 5.60529 3.57713 5.31229L16.6901 2.03433C16.7851 2.01133 16.8741 2.00125 16.9571 2.00125C17.3331 2.00125 17.5871 2.20829 17.6911 2.31229C17.8161 2.43829 18.0981 2.78929 17.9671 3.31229Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const MicIcon: FC<ISvgComponent> = ({ customClass, fillColor }) => {
  return (
    <svg
      className={customClass}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9997 3C11.204 3 10.441 3.31607 9.87837 3.87868C9.31576 4.44129 8.99969 5.20435 8.99969 6V10C8.99969 10.7956 9.31576 11.5587 9.87837 12.1213C10.441 12.6839 11.204 13 11.9997 13C12.7953 13 13.5584 12.6839 14.121 12.1213C14.6836 11.5587 14.9997 10.7956 14.9997 10V6C14.9997 5.20435 14.6836 4.44129 14.121 3.87868C13.5584 3.31607 12.7953 3 11.9997 3ZM11.9997 1C12.6563 1 13.3065 1.12933 13.9131 1.3806C14.5197 1.63188 15.0709 2.00017 15.5352 2.46447C15.9995 2.92876 16.3678 3.47995 16.6191 4.08658C16.8704 4.69321 16.9997 5.34339 16.9997 6V10C16.9997 11.3261 16.4729 12.5979 15.5352 13.5355C14.5975 14.4732 13.3258 15 11.9997 15C10.6736 15 9.40184 14.4732 8.46415 13.5355C7.52647 12.5979 6.99969 11.3261 6.99969 10V6C6.99969 4.67392 7.52647 3.40215 8.46415 2.46447C9.40184 1.52678 10.6736 1 11.9997 1ZM3.05469 11H5.06969C5.31198 12.6648 6.14556 14.1867 7.41792 15.2873C8.69028 16.3879 10.3164 16.9936 11.9987 16.9936C13.681 16.9936 15.3071 16.3879 16.5795 15.2873C17.8518 14.1867 18.6854 12.6648 18.9277 11H20.9437C20.7163 13.0287 19.8063 14.9199 18.3629 16.3635C16.9195 17.8071 15.0284 18.7174 12.9997 18.945V23H10.9997V18.945C8.97082 18.7176 7.07947 17.8074 5.63586 16.3638C4.19226 14.9202 3.2821 13.0289 3.05469 11Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const EmojiIcon: FC<ISvgComponent> = ({ fillColor, customClass }) => {
  return (
    <svg
      className={customClass}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18V18ZM5 11H7C7 11.7956 7.31607 12.5587 7.87868 13.1213C8.44129 13.6839 9.20435 14 10 14C10.7956 14 11.5587 13.6839 12.1213 13.1213C12.6839 12.5587 13 11.7956 13 11H15C15 12.3261 14.4732 13.5979 13.5355 14.5355C12.5979 15.4732 11.3261 16 10 16C8.67392 16 7.40215 15.4732 6.46447 14.5355C5.52678 13.5979 5 12.3261 5 11V11ZM6 9C5.60218 9 5.22064 8.84196 4.93934 8.56066C4.65804 8.27936 4.5 7.89782 4.5 7.5C4.5 7.10218 4.65804 6.72064 4.93934 6.43934C5.22064 6.15804 5.60218 6 6 6C6.39782 6 6.77936 6.15804 7.06066 6.43934C7.34196 6.72064 7.5 7.10218 7.5 7.5C7.5 7.89782 7.34196 8.27936 7.06066 8.56066C6.77936 8.84196 6.39782 9 6 9ZM14 9C13.6022 9 13.2206 8.84196 12.9393 8.56066C12.658 8.27936 12.5 7.89782 12.5 7.5C12.5 7.10218 12.658 6.72064 12.9393 6.43934C13.2206 6.15804 13.6022 6 14 6C14.3978 6 14.7794 6.15804 15.0607 6.43934C15.342 6.72064 15.5 7.10218 15.5 7.5C15.5 7.89782 15.342 8.27936 15.0607 8.56066C14.7794 8.84196 14.3978 9 14 9Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ThreeDotIcon: FC<ISvgComponent> = ({
  customClass,
  fillColor,
  handleClick,
}) => {
  return (
    <svg
      className={customClass}
      onClick={handleClick}
      width="4"
      height="18"
      viewBox="0 0 4 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.375 0C1.55 0 0.875 0.675 0.875 1.5C0.875 2.325 1.55 3 2.375 3C3.2 3 3.875 2.325 3.875 1.5C3.875 0.675 3.2 0 2.375 0ZM2.375 15C1.55 15 0.875 15.675 0.875 16.5C0.875 17.325 1.55 18 2.375 18C3.2 18 3.875 17.325 3.875 16.5C3.875 15.675 3.2 15 2.375 15ZM2.375 7.5C1.55 7.5 0.875 8.175 0.875 9C0.875 9.825 1.55 10.5 2.375 10.5C3.2 10.5 3.875 9.825 3.875 9C3.875 8.175 3.2 7.5 2.375 7.5Z"
        fill={fillColor ? fillColor : "#181818"}
      />
    </svg>
  );
};

export const NewChatIcon: FC<ISvgComponent> = ({ customClass }) => {
  return (
    <svg
      className={customClass}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.375 3V5H4.375V18.385L6.138 17H20.375V10H22.375V18C22.375 18.2652 22.2696 18.5196 22.0821 18.7071C21.8946 18.8946 21.6402 19 21.375 19H6.83L2.375 22.5V4C2.375 3.73478 2.48036 3.48043 2.66789 3.29289C2.85543 3.10536 3.10978 3 3.375 3H14.375ZM19.375 3V0H21.375V3H24.375V5H21.375V8H19.375V5H16.375V3H19.375Z"
        fill="#02BF90"
      />
    </svg>
  );
};
export const OnlineofflineIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="5" r="5" fill={fillColor} />
    </svg>
  );
};
export const SearchButton: React.FunctionComponent<ISvgComponent> = ({
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      width={width ? width : "42"}
      height={height ? height : "42"}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <rect width="42" height="42" rx="4" fill="#02BF90" />
      <path
        d="M29.7068 28.293L25.1678 23.754C26.3108 22.306 26.9998 20.483 26.9998 18.5C26.9998 13.813 23.1868 10 18.4999 10C13.813 10 10 13.813 10 18.5C10 23.187 13.813 27 18.4999 27C20.4839 27 22.3058 26.312 23.7538 25.168L28.2928 29.707C28.4878 29.902 28.7438 30 28.9998 30C29.2558 30 29.5118 29.902 29.7068 29.707C30.0977 29.316 30.0977 28.684 29.7068 28.293ZM12 18.5C12 14.916 14.9159 12 18.4999 12C22.0838 12 24.9998 14.916 24.9998 18.5C24.9998 22.084 22.0838 25 18.4999 25C14.9159 25 12 22.084 12 18.5Z"
        fill="white"
      />
    </svg>
  );
};

export const ReloadIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.81818C11.3636 1.81818 12.8182 2.18182 14 2.90909L13 3.90909C12.6364 4.27273 12.6364 4.81818 13 5.18182C13.1818 5.36364 13.3636 5.45455 13.6364 5.45455H17.2727C17.8182 5.45455 18.1818 5.09091 18.1818 4.54545V0.909091C18.1818 0.363636 17.8182 0 17.2727 0C17 0 16.8182 0.0909091 16.6364 0.272727L15.3636 1.54545C10.6364 -1.36364 4.54545 0 1.54545 4.63636C0.545455 6.27273 0 8.09091 0 10C0 10.5455 0.363636 10.9091 0.909091 10.9091C1.45455 10.9091 1.81818 10.5455 1.81818 10C1.81818 5.45455 5.45455 1.81818 10 1.81818Z"
        fill="white"
      />
      <path
        d="M19.0909 9.09091C18.5455 9.09091 18.1818 9.45455 18.1818 10C18.1818 14.5455 14.5455 18.1818 10 18.1818C8.63636 18.1818 7.18182 17.8182 6 17.0909L7 16.0909C7.36364 15.7273 7.36364 15.1818 7 14.8182C6.81818 14.6364 6.63636 14.5455 6.36364 14.5455H2.72727C2.18182 14.5455 1.81818 14.9091 1.81818 15.4545V19.0909C1.81818 19.4545 2 19.8182 2.36364 19.9091C2.45455 20 2.63636 20 2.72727 20C3 20 3.18182 19.9091 3.36364 19.7273L4.63636 18.4545C6.27273 19.4545 8.09091 20 10 20C15.5455 20 20 15.5455 20 10C20 9.54545 19.6364 9.09091 19.0909 9.09091Z"
        fill="white"
      />
    </svg>
  );
};

export const DoctorIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1883_6396)">
        <path
          d="M8.768 29.9987C9.24843 29.9987 9.74239 29.9987 10.2431 29.9987H19.7569C20.2576 29.9987 20.7516 29.9987 21.232 29.9987C25.637 29.9987 29 29.7839 29 25.3503C29 20.7148 25.3122 16.9128 20.6095 16.4961C20.5689 18.1172 15 22.1211 15 22.1211C15 22.1211 9.42436 18.1172 9.39053 16.4961C4.68777 16.9063 1 20.7148 1 25.3503C1 29.7839 4.36298 29.9987 8.768 29.9987ZM19.1547 23.9505C19.1547 23.8203 19.2765 23.7096 19.4321 23.7096H20.9343V22.2643C20.9343 22.1146 21.0425 21.9974 21.1846 21.9974H22.6665C22.8018 21.9974 22.9169 22.1146 22.9169 22.2643V23.7096H24.419C24.5747 23.7096 24.6965 23.8138 24.6965 23.9505V25.3763C24.6965 25.5065 24.5747 25.6172 24.419 25.6172H22.9169V27.0625C22.9169 27.2122 22.8086 27.3294 22.6665 27.3294H21.1846C21.0493 27.3294 20.9343 27.2122 20.9343 27.0625V25.6172H19.4321C19.2765 25.6172 19.1547 25.513 19.1547 25.3763V23.9505Z"
          fill={fillColor}
        />
        <path
          d="M14.9992 17.6628C19.2553 17.6628 22.7063 11.5039 22.7063 7.40885C22.7063 3.32031 19.2553 0 14.9992 0C10.743 0 7.29883 3.32031 7.29883 7.41536C7.29883 11.5039 10.743 17.6628 14.9992 17.6628Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1883_6396"
          x1="1.80575"
          y1="16.4961"
          x2="30.7389"
          y2="17.9851"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5936F1" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1883_6396"
          x1="7.74221"
          y1="1.20521e-05"
          x2="23.6978"
          y2="0.345428"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5936F1" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
        <clipPath id="clip0_1883_6396">
          <rect width="28" height="30" fill="white" transform="translate(1)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DiagnosisIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path d="M8.7832 0H14.0625V3.55078H8.7832V0Z" fill="#BBBBBB" />
      <path
        d="M20.2148 1.83984H15.8203V4.42969C15.8203 4.91602 15.4277 5.30859 14.9414 5.30859H7.9043C7.41797 5.30859 7.02539 4.91602 7.02539 4.42969V1.83984H2.63672C1.18359 1.83984 0 3.02344 0 4.47656V7.08984H22.8516V4.47656C22.8516 3.02344 21.668 1.83984 20.2148 1.83984Z"
        fill={fillColor ? fillColor : "#EAEFFE"}
      />
      <path
        d="M0 27.3633C0 28.8164 1.18359 30 2.63672 30H20.2148C21.668 30 22.8516 28.8164 22.8516 27.3633V8.84766H0V27.3633ZM14.9414 12.3633H15.8203V11.4844C15.8203 10.998 16.2129 10.6055 16.6992 10.6055C17.1855 10.6055 17.5781 10.998 17.5781 11.4844V12.3633H18.457C18.9434 12.3633 19.3359 12.7559 19.3359 13.2422C19.3359 13.7285 18.9434 14.1211 18.457 14.1211H17.5781V15.0117C17.5781 15.498 17.1855 15.8906 16.6992 15.8906C16.2129 15.8906 15.8203 15.498 15.8203 15.0117V14.1211H14.9414C14.4551 14.1211 14.0625 13.7285 14.0625 13.2422C14.0625 12.7559 14.4551 12.3633 14.9414 12.3633ZM4.38867 10.6055H11.4199C11.9062 10.6055 12.2988 10.998 12.2988 11.4844C12.2988 11.9707 11.9062 12.3633 11.4199 12.3633H4.38867C3.90234 12.3633 3.50977 11.9707 3.50977 11.4844C3.50977 10.998 3.9082 10.6055 4.38867 10.6055ZM12.3047 15C12.3047 15.4863 11.9121 15.8789 11.4258 15.8789H4.39453C3.9082 15.8789 3.51562 15.4863 3.51562 15C3.51562 14.5137 3.9082 14.1211 4.39453 14.1211H11.4258C11.9121 14.1211 12.3047 14.5137 12.3047 15ZM4.38867 17.6367H18.4512C18.9375 17.6367 19.3301 18.0293 19.3301 18.5156C19.3301 19.002 18.9375 19.3945 18.4512 19.3945H4.38867C3.90234 19.3945 3.50977 19.002 3.50977 18.5156C3.50977 18.0293 3.9082 17.6367 4.38867 17.6367ZM4.38867 21.1523H18.4512C18.9375 21.1523 19.3301 21.5449 19.3301 22.0312C19.3301 22.5176 18.9375 22.9102 18.4512 22.9102H4.38867C3.90234 22.9102 3.50977 22.5176 3.50977 22.0312C3.50977 21.5449 3.9082 21.1523 4.38867 21.1523ZM4.38867 24.668H18.4512C18.9375 24.668 19.3301 25.0605 19.3301 25.5469C19.3301 26.0332 18.9375 26.4258 18.4512 26.4258H4.38867C3.90234 26.4258 3.50977 26.0332 3.50977 25.5469C3.50977 25.0605 3.9082 24.668 4.38867 24.668Z"
        fill={fillColor ? fillColor : "#EAEFFE"}
      />
    </svg>
  );
};

export const FormBuilderIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="28"
      height="30"
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7277 27.5759L12.8906 28.3795C12.6696 28.4263 12.4487 28.4531 12.2277 28.4531C11.3772 28.4531 10.5603 28.1116 9.95759 27.5089C9.1875 26.7388 8.85937 25.6339 9.08705 24.5759L9.89062 20.7388C10.0179 20.1228 10.3192 19.5603 10.7679 19.1183L20.8527 9.04018C21.0335 8.85938 21.2277 8.69866 21.4286 8.54464V3.21429C21.4219 1.43973 19.9888 0.00669643 18.2143 0H3.21429C1.43973 0.00669643 0.00669643 1.43973 0 3.21429V26.7857C0.00669643 28.5603 1.43973 29.9933 3.21429 30H18.2143C19.9888 29.9933 21.4219 28.5603 21.4286 26.7857V23.6116L18.3415 26.6987C17.9062 27.1473 17.3371 27.4554 16.7277 27.5759ZM5.35714 4.28571H16.0714C16.6607 4.28571 17.1429 4.76786 17.1429 5.35714C17.1429 5.94643 16.6607 6.42857 16.0714 6.42857H5.35714C4.76786 6.42857 4.28571 5.94643 4.28571 5.35714C4.28571 4.76786 4.76786 4.28571 5.35714 4.28571ZM5.35714 8.57143H16.0714C16.6607 8.57143 17.1429 9.05357 17.1429 9.64286C17.1429 10.2321 16.6607 10.7143 16.0714 10.7143H5.35714C4.76786 10.7143 4.28571 10.2321 4.28571 9.64286C4.28571 9.05357 4.76786 8.57143 5.35714 8.57143ZM4.28571 13.9286C4.28571 13.3393 4.76786 12.8571 5.35714 12.8571H9.64286C10.2321 12.8571 10.7143 13.3393 10.7143 13.9286C10.7143 14.5179 10.2321 15 9.64286 15H5.35714C4.76786 15 4.28571 14.5179 4.28571 13.9286Z"
        fill="white"
      />
      <path
        d="M26.9196 10.5536C25.6473 9.34152 23.645 9.34152 22.3727 10.5536L12.2745 20.6451C12.1272 20.7924 12.0267 20.9799 11.9866 21.1808L11.183 25.0179C11.0625 25.5937 11.4308 26.1629 12.0133 26.2902C12.087 26.3036 12.1607 26.3103 12.2343 26.3103C12.308 26.3103 12.3817 26.3036 12.4553 26.2835L16.2924 25.4799C16.4933 25.4397 16.6808 25.3393 16.8281 25.192L26.9196 15.1004C28.1718 13.8415 28.1718 11.8058 26.9196 10.5536C26.9129 10.5536 26.9129 10.5536 26.9196 10.5536Z"
        fill="#67CDDF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9350_13263"
          x1="0.616649"
          y1="2.04703e-05"
          x2="22.8111"
          y2="0.393455"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5936F1" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9350_13263"
          x1="11.6407"
          y1="9.64454"
          x2="28.9308"
          y2="10.0745"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5936F1" />
          <stop offset="0.995389" stopColor="#2ADBDF" />
          <stop offset="0.9998" stopColor="#4BB3E7" />
          <stop offset="0.9999" stopColor="#47DAE3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IPDIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9326 5.11848L20.9168 7.2521C21.9309 7.83896 22.3623 7.77398 23.0427 7.41464V3.99093C23.0427 3.5529 22.6555 3.19531 22.1835 3.19531H16.9326L16.1951 4.09359L16.9326 5.11848Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7464 3.22437L5.93497 3.19531H0.85732C0.38535 3.19531 0 3.5529 0 3.99093V29.2043C0 29.6407 0.38535 30 0.85732 30H22.1837C22.6557 30 23.0429 29.6407 23.0429 29.2043V15.4067L20.9171 13.6135L11.7464 3.22437Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3759 5.77594H6.49171C6.18567 5.77594 5.93488 5.54321 5.93488 5.25921V5.11719H2.64016C2.35624 5.11719 2.12573 5.33105 2.12573 5.59454V27.5964C2.12573 27.8599 2.35617 28.0755 2.64016 28.0755H20.4008C20.6847 28.0755 20.917 27.8599 20.917 27.5964V13.6124L20.7917 13.508C17.803 10.986 18.7746 7.88396 20.917 7.25087V5.59459C20.917 5.33111 20.6847 5.11725 20.4008 5.11725H16.9327V5.25927C16.9327 5.54327 16.682 5.77594 16.3759 5.77594Z"
        fill="#F9F7F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9326 5.1176V3.19443V2.55279C16.9326 2.26874 16.6819 2.03607 16.3758 2.03607H13.8204C13.7817 1.26611 13.2986 0.59881 12.6054 0.253176C12.2809 0.0907004 11.9122 0 11.5213 0C11.1286 0 10.7598 0.0907004 10.4372 0.253234C9.74207 0.598868 9.25902 1.26617 9.22034 2.03613H6.49164C6.1856 2.03613 5.93481 2.2688 5.93481 2.55285V3.19443V5.1176V5.25962C5.93481 5.54368 6.18554 5.77635 6.49164 5.77635H16.3759C16.6819 5.77635 16.9327 5.54362 16.9327 5.25962V5.1176H16.9326Z"
        fill="#78E7DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3761 5.77588H13.9976H12.0543C14.5563 12.4522 15.4302 21.9517 11.3315 28.0755H20.4008C20.6848 28.0755 20.9171 27.8599 20.9171 27.5963C20.9171 19.5649 20.9171 11.9646 20.9171 5.59454C20.9171 5.33105 20.6848 5.11719 20.4008 5.11719H16.9328V5.25921C16.9328 5.54321 16.6821 5.77588 16.3761 5.77588Z"
        fill="#DDDAEC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.917 13.6133V27.5973C20.917 27.8608 20.6847 28.0764 20.4007 28.0764H11.3314C10.8539 28.7899 10.3377 29.4349 9.78638 29.9996H22.1836C22.6556 29.9996 23.0427 29.6403 23.0427 29.204V15.4064L20.917 13.6133Z"
        fill="#67CDDF"
      />
      <path
        d="M11.9144 14.6758C11.9089 14.6758 11.9034 14.6758 11.8979 14.6756C11.6994 14.6693 11.525 14.5514 11.4575 14.3776L10.3069 11.418L9.37972 13.2055C9.30513 13.3493 9.15457 13.4458 8.98359 13.4593C8.8125 13.4732 8.64656 13.4016 8.5469 13.2717L7.59704 12.034H5.015C4.7467 12.034 4.5293 11.8318 4.5293 11.5823C4.5293 11.3327 4.74676 11.1305 5.015 11.1305H7.84695C8.00387 11.1305 8.15109 11.201 8.24231 11.3198L8.861 12.126L9.93352 10.0582C10.0185 9.89448 10.2012 9.79371 10.3959 9.80337C10.5911 9.81269 10.7613 9.92993 10.8278 10.1009L11.9584 13.0091L12.7197 11.4003C12.7972 11.2363 12.9717 11.1305 13.1642 11.1305H17.7975C18.0658 11.1305 18.2833 11.3327 18.2833 11.5822C18.2833 11.8318 18.0658 12.034 17.7975 12.034H13.4811L12.3588 14.4059C12.2811 14.5704 12.1063 14.6758 11.9144 14.6758Z"
        fill="#002C5A"
      />
      <path
        d="M18.0261 17.7804H12.8249C12.5566 17.7804 12.3392 17.5782 12.3392 17.3287C12.3392 17.0792 12.5566 16.877 12.8249 16.877H18.0261C18.2944 16.877 18.5118 17.0792 18.5118 17.3287C18.5118 17.5782 18.2943 17.7804 18.0261 17.7804ZM10.216 17.7804H5.01482C4.74652 17.7804 4.52905 17.5782 4.52905 17.3287C4.52905 17.0792 4.74652 16.877 5.01482 16.877H10.216C10.4843 16.877 10.7017 17.0792 10.7017 17.3287C10.7017 17.5782 10.4843 17.7804 10.216 17.7804Z"
        fill="#002C5A"
      />
      <path
        d="M18.0261 20.6574H12.8249C12.5566 20.6574 12.3392 20.4551 12.3392 20.2056C12.3392 19.9562 12.5566 19.7539 12.8249 19.7539H18.0261C18.2944 19.7539 18.5118 19.9562 18.5118 20.2056C18.5118 20.4551 18.2943 20.6574 18.0261 20.6574ZM10.216 20.6574H5.01482C4.74652 20.6574 4.52905 20.4551 4.52905 20.2056C4.52905 19.9562 4.74652 19.7539 5.01482 19.7539H10.216C10.4843 19.7539 10.7017 19.9562 10.7017 20.2056C10.7017 20.4551 10.4843 20.6574 10.216 20.6574Z"
        fill="#002C5A"
      />
      <path
        d="M18.0261 23.5324H12.8249C12.5566 23.5324 12.3392 23.3301 12.3392 23.0806C12.3392 22.8312 12.5566 22.6289 12.8249 22.6289H18.0261C18.2944 22.6289 18.5118 22.8312 18.5118 23.0806C18.5118 23.3301 18.2943 23.5324 18.0261 23.5324ZM10.216 23.5324H5.01482C4.74652 23.5324 4.52905 23.3301 4.52905 23.0806C4.52905 22.8312 4.74652 22.6289 5.01482 22.6289H10.216C10.4843 22.6289 10.7017 22.8312 10.7017 23.0806C10.7017 23.3301 10.4843 23.5324 10.216 23.5324Z"
        fill="#002C5A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9171 7.25154C18.7747 7.88463 17.8031 10.9867 20.7917 13.5087L20.9171 13.613L23.0429 15.4062L24.4534 16.5971L28.1169 13.5087C32.5233 9.79069 28.3196 4.81336 24.4534 8.34317C23.9832 7.91199 23.5075 7.60913 23.0429 7.41408C22.2796 7.09417 21.5476 7.0668 20.9171 7.25154Z"
        fill="#EB5468"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5047 7.1543C28.6275 8.39135 28.6773 10.679 26.3726 12.621L23.0576 15.4185L24.4533 16.5973L28.1168 13.5089C31.3249 10.8022 29.9697 7.42804 27.5047 7.1543Z"
        fill="#E5384F"
      />
      <path
        d="M25.6868 11.0472H24.9391V10.356C24.9391 10.1065 24.7216 9.9043 24.4534 9.9043C24.1851 9.9043 23.9677 10.1066 23.9677 10.356V11.0472H23.2218C22.9535 11.0472 22.7361 11.2495 22.7361 11.4989C22.7361 11.7485 22.9535 11.9507 23.2218 11.9507H23.9677V12.6419C23.9677 12.8914 24.1851 13.0936 24.4534 13.0936C24.7217 13.0936 24.9391 12.8914 24.9391 12.6419V11.9507H25.6868C25.9551 11.9507 26.1726 11.7484 26.1726 11.4989C26.1726 11.2495 25.9551 11.0472 25.6868 11.0472Z"
        fill="#07C3AA"
      />
    </svg>
  );
};

export const DiagnosPlayIcon: FC<ISvgComponent> = ({
  customClass,
  fillColor,
  handleClick,
  style = { cursor: "pointer" },
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      // style={{ cursor: 'pointer' }}
      style={style}
    >
      <path
        d="M12.5 0C5.5957 0 0 5.5957 0 12.5C0 19.4043 5.5957 25 12.5 25C19.4043 25 25 19.4043 25 12.5C25 5.5957 19.4043 0 12.5 0ZM16.8213 13.1641L10.5713 17.0703C10.4443 17.1484 10.3027 17.1875 10.1562 17.1875C10.0244 17.1875 9.89746 17.1533 9.77539 17.0898C9.52637 16.9531 9.375 16.6895 9.375 16.4062V8.59375C9.375 8.31055 9.53125 8.04688 9.77539 7.91016C10.0244 7.77344 10.3271 7.77832 10.5664 7.92969L16.8164 11.8359C17.0459 11.9775 17.1826 12.2314 17.1826 12.5C17.1826 12.7686 17.0508 13.0176 16.8213 13.1641Z"
        // fill="#02BF90"
        fill={fillColor}
      />
    </svg>
  );
};

export const ZoomInICon: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.28 25.0537L19.08 17.867C20.5426 16.0036 21.3363 13.7025 21.3333 11.3337C21.3333 5.44262 16.5577 0.666992 10.6667 0.666992C4.77563 0.666992 0 5.44262 0 11.3337C0 17.2247 4.77563 22.0003 10.6667 22.0003C13.0355 22.0033 15.3366 21.2096 17.2 19.747L24.3867 26.947C24.637 27.1994 24.9778 27.3414 25.3333 27.3414C25.6889 27.3414 26.0296 27.1994 26.28 26.947C26.5324 26.6966 26.6744 26.3558 26.6744 26.0003C26.6744 25.6448 26.5324 25.304 26.28 25.0537ZM2.66667 11.3337C2.66667 6.91538 6.24839 3.33366 10.6667 3.33366C15.0849 3.33366 18.6667 6.91538 18.6667 11.3337C18.6667 15.7519 15.0849 19.3337 10.6667 19.3337C6.24839 19.3337 2.66667 15.7519 2.66667 11.3337ZM14.6667 12.667C15.403 12.667 16 12.07 16 11.3337C16 10.5973 15.403 10.0003 14.6667 10.0003H12V7.33366C12 6.59728 11.403 6.00033 10.6667 6.00033C9.93029 6.00033 9.33333 6.59728 9.33333 7.33366V10.0003H6.66667C5.93029 10.0003 5.33333 10.5973 5.33333 11.3337C5.33333 12.07 5.93029 12.667 6.66667 12.667H9.33333V15.3337C9.33333 16.07 9.93029 16.667 10.6667 16.667C11.403 16.667 12 16.07 12 15.3337V12.667H14.6667Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ZoomOutIcon: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.28 26.947C26.0296 27.1994 25.6889 27.3414 25.3333 27.3414C24.9778 27.3414 24.637 27.1994 24.3867 26.947L17.2 19.747C15.3366 21.2096 13.0355 22.0033 10.6667 22.0003C4.77563 22.0003 0 17.2247 0 11.3337C0 5.44262 4.77563 0.666992 10.6667 0.666992C16.5577 0.666992 21.3333 5.44262 21.3333 11.3337C21.3363 13.7025 20.5426 16.0036 19.08 17.867L26.28 25.0537C26.5324 25.304 26.6744 25.6448 26.6744 26.0003C26.6744 26.3558 26.5324 26.6966 26.28 26.947ZM16 11.3337C16 12.07 15.403 12.667 14.6667 12.667H6.66667C5.93029 12.667 5.33333 12.07 5.33333 11.3337C5.33333 10.5973 5.93029 10.0003 6.66667 10.0003H14.6667C15.403 10.0003 16 10.5973 16 11.3337ZM10.6667 3.33366C15.0849 3.33366 18.6667 6.91538 18.6667 11.3337C18.6667 13.4554 17.8238 15.4902 16.3235 16.9905C14.8232 18.4908 12.7884 19.3337 10.6667 19.3337C6.24839 19.3337 2.66667 15.7519 2.66667 11.3337C2.66667 6.91538 6.24839 3.33366 10.6667 3.33366Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AttachmentLightIcon: React.FunctionComponent<ISvgComponent> = ({
  handleClick,
}) => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <circle opacity="0.2" cx="17.5" cy="17.5" r="17.5" fill="#02BF90" />
      <path
        d="M24.3806 17.281L18.3282 23.3333C17.379 24.3016 16.1114 24.8936 14.7596 24.9997H14.4138C13.2376 25.0132 12.105 24.5546 11.2697 23.7263C9.4304 21.8871 9.61119 18.7115 11.6706 16.6521L17.0941 11.2286C17.4007 10.9238 17.8958 10.9238 18.2024 11.2286C18.3512 11.3762 18.4349 11.5771 18.4349 11.7866C18.4349 11.9962 18.3512 12.1971 18.2024 12.3447L12.771 17.7761C11.3169 19.2224 11.1361 21.3997 12.3623 22.6259C12.975 23.2067 13.8093 23.4934 14.6496 23.4119C15.6219 23.3311 16.5321 22.9011 17.212 22.2015L23.3037 16.1727C24.2159 15.3978 24.3416 14.036 23.5867 13.1072C22.6605 12.3531 21.3012 12.4789 20.5291 13.3901L14.4767 19.4425C14.2788 19.6346 14.1561 19.8911 14.1308 20.1657C14.1088 20.3666 14.1747 20.5672 14.3116 20.7159C14.7118 21.0047 15.267 20.9361 15.585 20.5587L21.9596 14.184C22.2662 13.8793 22.7613 13.8793 23.0679 14.184C23.2167 14.3316 23.3004 14.5325 23.3004 14.7421C23.3004 14.9517 23.2167 15.1526 23.0679 15.3002L16.7011 21.667C15.7789 22.6743 14.2163 22.748 13.2033 21.832C12.2853 20.8211 12.3555 19.2587 13.3605 18.3342L19.3736 12.2818C20.7611 10.7532 23.1209 10.6269 24.6635 11.9989C26.0346 13.5389 25.9083 15.8962 24.3806 17.281Z"
        fill="#02BF90"
      />
    </svg>
  );
};

export const ResetImageIcon: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        d="M21.9874 3.5919C21.9874 3.4132 21.9874 3.30761 21.9874 3.1939C21.9874 2.52785 21.963 1.85368 22.0117 1.18764C22.0605 0.456616 22.6534 -0.0226109 23.3845 0.0180015C24.0587 0.0504915 24.5785 0.602821 24.5948 1.30948C24.6029 1.75621 24.5948 2.20295 24.5948 2.64969C24.5948 4.14423 24.5948 5.63877 24.5948 7.12518C24.5948 7.8887 24.0587 8.44103 23.3033 8.44915C21.3294 8.45727 19.3637 8.45727 17.3899 8.44915C16.732 8.44915 16.204 7.9618 16.1228 7.35261C16.0416 6.69469 16.4152 6.10175 17.0406 5.92305C17.2031 5.87432 17.3818 5.87432 17.5524 5.87432C18.4134 5.8662 19.2825 5.87432 20.1435 5.87432C20.241 5.87432 20.3385 5.87432 20.4359 5.87432C20.4522 5.84995 20.4684 5.82558 20.4766 5.80122C20.1435 5.50068 19.8267 5.18391 19.4693 4.90774C13.3042 0.00987921 4.15803 3.38883 2.65533 11.1214C1.55064 16.8153 5.39268 22.3711 11.1273 23.3702C16.9351 24.3774 22.4423 20.4217 23.287 14.6141C23.3682 14.0618 23.3764 13.5013 23.4089 12.949C23.4495 12.3155 23.9125 11.7956 24.5217 11.7225C25.1877 11.6494 25.7726 12.0149 25.9513 12.6485C25.9919 12.7947 26 12.949 26 13.1033C25.9594 19.3983 21.4107 24.7591 15.213 25.815C8.18689 27.0009 1.51815 22.363 0.218515 15.3858C-1.06487 8.46539 3.43511 1.68311 10.2988 0.294166C14.6038 -0.57494 18.4459 0.489106 21.7518 3.38884C21.8087 3.43757 21.8655 3.48631 21.9874 3.5919Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const TodoAlaramIcon: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <rect
        opacity="0.1"
        x="1.5"
        y="1.5"
        width="35"
        height="35"
        rx="11.5"
        // fill="#FFA873"
        fill={fillColor}
        stroke="white"
        strokeWidth="3"
      />
      <path
        d="M13.2213 16.5016C14.0674 15.2098 15.3871 14.2572 16.9309 13.8839C17.0498 13.8554 17.1478 13.7712 17.1937 13.6581C17.2399 13.5448 17.2287 13.4163 17.1639 13.3124C16.6697 12.5246 15.7954 12 14.7966 12C13.2525 12 12 13.2518 12 14.7959C12 15.4513 12.2264 16.0533 12.6046 16.5294C12.6803 16.6254 12.7976 16.6785 12.9198 16.673C13.0421 16.6674 13.1545 16.6035 13.2213 16.5016Z"
        // fill="#FFA873"
        fill={fillColor}
      />
      <path
        d="M23.316 12C22.3218 12 21.4504 12.5197 20.9553 13.3023C20.8897 13.4058 20.8783 13.5353 20.9245 13.6493C20.971 13.7637 21.0693 13.8476 21.1896 13.8757C22.7376 14.2401 24.0619 15.1862 24.9152 16.4737C24.983 16.576 25.0961 16.6392 25.219 16.6435C25.3418 16.6481 25.4585 16.593 25.5339 16.4957C25.896 16.0251 26.1126 15.4366 26.1126 14.7962C26.1116 13.2518 24.8601 12 23.316 12Z"
        // fill="#FFA873"
        fill={fillColor}
      />
      <path
        d="M25.2387 20.5627C25.2387 19.4833 24.9579 18.4687 24.4683 17.5859C23.5609 15.9507 21.9313 14.7753 20.0133 14.481C19.7075 14.4341 19.3972 14.4023 19.0783 14.4023C18.7454 14.4023 18.421 14.4364 18.1021 14.4875C16.1923 14.7939 14.5709 15.9743 13.673 17.6115C13.1923 18.4884 12.918 19.4938 12.918 20.5627C12.918 22.3932 13.7251 24.0353 14.9966 25.1639L14.4775 25.895C14.254 26.2099 14.3281 26.6458 14.643 26.8699C14.7659 26.9571 14.9071 26.9994 15.047 26.9994C15.2659 26.9994 15.4815 26.8968 15.6175 26.7051L16.1363 25.9743C17.0109 26.4518 18.0133 26.7238 19.0783 26.7238C20.143 26.7238 21.1455 26.4518 22.0201 25.9743L22.5388 26.7051C22.6752 26.8971 22.8905 26.9994 23.1094 26.9994C23.2493 26.9994 23.3902 26.9571 23.5131 26.8699C23.828 26.6458 23.9024 26.2099 23.6789 25.895L23.1598 25.1639C24.4313 24.0353 25.2387 22.3932 25.2387 20.5627ZM19.0787 25.0004C16.6314 25.0004 14.641 23.01 14.641 20.5627C14.641 19.7998 14.8347 19.0819 15.1748 18.454C15.8223 17.2599 17.0034 16.3997 18.3948 16.1831C18.6183 16.1483 18.8454 16.1247 19.0787 16.1247C19.2982 16.1247 19.5129 16.146 19.7242 16.1772C21.1274 16.3829 22.3212 17.2432 22.9763 18.4425C23.3204 19.0727 23.516 19.7946 23.516 20.5624C23.516 23.01 21.5256 25.0004 19.0787 25.0004Z"
        // fill="#FFA873"
        fill={fillColor}
      />
      <path
        d="M21.5647 21.6005L19.8718 20.5551C19.8367 20.3572 19.7296 20.1865 19.5792 20.0655L19.6565 17.9414C19.666 17.6701 19.4543 17.4423 19.1833 17.4322C18.9129 17.4197 18.6842 17.634 18.6741 17.9054L18.5964 20.0318C18.3863 20.1799 18.248 20.4237 18.248 20.7006C18.248 21.1532 18.6147 21.5195 19.0673 21.5195C19.1961 21.5195 19.3163 21.4871 19.4245 21.4343L21.0482 22.4377C21.1288 22.4869 21.2183 22.5108 21.3061 22.5108C21.4709 22.5108 21.6315 22.4282 21.7249 22.2778C21.8678 22.0461 21.7957 21.7433 21.5647 21.6005Z"
        // fill="#FFA873"
        fill={fillColor}
      />
    </svg>
  );
};

export const NotificationNewIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
  iconRef,
  height,
  width,
  fillColor,
}) => {
  return (
    // <svg
    //   // width="16"
    //   // height="18"
    //   width={width}
    //   height={height}
    //   viewBox="0 0 16 18"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   className={customClass}
    //   style={{ cursor: 'pointer' }}
    //   onClick={(e) => {
    //     handleClick && handleClick(e)
    //   }}
    //   ref={iconRef}
    // >
    //   <path
    //     opacity="0.4"
    //     d="M7.87457 17.2262C8.39959 17.2255 8.91135 17.0612 9.33872 16.7563C9.76609 16.4513 10.0878 16.0208 10.2592 15.5245L5.48122 15.5368C5.65515 16.0321 5.9791 16.461 6.40803 16.7638C6.83695 17.0666 7.34955 17.2282 7.87457 17.2262V17.2262ZM13.7928 10.9256L13.7828 7.03778C13.7758 4.31053 11.9175 2.01786 9.40636 1.33338C9.15636 0.708367 8.54823 0.26909 7.83103 0.270932C7.11382 0.272774 6.50796 0.715169 6.26117 1.34145C3.75357 2.03967 1.90711 4.34102 1.91411 7.06826L1.9241 10.9561L0.480686 12.4069C0.40201 12.4857 0.339695 12.5793 0.29733 12.6823C0.254964 12.7853 0.233384 12.8956 0.233831 13.0069L0.236008 13.8547C0.236586 14.0796 0.326457 14.295 0.485851 14.4535C0.645246 14.6121 0.861107 14.7009 1.08595 14.7003L14.6501 14.6655C14.875 14.6649 15.0904 14.575 15.249 14.4156C15.4075 14.2562 15.4963 14.0404 15.4957 13.8155L15.4935 12.9678C15.4934 12.8564 15.4713 12.7462 15.4284 12.6434C15.3855 12.5407 15.3227 12.4474 15.2436 12.369L13.7928 10.9256Z"
    //     fill="#181818"
    //   />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="26"
      viewBox="0 0 23 26"
      fill="none"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      ref={iconRef}
    >
      <path
        opacity="0.4"
        d="M7.87457 17.2262C8.39959 17.2255 8.91135 17.0612 9.33872 16.7563C9.76609 16.4513 10.0878 16.0208 10.2592 15.5245L5.48122 15.5368C5.65515 16.0321 5.9791 16.461 6.40803 16.7638C6.83695 17.0666 7.34955 17.2282 7.87457 17.2262V17.2262ZM13.7928 10.9256L13.7828 7.03778C13.7758 4.31053 11.9175 2.01786 9.40636 1.33338C9.15636 0.708367 8.54823 0.26909 7.83103 0.270932C7.11382 0.272774 6.50796 0.715169 6.26117 1.34145C3.75357 2.03967 1.90711 4.34102 1.91411 7.06826L1.9241 10.9561L0.480686 12.4069C0.40201 12.4857 0.339695 12.5793 0.29733 12.6823C0.254964 12.7853 0.233384 12.8956 0.233831 13.0069L0.236008 13.8547C0.236586 14.0796 0.326457 14.295 0.485851 14.4535C0.645246 14.6121 0.861107 14.7009 1.08595 14.7003L14.6501 14.6655C14.875 14.6649 15.0904 14.575 15.249 14.4156C15.4075 14.2562 15.4963 14.0404 15.4957 13.8155L15.4935 12.9678C15.4934 12.8564 15.4713 12.7462 15.4284 12.6434C15.3855 12.5407 15.3227 12.4474 15.2436 12.369L13.7928 10.9256Z"
        // fill="#181818"
        fill={fillColor ? fillColor : "#181818"}
      />
    </svg>
  );
};

export const TagPatientIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M15.8854 6.85433L10.2857 1.25548C9.47672 0.446468 8.40032 0 7.25623 0H3.428C1.53746 0 0 1.53746 0 3.428V7.25531C0 8.39941 0.445631 9.47581 1.25464 10.2857L6.85427 15.8845C7.66328 16.6935 8.73968 17.14 9.88377 17.14C11.0287 17.14 12.1043 16.6935 12.9141 15.8845L15.8845 12.9141C17.5556 11.2438 17.5557 8.52462 15.8854 6.85433ZM14.6736 11.7024L11.7032 14.6727C10.7322 15.6428 9.03963 15.6445 8.06694 14.6727L2.4673 9.07393C1.98138 8.58801 1.714 7.94177 1.714 7.25531V3.428C1.714 2.48273 2.48273 1.714 3.428 1.714H7.25536C7.93239 1.714 8.594 1.98826 9.07306 2.46733L14.6727 8.06607C15.6754 9.06876 15.6754 10.6997 14.6736 11.7024ZM5.999 4.7135C5.999 5.4231 5.4231 5.999 4.7135 5.999C4.0039 5.999 3.428 5.4231 3.428 4.7135C3.428 4.0039 4.0039 3.428 4.7135 3.428C5.4231 3.428 5.999 4.0039 5.999 4.7135Z"
        fill="#0BD26E"
      />
    </svg>
  );
};

export const FormIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 14.5614C16 15.9813 14.9255 17.1324 13.6 17.1324H2.4C1.07452 17.1324 0 15.9813 0 14.5614V2.56322C0 1.14328 1.07452 -0.0078125 2.4 -0.0078125H13.6C14.9255 -0.0078125 16 1.14328 16 2.56322V14.5614ZM7.19999 3.41992H12C12.4418 3.41992 12.8 3.80362 12.8 4.27693C12.8 4.75025 12.4418 5.13394 12 5.13394H7.19999C6.75817 5.13394 6.39999 4.75025 6.39999 4.27693C6.39999 3.80362 6.75817 3.41992 7.19999 3.41992ZM4.80003 4.27735C4.79876 4.16536 4.77702 4.05472 4.73603 3.95169C4.69551 3.84783 4.63869 3.75218 4.56803 3.66888C4.49026 3.59318 4.40097 3.53231 4.30403 3.4889C4.00611 3.3547 3.66207 3.4257 3.43203 3.66888C3.36136 3.75218 3.30454 3.84783 3.26403 3.95169C3.22303 4.05472 3.20129 4.16536 3.20003 4.27735C3.1988 4.50515 3.28228 4.7241 3.43203 4.88583C3.58533 5.04244 3.78821 5.13121 4.00003 5.13436C4.10497 5.13726 4.20908 5.11378 4.30403 5.0658C4.40097 5.0224 4.49026 4.96153 4.56803 4.88583C4.71421 4.7216 4.79708 4.50426 4.80003 4.27735ZM4.30403 7.77308C4.00611 7.63888 3.66207 7.70988 3.43203 7.95306C3.35794 8.0335 3.30068 8.12991 3.26403 8.23587C3.22303 8.3389 3.20129 8.44954 3.20003 8.56153C3.1988 8.78933 3.28228 9.00828 3.43203 9.17001C3.58533 9.32662 3.78821 9.41539 4.00003 9.41854C4.10457 9.41719 4.20785 9.3939 4.30403 9.34998C4.40097 9.30658 4.49026 9.24571 4.56803 9.17001L4.66403 9.04146C4.6943 8.99368 4.71851 8.94181 4.73603 8.8872C4.76466 8.83962 4.78625 8.78759 4.80003 8.73294C4.80395 8.67588 4.80395 8.61859 4.80003 8.56153C4.79708 8.33463 4.71421 8.11729 4.56803 7.95306C4.49026 7.87736 4.40097 7.81648 4.30403 7.77308ZM7.2 7.70528H12C12.4418 7.70528 12.8 8.08897 12.8 8.56229C12.8 9.0356 12.4418 9.4193 12 9.4193H7.2C6.75817 9.4193 6.4 9.0356 6.4 8.56229C6.4 8.08897 6.75817 7.70528 7.2 7.70528ZM4.56798 12.2382C4.49022 12.1625 4.40093 12.1016 4.30398 12.0582C4.00607 11.924 3.66203 11.995 3.43198 12.2382C3.35915 12.3197 3.30206 12.4158 3.26398 12.521C3.1784 12.7285 3.1784 12.9649 3.26398 13.1724C3.30206 13.2776 3.35915 13.3737 3.43198 13.4552C3.58529 13.6118 3.78817 13.7005 3.99998 13.7037C4.10453 13.7023 4.20781 13.6791 4.30398 13.6351C4.40093 13.5917 4.49022 13.5309 4.56798 13.4552C4.64082 13.3737 4.69791 13.2776 4.73598 13.1724C4.82157 12.9649 4.82157 12.7285 4.73598 12.521C4.69791 12.4158 4.64082 12.3197 4.56798 12.2382ZM7.2 11.9903H12C12.4418 11.9903 12.8 12.374 12.8 12.8473C12.8 13.3207 12.4418 13.7043 12 13.7043H7.2C6.75817 13.7043 6.4 13.3207 6.4 12.8473C6.4 12.374 6.75817 11.9903 7.2 11.9903ZM13.6 1.70605C14.0418 1.70605 14.4 2.08975 14.4 2.56306V14.5612C14.4 15.0345 14.0418 15.4182 13.6 15.4182H2.40001C1.95818 15.4182 1.60001 15.0345 1.60001 14.5612V2.56306C1.60001 2.08975 1.95818 1.70605 2.40001 1.70605H13.6Z"
        fill="#0BD26E"
      />
    </svg>
  );
};

export const KpiRevenueIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M7.80775 4.47872H10.0421C10.7821 4.47872 10.7821 3.34916 10.0421 3.34561H9.07895V2.83218C9.07895 2.52057 8.824 2.26562 8.51239 2.26562C8.20079 2.26562 7.94584 2.52057 7.94584 2.83218V3.34561C5.54508 3.25355 5.41052 6.76971 7.80775 6.85115H8.85587C9.66674 6.86532 9.67383 8.06924 8.85587 8.0834H6.62153C5.87793 8.09403 5.87439 9.20588 6.62153 9.21651H7.94584V9.72994C7.94938 10.47 9.07541 10.4735 9.07895 9.72994V9.19526C11.2283 8.8872 11.0265 5.76408 8.85587 5.72159H7.80775C6.99333 5.70389 6.98979 4.49288 7.80775 4.47872Z"
        fill="#0BD26E"
      />
      <path
        d="M3.98365 11.7844C4.4723 11.7986 4.74495 11.1471 4.38023 10.8142C0.775547 7.34408 3.32503 1.10139 8.33193 1.13325C11.4444 1.13325 13.9762 3.66503 13.9762 6.77753C13.9904 7.26264 13.7283 8.02394 14.4224 8.12663C15.1695 8.18682 15.0951 7.29451 15.1093 6.77753C15.1093 3.04183 12.0676 0.000151194 8.32839 0.000151194C2.3194 -0.0387992 -0.739979 7.45739 3.58706 11.6251C3.69683 11.7313 3.84201 11.7844 3.98365 11.7844Z"
        fill="#0BD26E"
      />
      <path
        d="M16.6461 9.47949C16.632 9.19975 16.3841 9.01562 16.1221 8.98021L12.0854 8.78546C11.3489 8.76421 11.2851 9.86545 12.0323 9.91856L14.5428 10.039L9.34115 14.0721L7.19888 11.2004C7.01829 10.949 6.63233 10.8959 6.39154 11.0942L0.21613 15.9842C-0.361045 16.4445 0.336522 17.3298 0.920778 16.873L6.63941 12.3441L8.77814 15.2123C8.87021 15.3362 9.00476 15.4141 9.15703 15.4354C9.30575 15.4531 9.46155 15.4141 9.58194 15.3221L15.2404 10.9313L14.7482 13.3993C14.6065 14.1217 15.7078 14.3518 15.86 13.6189L16.6497 9.65653C16.6532 9.59988 16.6532 9.53968 16.6461 9.47949Z"
        fill="#0BD26E"
      />
    </svg>
  );
};

export const StaffChatMessageIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
  fillColor,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M16 5V4C16 1.794 14.206 0 12 0H4C1.794 0 0 1.794 0 4V14C0 14.406 0.246009 14.772 0.622009 14.926C0.744009 14.976 0.872 15 1 15C1.264 15 1.52199 14.896 1.71399 14.7L3.38 13H4V14C4 16.206 5.794 18 8 18H16.62L18.286 19.7C18.478 19.895 18.737 20 19 20C19.127 20 19.256 19.976 19.378 19.926C19.754 19.773 20 19.406 20 19V9C20 6.794 18.206 5 16 5ZM2.95999 11C2.69099 11 2.434 11.108 2.246 11.3L2 11.551V4C2 2.897 2.897 2 4 2H12C13.103 2 14 2.897 14 4V9C14 10.103 13.103 11 12 11H2.95999ZM18 16.551L17.754 16.3C17.566 16.109 17.308 16 17.04 16H8C6.897 16 6 15.103 6 14V13H12C14.206 13 16 11.206 16 9V7C17.103 7 18 7.897 18 9V16.551Z"
        // fill="#BBBBBB"
        fill={fillColor ? fillColor : "#181818"}
      />
    </svg>
  );
};

export const DiagnosCheckIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
  fillColor,
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      // style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 0C5.5957 0 0 5.5957 0 12.5C0 19.4043 5.5957 25 12.5 25C19.4043 25 25 19.4043 25 12.5C25 5.5957 19.4043 0 12.5 0ZM12.1232 17.6272L18.6199 11.2009C19.1267 10.6997 19.1267 9.87719 18.6199 9.37594C18.1132 8.87469 17.2816 8.87469 16.7749 9.37594L11.2006 14.9026L8.22512 11.9465C7.71837 11.4452 6.88681 11.4452 6.38006 11.9465C5.87331 12.4477 5.87331 13.2702 6.38006 13.7714L10.2781 17.6272C10.538 17.8714 10.8628 18 11.2006 18C11.5385 18 11.8633 17.8714 12.1232 17.6272Z"
        // fill="#5936F1"
        fill={fillColor}
      />
    </svg>
  );
};

export const DiagnosPauseIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
  fillColor,
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 0C5.5957 0 0 5.5957 0 12.5C0 19.4043 5.5957 25 12.5 25C19.4043 25 25 19.4043 25 12.5C25 5.5957 19.4043 0 12.5 0ZM8 7C7.44772 7 7 7.41041 7 7.91667V17.0833C7 17.5896 7.44772 18 8 18H9C9.55228 18 10 17.5896 10 17.0833V7.91667C10 7.41041 9.55228 7 9 7H8ZM16 7C15.4477 7 15 7.41041 15 7.91667V17.0833C15 17.5896 15.4477 18 16 18H17C17.5523 18 18 17.5896 18 17.0833V7.91667C18 7.41041 17.5523 7 17 7H16Z"
        // fill="#FFA009"
        fill={fillColor}
      />
    </svg>
  );
};

export const AppointmentIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
  fillColor,
}) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <rect
        opacity="0.2"
        x="1.5"
        y="1.5"
        width="35"
        height="35"
        rx="11.5"
        // fill="#BBBBBB"
        fill={fillColor}
        stroke="white"
        strokeWidth="3"
      />
      <g clipPath="url(#clip0_11242_14604)">
        <path
          d="M24.2736 13.4319V12.6808C24.2736 12.3068 23.9668 12 23.5928 12C23.2156 12 22.912 12.3068 22.912 12.6808V13.3616H20.1824V12.6808C20.1824 12.3068 19.8756 12 19.5016 12C19.1244 12 18.8208 12.3068 18.8208 12.6808V13.3616H16.0912V12.6808C16.0912 12.3068 15.7844 12 15.4104 12C15.0364 12 14.7264 12.3068 14.7264 12.6808V13.4319C13.1411 13.7547 12 15.1515 12 16.772V23.5896C12 25.4722 13.5278 27 15.4104 27H23.5928C25.4754 27 27.0032 25.4722 27.0032 23.5896V16.772C27 15.1515 25.8621 13.7547 24.2736 13.4319ZM25.6384 23.5928C25.6384 24.7211 24.7211 25.6384 23.5928 25.6384H15.4104C14.2821 25.6384 13.3648 24.7211 13.3648 23.5928V16.772C13.368 15.9058 13.9146 15.1387 14.7296 14.8479V15.4072C14.7296 15.7844 15.0364 16.088 15.4104 16.088C15.7844 16.088 16.0912 15.7812 16.0912 15.4072V14.7264H18.8176V15.4072C18.8176 15.7844 19.1244 16.088 19.4984 16.088C19.8756 16.088 20.1792 15.7812 20.1792 15.4072V14.7264H22.9056V15.4072C22.9056 15.7844 23.2124 16.088 23.5864 16.088C23.9636 16.088 24.2672 15.7812 24.2672 15.4072V14.8511C25.0823 15.1387 25.6288 15.909 25.632 16.7752V23.5928H25.6384ZM22.7458 18.3701C23.0143 18.6354 23.0143 19.0669 22.749 19.3354L22.7458 19.3386L19.4664 22.5636C19.2012 22.8289 18.7697 22.8289 18.5044 22.5636L16.9414 21.0358C16.6729 20.7705 16.6729 20.339 16.9382 20.0705L16.9414 20.0673C17.2067 19.802 17.6382 19.802 17.9035 20.0673L18.9806 21.1253L21.7901 18.3989C22.049 18.1272 22.4741 18.1176 22.7458 18.3701Z"
          // fill="#797979"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_11242_14604">
          <rect
            width="15"
            height="15"
            // fill="white"
            fill={fillColor}
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const JobIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.75 8.11523H11.25V10.3711H3.75V8.11523Z" fill="#002C5A" />
      <path
        d="M3.75 20.625C3.75 22.6934 5.43164 24.375 7.5 24.375C9.56836 24.375 11.25 22.6934 11.25 20.625V12.1289H8.37891V15.9316H6.62109V12.1289H3.75V20.625Z"
        fill="#002C5A"
      />
      <path
        d="M3.74998 6.35742H11.25V3.75H12.5039V0H2.49607V3.75H3.74998V6.35742Z"
        fill="#002C5A"
      />
      <path
        d="M23.3789 15.9316H21.6211V12.1289H18.75V20.625C18.75 22.6934 20.4316 24.375 22.5 24.375C24.5684 24.375 26.25 22.6934 26.25 20.625V12.1289H23.3789V15.9316Z"
        fill="#002C5A"
      />
      <path d="M18.75 8.11523H26.25V10.3711H18.75V8.11523Z" fill="#002C5A" />
      <path
        d="M18.75 6.35742H26.25V3.75H27.5039V0H17.4961V3.75H18.75V6.35742Z"
        fill="#002C5A"
      />
      <path d="M11.25 10.3711H18.75V12.1289H11.25V10.3711Z" fill="#002C5A" />
      <path
        d="M26.25 10.3711V12.1289H28.2422V26.25H1.75781V12.1289H3.75V10.3711H0V30H30V10.3711H26.25Z"
        fill="#002C5A"
      />
    </svg>
  );
};

export const LabRequestIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.92864 4.54994L13.1984 1.37848L12.6721 0.496764C12.3782 0.0114772 11.7494 -0.145728 11.2641 0.148178L7.75093 2.2602C7.26564 2.55411 7.10843 3.18293 7.40234 3.66822L7.92864 4.54994Z"
        fill={fillColor}
      />
      <path
        d="M29.1377 23.9341C28.8438 23.4488 28.215 23.2984 27.7297 23.5923L22.0088 27.0645C22.2822 27.7139 22.4599 28.4179 22.5214 29.1492L28.7892 25.3421C29.2813 25.0482 29.4316 24.4194 29.1377 23.9341Z"
        fill={fillColor}
      />
      <path
        d="M23.5809 32.9495H20.5051V29.8054C20.5051 26.9757 18.2085 24.6791 15.3788 24.6791C12.5491 24.6791 10.2525 26.9757 10.2525 29.8054V32.9495H7.17678C6.60947 32.9495 6.15153 33.4074 6.15153 33.9747C6.15153 34.5421 6.60947 35 7.17678 35H23.5809C24.1482 35 24.6061 34.5421 24.6061 33.9747C24.6061 33.4074 24.1482 32.9495 23.5809 32.9495ZM15.3788 30.8306C14.8115 30.8306 14.3536 30.3727 14.3536 29.8054C14.3536 29.2381 14.8115 28.7801 15.3788 28.7801C15.9461 28.7801 16.4041 29.2381 16.4041 29.8054C16.4041 30.3727 15.9461 30.8306 15.3788 30.8306Z"
        fill={fillColor}
      />
      <path
        d="M7.75776 8.24085L8.8377 10.0385L11.0249 8.71931C13.6154 7.15408 16.9577 8.02213 18.4956 10.5374C20.0813 13.1279 19.2474 16.5044 16.6433 18.0628L14.4424 19.382L15.1396 20.5507C15.4335 21.036 16.0623 21.1932 16.5476 20.8993C16.5818 20.8788 16.9235 20.6738 17.443 20.3594L19.0151 22.9772C19.309 23.4625 19.9378 23.6197 20.4231 23.3258L23.9363 21.2137C24.4216 20.9198 24.5788 20.291 24.2849 19.8057L22.7128 17.1879C23.2391 16.8735 23.574 16.6684 23.574 16.6684C24.0593 16.3745 24.2165 15.7457 23.9226 15.2604C23.8953 15.2194 16.5203 2.94371 16.4929 2.9027C16.1854 2.45842 15.5839 2.32855 15.1191 2.60195L8.10635 6.83284C7.62106 7.12674 7.46385 7.75557 7.75776 8.24085Z"
        fill={fillColor}
      />
      <path
        d="M8.20204 29.8054C8.20204 27.7959 9.02908 25.9846 10.3619 24.6791H9.22729C7.5322 24.6791 6.15153 23.2984 6.15153 21.6033C6.15153 19.9083 7.5322 18.5276 9.22729 18.5276H11.5922C11.7768 18.5276 11.9613 18.4797 12.1185 18.384L15.5907 16.3062C17.2174 15.3356 17.7301 13.2304 16.7458 11.6105C15.7753 10.018 13.6837 9.51217 12.0843 10.4759L8.93338 12.376C3.97799 12.5333 0 16.6138 0 21.6033C0 26.3469 3.59523 30.2633 8.20204 30.776V29.8054Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const InvoiceIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M26.2901 5.66669V25.7748C26.2825 26.6284 25.8361 27.4453 25.0475 28.0489C24.2589 28.6525 23.1915 28.9942 22.0762 29H7.32083C6.24277 29 5.20886 28.6722 4.44655 28.0888C3.68425 27.5053 3.25599 26.714 3.25599 25.8889V3.0741C3.25543 2.58457 3.02866 2.11097 2.61579 1.73708C2.20292 1.3632 1.63057 1.11314 1 1.03114C1.07123 1.00991 1.14713 0.999348 1.22357 1.00003H20.1928C21.8085 1.00359 23.3567 1.49639 24.4991 2.37079C25.6416 3.24519 26.2855 4.43011 26.2901 5.66669Z"
        fill="#67CDDF"
      />
      <path
        d="M26.2901 5.66666V25.7748C26.2909 26.452 26.0083 27.1116 25.4839 27.657C24.7739 28.0444 23.9238 28.2528 23.0518 28.2533H8.2964C7.7624 28.2538 7.2335 28.1737 6.74001 28.0176C6.24651 27.8614 5.79813 27.6323 5.42053 27.3433C5.04293 27.0543 4.74354 26.7111 4.53952 26.3334C4.33549 25.9557 4.23084 25.5509 4.23155 25.1422V2.32741C4.23412 1.84081 4.00811 1.36971 3.59473 1H20.1929C21.8085 1.00356 23.3567 1.49636 24.4991 2.37076C25.6416 3.24516 26.2855 4.43008 26.2901 5.66666Z"
        fill="#EAEFFE"
      />
      <path
        d="M14.7731 7.74001C14.3712 7.74001 13.9782 7.64878 13.644 7.47786C13.3098 7.30693 13.0493 7.06398 12.8954 6.77974C12.7416 6.4955 12.7014 6.18273 12.7798 5.88099C12.8582 5.57924 13.0518 5.30207 13.336 5.08452C13.6202 4.86697 13.9824 4.71882 14.3766 4.6588C14.7709 4.59878 15.1795 4.62958 15.5509 4.74732C15.9223 4.86505 16.2397 5.06443 16.463 5.32024C16.6864 5.57605 16.8056 5.8768 16.8056 6.18446C16.8056 6.32198 16.7342 6.45387 16.6071 6.55111C16.4801 6.64835 16.3078 6.70298 16.1281 6.70298C15.9484 6.70298 15.7761 6.64835 15.649 6.55111C15.522 6.45387 15.4506 6.32198 15.4506 6.18446C15.4506 6.08191 15.4109 5.98166 15.3364 5.89639C15.262 5.81112 15.1562 5.74466 15.0324 5.70541C14.9086 5.66617 14.7724 5.6559 14.641 5.67591C14.5096 5.69591 14.3888 5.7453 14.2941 5.81781C14.1994 5.89033 14.1348 5.98272 14.1087 6.0833C14.0825 6.18389 14.096 6.28814 14.1472 6.38289C14.1985 6.47764 14.2854 6.55862 14.3968 6.61559C14.5082 6.67257 14.6392 6.70298 14.7731 6.70298C14.9528 6.70298 15.1251 6.75761 15.2522 6.85485C15.3792 6.95209 15.4506 7.08398 15.4506 7.2215C15.4506 7.35902 15.3792 7.4909 15.2522 7.58814C15.1251 7.68538 14.9528 7.74001 14.7731 7.74001Z"
        fill="#07C3AA"
      />
      <path
        d="M14.7731 9.81423C14.2341 9.81423 13.7172 9.65034 13.336 9.35862C12.9549 9.0669 12.7407 8.67124 12.7407 8.25868C12.7407 8.12116 12.8121 7.98927 12.9391 7.89203C13.0662 7.79479 13.2385 7.74016 13.4182 7.74016C13.5979 7.74016 13.7702 7.79479 13.8972 7.89203C14.0243 7.98927 14.0957 8.12116 14.0957 8.25868C14.0957 8.36123 14.1354 8.46148 14.2098 8.54675C14.2843 8.63202 14.3901 8.69848 14.5139 8.73773C14.6377 8.77697 14.7739 8.78724 14.9053 8.76723C15.0367 8.74723 15.1574 8.69784 15.2522 8.62533C15.3469 8.55281 15.4115 8.46042 15.4376 8.35984C15.4637 8.25925 15.4503 8.155 15.399 8.06025C15.3478 7.9655 15.2609 7.88452 15.1495 7.82755C15.0381 7.77057 14.9071 7.74016 14.7731 7.74016C14.5935 7.74016 14.4211 7.68553 14.2941 7.58829C14.167 7.49105 14.0957 7.35916 14.0957 7.22164C14.0957 7.08412 14.167 6.95224 14.2941 6.85499C14.4211 6.75775 14.5935 6.70312 14.7731 6.70312C15.3122 6.70313 15.8291 6.86701 16.2103 7.15874C16.5914 7.45046 16.8056 7.84612 16.8056 8.25868C16.8056 8.67124 16.5914 9.0669 16.2103 9.35862C15.8291 9.65034 15.3122 9.81423 14.7731 9.81423Z"
        fill="#07C3AA"
      />
      <path
        d="M14.7732 5.66767C14.5935 5.66767 14.4212 5.61304 14.2941 5.5158C14.1671 5.41856 14.0957 5.28667 14.0957 5.14916V4.45797C14.0957 4.32045 14.1671 4.18856 14.2941 4.09132C14.4212 3.99408 14.5935 3.93945 14.7732 3.93945C14.9529 3.93945 15.1252 3.99408 15.2522 4.09132C15.3793 4.18856 15.4507 4.32045 15.4507 4.45797V5.14916C15.4507 5.28667 15.3793 5.41856 15.2522 5.5158C15.1252 5.61304 14.9529 5.66767 14.7732 5.66767Z"
        fill="#07C3AA"
      />
      <path
        d="M14.7732 10.5056C14.5935 10.5056 14.4212 10.4509 14.2941 10.3537C14.1671 10.2565 14.0957 10.1246 14.0957 9.98705V9.29586C14.0957 9.15834 14.1671 9.02645 14.2941 8.92921C14.4212 8.83197 14.5935 8.77734 14.7732 8.77734C14.9529 8.77734 15.1252 8.83197 15.2522 8.92921C15.3793 9.02645 15.4507 9.15834 15.4507 9.29586V9.98705C15.4507 10.1246 15.3793 10.2565 15.2522 10.3537C15.1252 10.4509 14.9529 10.5056 14.7732 10.5056Z"
        fill="#07C3AA"
      />
      <path
        d="M21.548 13.4452H18.8381C18.6584 13.4452 18.4861 13.3906 18.3591 13.2934C18.232 13.1961 18.1606 13.0642 18.1606 12.9267C18.1606 12.7892 18.232 12.6573 18.3591 12.5601C18.4861 12.4628 18.6584 12.4082 18.8381 12.4082H21.548C21.7277 12.4082 21.9 12.4628 22.0271 12.5601C22.1541 12.6573 22.2255 12.7892 22.2255 12.9267C22.2255 13.0642 22.1541 13.1961 22.0271 13.2934C21.9 13.3906 21.7277 13.4452 21.548 13.4452Z"
        fill="#002C5A"
      />
      <path
        d="M16.8054 13.4452H7.99828C7.8186 13.4452 7.64628 13.3906 7.51923 13.2934C7.39218 13.1961 7.3208 13.0642 7.3208 12.9267C7.3208 12.7892 7.39218 12.6573 7.51923 12.5601C7.64628 12.4628 7.8186 12.4082 7.99828 12.4082H16.8054C16.9851 12.4082 17.1574 12.4628 17.2845 12.5601C17.4115 12.6573 17.4829 12.7892 17.4829 12.9267C17.4829 13.0642 17.4115 13.1961 17.2845 13.2934C17.1574 13.3906 16.9851 13.4452 16.8054 13.4452Z"
        fill="#002C5A"
      />
      <path
        d="M21.548 18.6308H20.1931C20.0134 18.6308 19.8411 18.5762 19.7141 18.4789C19.587 18.3817 19.5156 18.2498 19.5156 18.1123C19.5156 17.9747 19.587 17.8429 19.7141 17.7456C19.8411 17.6484 20.0134 17.5938 20.1931 17.5938H21.548C21.7277 17.5938 21.9 17.6484 22.0271 17.7456C22.1541 17.8429 22.2255 17.9747 22.2255 18.1123C22.2255 18.2498 22.1541 18.3817 22.0271 18.4789C21.9 18.5762 21.7277 18.6308 21.548 18.6308Z"
        fill="#002C5A"
      />
      <path
        d="M18.1604 18.6308H7.99828C7.8186 18.6308 7.64628 18.5762 7.51923 18.4789C7.39218 18.3817 7.3208 18.2498 7.3208 18.1123C7.3208 17.9747 7.39218 17.8429 7.51923 17.7456C7.64628 17.6484 7.8186 17.5938 7.99828 17.5938H18.1604C18.3401 17.5938 18.5124 17.6484 18.6394 17.7456C18.7665 17.8429 18.8379 17.9747 18.8379 18.1123C18.8379 18.2498 18.7665 18.3817 18.6394 18.4789C18.5124 18.5762 18.3401 18.6308 18.1604 18.6308Z"
        fill="#002C5A"
      />
      <path
        d="M10.0307 16.037H7.99828C7.8186 16.037 7.64628 15.9824 7.51923 15.8852C7.39218 15.7879 7.3208 15.656 7.3208 15.5185C7.3208 15.381 7.39218 15.2491 7.51923 15.1519C7.64628 15.0546 7.8186 15 7.99828 15H10.0307C10.2104 15 10.3827 15.0546 10.5097 15.1519C10.6368 15.2491 10.7082 15.381 10.7082 15.5185C10.7082 15.656 10.6368 15.7879 10.5097 15.8852C10.3827 15.9824 10.2104 16.037 10.0307 16.037Z"
        fill="#002C5A"
      />
      <path
        d="M21.5479 16.037H12.0632C11.8835 16.037 11.7112 15.9824 11.5842 15.8852C11.4571 15.7879 11.3857 15.656 11.3857 15.5185C11.3857 15.381 11.4571 15.2491 11.5842 15.1519C11.7112 15.0546 11.8835 15 12.0632 15H21.5479C21.7275 15 21.8999 15.0546 22.0269 15.1519C22.154 15.2491 22.2253 15.381 22.2253 15.5185C22.2253 15.656 22.154 15.7879 22.0269 15.8852C21.8999 15.9824 21.7275 16.037 21.5479 16.037Z"
        fill="#002C5A"
      />
      <path
        d="M21.5478 21.2226H7.99828C7.8186 21.2226 7.64628 21.168 7.51923 21.0707C7.39218 20.9735 7.3208 20.8416 7.3208 20.7041C7.3208 20.5665 7.39218 20.4347 7.51923 20.3374C7.64628 20.2402 7.8186 20.1855 7.99828 20.1855H21.5478C21.7274 20.1855 21.8998 20.2402 22.0268 20.3374C22.1539 20.4347 22.2252 20.5665 22.2252 20.7041C22.2252 20.8416 22.1539 20.9735 22.0268 21.0707C21.8998 21.168 21.7274 21.2226 21.5478 21.2226Z"
        fill="#002C5A"
      />
      <path
        d="M28.9997 23.8154V25.3709C28.9983 26.3332 28.4982 27.2558 27.6092 27.9363C26.7201 28.6167 25.5147 28.9995 24.2574 29.0006H7.99804C7.92386 29.0008 7.85029 28.9902 7.78125 28.9695C8.43985 28.8833 9.03348 28.6136 9.44784 28.2124C9.83034 27.8482 10.0362 27.3938 10.0305 26.9265V23.8154C10.0305 23.6779 10.1018 23.546 10.2289 23.4487C10.3559 23.3515 10.5283 23.2969 10.7079 23.2969H28.3223C28.5019 23.2969 28.6743 23.3515 28.8013 23.4487C28.9284 23.546 28.9997 23.6779 28.9997 23.8154Z"
        fill="#67CDDF"
      />
      <path
        d="M27.9704 23.2969V24.5828C27.969 25.5451 27.4689 26.4677 26.5798 27.1481C25.6908 27.8286 24.4854 28.2113 23.2281 28.2124H9.44824C9.83075 27.8482 10.0366 27.3938 10.0309 26.9265V23.8154C10.0309 23.6779 10.1022 23.546 10.2293 23.4487C10.3563 23.3515 10.5287 23.2969 10.7083 23.2969H27.9704Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const ConfigIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="25"
      height="30"
      viewBox="0 0 25 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9902 9.05315V0.832677C16.9902 0.372047 16.6181 0 16.1575 0H9.73228C9.27165 0 8.89961 0.372047 8.89961 0.832677V9.04724C3.63189 10.7835 0 15.75 0 21.3484C0 24.4075 1.08661 27.372 3.06496 29.7047C3.22441 29.8937 3.45472 30 3.70276 30H22.187C22.4291 30 22.6654 29.8937 22.8248 29.7047C24.8031 27.372 25.8898 24.4016 25.8898 21.3484C25.8898 15.75 22.2579 10.7835 16.9902 9.05315ZM20.5335 20.8878C20.5335 21.3484 20.1614 21.7205 19.7008 21.7205H18.3839C18.3425 21.8209 18.3012 21.9213 18.2598 22.0157L19.1929 22.9488C19.5059 23.2441 19.5354 23.7579 19.1929 24.1299L17.4272 25.8957C17.2736 26.0492 17.0551 26.1319 16.8366 26.1319C16.6181 26.1319 16.4055 26.0551 16.2461 25.8957L15.313 24.9626C15.313 24.9626 15.313 24.9626 15.3071 24.9626C15.2126 25.0039 15.1122 25.0453 15.0118 25.0866V26.4035C15.0118 26.8642 14.6398 27.2362 14.1791 27.2362H11.6929C11.2323 27.2362 10.8602 26.8642 10.8602 26.4035V25.0866C10.7598 25.0453 10.6594 25.0039 10.565 24.9626C10.565 24.9626 10.565 24.9626 10.5591 24.9626L9.63189 25.8839C9.30709 26.2087 8.7815 26.2087 8.45079 25.8839L6.68504 24.1181C6.52559 23.9646 6.44291 23.7579 6.44291 23.5453C6.44291 23.3327 6.51968 23.1201 6.68504 22.9488L7.61811 22.0157C7.61811 22.0157 7.61811 22.0098 7.6122 22.0098L7.61811 22.0039C7.57677 21.9095 7.53543 21.8091 7.49409 21.7087H6.17717C5.71654 21.7087 5.34449 21.3366 5.34449 20.876V20.4626V18.815V18.4016C5.34449 17.9409 5.71654 17.5689 6.17717 17.5689H7.5C7.54134 17.4685 7.58268 17.3681 7.62402 17.2736L6.69094 16.3406C6.36614 16.0394 6.36614 15.4606 6.69094 15.1594L8.45669 13.3937C8.7874 13.0689 9.31299 13.0689 9.63779 13.3937L10.5709 14.315C10.6654 14.2677 10.7657 14.2264 10.8661 14.1909V12.874C10.8661 12.4134 11.2382 12.0413 11.6988 12.0413H14.1909C14.6516 12.0413 15.0236 12.4134 15.0236 12.874V14.1909C15.124 14.2323 15.2244 14.2736 15.3189 14.315L16.252 13.3819C16.5827 13.0571 17.1083 13.0571 17.4331 13.3819L19.1988 15.1476C19.5177 15.4724 19.5295 15.998 19.1988 16.3287L18.2657 17.2618C18.313 17.3563 18.3543 17.4567 18.3898 17.5571H19.7067C20.1673 17.5571 20.5394 17.9291 20.5394 18.3898L20.5335 20.8878Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const InsuranceMasterIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M17.8123 0H3.43942C1.53514 0 0 1.53516 0 3.43946V22.8165C0 24.7149 1.53514 26.25 3.43942 26.25H13.6288C12.58 24.586 11.8768 22.6231 11.8768 20.3731V17.3203C11.6893 17.4317 11.4784 17.4961 11.2499 17.4961H4.998C4.31246 17.4961 3.74996 16.9336 3.74996 16.2481C3.74996 15.5625 4.31246 15 4.998 15H11.2499C11.4901 15 11.7011 15.0645 11.8886 15.1758C11.9413 14.1153 12.4393 13.1367 13.2245 12.4981H4.998C4.31246 12.4981 3.74996 11.9356 3.74996 11.25C3.74996 10.5645 4.31246 10.002 4.998 10.002H16.2479C16.7752 10.002 17.2205 10.3242 17.408 10.7871L20.9705 9.57424C21.0584 9.53908 21.1463 9.50978 21.2459 9.49807V3.43946C21.2517 1.53516 19.7107 0 17.8123 0ZM10.0019 7.50001H4.998C4.31246 7.50001 3.74996 6.93751 3.74996 6.25197C3.74996 5.56642 4.31246 5.00392 4.998 5.00392H9.99599C10.6815 5.00392 11.244 5.56642 11.244 6.25197C11.244 6.93751 10.6874 7.50001 10.0019 7.50001Z"
        fill="#EAEFFE"
      />
      <path
        d="M29.1504 14.1738L22.588 11.9414C22.3243 11.8535 22.0431 11.8535 21.7794 11.9414L15.2169 14.1738C14.713 14.3437 14.3673 14.8242 14.3673 15.3574V20.3789C14.3673 26.7129 21.3927 29.7715 21.6915 29.9004C21.8497 29.9648 22.0138 30 22.1837 30C22.3477 30 22.5177 29.9648 22.6759 29.9004C22.9747 29.7715 30 26.7129 30 20.3789V15.3574C30 14.8183 29.6602 14.3437 29.1504 14.1738ZM26.625 18.873L22.8751 23.8711C22.6583 24.1582 22.3243 24.3398 21.961 24.3691C21.9317 24.3691 21.9024 24.375 21.8731 24.375C21.5391 24.375 21.2227 24.2461 20.9884 24.0058L18.4864 21.5039C18.0001 21.0176 18.0001 20.2265 18.4864 19.7344C18.9728 19.248 19.7638 19.248 20.256 19.7344L21.7384 21.2168L24.6211 17.3672C25.0372 16.8164 25.8164 16.7051 26.3672 17.1152C26.9297 17.5371 27.041 18.3222 26.625 18.873Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const InsuranceClaimsIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M22.8234 5.12134C22.8234 4.41818 22.548 3.75604 22.0499 3.25797L19.5654 0.773475C19.0732 0.281264 18.3759 0 17.6845 0H17.5321V5.27369H22.8234V5.12134Z"
        fill="#67CDDF"
      />
      <path
        d="M16.0496 18.1356C16.2195 17.6259 16.5125 17.1512 16.8934 16.7645L22.8468 10.8404V7.03159H16.6707C16.1844 7.03159 15.8211 6.639 15.8211 6.15264V0H2.63685C1.18365 0 0 1.18365 0 2.63685V27.3646C0 28.8178 1.18365 30.0015 2.63685 30.0015H20.1865C21.6397 30.0015 22.8468 28.8178 22.8468 27.3646V20.8018L21.88 21.7452C21.4874 22.1319 21.0303 22.4132 20.5147 22.589L17.7196 23.5207L17.2919 23.5441C16.5887 23.5441 15.9207 23.2043 15.5105 22.63C15.1003 22.0616 14.989 21.3174 15.2117 20.6494L16.0496 18.1356ZM4.39475 15.8211H13.1549C13.6413 15.8211 14.0339 16.2137 14.0339 16.7C14.0339 17.1864 13.6413 17.579 13.1549 17.579H4.39475C3.90839 17.579 3.5158 17.1864 3.5158 16.7C3.5158 16.2137 3.90839 15.8211 4.39475 15.8211ZM3.5158 13.1842C3.5158 12.6979 3.90839 12.3053 4.39475 12.3053H13.1549C13.6413 12.3053 14.0339 12.6979 14.0339 13.1842C14.0339 13.6706 13.6413 14.0632 13.1549 14.0632H4.39475C3.90839 14.0632 3.5158 13.6706 3.5158 13.1842ZM3.5158 20.2158C3.5158 19.7295 3.90839 19.3369 4.39475 19.3369H13.1549C13.6413 19.3369 14.0339 19.7295 14.0339 20.2158C14.0339 20.7022 13.6413 21.0948 13.1549 21.0948H4.39475C3.90839 21.0948 3.5158 20.7022 3.5158 20.2158ZM16.6707 24.6106C17.1571 24.6106 17.5497 25.0032 17.5497 25.4895C17.5497 25.9759 17.1571 26.3685 16.6707 26.3685H11.397C10.9107 26.3685 10.5181 25.9759 10.5181 25.4895C10.5181 25.0032 10.9107 24.6106 11.397 24.6106H16.6707ZM4.39475 10.5474C3.90839 10.5474 3.5158 10.1548 3.5158 9.66844C3.5158 9.18209 3.90839 8.78949 4.39475 8.78949H16.6707C17.1571 8.78949 17.5497 9.18209 17.5497 9.66844C17.5497 10.1548 17.1571 10.5474 16.6707 10.5474H4.39475Z"
        fill="#EAEFFE"
      />
      <path
        d="M17.6434 18.915L16.8817 21.212C16.7645 21.5577 17.0926 21.88 17.4384 21.7686L19.7295 21.001L17.6434 18.915Z"
        fill="#67CDDF"
      />
      <path
        d="M24.4699 11.6783L18.6806 17.4676L21.1768 19.9639C22.4835 18.6572 25.0325 16.1082 26.9662 14.1745L24.4699 11.6783Z"
        fill="#67CDDF"
      />
      <path
        d="M29.4858 9.15865C29.1753 8.84809 28.7241 8.6723 28.2377 8.6723C27.7514 8.6723 27.3002 8.84809 26.9896 9.16451L25.7122 10.4419L28.2084 12.9381C28.9057 12.2408 29.3921 11.7545 29.4858 11.6607C30.1714 10.9693 30.1714 9.84423 29.4858 9.15865Z"
        fill="#67CDDF"
      />
      <path
        d="M29.4917 11.649L29.4975 11.6431C29.4975 11.6431 29.4975 11.649 29.4917 11.649Z"
        fill="#BBBBBB"
      />
      <path
        d="M29.4975 11.6431C29.5034 11.6373 29.5034 11.6373 29.4975 11.6431V11.6431Z"
        fill="#BBBBBB"
      />
    </svg>
  );
};
export const ScanIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.798687 5.59831C1.24115 5.59831 1.59737 5.23834 1.59737 4.79962V2.39981C1.59737 1.95735 1.95735 1.60112 2.39606 1.60112H4.79587C5.23834 1.60112 5.59456 1.24115 5.59456 0.802437C5.59456 0.363721 5.24208 0 4.79962 0H2.39981C1.07616 0 0 1.07616 0 2.39981V4.79962C0 5.24209 0.359971 5.59831 0.798687 5.59831Z"
        fill={fillColor}
      />
      <path
        d="M15.1975 10.398C14.755 10.398 14.3988 10.7579 14.3988 11.1966V13.5965C14.3988 14.0389 14.0388 14.3951 13.6001 14.3951H11.2003C10.7578 14.3951 10.4016 14.7551 10.4016 15.1938C10.4016 15.6325 10.7616 15.9925 11.2003 15.9925H13.6001C14.9238 15.9925 15.9999 14.9164 15.9999 13.5927V11.1929C15.9999 10.7579 15.64 10.398 15.1975 10.398Z"
        fill={fillColor}
      />
      <path
        d="M4.79962 14.3989H2.39981C1.95735 14.3989 1.60112 14.0389 1.60112 13.6002V11.2004C1.60112 10.7579 1.24115 10.4017 0.802436 10.4017C0.363721 10.4017 0 10.7579 0 11.2004V13.6002C0 14.9238 1.07616 16 2.39981 16H4.79962C5.24208 16 5.59831 15.64 5.59831 15.2013C5.59831 14.7626 5.24208 14.3989 4.79962 14.3989Z"
        fill={fillColor}
      />
      <path
        d="M13.6001 0H11.2003C10.7578 0 10.4016 0.359972 10.4016 0.798687C10.4016 1.2374 10.7616 1.59737 11.2003 1.59737H13.6001C14.0426 1.59737 14.3988 1.95735 14.3988 2.39606V4.79587C14.3988 5.23834 14.7588 5.59456 15.1975 5.59456C15.6362 5.59456 15.9962 5.23459 15.9962 4.79587V2.39981C15.9999 1.07616 14.9238 0 13.6001 0Z"
        fill={fillColor}
      />
      <path
        d="M15.1975 7.19943H0.798687C0.359971 7.19943 0 7.5594 0 7.99812C0 8.44058 0.359971 8.79681 0.798687 8.79681H15.1975C15.64 8.79681 15.9962 8.43683 15.9962 7.99812C16 7.5594 15.64 7.19943 15.1975 7.19943Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const RectangleIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  // handleClick,
  fillColor,
}) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      // style={{ cursor: "pointer" }}
      // onClick={(e) => {
      //   handleClick && handleClick(e);
      // }}
    >
      <rect
        x="18.082"
        y="-2"
        width="28.4001"
        height="28.4001"
        rx="6"
        transform="rotate(45 18.082 -2)"
        fill={fillColor ? fillColor : "white"}
      />
    </svg>
  );
};

export const ReferralIcon: React.FunctionComponent<ISvgComponent> = ({
  customClass,
  handleClick,
  fillColor,
}) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <rect
        opacity="0.1"
        x="1.5"
        y="1.5"
        width="35"
        height="35"
        rx="11.5"
        // fill="#5936F1"
        fill={fillColor}
        stroke="white"
        strokeWidth="3"
      />
      <path
        d="M24.1172 20.249C24.1289 20.2402 24.1377 20.2285 24.1494 20.2197C24.6445 19.7305 24.9141 19.0771 24.9141 18.3799V16.7773C24.9141 15.3477 23.751 14.1846 22.3213 14.1846C21.0527 14.1846 19.9951 15.1016 19.7725 16.3057C19.5615 16.1855 19.333 16.0918 19.0957 16.0244C19.4502 15.6201 19.6436 15.1045 19.6436 14.5596V13.2295C19.6436 12.002 18.6445 11 17.4141 11C16.1836 11 15.1846 11.999 15.1846 13.2295V14.5391C15.1846 15.1074 15.3955 15.626 15.7412 16.0244C14.4463 16.3848 13.4941 17.5742 13.4941 18.9863V19.3525L12 21.5557H13.04V22.9238C13.04 24.6201 14.4199 26 16.1162 26H26.9707V24.0459C26.9707 22.2471 25.7637 20.7266 24.1172 20.249ZM16.1162 23.3633C15.873 23.3633 15.6768 23.167 15.6768 22.9238V21.5557H16.7168L16.3184 20.9697H19.1484C18.4189 21.5586 17.9033 22.4023 17.7363 23.3633H16.1162ZM20.6104 16.7744C20.6104 15.8311 21.3779 15.0605 22.3242 15.0605C23.2676 15.0605 24.0381 15.8281 24.0381 16.7744V18.377C24.0381 18.8369 23.8594 19.2676 23.5312 19.5928C23.2061 19.918 22.7695 20.0938 22.3125 20.0908C21.375 20.085 20.6133 19.3027 20.6133 18.3506V16.7744H20.6104ZM16.0664 13.2295C16.0664 12.4854 16.6729 11.8789 17.417 11.8789C18.1611 11.8789 18.7676 12.4854 18.7676 13.2295V14.5625C18.7676 14.9258 18.627 15.2656 18.3691 15.5205C18.1113 15.7754 17.7715 15.9131 17.4082 15.9131C16.6699 15.9072 16.0693 15.292 16.0693 14.542L16.0664 13.2295ZM16.5703 16.7891H18.2695C18.832 16.7891 19.3447 17 19.7344 17.3486V18.3506C19.7344 19.0156 19.9834 19.6279 20.3936 20.0908H15.7236L14.4902 18.2715C14.7891 17.4102 15.6064 16.7891 16.5703 16.7891ZM16.1162 25.1211C14.9033 25.1211 13.9189 24.1367 13.9189 22.9238V20.6768H13.6582L14.3584 19.6426L15.0586 20.6768H14.7979V22.9238C14.7979 23.6504 15.3896 24.2422 16.1162 24.2422H18.0205V25.1211H16.1162ZM26.0918 25.1211H18.8994V23.3633H18.6328C18.9434 21.9951 20.1709 20.9697 21.6328 20.9697H23.0156C24.7119 20.9697 26.0918 22.3496 26.0918 24.0459V25.1211Z"
        // fill="#5936F1"
        fill={fillColor}
      />
    </svg>
  );
};

export const RequestIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="35"
      viewBox="0 0 30 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.92864 4.54994L13.1984 1.37848L12.6721 0.496764C12.3782 0.0114772 11.7494 -0.145728 11.2641 0.148178L7.75093 2.2602C7.26564 2.55411 7.10843 3.18293 7.40234 3.66822L7.92864 4.54994Z"
        fill={fillColor}
      />
      <path
        d="M29.1377 23.9341C28.8438 23.4488 28.215 23.2984 27.7297 23.5923L22.0088 27.0645C22.2822 27.7139 22.4599 28.4179 22.5214 29.1492L28.7892 25.3421C29.2813 25.0482 29.4316 24.4194 29.1377 23.9341Z"
        fill={fillColor}
      />
      <path
        d="M23.5809 32.9495H20.5051V29.8054C20.5051 26.9757 18.2085 24.6791 15.3788 24.6791C12.5491 24.6791 10.2525 26.9757 10.2525 29.8054V32.9495H7.17678C6.60947 32.9495 6.15153 33.4074 6.15153 33.9747C6.15153 34.5421 6.60947 35 7.17678 35H23.5809C24.1482 35 24.6061 34.5421 24.6061 33.9747C24.6061 33.4074 24.1482 32.9495 23.5809 32.9495ZM15.3788 30.8306C14.8115 30.8306 14.3536 30.3727 14.3536 29.8054C14.3536 29.2381 14.8115 28.7801 15.3788 28.7801C15.9461 28.7801 16.4041 29.2381 16.4041 29.8054C16.4041 30.3727 15.9461 30.8306 15.3788 30.8306Z"
        fill={fillColor}
      />
      <path
        d="M7.75776 8.24085L8.8377 10.0385L11.0249 8.71931C13.6154 7.15408 16.9577 8.02213 18.4956 10.5374C20.0813 13.1279 19.2474 16.5044 16.6433 18.0628L14.4424 19.382L15.1396 20.5507C15.4335 21.036 16.0623 21.1932 16.5476 20.8993C16.5818 20.8788 16.9235 20.6738 17.443 20.3594L19.0151 22.9772C19.309 23.4625 19.9378 23.6197 20.4231 23.3258L23.9363 21.2137C24.4216 20.9198 24.5788 20.291 24.2849 19.8057L22.7128 17.1879C23.2391 16.8735 23.574 16.6684 23.574 16.6684C24.0593 16.3745 24.2165 15.7457 23.9226 15.2604C23.8953 15.2194 16.5203 2.94371 16.4929 2.9027C16.1854 2.45842 15.5839 2.32855 15.1191 2.60195L8.10635 6.83284C7.62106 7.12674 7.46385 7.75557 7.75776 8.24085Z"
        fill={fillColor}
      />
      <path
        d="M8.20204 29.8054C8.20204 27.7959 9.02908 25.9846 10.3619 24.6791H9.22729C7.5322 24.6791 6.15153 23.2984 6.15153 21.6033C6.15153 19.9083 7.5322 18.5276 9.22729 18.5276H11.5922C11.7768 18.5276 11.9613 18.4797 12.1185 18.384L15.5907 16.3062C17.2174 15.3356 17.7301 13.2304 16.7458 11.6105C15.7753 10.018 13.6837 9.51217 12.0843 10.4759L8.93338 12.376C3.97799 12.5333 0 16.6138 0 21.6033C0 26.3469 3.59523 30.2633 8.20204 30.776V29.8054Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ConfigurationIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M15.0434 22.6247C16.952 22.6247 18.4991 21.2895 18.4991 19.6424C18.4991 17.9954 16.952 16.6602 15.0434 16.6602C13.1348 16.6602 11.5876 17.9954 11.5876 19.6424C11.5876 21.2895 13.1348 22.6247 15.0434 22.6247Z"
        fill="#67CDDF"
      />
      <path
        d="M19.6875 9.05315V0.832677C19.6875 0.372047 19.2564 0 18.7226 0H11.2774C10.7436 0 10.3125 0.372047 10.3125 0.832677V9.04724C4.20849 10.7835 0 15.75 0 21.3484C0 24.4075 1.25912 27.372 3.55155 29.7047C3.73631 29.8937 4.00319 30 4.2906 30H25.7094C25.99 30 26.2637 29.8937 26.4484 29.7047C28.7409 27.372 30 24.4016 30 21.3484C30 15.75 25.7915 10.7835 19.6875 9.05315ZM23.7933 20.8878C23.7933 21.3484 23.3622 21.7205 22.8285 21.7205H21.3025C21.2546 21.8209 21.2067 21.9213 21.1588 22.0157L22.24 22.9488C22.6026 23.2441 22.6369 23.7579 22.24 24.1299L20.1939 25.8957C20.016 26.0492 19.7628 26.1319 19.5096 26.1319C19.2564 26.1319 19.01 26.0551 18.8253 25.8957L17.7441 24.9626C17.7441 24.9626 17.7441 24.9626 17.7372 24.9626C17.6277 25.0039 17.5114 25.0453 17.3951 25.0866V26.4035C17.3951 26.8642 16.964 27.2362 16.4302 27.2362H13.5493C13.0155 27.2362 12.5844 26.8642 12.5844 26.4035V25.0866C12.4681 25.0453 12.3517 25.0039 12.2422 24.9626C12.2422 24.9626 12.2422 24.9626 12.2354 24.9626L11.161 25.8839C10.7847 26.2087 10.1756 26.2087 9.79243 25.8839L7.74635 24.1181C7.56159 23.9646 7.46578 23.7579 7.46578 23.5453C7.46578 23.3327 7.55474 23.1201 7.74635 22.9488L8.82755 22.0157C8.82755 22.0157 8.82755 22.0098 8.82071 22.0098L8.82755 22.0039C8.77965 21.9095 8.73175 21.8091 8.68385 21.7087H7.15785C6.62409 21.7087 6.19297 21.3366 6.19297 20.876V20.4626V18.815V18.4016C6.19297 17.9409 6.62409 17.5689 7.15785 17.5689H8.69069C8.73859 17.4685 8.7865 17.3681 8.8344 17.2736L7.75319 16.3406C7.37682 16.0394 7.37682 15.4606 7.75319 15.1594L9.79927 13.3937C10.1825 13.0689 10.7915 13.0689 11.1679 13.3937L12.2491 14.315C12.3586 14.2677 12.4749 14.2264 12.5912 14.1909V12.874C12.5912 12.4134 13.0224 12.0413 13.5561 12.0413H16.4439C16.9776 12.0413 17.4088 12.4134 17.4088 12.874V14.1909C17.5251 14.2323 17.6414 14.2736 17.7509 14.315L18.8321 13.3819C19.2153 13.0571 19.8244 13.0571 20.2007 13.3819L22.2468 15.1476C22.6163 15.4724 22.63 15.998 22.2468 16.3287L21.1656 17.2618C21.2203 17.3563 21.2682 17.4567 21.3093 17.5571H22.8353C23.3691 17.5571 23.8002 17.9291 23.8002 18.3898L23.7933 20.8878Z"
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const ExitIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <path
        d="M21.9314 9.73232C21.8842 9.62061 21.8197 9.51748 21.7338 9.43154L18.9838 6.68154C18.6271 6.3249 18.0471 6.3249 17.6861 6.68154C17.3295 7.03818 17.3295 7.61826 17.6861 7.9792L18.8721 9.16514H13.7502C13.2432 9.16514 12.835 9.57764 12.835 10.0804C12.835 10.5831 13.2432 10.9999 13.7502 10.9999H18.8721L17.6861 12.1858C17.3295 12.5425 17.3295 13.1226 17.6861 13.4835C17.8666 13.664 18.0986 13.7542 18.335 13.7542C18.5713 13.7542 18.8033 13.664 18.9838 13.4835L21.7338 10.7335C21.8197 10.6476 21.8842 10.5487 21.9314 10.4327C22.0217 10.2093 22.0217 9.95576 21.9314 9.73232Z"
        fill={fillColor}
      />
      <path
        d="M15.5848 12.8348C15.0777 12.8348 14.6695 13.2473 14.6695 13.75V18.3348H11V3.66523C11 3.26133 10.7336 2.90469 10.3469 2.78867L7.16289 1.83477H14.6652V6.41953C14.6652 6.92656 15.0734 7.33477 15.5805 7.33477C16.0875 7.33477 16.4957 6.92227 16.4957 6.41953V0.919531C16.5 0.4125 16.0918 0 15.5848 0H0.915234C0.880859 0 0.850781 0.0128906 0.820703 0.0171875C0.777734 0.0214844 0.739063 0.0300781 0.696094 0.0386719C0.601563 0.0644531 0.515625 0.103125 0.433984 0.154687C0.4125 0.167578 0.386719 0.167578 0.369531 0.180469C0.360938 0.189062 0.360938 0.197656 0.352344 0.201953C0.253516 0.279297 0.167578 0.378125 0.107422 0.489844C0.0945313 0.515625 0.0902344 0.541406 0.0816406 0.567187C0.0515625 0.635938 0.0214844 0.704688 0.00859375 0.782031C0.00429688 0.807813 0.0128906 0.833594 0.0128906 0.863672C0.0128906 0.880859 0 0.898047 0 0.915234V19.25C0 19.6883 0.309375 20.0621 0.739063 20.148L9.9043 21.9828C9.96445 21.9957 10.0246 22 10.0848 22C10.2953 22 10.5016 21.927 10.6648 21.7938C10.8754 21.6176 11 21.3598 11 21.0848V20.1695H15.5848C16.0918 20.1695 16.5 19.757 16.5 19.2543V13.75C16.5 13.243 16.0918 12.8348 15.5848 12.8348Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const CrossIcon2: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  fillColor1,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <circle cx="10" cy="10.585" r="10" fill={fillColor1} />
      <path
        d="M13.9475 6.6377L6.05273 14.5324"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.05253 6.6377L13.9473 14.5324"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SubstoreIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6685 26.7968C26.8643 26.6015 26.6685 31 26.7378 18.5815L26.7515 18.5969V7.82705C26.7515 7.76547 26.7202 7.70816 26.6685 7.67477L14.8259 0.0289846C14.7672 -0.0089256 14.692 -0.00968732 14.6325 0.0269338L2.21223 7.67518C2.15861 7.70816 2.12598 7.76658 2.12598 7.82957V26.7968H5.15029H26.6685Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.749 21.3615C17.9001 21.2947 18.0495 21.2279 18.0495 21.0635V15.0185C18.0495 14.8541 17.9139 14.7188 17.749 14.7188C16.6682 14.7188 16.0119 14.7188 15.5164 14.7188C15.1742 15.0001 14.598 15.1368 13.9433 14.7188C13.4475 14.7188 12.7908 14.7188 11.709 14.7188C11.5441 14.7188 11.4102 14.8541 11.4102 15.0185V21.0635C11.4102 21.2262 11.5424 21.3599 11.7073 21.3616L14.7299 22.6994L17.749 21.3615Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5165 14.7188H13.9434V16.667C13.9434 16.7641 14.0221 16.8428 14.1191 16.8428H15.3407C15.4378 16.8428 15.5165 16.7641 15.5165 16.667V14.7188Z"
        fill="#002C5A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7297 25.4979V19.7578C11.4688 19.7578 10.7386 19.7578 10.1966 19.7578C9.83664 20.1387 9.29465 20.2852 8.62346 19.7578C8.12565 19.7578 7.4684 19.7578 6.39086 19.7578C6.22428 19.7578 6.09033 19.8931 6.09033 20.0576V25.4979C6.09033 25.6623 6.22428 25.7977 6.39086 25.7977H12.4292C12.5941 25.7977 12.7297 25.6623 12.7297 25.4979Z"
        fill="#78E7DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1047 19.7578V25.4722C16.1047 25.6503 16.2507 25.7977 16.4293 25.7977H22.9811C23.1597 25.7977 23.3057 25.6504 23.3057 25.4722V20.0832C23.3057 19.9051 23.1598 19.7578 22.9811 19.7578H19.3798H16.1047Z"
        fill="#78E7DC"
      />
      <path
        d="M15.5318 6.80879H13.8951C13.6448 6.80879 13.4419 6.60588 13.4419 6.35557C13.4419 6.10525 13.6448 5.90234 13.8951 5.90234H15.5318C15.7821 5.90234 15.985 6.10525 15.985 6.35557C15.985 6.60588 15.7821 6.80879 15.5318 6.80879Z"
        fill="#00366D"
      />
      <path
        d="M15.5318 4.99629H13.8951C13.6448 4.99629 13.4419 4.79338 13.4419 4.54307C13.4419 4.29275 13.6448 4.08984 13.8951 4.08984H15.5318C15.7821 4.08984 15.985 4.29275 15.985 4.54307C15.985 4.79338 15.7821 4.99629 15.5318 4.99629Z"
        fill="#00366D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7072 20.7578H10.6235V22.7061C10.6235 22.8031 10.7022 22.8818 10.7993 22.8818H12.0209C12.118 22.8818 12.1967 22.8031 12.1967 22.7061V20.7578H11.7089H11.7072Z"
        fill="#002C5A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0837 21H17V22.9482C17 23.0453 17.0787 23.124 17.1758 23.124H18.3973C18.4944 23.124 18.5731 23.0453 18.5731 22.9482V21H18.0854H18.0837Z"
        fill="#002C5A"
      />
      <path
        d="M24.5234 10.9064H4.47651C4.21333 10.9064 4 10.7035 4 10.4532C4 10.2029 4.21333 10 4.47651 10H24.5235C24.7867 10 25 10.2029 25 10.4532C24.9999 10.7035 24.7866 10.9064 24.5234 10.9064Z"
        fill="#00366D"
      />
      <path
        d="M5.90644 7.45404L5.90645 26.5214C5.90645 26.7717 5.70354 26.9746 5.45322 26.9746C5.20291 26.9746 5 26.7717 5 26.5214L5 7.45399C5 7.20367 5.20291 7.00076 5.45322 7.00076C5.70354 7.00082 5.90644 7.20373 5.90644 7.45404Z"
        fill="#00366D"
      />
      <path
        d="M23.9064 8.45404L23.9064 27.5214C23.9064 27.7717 23.7035 27.9746 23.4532 27.9746C23.2029 27.9746 23 27.7717 23 27.5214L23 8.45399C23 8.20367 23.2029 8.00076 23.4532 8.00076C23.7035 8.00082 23.9064 8.20373 23.9064 8.45404Z"
        fill="#00366D"
      />
    </svg>
  );
};

export const MainstoreIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1051 14.2422H16.0986V16.1959C16.0986 16.4601 15.8926 16.6683 15.6484 16.6683H14.1912C13.9395 16.6683 13.7411 16.4521 13.7411 16.1959V14.2422H11.7346C11.5439 14.2422 11.3913 14.4023 11.3913 14.6025V21.1602C11.3913 21.4324 11.6049 21.6566 11.8643 21.6566H17.983C18.2424 21.6566 18.456 21.4324 18.456 21.1602V14.6025C18.4484 14.4023 18.2958 14.2422 18.1051 14.2422Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.155 14.2422H8.1485V16.1959C8.1485 16.4601 7.94251 16.6683 7.69837 16.6683H6.24117C5.9894 16.6683 5.79104 16.4521 5.79104 16.1959V14.2422H3.77689C3.58616 14.2422 3.43357 14.4023 3.43357 14.6025V21.1602C3.43357 21.4324 3.6472 21.6566 3.90659 21.6566H10.0253C10.2847 21.6566 10.4983 21.4324 10.4983 21.1602V14.6025C10.4983 14.4023 10.3457 14.2422 10.155 14.2422Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1051 22.5859H16.0986V24.5396C16.0986 24.8039 15.8926 25.012 15.6484 25.012H14.1912C13.9395 25.012 13.7411 24.7959 13.7411 24.5396V22.5859H11.7346C11.5439 22.5859 11.3913 22.7461 11.3913 22.9462V29.5039C11.3913 29.7762 11.6049 30.0004 11.8643 30.0004H17.983C18.2424 30.0004 18.456 29.7762 18.456 29.5039V22.9462C18.4484 22.7461 18.2958 22.5859 18.1051 22.5859Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.1689 14.2422H24.1624V16.1959C24.1624 16.4601 23.9564 16.6683 23.7122 16.6683H22.255C22.0033 16.6683 21.8049 16.4521 21.8049 16.1959V14.2422H19.7984C19.6076 14.2422 19.4551 14.4023 19.4551 14.6025V21.1602C19.4551 21.4324 19.6687 21.6566 19.9281 21.6566H26.0468C26.3062 21.6566 26.5198 21.4324 26.5198 21.1602V14.6025C26.5122 14.4023 26.3596 14.2422 26.1689 14.2422Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.1689 22.5859H24.1624V24.5396C24.1624 24.8039 23.9564 25.012 23.7122 25.012H22.255C22.0033 25.012 21.8049 24.7959 21.8049 24.5396V22.5859H19.7984C19.6076 22.5859 19.4551 22.7461 19.4551 22.9462V29.5039C19.4551 29.7762 19.6687 30.0004 19.9281 30.0004H26.0468C26.3062 30.0004 26.5198 29.7762 26.5198 29.5039V22.9462C26.5122 22.7461 26.3596 22.5859 26.1689 22.5859Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.155 22.5859H8.1485V24.5396C8.1485 24.8039 7.94251 25.012 7.69837 25.012H6.24117C5.9894 25.012 5.79104 24.7959 5.79104 24.5396V22.5859H3.77689C3.58616 22.5859 3.43357 22.7461 3.43357 22.9462V29.5039C3.43357 29.7762 3.6472 30.0004 3.90659 30.0004H10.0253C10.2847 30.0004 10.4983 29.7762 10.4983 29.5039V22.9462C10.4983 22.7461 10.3457 22.5859 10.155 22.5859Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9451 6.21138L15.0298 0.0060052C15.0069 -0.00200173 14.984 -0.00200173 14.9688 0.0060052L0.0534053 6.21138C0.022888 6.2274 0 6.25942 0 6.29145V29.992H2.21251C2.25828 29.992 2.29643 29.952 2.29643 29.9039V11.1116C2.29643 11.0636 2.33458 11.0236 2.38035 11.0236H27.6182C27.664 11.0236 27.7021 11.0636 27.7021 11.1116V29.9119C27.7021 29.96 27.7403 30 27.786 30H29.9146C29.9604 30 29.9985 29.96 29.9985 29.9119V6.29145C30.0062 6.25942 29.9833 6.2274 29.9451 6.21138ZM18.6079 8.01294C18.6079 8.14906 18.5088 8.25315 18.3791 8.25315H11.6195C11.4898 8.25315 11.3906 8.14906 11.3906 8.01294V6.53967C11.3906 6.40355 11.4898 6.29946 11.6195 6.29946H18.3791C18.5088 6.29946 18.6079 6.40355 18.6079 6.53967V8.01294Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const PurchaseIon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M6.92308 3.13557V14.982C6.92083 15.1965 6.84582 15.4052 6.70821 15.5797C6.5706 15.7542 6.37706 15.8862 6.15385 15.9576C6.03143 16.002 5.90107 16.0256 5.76923 16.0273H1.15385C0.84907 16.0237 0.557894 15.9124 0.342363 15.7172C0.126833 15.5219 0.00398812 15.2581 3.55724e-06 14.982V3.13557C-0.00126418 2.33577 0.336362 1.56603 0.943235 0.985141C1.55011 0.404251 2.37994 0.0565175 3.26154 0.0136719H3.46154C4.37694 0.0136637 5.25507 0.342131 5.9038 0.927203C6.55252 1.51227 6.91901 2.30631 6.92308 3.13557Z"
        fill="#67CDDF"
      />
      <path
        d="M29.9999 8.0138V27.219C29.9998 27.641 29.8787 28.0557 29.6487 28.4226C29.4187 28.7895 29.0875 29.0961 28.6875 29.3124C28.2876 29.5287 27.8325 29.6472 27.3668 29.6565C26.9011 29.6658 26.4408 29.5655 26.0307 29.3653L25.5384 29.1145C24.9357 28.7197 24.2047 28.5186 23.4615 28.543C22.7066 28.5207 21.9651 28.7266 21.3538 29.1284C20.3763 29.6975 19.2388 30 18.0769 30C16.9149 30 15.7774 29.6975 14.7999 29.1284C14.1832 28.7381 13.4443 28.5378 12.6922 28.557C11.9448 28.5368 11.2105 28.7373 10.5999 29.1284L10.123 29.3793C9.71294 29.5794 9.25257 29.6797 8.78689 29.6705C8.3212 29.6612 7.86614 29.5426 7.46618 29.3263C7.06622 29.1101 6.73504 28.8035 6.50501 28.4366C6.27497 28.0696 6.15395 27.6549 6.15378 27.233V2.78741C6.1552 2.07623 5.85648 1.39145 5.3188 0.873262C4.78111 0.355075 4.04511 0.0426698 3.26147 0H21.1538C23.4987 0.00368476 25.7464 0.849176 27.4045 2.35126C29.0626 3.85334 29.9959 5.88954 29.9999 8.0138Z"
        fill="#EAEFFE"
      />
      <path
        d="M23.4616 9.05931H12.6924C12.3864 9.05931 12.0929 8.94918 11.8765 8.75315C11.6601 8.55712 11.5386 8.29125 11.5386 8.01403C11.5386 7.7368 11.6601 7.47093 11.8765 7.2749C12.0929 7.07888 12.3864 6.96875 12.6924 6.96875H23.4616C23.7677 6.96875 24.0612 7.07888 24.2775 7.2749C24.4939 7.47093 24.6155 7.7368 24.6155 8.01403C24.6155 8.29125 24.4939 8.55712 24.2775 8.75315C24.0612 8.94918 23.7677 9.05931 23.4616 9.05931Z"
        fill="#002C5A"
      />
      <path
        d="M18.8463 20.2077H12.6924C12.3864 20.2077 12.0929 20.0976 11.8765 19.9016C11.6601 19.7056 11.5386 19.4397 11.5386 19.1625C11.5386 18.8852 11.6601 18.6194 11.8765 18.4233C12.0929 18.2273 12.3864 18.1172 12.6924 18.1172H18.8463C19.1523 18.1172 19.4458 18.2273 19.6622 18.4233C19.8785 18.6194 20.0001 18.8852 20.0001 19.1625C20.0001 19.4397 19.8785 19.7056 19.6622 19.9016C19.4458 20.0976 19.1523 20.2077 18.8463 20.2077Z"
        fill="#002C5A"
      />
      <path
        d="M23.4616 14.6335H12.6924C12.3864 14.6335 12.0929 14.5234 11.8765 14.3274C11.6601 14.1313 11.5386 13.8655 11.5386 13.5882C11.5386 13.311 11.6601 13.0452 11.8765 12.8491C12.0929 12.6531 12.3864 12.543 12.6924 12.543H23.4616C23.7677 12.543 24.0612 12.6531 24.2775 12.8491C24.4939 13.0452 24.6155 13.311 24.6155 13.5882C24.6155 13.8655 24.4939 14.1313 24.2775 14.3274C24.0612 14.5234 23.7677 14.6335 23.4616 14.6335Z"
        fill="#002C5A"
      />
    </svg>
  );
};

export const UsDollarCurrencyIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49833 0C3.35231 0 0 3.35231 0 7.49833C0 11.6443 3.35231 15 7.49833 15C11.6443 15 15 11.6443 15 7.49833C15 3.35231 11.6443 0 7.49833 0ZM1.41996 4.17281C2.05626 3.01072 3.01741 2.04956 4.1795 1.41326C4.33691 1.34293 4.44407 1.42666 4.48091 1.50368C4.53784 1.61085 4.49766 1.74481 4.39049 1.80174C3.30208 2.39451 2.40455 3.29873 1.80844 4.38714C1.75151 4.49766 1.6142 4.53784 1.50368 4.47756C1.39652 4.41728 1.35968 4.27997 1.41996 4.17281ZM1.58741 7.44809C1.58741 4.17281 4.24983 1.50703 7.52847 1.50703C10.8071 1.50703 13.4662 4.16946 13.4662 7.44809C13.4662 10.7267 10.8038 13.3891 7.52847 13.3891C4.25318 13.3891 1.58741 10.7267 1.58741 7.44809ZM10.8439 13.5733C10.7368 13.6303 10.6028 13.5934 10.5459 13.4863C10.4856 13.3791 10.5258 13.2418 10.633 13.1849C11.7214 12.5854 12.6155 11.6845 13.2083 10.5928C13.2485 10.5224 13.3054 10.4923 13.3657 10.4823C13.4226 10.4722 13.4762 10.4856 13.5097 10.5023C13.6169 10.5593 13.6571 10.6932 13.6001 10.8004C12.9638 11.9658 12.006 12.9337 10.8439 13.5733Z"
        fill="#FFA009"
      />
      <path
        d="M7.50092 2.06641C4.52369 2.06641 2.11914 4.47096 2.11914 7.44819C2.11914 10.4254 4.52369 12.83 7.50092 12.83C10.4781 12.83 12.8827 10.4254 12.8827 7.44819C12.8827 4.47096 10.4748 2.06641 7.50092 2.06641ZM9.09168 9.77237C8.85055 10.0671 8.53575 10.2647 8.16737 10.3651C8.00662 10.4087 7.93294 10.4924 7.94299 10.6598C7.94968 10.8239 7.94299 10.9847 7.93964 11.1521C7.93964 11.2995 7.86596 11.3765 7.72195 11.3799C7.62818 11.3832 7.53441 11.3832 7.44064 11.3832C7.35692 11.3832 7.27654 11.3832 7.19282 11.3799C7.03877 11.3765 6.96509 11.2894 6.96509 11.1387C6.96174 11.0215 6.96174 10.8976 6.96174 10.7804C6.95839 10.5158 6.95169 10.5058 6.69717 10.4656C6.37232 10.412 6.05417 10.3417 5.75611 10.1977C5.52169 10.0838 5.49824 10.0269 5.56522 9.77907C5.61546 9.59487 5.66569 9.41403 5.72262 9.23319C5.76281 9.09923 5.803 9.04229 5.87333 9.04229C5.91351 9.04229 5.9671 9.06239 6.03743 9.09923C6.36562 9.27002 6.71392 9.36714 7.0823 9.41068C7.14258 9.41738 7.20621 9.42073 7.26649 9.42073C7.43729 9.42073 7.60474 9.38724 7.76549 9.31691C8.17406 9.13941 8.23769 8.66721 7.89275 8.38255C7.77554 8.28543 7.64158 8.2151 7.50092 8.15482C7.14258 7.99742 6.77085 7.8802 6.4326 7.67592C5.88337 7.34772 5.53843 6.89896 5.57862 6.22917C5.6255 5.47565 6.05082 5.00679 6.74406 4.75562C7.02872 4.6518 7.03207 4.65515 7.03207 4.3571C7.03207 4.25663 7.02872 4.15616 7.03542 4.05234C7.04211 3.82796 7.07895 3.79112 7.30333 3.78442C7.32678 3.78442 7.35692 3.78442 7.38036 3.78442C7.4239 3.78442 7.46743 3.78442 7.51097 3.78442C7.52771 3.78442 7.54781 3.78442 7.56455 3.78442C7.98987 3.78442 7.98987 3.80117 7.98987 4.25998C7.99322 4.59822 7.99322 4.59822 8.32812 4.6518C8.58599 4.69199 8.83046 4.76902 9.06824 4.87284C9.19885 4.92977 9.24908 5.02019 9.20889 5.16085C9.14861 5.36513 9.09168 5.57277 9.02805 5.77706C8.98786 5.90097 8.94767 5.9579 8.874 5.9579C8.83381 5.9579 8.78357 5.94116 8.71994 5.91101C8.39175 5.75026 8.0468 5.67324 7.68512 5.67324C7.63823 5.67324 7.59134 5.67659 7.54446 5.67659C7.43729 5.68329 7.33347 5.69668 7.23301 5.74022C6.87802 5.89427 6.82108 6.28945 7.12249 6.53057C7.27654 6.65448 7.45069 6.74156 7.63153 6.81523C7.94633 6.94584 8.26114 7.06976 8.55919 7.23385C9.5036 7.76634 9.75812 8.96192 9.09168 9.77237Z"
        fill="#FFA009"
      />
    </svg>
  );
};

export const KuwaitDinarCurrencyIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18095_15604)">
        <path
          d="M7.5274 2.06836C4.55119 2.06836 2.14453 4.47502 2.14453 7.45123C2.14453 10.4274 4.55119 12.8341 7.5274 12.8341C10.5036 12.8341 12.9068 10.4274 12.9068 7.45123C12.9068 4.47502 10.5036 2.06836 7.5274 2.06836ZM3.65173 5.1418H4.47132V7.35399L4.92626 6.79139L6.30497 5.13833H7.29472L5.54442 7.22897L7.39543 9.85789H6.42304L5.00266 7.81935L4.46785 8.38542V9.85789H3.64826L3.65173 5.1418ZM7.83301 5.1418H9.22561C9.64235 5.1418 10.0105 5.23557 10.3334 5.41963C10.6564 5.60369 10.9065 5.86762 11.0836 6.21143C11.2919 6.68373 11.3475 7.11436 11.351 7.6214C11.351 8.06939 11.2607 8.46182 11.0801 8.80215C10.903 9.14249 10.6495 9.40295 10.3195 9.58701C9.98963 9.77107 9.61456 9.86136 9.18741 9.86136H7.82954V5.1418H7.83301ZM8.65259 5.80164V9.20153H9.18741C9.61804 9.20153 9.94795 9.06609 10.1772 8.79868C10.4098 8.5278 10.5244 8.14232 10.5314 7.63876C10.5835 7.11089 10.4411 6.51357 10.198 6.20449C9.97574 5.93361 9.65276 5.79817 9.22908 5.79817H8.65259V5.80164Z"
          fill="#FFA009"
        />
        <path
          d="M7.49977 0.00195312C3.35322 0.00195312 0.00195312 3.35322 0.00195312 7.49977C0.00195312 11.6463 3.35322 15.0011 7.49977 15.0011C11.6463 15.0011 15.0011 11.6463 15.0011 7.49977C15.0011 3.35322 11.6428 0.00195312 7.49977 0.00195312ZM4.48189 1.50221C4.53745 1.60987 4.49925 1.74183 4.3916 1.80087C3.30113 2.39472 2.40514 3.29766 1.80782 4.38465C1.74878 4.49578 1.61334 4.53398 1.50568 4.47494C1.39803 4.4159 1.35983 4.27699 1.41886 4.16933C2.05786 3.00594 3.01636 2.04397 4.17975 1.40844C4.33603 1.33899 4.44369 1.42234 4.48189 1.50221ZM7.52755 1.50916C10.8024 1.50916 13.4661 4.17281 13.4661 7.44768C13.4661 10.7225 10.8024 13.3862 7.52755 13.3862C4.25268 13.3862 1.58903 10.7225 1.58903 7.44768C1.58903 4.17281 4.25268 1.50916 7.52755 1.50916ZM13.5077 10.5003C13.6154 10.5593 13.6536 10.6913 13.598 10.7989C12.966 11.9658 12.0075 12.9313 10.8476 13.5703C10.7399 13.6293 10.6079 13.5876 10.5489 13.4834C10.4899 13.3758 10.5281 13.2403 10.6357 13.1813C11.7227 12.5805 12.6187 11.681 13.2126 10.5871C13.2508 10.5176 13.3098 10.4864 13.3688 10.476C13.4209 10.469 13.473 10.4829 13.5077 10.5003Z"
          fill="#FFA009"
        />
      </g>
      <defs>
        <clipPath id="clip0_18095_15604">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmiratiDirhamCurrencyIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18095_15617)">
        <path
          d="M7.52749 2.06836C4.55123 2.06836 2.14453 4.47506 2.14453 7.45131C2.14453 10.4276 4.55123 12.8343 7.52749 12.8343C10.5037 12.8343 12.907 10.4276 12.907 7.45131C12.907 4.47506 10.5037 2.06836 7.52749 2.06836ZM4.78739 4.0479C5.0166 5.38148 5.22497 6.56573 5.26317 7.82291C5.26317 8.06601 5.23539 8.28828 5.17635 8.4897C5.12078 8.68766 5.00618 8.95854 4.84295 9.29541L4.59638 9.19817C4.66236 8.85088 4.69362 8.56611 4.69362 8.34731C4.68667 7.34713 4.23867 5.61764 4.30119 5.21826C4.38106 4.79456 4.61374 4.39866 4.78739 4.0479ZM9.90988 5.1488C10.6947 5.8017 10.8684 6.74285 10.8684 7.70136V9.01411H9.01735C8.58671 9.01758 8.42001 8.73628 8.43043 8.44455C8.42349 8.16325 8.46863 7.89237 8.50336 7.63538L8.65964 7.62843C8.71868 7.87848 8.91664 7.89931 9.07639 7.90279H10.4829C10.3996 7.22558 10.1877 6.74979 9.62163 6.42682L9.90988 5.1488ZM6.74956 8.99674C7.11769 8.99674 7.41983 9.27804 7.41983 9.6288C7.41983 9.97609 7.12116 10.2574 6.75304 10.2574C6.38491 10.2574 6.08624 9.97609 6.08624 9.6288C6.0793 9.27804 6.37796 8.99674 6.74956 8.99674ZM4.90199 9.76772C5.09995 9.7573 5.11384 9.96567 5.06869 10.0664C5.05827 10.0976 5.03396 10.1428 4.99576 10.2053C4.86032 10.1358 4.76655 10.1046 4.71793 10.1046C4.61374 10.0872 4.52692 10.1497 4.48178 10.2053C4.56512 10.3546 4.79086 10.4623 4.96103 10.4797C5.08258 10.4658 5.16246 10.438 5.25623 10.4171C5.24581 10.5873 5.12078 10.6498 5.02007 10.6846L4.13796 10.9554C4.19005 10.7783 4.34286 10.7158 4.49219 10.6394C4.34286 10.5977 4.28729 10.4727 4.27688 10.3789C4.28382 10.0699 4.6068 9.78161 4.90199 9.76772Z"
          fill="#FFA009"
        />
        <path
          d="M7.49989 0.00195312C3.35328 0.00195312 0.00195312 3.35328 0.00195312 7.49989C0.00195312 11.6465 3.35328 15.0013 7.49989 15.0013C11.6465 15.0013 15.0013 11.6465 15.0013 7.49989C15.0013 3.35328 11.643 0.00195312 7.49989 0.00195312ZM4.48196 1.50223C4.53753 1.60989 4.49932 1.74186 4.39167 1.8009C3.30118 2.39476 2.40518 3.29771 1.80785 4.38472C1.74881 4.49585 1.61337 4.53405 1.50571 4.47501C1.39805 4.41598 1.35985 4.27706 1.41889 4.1694C2.05789 3.00599 3.01641 2.044 4.17982 1.40847C4.3361 1.33901 4.44376 1.42236 4.48196 1.50223ZM7.52767 1.50918C10.8026 1.50918 13.4663 4.17287 13.4663 7.44779C13.4663 10.7227 10.8026 13.3864 7.52767 13.3864C4.25275 13.3864 1.58906 10.7227 1.58906 7.44779C1.58906 4.17287 4.25275 1.50918 7.52767 1.50918ZM13.508 10.5004C13.6156 10.5595 13.6538 10.6915 13.5983 10.7991C12.9662 11.966 12.0077 12.9315 10.8477 13.5705C10.7401 13.6295 10.6081 13.5878 10.5491 13.4836C10.49 13.376 10.5282 13.2405 10.6359 13.1815C11.7229 12.5807 12.6189 11.6812 13.2128 10.5873C13.251 10.5178 13.31 10.4866 13.369 10.4761C13.4211 10.4692 13.4732 10.4831 13.508 10.5004Z"
          fill="#FFA009"
        />
      </g>
      <defs>
        <clipPath id="clip0_18095_15617">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RequestInventoryIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M16.6964 4.47153C17.5599 4.47153 18.2629 3.8247 18.2629 3.0232V1.44129C18.2629 0.646824 17.5599 0 16.6964 0H6.80107C5.93761 0 5.23462 0.646824 5.23462 1.44129V3.0232C5.23462 3.81767 5.93761 4.47153 6.80107 4.47153H16.6964Z"
        fill="#67CDDF"
      />
      <path
        d="M11.5603 21.4585C12.5078 21.6413 13.3254 22.2952 13.6846 22.6256C14.2729 23.167 14.8613 23.9404 15.0676 24.7208L27.0643 13.6826L23.5341 10.4414L11.5603 21.4585Z"
        fill="#67CDDF"
      />
      <path
        d="M10.9801 22.6023L9.98678 25.3935C9.91801 25.6115 9.97149 25.8435 10.1472 26.0052C10.2695 26.1177 10.4376 26.1809 10.6057 26.1809C10.6745 26.1809 10.7433 26.1669 10.8044 26.1528L13.8379 25.2388C13.815 24.7607 13.4024 24.0577 12.7605 23.4671C12.1416 22.8976 11.4157 22.5531 10.9801 22.6023Z"
        fill="#78E7DC"
      />
      <path
        d="M25.7363 8.4147L24.4602 9.58882L27.9904 12.837L29.2665 11.6629C29.7326 11.227 30.0001 10.6505 30.0001 10.0388C30.0001 9.42712 29.7403 8.8506 29.2665 8.42173C28.319 7.54289 26.6762 7.54289 25.7363 8.4147Z"
        fill="#78E7DC"
      />
      <path
        d="M3.2093 1.63203C1.44419 1.63203 0 2.96083 0 4.58492V27.048C0 28.6791 1.44419 30.0009 3.2093 30.0009H20.2874C22.0602 30.0009 23.5043 28.6791 23.5043 27.048V18.6604L15.8555 25.6911C15.6339 25.8879 15.3817 26.0356 15.0914 26.12L11.2096 27.2871C10.9804 27.3503 10.7894 27.3785 10.606 27.3785C10.0864 27.3785 9.59735 27.1957 9.23057 26.8582C8.71861 26.3871 8.52758 25.6911 8.74154 25.0443L10.01 21.4656C10.1093 21.1914 10.2698 20.9454 10.4837 20.7485L23.4967 8.78225V4.57789C23.4967 2.9538 22.0525 1.625 20.2797 1.625H19.5615V3.01708C19.5615 4.47243 18.2778 5.66062 16.696 5.66062H6.80067C5.21894 5.66062 3.93522 4.47243 3.93522 3.01708V1.63203H3.2093ZM13.1811 14.906H4.26379C3.90465 14.906 3.61429 14.6388 3.61429 14.3084C3.61429 13.9779 3.90465 13.7108 4.26379 13.7108H13.1811C13.5402 13.7108 13.8306 13.9779 13.8306 14.3084C13.8306 14.6388 13.5402 14.906 13.1811 14.906ZM19.2253 11.4258H4.26379C3.90465 11.4258 3.61429 11.1586 3.61429 10.8282C3.61429 10.4977 3.90465 10.2306 4.26379 10.2306H19.2253C19.5844 10.2306 19.8748 10.4977 19.8748 10.8282C19.8824 11.1516 19.5844 11.4258 19.2253 11.4258ZM4.26379 6.74335H19.2253C19.5844 6.74335 19.8748 7.01052 19.8748 7.34096C19.8748 7.6714 19.5844 7.93857 19.2253 7.93857H4.26379C3.90465 7.93857 3.61429 7.6714 3.61429 7.34096C3.61429 7.01755 3.90465 6.74335 4.26379 6.74335Z"
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const ColorPicker: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  fillColor1,
  customClass,
}) => {
  return (
    <svg
      width="234"
      height="42"
      viewBox="0 0 234 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <g clipPath="url(#clip0_15803_16093)">
        <path
          d="M41.9792 21.4355H34.3152C34.1629 26.0289 31.7013 30.0217 28.0469 32.3056L32.2173 38.7262C37.978 35.0887 41.8269 28.7189 41.9792 21.4355Z"
          fill="#ED87C0"
        />
        <path
          d="M41.9845 21.4355C41.8407 28.7105 37.9917 35.0887 32.231 38.7346L30.7422 36.4422C35.7754 33.1262 39.286 27.7038 40.0304 21.4355H41.9845Z"
          fill="#D870AD"
        />
        <path
          d="M20.9935 34.3443C17.2207 34.3443 13.8201 32.7708 11.3923 30.25L5.75 35.427C9.57357 39.4705 14.9875 41.9998 20.9935 41.9998C25.1301 41.9998 28.979 40.7986 32.2273 38.7346L28.057 32.314C26.0098 33.5914 23.5989 34.3443 20.9935 34.3443Z"
          fill="#49CFAE"
        />
        <path
          d="M32.2352 38.7347C28.9868 40.7987 25.1379 41.9999 21.0013 41.9999C14.9953 41.9999 9.58138 39.4706 5.75781 35.4271L7.08591 34.209C10.6642 37.0428 15.1814 38.7347 20.0962 38.7347C23.8605 38.7347 27.3965 37.7449 30.4503 36.0023L32.2352 38.7347Z"
          fill="#36BB9B"
        />
        <path
          d="M20.994 7.65559V0C20.994 0 20.994 0 20.9856 0C14.1336 0 8.04296 3.29063 4.21094 8.38308L10.2677 13.0949C12.6955 9.80423 16.5868 7.65559 20.994 7.65559Z"
          fill="#FB6E52"
        />
        <path
          d="M7.65559 20.9955C7.65559 18.0263 8.63686 15.3025 10.2695 13.0861L4.21269 8.38281C1.56495 11.8934 0 16.2668 0 20.9955C0 26.587 2.19094 31.6626 5.75227 35.4269L11.3946 30.2499C9.0852 27.8475 7.65559 24.5991 7.65559 20.9955Z"
          fill="#FFCE54"
        />
        <g opacity="0.15">
          <path
            d="M1.31428 21.3256C1.12818 21.3256 0.984375 21.1818 0.984375 20.9957C0.984375 17.096 2.10945 13.3232 4.21579 10.0834C4.31731 9.93109 4.52033 9.89725 4.67259 9.98184C4.82486 10.0834 4.86715 10.2864 4.7741 10.4386C2.72697 13.577 1.64419 17.2229 1.64419 20.9957C1.64419 21.1818 1.49193 21.3256 1.31428 21.3256Z"
            fill="white"
          />
        </g>
        <path
          d="M41.2482 3.73899C41.2482 4.68642 40.8845 5.64231 40.157 6.3698L36.6125 9.90576L31.3594 4.64412L34.8953 1.10817C36.3419 -0.346812 38.702 -0.355271 40.157 1.09971C40.8845 1.82721 41.2482 2.7831 41.2482 3.73899Z"
          fill="#646D78"
        />
        <path
          d="M41.2482 3.73922C41.2482 4.68666 40.8845 5.64255 40.157 6.37004L36.6125 9.90599L31.3594 4.64436L32.0615 3.94225L33.0681 4.95735C35.0222 6.91143 38.2029 6.91143 40.157 4.95735C40.6983 4.41596 41.0452 3.73922 41.1805 3.03711C41.2228 3.27397 41.2482 3.51083 41.2482 3.73922Z"
          fill="#434A54"
        />
        <path
          d="M34.5543 12.1898L22.5338 24.2188C21.7132 25.0478 20.6135 25.5469 19.4546 25.64C18.2872 25.733 17.196 26.2321 16.3755 27.0611L15.3688 28.0678C14.6498 28.7783 13.4486 28.6938 12.8564 27.8055C12.425 27.1542 12.5604 26.2744 13.1187 25.7161L14.0661 24.7687C14.8951 23.9397 15.3942 22.8484 15.4872 21.6811C15.5718 20.5137 16.0794 19.4225 16.9084 18.5935L23.1174 12.3759L28.9289 6.56445L34.5543 12.1898Z"
          fill="#E7E9EE"
        />
        <path
          d="M37.1015 12.5107C36.7969 12.8152 36.3909 12.9675 35.9933 12.9675C35.5957 12.9675 35.1897 12.8152 34.8851 12.5107L28.6084 6.23397C27.9993 5.62491 27.9909 4.62672 28.6084 4.0092C28.9129 3.70467 29.319 3.5524 29.725 3.54395C30.1226 3.54395 30.5287 3.70467 30.8332 4.00074L37.1099 10.2775C37.719 10.9035 37.7105 11.8932 37.1015 12.5107Z"
          fill="#646D78"
        />
        <path
          d="M37.1058 12.5114C36.8013 12.816 36.3953 12.9767 35.9892 12.9767C35.5916 12.9767 35.1856 12.816 34.8811 12.5114L28.6043 6.24316C28.2575 5.89633 28.1052 5.42262 28.1475 4.96582C28.2237 5.09271 28.3082 5.21114 28.4098 5.31265L34.6865 11.5894C34.991 11.8939 35.3971 12.0462 35.7947 12.0462C36.1922 12.0462 36.5983 11.8855 36.9113 11.5894C37.182 11.3187 37.3258 10.9888 37.3681 10.642C37.7064 11.2341 37.6134 12.0039 37.1058 12.5114Z"
          fill="#434A54"
        />
        <path
          d="M26.9156 19.8282L22.5338 24.2101C21.7132 25.0391 20.6135 25.5382 19.4546 25.6312C18.2872 25.7243 17.196 26.2234 16.3755 27.0524L15.3688 28.059C14.6498 28.7696 13.4486 28.685 12.8564 27.7968C12.425 27.1454 12.5604 26.2657 13.1187 25.7074L14.0661 24.7599C14.8951 23.9309 15.3942 22.8397 15.4872 21.6723C15.5718 20.505 16.0794 19.4137 16.9084 18.5847L23.1174 12.3672C23.5996 13.0524 24.0226 13.7376 23.9803 14.5497C23.938 15.2095 23.5827 15.8524 23.7181 16.4953C23.828 17.0028 24.2341 17.392 24.6655 17.6796C25.0969 17.9672 25.5791 18.1787 25.9851 18.5001C26.4081 18.8469 26.7295 19.3122 26.9156 19.8282Z"
          fill="#FB6E52"
        />
      </g>
      <g clipPath="url(#clip1_15803_16093)">
        <path
          d="M67 12C65.22 12 63.4799 12.5278 61.9999 13.5168C60.5198 14.5057 59.3663 15.9113 58.6851 17.5558C58.0039 19.2004 57.8257 21.01 58.1729 22.7558C58.5202 24.5016 59.3774 26.1053 60.636 27.364C61.8947 28.6226 63.4984 29.4798 65.2442 29.8271C66.99 30.1743 68.7996 29.9961 70.4442 29.3149C72.0887 28.6337 73.4943 27.4802 74.4832 26.0001C75.4722 24.5201 76 22.78 76 21C75.9974 18.6138 75.0484 16.3262 73.3611 14.6389C71.6738 12.9516 69.3862 12.0026 67 12V12ZM67 28.5C65.5166 28.5 64.0666 28.0601 62.8332 27.236C61.5999 26.4119 60.6386 25.2406 60.0709 23.8701C59.5033 22.4997 59.3547 20.9917 59.6441 19.5368C59.9335 18.082 60.6478 16.7456 61.6967 15.6967C62.7456 14.6478 64.082 13.9335 65.5368 13.6441C66.9917 13.3547 68.4997 13.5032 69.8701 14.0709C71.2406 14.6386 72.4119 15.5999 73.236 16.8332C74.0601 18.0666 74.5 19.5166 74.5 21C74.4978 22.9885 73.7069 24.8948 72.3009 26.3009C70.8948 27.7069 68.9885 28.4978 67 28.5Z"
          fill="#797979"
        />
        <path
          d="M67 19.5H66.25C66.0511 19.5 65.8603 19.579 65.7197 19.7197C65.579 19.8603 65.5 20.0511 65.5 20.25C65.5 20.4489 65.579 20.6397 65.7197 20.7803C65.8603 20.921 66.0511 21 66.25 21H67V25.5C67 25.6989 67.079 25.8897 67.2197 26.0303C67.3603 26.171 67.5511 26.25 67.75 26.25C67.9489 26.25 68.1397 26.171 68.2803 26.0303C68.421 25.8897 68.5 25.6989 68.5 25.5V21C68.5 20.6022 68.342 20.2206 68.0607 19.9393C67.7794 19.658 67.3978 19.5 67 19.5Z"
          fill="#797979"
        />
        <path
          d="M67 18C67.6213 18 68.125 17.4963 68.125 16.875C68.125 16.2537 67.6213 15.75 67 15.75C66.3787 15.75 65.875 16.2537 65.875 16.875C65.875 17.4963 66.3787 18 67 18Z"
          fill="#797979"
        />
      </g>
      <defs>
        <clipPath id="clip0_15803_16093">
          <rect width="41.9831" height="42" fill="white" />
        </clipPath>
        <clipPath id="clip1_15803_16093">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(58 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CopyIcon: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 14"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      style={{ cursor: "pointer" }}
      className={customClass}
    >
      <path
        d="M12.658 2.81939L10.382 0.368264C10.1613 0.130623 9.86867 0 9.55733 0H5.83333C4.45467 0 3.33333 1.20759 3.33333 2.69231V2.87179H2.5C1.12133 2.87179 0 4.07938 0 5.5641V11.3077C0 12.7924 1.12133 14 2.5 14H7.16667C8.54533 14 9.66667 12.7924 9.66667 11.3077V11.1282H10.5C11.8787 11.1282 13 9.92062 13 8.4359V3.70744C13 3.37216 12.8787 3.05631 12.658 2.81939ZM10.3333 1.83799L11.2927 2.87109H11.0413C10.6513 2.87109 10.3333 2.52862 10.3333 2.10862V1.83799ZM8.66667 11.3077C8.66667 12.1987 7.994 12.9231 7.16667 12.9231H2.5C1.67267 12.9231 1 12.1987 1 11.3077V5.5641C1 4.67313 1.67267 3.94872 2.5 3.94872H3.33333V8.4359C3.33333 9.92062 4.45467 11.1282 5.83333 11.1282H8.66667V11.3077ZM10.5 10.0513H5.83333C5.006 10.0513 4.33333 9.32687 4.33333 8.4359V2.69231C4.33333 1.80133 5.006 1.07692 5.83333 1.07692H9.33333V2.10932C9.33333 3.12379 10.0993 3.94872 11.0413 3.94872H12V8.4359C12 9.32615 11.3273 10.0513 10.5 10.0513Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ServicesMastersIcons: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <g clipPath="url(#clip0_22802_27335)">
        <path
          d="M29.3322 12.3987L27.8325 12.0296C27.5161 10.606 26.9538 9.2526 26.1803 8.02231L26.9362 6.75692C27.1469 6.40542 27.0943 5.96602 26.813 5.68477L25.5828 4.45448L24.3174 3.1891C24.0361 2.90785 23.5968 2.85517 23.2451 3.06605L21.9797 3.82179C20.7495 3.04847 19.3961 2.48603 17.9723 2.16968L17.6033 0.669862C17.5154 0.283144 17.1639 0.00195312 16.7598 0.00195312H13.2445C12.8404 0.00195312 12.4889 0.283085 12.401 0.669862L12.0319 2.16968C10.6082 2.48603 9.25485 3.04847 8.02461 3.82179L6.75911 3.06605C6.4076 2.85511 5.96821 2.90779 5.68696 3.1891L3.19105 5.68483C2.9098 5.96597 2.85712 6.40536 3.068 6.75698L3.82374 8.02237C3.05042 9.25266 2.48798 10.6061 2.17164 12.0297L0.671815 12.3987C0.285097 12.4867 0.00390625 12.8381 0.00390625 13.2424V16.7576C0.00390625 17.1617 0.285039 17.5133 0.671815 17.6011L2.17164 17.9703C2.57582 19.7454 3.36677 21.4327 4.4565 22.8916L7.11044 25.5455C8.5693 26.6352 10.2564 27.4261 12.0317 27.8304L12.4007 29.3302C12.4887 29.7168 12.8401 29.9981 13.2443 29.9981H16.7595C17.1637 29.9981 17.5151 29.7168 17.6031 29.3302L17.9721 27.8304C19.3959 27.514 20.7492 26.9516 21.9795 26.1782L23.2448 26.9339C23.5965 27.1449 24.0359 27.0922 24.3172 26.8109L26.8128 24.3151C27.0941 24.034 27.1466 23.5946 26.936 23.243L26.1801 21.9775C26.9536 20.7472 27.5159 19.3939 27.8324 17.9703L29.3321 17.6011C29.7189 17.5132 30 17.1617 30 16.7576V13.2424C30.0001 12.8381 29.7191 12.4866 29.3322 12.3987ZM15.002 22.9091C12.9457 22.9091 11.065 22.1358 9.67643 20.8176C9.58854 20.7648 9.51828 20.6945 9.43045 20.6066C7.98922 19.183 7.0928 17.1969 7.0928 14.9999C7.0928 10.6235 10.6255 7.09079 15.0019 7.09079C17.1989 7.09079 19.185 7.98715 20.6085 9.42832C20.6965 9.51627 20.7669 9.58658 20.8197 9.67436C22.1379 11.0629 22.9111 12.9435 22.9111 14.9999C22.9111 19.3763 19.3784 22.9091 15.002 22.9091Z"
          fill="#EAEFFE"
        />
        <path
          d="M30 13.243V16.7581C30 17.1623 29.7189 17.5138 29.3321 17.6017L27.8323 17.9708C27.5159 19.3945 26.9536 20.7477 26.1801 21.978L26.936 23.2435C27.1467 23.595 27.0941 24.0344 26.8128 24.3157L24.3171 26.8114C24.0359 27.0927 23.5965 27.1453 23.2448 26.9345L21.9794 26.1787C20.7492 26.952 19.3958 27.5145 17.9721 27.8309L17.6031 29.3307C17.5151 29.7173 17.1637 29.9986 16.7595 29.9986H13.2443C12.8401 29.9986 12.4887 29.7174 12.4007 29.3307L12.0317 27.8309C10.2564 27.4267 8.56916 26.6358 7.11042 25.546L5.79224 24.2279L9.43043 20.6072C9.51832 20.6951 9.58858 20.7654 9.67641 20.8182C11.065 22.1364 12.9457 22.9097 15.002 22.9097C19.3784 22.9097 22.9111 19.377 22.9111 15.0006C22.9111 12.9441 22.1379 11.0636 20.8197 9.67501C20.7669 9.58712 20.6965 9.51686 20.6085 9.42897L25.5826 4.45508L26.8128 5.68537C27.0941 5.9665 27.1466 6.40589 26.936 6.75751L26.1801 8.0229C26.9536 9.25319 27.5159 10.6066 27.8323 12.0302L29.3321 12.3993C29.7189 12.4872 30 12.8387 30 13.243Z"
          fill="#EAEFFE"
        />
        <path
          d="M20.9536 13.4134C20.8765 13.1064 20.6404 12.8645 20.3351 12.7803C20.03 12.6961 19.7037 12.783 19.4799 13.0069L17.4873 14.9995C17.156 15.3307 16.7149 15.5127 16.2446 15.5127C15.7743 15.5127 15.3332 15.3308 15.0019 14.9995C14.3171 14.3147 14.3171 13.1991 15.0019 12.5142L17.0082 10.5078C17.229 10.2871 17.3142 9.96492 17.2317 9.66392C17.1491 9.36293 16.9114 9.12891 16.6088 9.05203C15.8554 8.86061 14.8716 8.77184 13.8588 8.95002C11.3795 9.40488 9.40737 11.377 8.95163 13.8606C8.7551 14.9591 8.84264 16.0533 9.20217 17.0608C8.70208 17.5609 0.978614 25.2843 0.771016 25.492C-0.259704 26.5227 -0.259704 28.1996 0.787305 29.2466C1.82453 30.2298 3.41306 30.2712 4.50929 29.2303L12.9404 20.7992C14.2906 21.2811 15.7964 21.2713 17.2699 20.7513C19.2602 20.0489 20.6374 18.2121 21.0513 16.1426L21.0521 16.1383C21.2299 15.1444 21.1427 14.1671 20.9536 13.4134Z"
          fill="#67CDDF"
        />
        <path
          d="M4.5094 29.2317L12.9406 20.8005C14.2907 21.2824 15.7965 21.2726 17.2701 20.7527C19.2604 20.0503 20.6376 18.2135 21.0514 16.1439L21.0523 16.1396C21.2316 15.1367 21.1413 14.1506 20.9485 13.3942C20.8713 13.0916 20.6377 12.8536 20.3365 12.7711C20.0354 12.6885 19.7136 12.7746 19.4928 12.9953L17.4874 15.0009C17.1561 15.3321 16.715 15.5141 16.2447 15.5141C15.7825 15.5141 15.3509 15.3345 15.0216 15.014L0.787354 29.248C1.82458 30.2312 3.41311 30.2726 4.5094 29.2317Z"
          fill="#67CDDF"
        />
      </g>
      <defs>
        <clipPath id="clip0_22802_27335">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ReportsIcons: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
    >
      <path
        d="M10.5 9.99065C10.5 10.1801 10.4262 10.3617 10.295 10.4956C10.1637 10.6296 9.98564 10.7048 9.79999 10.7048H4.2C4.01434 10.7048 3.8363 10.6296 3.70502 10.4956C3.57375 10.3617 3.5 10.1801 3.5 9.99065C3.5 9.80123 3.57375 9.61958 3.70502 9.48565C3.8363 9.35171 4.01434 9.27647 4.2 9.27647H9.79999C9.98564 9.27647 10.1637 9.35171 10.295 9.48565C10.4262 9.61958 10.5 9.80123 10.5 9.99065ZM7.69999 12.1332H4.2C4.01434 12.1332 3.8363 12.2084 3.70502 12.3423C3.57375 12.4763 3.5 12.6579 3.5 12.8473C3.5 13.0368 3.57375 13.2184 3.70502 13.3523C3.8363 13.4863 4.01434 13.5615 4.2 13.5615H7.69999C7.88564 13.5615 8.06369 13.4863 8.19496 13.3523C8.32624 13.2184 8.39999 13.0368 8.39999 12.8473C8.39999 12.6579 8.32624 12.4763 8.19496 12.3423C8.06369 12.2084 7.88564 12.1332 7.69999 12.1332ZM14 7.48032V13.5615C13.9989 14.5082 13.6298 15.4158 12.9736 16.0853C12.3175 16.7547 11.4279 17.1313 10.5 17.1324H3.5C2.57208 17.1313 1.68249 16.7547 1.02635 16.0853C0.370217 15.4158 0.0011115 14.5082 0 13.5615V3.56308C0.0011115 2.61637 0.370217 1.70876 1.02635 1.03934C1.68249 0.369918 2.57208 -0.00666203 3.5 -0.00779604H6.66049C7.30422 -0.00948644 7.9419 0.119033 8.53665 0.37033C9.13139 0.621628 9.67142 0.990718 10.1255 1.45626L12.5643 3.94587C13.0208 4.40883 13.3828 4.95961 13.6293 5.56632C13.8757 6.17302 14.0017 6.82358 14 7.48032ZM9.13569 2.4661C8.91539 2.2484 8.66804 2.06111 8.39999 1.90905V4.99142C8.39999 5.18084 8.47374 5.36249 8.60501 5.49642C8.73629 5.63036 8.91434 5.7056 9.09999 5.7056H12.1212C11.9721 5.43221 11.7882 5.18007 11.5745 4.95572L9.13569 2.4661ZM12.6 7.48032C12.6 7.36248 12.5776 7.24964 12.5671 7.13395H9.09999C8.54304 7.13395 8.00889 6.90822 7.61507 6.50642C7.22124 6.10462 6.99999 5.55966 6.99999 4.99142V1.45412C6.88659 1.44341 6.77529 1.42055 6.66049 1.42055H3.5C2.94304 1.42055 2.4089 1.64628 2.01507 2.04808C1.62125 2.44988 1.4 2.99484 1.4 3.56308V13.5615C1.4 14.1297 1.62125 14.6747 2.01507 15.0765C2.4089 15.4783 2.94304 15.704 3.5 15.704H10.5C11.0569 15.704 11.5911 15.4783 11.9849 15.0765C12.3787 14.6747 12.6 14.1297 12.6 13.5615V7.48032Z"
        fill="#0BD26E"
        // fill="#EAEFFE"
      />
    </svg>
  );
};

export const MasterTableManageIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0293 23.1504C11.9473 23.2324 11.8887 23.3379 11.8653 23.4492L10.5 29.2324C10.4473 29.4434 10.5117 29.666 10.6641 29.8184C10.7813 29.9355 10.9453 30 11.1094 30C11.1563 30 11.2032 29.9941 11.2559 29.9824L17.0391 28.6172C17.1504 28.5937 17.2559 28.5352 17.3379 28.4531L25.5118 20.2793L20.209 14.9766L12.0293 23.1504Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
      <path
        d="M29.2675 12.9844L27.498 11.2149C26.5546 10.2715 24.9081 10.2715 23.9589 11.2149L21.5273 13.6465L26.83 18.9492L29.2616 16.5176C29.7363 16.043 29.9941 15.416 29.9941 14.7481C29.9999 14.086 29.7421 13.459 29.2675 12.9844Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
      <path
        d="M8.54883 23.7481H3.12305C2.77735 23.7481 2.4961 23.4668 2.4961 23.1211V19.9981H11.8711C12.5625 19.9981 13.1192 19.4356 13.1192 18.75V13.752H18.2051C18.8965 13.752 19.4531 13.1895 19.4531 12.5039C19.4531 11.8125 18.8906 11.2559 18.2051 11.2559H13.125V7.50587H21.252V8.75391C21.252 9.44532 21.8145 10.002 22.5 10.002C23.1856 10.002 23.7481 9.43946 23.7481 8.75391V2.8125C23.7481 1.25977 22.4883 0 20.9356 0H2.8125C1.25977 0 0 1.25977 0 2.8125V23.127C0 24.8496 1.40039 26.25 3.12305 26.25H8.54883C9.24024 26.25 9.79688 25.6875 9.79688 25.002C9.80274 24.3106 9.24024 23.7481 8.54883 23.7481ZM2.50196 17.502V13.752H10.6289V17.502H2.50196ZM2.50196 11.25V7.50001H10.6289V11.25H2.50196Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const ReportMappingIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <path
        d="M25.2966 22.9631C27.5847 22.9631 29.4915 21.0563 29.4915 18.7681V4.53085C29.4915 2.24272 27.5847 0.335938 25.2966 0.335938H4.19491C1.77966 0.335938 0 2.24272 0 4.53085V18.7681C0 21.0563 1.90678 22.9631 4.19491 22.9631H13.4746V24.2342C12.3305 24.7427 11.5678 25.8868 11.5678 27.158C11.5678 28.9376 12.9661 30.3359 14.7458 30.3359C16.5254 30.3359 17.9237 28.9376 17.9237 27.158C17.9237 25.8868 17.161 24.7427 16.017 24.2342V22.9631H25.2966ZM21.9915 11.141C21.9915 10.5054 22.5 9.86984 23.2627 9.86984C24.0254 9.86984 24.5339 10.5054 24.5339 11.141V16.0987C24.5339 16.8614 24.0254 17.3698 23.2627 17.3698C22.5 17.3698 21.9915 16.8614 21.9915 16.0987V11.141ZM16.2712 7.20034C16.2712 6.43763 16.7797 5.92916 17.5424 5.92916C18.3051 5.92916 18.8136 6.43763 18.8136 7.20034V16.0987C18.8136 16.8614 18.3051 17.3698 17.5424 17.3698C16.7797 17.3698 16.2712 16.8614 16.2712 16.0987V7.20034ZM7.62712 16.0987C7.62712 16.8614 7.11864 17.3698 6.35593 17.3698C5.59322 17.3698 5.08475 16.8614 5.08475 16.0987V8.85289C5.08475 8.21729 5.59322 7.5817 6.35593 7.5817C7.11864 7.5817 7.62712 8.21729 7.62712 8.85289V16.0987ZM13.2203 16.0987C13.2203 16.8614 12.5847 17.3698 11.9492 17.3698C11.1864 17.3698 10.678 16.8614 10.678 16.0987V11.3953C10.678 10.7597 11.1864 10.1241 11.9492 10.1241C12.5847 10.1241 13.2203 10.7597 13.2203 11.3953V16.0987Z"
        // fill={fillColor}
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const ReportGeneratorIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
    >
      <g id="Group">
        <path
          id="Vector"
          d="M21.1523 1.64648H19.9805C20.4844 2.57227 20.7715 3.63281 20.7715 4.75781C20.7715 6.2168 19.5879 7.40039 18.1348 7.40039H5.6543C4.20117 7.40039 3.01758 6.2168 3.01758 4.75781C3.01758 3.63281 3.30469 2.57227 3.80859 1.64648H2.63672C1.18359 1.64648 0 2.83008 0 4.28906V27.3633C0 28.8164 1.18359 30 2.63672 30H21.1523C22.6055 30 23.7891 28.8164 23.7891 27.3574V4.2832C23.7891 2.83008 22.6055 1.64648 21.1523 1.64648ZM8.80664 24.9668L6.89062 26.8828C6.54492 27.2285 5.98828 27.2285 5.64844 26.8828L4.71094 25.9453C4.36523 25.5996 4.36523 25.043 4.71094 24.6973C5.05664 24.3516 5.61328 24.3516 5.95312 24.6973L6.26953 25.0137L7.56445 23.7187C7.91016 23.373 8.4668 23.373 8.80664 23.7187C9.14648 24.0645 9.14648 24.6211 8.80664 24.9668ZM8.80664 19.916L6.89062 21.832C6.54492 22.1777 5.98828 22.1777 5.64844 21.832L4.71094 20.8945C4.36523 20.5488 4.36523 19.9922 4.71094 19.6465C5.05664 19.3008 5.61328 19.3008 5.95312 19.6465L6.26953 19.9629L7.56445 18.668C7.91016 18.3223 8.4668 18.3223 8.80664 18.668C9.14648 19.0195 9.14648 19.5762 8.80664 19.916ZM7.125 16.3594C6.7793 16.7051 6.22266 16.7051 5.88281 16.3594C5.53711 16.0137 5.53711 15.457 5.88281 15.1113L9.04688 11.9414C9.39258 11.5957 9.94922 11.5957 10.2891 11.9414L12.9492 14.6074L15.0469 12.5039H14.9414C14.4551 12.5039 14.0625 12.1113 14.0625 11.625C14.0625 11.1387 14.4551 10.7461 14.9414 10.7461C17.3613 10.7461 17.5664 10.6406 17.9004 11.1387C18.0996 11.4434 18.0469 11.543 18.0469 13.8574C18.0469 14.3438 17.6543 14.7363 17.168 14.7363C16.6816 14.7363 16.2891 14.3438 16.2891 13.8574V13.752L13.5703 16.4766C13.2246 16.8223 12.668 16.8223 12.3281 16.4766L9.66797 13.8105L7.125 16.3594ZM18.3984 26.1855H11.3086C10.8223 26.1855 10.4297 25.793 10.4297 25.3066C10.4297 24.8203 10.8223 24.4277 11.3086 24.4277H18.3984C18.8848 24.4277 19.2773 24.8203 19.2773 25.3066C19.2773 25.793 18.8848 26.1855 18.3984 26.1855ZM18.3984 21.1348H11.3086C10.8223 21.1348 10.4297 20.7422 10.4297 20.2559C10.4297 19.7695 10.8223 19.377 11.3086 19.377H18.3984C18.8848 19.377 19.2773 19.7695 19.2773 20.2559C19.2773 20.7422 18.8848 21.1348 18.3984 21.1348Z"
          // fill={fillColor}
          fill="#EAEFFE"
        />
        <path
          id="Vector_2"
          d="M14.2656 0H9.51953C6.90039 0 4.77344 2.13281 4.77344 4.75781C4.77344 5.24414 5.16602 5.63672 5.65234 5.63672H18.1328C18.6191 5.63672 19.0117 5.24414 19.0117 4.75781C19.0117 2.13281 16.8848 0 14.2656 0Z"
          // fill={fillColor}
          fill="#EAEFFE"
        />
      </g>
    </svg>
  );
};

export const InventoryMasterIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="30"
      viewBox="0 0 36 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.771 17.883L15.7198 17.0549C15.3261 16.9486 14.8902 17.1005 14.6301 17.4728L12.3171 20.7622L9.99713 17.4652C9.75107 17.0929 9.31519 16.903 8.87931 17.0169L5.23057 18.0273C2.12316 18.8934 0 21.841 0 25.3127V28.8605C0 29.491 0.471032 30 1.05455 30H18.9468C18.8343 29.6429 18.771 29.2631 18.771 28.868V17.883Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.9158 15.999L29.5555 16.3484V13.6743H27.3339V16.3484L27.9667 16.0066C28.2549 15.847 28.6064 15.8319 28.9158 15.999Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.9454 13.6743H31.6693V18.1945C31.6693 18.825 31.1983 19.334 30.6148 19.334C30.4109 19.334 30.2211 19.2732 30.0594 19.1593L28.4494 18.2856L26.7551 19.2049C26.0521 19.5847 25.2366 19.0149 25.2366 18.1869L25.2295 13.6668H21.9393C21.3558 13.6668 20.8848 14.1757 20.8848 14.8063V28.8605C20.8848 29.491 21.3558 30 21.9393 30H34.9454C35.529 30 36 29.491 36 28.8605V14.8139C36 14.1833 35.529 13.6743 34.9454 13.6743Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4225 7.67283C19.4225 11.9119 16.2448 15.3457 12.3218 15.3457C8.39891 15.3457 5.22119 11.9119 5.22119 7.67283C5.22119 3.43378 8.39891 0 12.3218 0C16.2448 0 19.4225 3.43378 19.4225 7.67283Z"
        fill="#FFCCBD"
      />
    </svg>
  );
};

export const RewokeIcon: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
  handleClick,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 27 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <g id="Vector">
        <path
          d="M22.9661 4.72781L18.9322 11.0004H21.5934C21.5934 15.4304 17.9854 19.0371 13.5537 19.0371C10.9541 19.0371 8.6458 17.7938 7.17232 15.8728L5.65401 18.2363C7.61492 20.3757 10.4218 21.7254 13.5537 21.7254C19.4813 21.7254 24.2827 16.9257 24.2827 11.0004H27L22.9661 4.72781Z"
          // fill="#CDD4D8"
          fill={fillColor}
        />
        <path
          d="M13.5537 0.275391C7.62613 0.275391 2.82469 5.07504 2.82469 11.0004H0.107422L4.1413 17.273L8.17518 11.0004H5.51394C5.51394 6.57038 9.12202 2.96364 13.5537 2.96364C16.1533 2.96364 18.4616 4.20696 19.9351 6.12794L21.4534 3.76452C19.4925 1.62512 16.6856 0.275391 13.5537 0.275391Z"
          // fill="#CDD4D8"
          fill={fillColor}
        />
        <path
          d="M18.5792 12.5013C18.0918 12.1429 17.1057 11.5436 15.6267 11.2244C15.0384 11.6445 14.3269 11.8965 13.5537 11.8965C12.7805 11.8965 12.069 11.6445 11.4807 11.23C10.0016 11.5492 9.01558 12.1485 8.52815 12.5069C8.30404 12.6749 8.17518 12.9382 8.17518 13.2238V14.5903H18.9322V13.2238C18.9322 12.9382 18.8033 12.6693 18.5792 12.5013Z"
          // fill="#CDD4D8"
          fill={fillColor}
        />
        <path
          d="M13.5537 11.0004C15.0389 11.0004 16.2429 9.79682 16.2429 8.31214C16.2429 6.82746 15.0389 5.62389 13.5537 5.62389C12.0685 5.62389 10.8644 6.82746 10.8644 8.31214C10.8644 9.79682 12.0685 11.0004 13.5537 11.0004Z"
          // fill="#CDD4D8"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

// UNIT TYPE MASTER ICON
export const unitTypeMastersIcons: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5126 22.8708C12.9139 22.8708 9.98608 19.9429 9.98608 16.3442C9.98608 12.7498 12.9139 9.82617 16.5126 9.82617C20.107 9.82617 23.0349 12.7498 23.0349 16.3442C23.0433 19.9429 20.1155 22.8708 16.5126 22.8708ZM20.8791 16.7535C20.6513 16.7535 20.4698 16.5721 20.4698 16.3442C20.4698 14.1589 18.6979 12.387 16.5126 12.387C16.2848 12.387 16.1034 12.2056 16.1034 11.9735C16.1034 11.7457 16.2848 11.5643 16.5126 11.5643C19.1494 11.5643 21.2925 13.7075 21.2925 16.3442C21.2925 16.5678 21.1111 16.7535 20.8791 16.7535Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3392 10.9139C18.2844 10.9139 18.2337 10.9013 18.1789 10.8844C17.968 10.7958 17.8709 10.5553 17.9595 10.3528L20.4697 4.24399C20.5583 4.03305 20.7988 3.9318 21.0055 4.02039C21.2164 4.10899 21.3135 4.34946 21.2249 4.55196L18.7147 10.6608C18.6556 10.8211 18.5037 10.9139 18.3392 10.9139Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3359 12.2886C12.2304 12.2886 12.1249 12.2506 12.0405 12.1663L9.8805 10.002C9.7244 9.84169 9.7244 9.58012 9.8805 9.41981C10.0408 9.26371 10.3024 9.26371 10.4627 9.41981L12.6227 11.5883C12.7788 11.7444 12.7788 12.0102 12.6227 12.1663C12.5468 12.2506 12.4413 12.2886 12.3359 12.2886Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3495 25.3333C5.22293 25.3333 5.10059 25.2827 5.02043 25.1772C4.87699 24.9958 4.91496 24.7384 5.09637 24.6034L11.4204 19.7518C11.6018 19.6126 11.8591 19.6463 11.9941 19.8277C12.1376 20.0091 12.0996 20.2665 11.9182 20.4015L5.59419 25.2531C5.52247 25.3037 5.43387 25.3333 5.3495 25.3333Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4738 26.1148C21.3261 26.1148 21.1869 26.0388 21.111 25.8996L18.9762 21.955C18.8708 21.7567 18.9425 21.512 19.1408 21.3981C19.3391 21.2927 19.588 21.3644 19.6977 21.5627L21.8282 25.5072C21.9336 25.7055 21.8661 25.9502 21.6636 26.0599C21.6004 26.0979 21.5371 26.1148 21.4738 26.1148Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2245 17.8067H22.5328C22.3049 17.8067 22.1235 17.6253 22.1235 17.3975C22.1235 17.1697 22.3049 16.9883 22.5328 16.9883H24.2245C24.4523 16.9883 24.6337 17.1697 24.6337 17.3975C24.6337 17.6253 24.4523 17.8067 24.2245 17.8067Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6384 4.96523C20.2715 4.96523 19.1577 3.85147 19.1577 2.48035C19.1577 1.11345 20.2715 0.00390625 21.6384 0.00390625C23.0011 0.00390625 24.1148 1.11345 24.1148 2.48035C24.1148 3.85147 23.0011 4.96523 21.6384 4.96523Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70765 10.7286C7.34497 10.7286 6.2312 9.61483 6.2312 8.24793C6.2312 6.88525 7.34497 5.77148 8.70765 5.77148C10.0745 5.77148 11.1883 6.88525 11.1883 8.24793C11.1883 9.61483 10.0745 10.7286 8.70765 10.7286Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.70838 28.6541C2.34148 28.6541 1.23193 27.5445 1.23193 26.1776C1.23193 24.8149 2.34148 23.7012 3.70838 23.7012C5.07106 23.7012 6.18482 24.8149 6.18482 26.1776C6.18482 27.5445 5.07106 28.6541 3.70838 28.6541Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4526 29.9959C21.0857 29.9959 19.9719 28.8863 19.9719 27.5194C19.9719 26.1567 21.0857 25.043 22.4526 25.043C23.8153 25.043 24.929 26.1567 24.929 27.5194C24.929 28.8863 23.8153 29.9959 22.4526 29.9959Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.2916 19.8748C24.929 19.8748 23.8152 18.7652 23.8152 17.3983C23.8152 16.0356 24.929 14.9219 26.2916 14.9219C27.6585 14.9219 28.7723 16.0356 28.7723 17.3983C28.7723 18.7652 27.6585 19.8748 26.2916 19.8748Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const Rise: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.12456 0.140412L9.13597 3.59371C9.6982 4.07773 9.35591 5 8.61403 5L1.30887 5C0.566997 5 0.224698 4.07773 0.786936 3.59371L4.79835 0.140412C4.89211 0.059698 5.0308 0.0596981 5.12456 0.140412Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Fall: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.58443 4.85959L0.573019 1.40629C0.010781 0.922274 0.353077 -4.43706e-08 1.09495 -6.76565e-08L8.40011 -2.9695e-07C9.14199 -3.20235e-07 9.48429 0.922272 8.92205 1.40629L4.91064 4.85959C4.81688 4.9403 4.67819 4.9403 4.58443 4.85959Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ChatGPTIcon: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      width="38"
      height="31"
      viewBox="0 0 38 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.537813 27.2C0.537813 26.6507 0.660479 26.16 0.905813 25.728C1.15648 25.2907 1.49515 24.952 1.92181 24.712C2.35381 24.4667 2.83648 24.344 3.36981 24.344C3.99381 24.344 4.54048 24.504 5.00981 24.824C5.47915 25.144 5.80715 25.5867 5.99381 26.152H4.70581C4.57781 25.8853 4.39648 25.6853 4.16181 25.552C3.93248 25.4187 3.66581 25.352 3.36181 25.352C3.03648 25.352 2.74581 25.4293 2.48981 25.584C2.23915 25.7333 2.04181 25.9467 1.89781 26.224C1.75915 26.5013 1.68981 26.8267 1.68981 27.2C1.68981 27.568 1.75915 27.8933 1.89781 28.176C2.04181 28.4533 2.23915 28.6693 2.48981 28.824C2.74581 28.9733 3.03648 29.048 3.36181 29.048C3.66581 29.048 3.93248 28.9813 4.16181 28.848C4.39648 28.7093 4.57781 28.5067 4.70581 28.24H5.99381C5.80715 28.8107 5.47915 29.256 5.00981 29.576C4.54581 29.8907 3.99915 30.048 3.36981 30.048C2.83648 30.048 2.35381 29.928 1.92181 29.688C1.49515 29.4427 1.15648 29.104 0.905813 28.672C0.660479 28.24 0.537813 27.7493 0.537813 27.2ZM9.44644 25.504C9.78244 25.504 10.0811 25.5787 10.3424 25.728C10.6038 25.872 10.8064 26.088 10.9504 26.376C11.0998 26.6587 11.1744 27 11.1744 27.4V30H10.0544V27.552C10.0544 27.2 9.96644 26.9307 9.79044 26.744C9.61444 26.552 9.37444 26.456 9.07044 26.456C8.7611 26.456 8.51577 26.552 8.33444 26.744C8.15844 26.9307 8.07044 27.2 8.07044 27.552V30H6.95044V24.08H8.07044V26.12C8.21444 25.928 8.40644 25.7787 8.64644 25.672C8.88644 25.56 9.1531 25.504 9.44644 25.504ZM11.9515 27.768C11.9515 27.32 12.0395 26.9227 12.2155 26.576C12.3968 26.2293 12.6395 25.9627 12.9435 25.776C13.2528 25.5893 13.5968 25.496 13.9755 25.496C14.3062 25.496 14.5942 25.5627 14.8395 25.696C15.0902 25.8293 15.2902 25.9973 15.4395 26.2V25.568H16.5675V30H15.4395V29.352C15.2955 29.56 15.0955 29.7333 14.8395 29.872C14.5888 30.0053 14.2982 30.072 13.9675 30.072C13.5942 30.072 13.2528 29.976 12.9435 29.784C12.6395 29.592 12.3968 29.3227 12.2155 28.976C12.0395 28.624 11.9515 28.2213 11.9515 27.768ZM15.4395 27.784C15.4395 27.512 15.3862 27.28 15.2795 27.088C15.1728 26.8907 15.0288 26.7413 14.8475 26.64C14.6662 26.5333 14.4715 26.48 14.2635 26.48C14.0555 26.48 13.8635 26.5307 13.6875 26.632C13.5115 26.7333 13.3675 26.8827 13.2555 27.08C13.1488 27.272 13.0955 27.5013 13.0955 27.768C13.0955 28.0347 13.1488 28.2693 13.2555 28.472C13.3675 28.6693 13.5115 28.8213 13.6875 28.928C13.8688 29.0347 14.0608 29.088 14.2635 29.088C14.4715 29.088 14.6662 29.0373 14.8475 28.936C15.0288 28.8293 15.1728 28.68 15.2795 28.488C15.3862 28.2907 15.4395 28.056 15.4395 27.784ZM18.9654 26.488V28.632C18.9654 28.7813 19 28.8907 19.0694 28.96C19.144 29.024 19.2667 29.056 19.4374 29.056H19.9574V30H19.2534C18.3094 30 17.8374 29.5413 17.8374 28.624V26.488H17.3094V25.568H17.8374V24.472H18.9654V25.568H19.9574V26.488H18.9654ZM26.5572 26.096C26.4292 25.8613 26.2532 25.6827 26.0292 25.56C25.8052 25.4373 25.5439 25.376 25.2452 25.376C24.9145 25.376 24.6212 25.4507 24.3652 25.6C24.1092 25.7493 23.9092 25.9627 23.7652 26.24C23.6212 26.5173 23.5492 26.8373 23.5492 27.2C23.5492 27.5733 23.6212 27.8987 23.7652 28.176C23.9145 28.4533 24.1199 28.6667 24.3812 28.816C24.6425 28.9653 24.9465 29.04 25.2932 29.04C25.7199 29.04 26.0692 28.928 26.3412 28.704C26.6132 28.4747 26.7919 28.1573 26.8772 27.752H24.9572V26.896H27.9812V27.872C27.9065 28.2613 27.7465 28.6213 27.5012 28.952C27.2559 29.2827 26.9385 29.5493 26.5492 29.752C26.1652 29.9493 25.7332 30.048 25.2532 30.048C24.7145 30.048 24.2265 29.928 23.7892 29.688C23.3572 29.4427 23.0159 29.104 22.7652 28.672C22.5199 28.24 22.3972 27.7493 22.3972 27.2C22.3972 26.6507 22.5199 26.16 22.7652 25.728C23.0159 25.2907 23.3572 24.952 23.7892 24.712C24.2265 24.4667 24.7119 24.344 25.2452 24.344C25.8745 24.344 26.4212 24.4987 26.8852 24.808C27.3492 25.112 27.6692 25.5413 27.8452 26.096H26.5572ZM32.8818 26.144C32.8818 26.4427 32.8098 26.7227 32.6658 26.984C32.5271 27.2453 32.3058 27.456 32.0018 27.616C31.7031 27.776 31.3245 27.856 30.8658 27.856H29.9298V30H28.8098V24.416H30.8658C31.2978 24.416 31.6658 24.4907 31.9698 24.64C32.2738 24.7893 32.5005 24.9947 32.6498 25.256C32.8045 25.5173 32.8818 25.8133 32.8818 26.144ZM30.8178 26.952C31.1271 26.952 31.3565 26.8827 31.5058 26.744C31.6551 26.6 31.7298 26.4 31.7298 26.144C31.7298 25.6 31.4258 25.328 30.8178 25.328H29.9298V26.952H30.8178ZM37.477 24.416V25.32H35.989V30H34.869V25.32H33.381V24.416H37.477Z"
        fill="#BBBBBB"
      />
      <g clipPath="url(#clip0_21874_16624)">
        <path
          d="M27.4454 8.16951L27.4388 8.16398C27.8813 6.80314 27.7209 5.31839 26.9995 4.08257C25.9042 2.18514 23.7114 1.20379 21.5706 1.6574L21.5628 1.66072C20.6069 0.597495 19.2417 -0.00658409 17.8111 5.41404e-05C15.6205 5.41404e-05 13.6744 1.40847 12.9962 3.48845L12.994 3.49619C11.5944 3.7938 10.3885 4.67558 9.67929 5.91693C8.58398 7.81436 8.8307 10.2041 10.2933 11.8305L10.3 11.836C9.85741 13.1969 10.0178 14.6816 10.7392 15.9174C11.8345 17.8149 14.0273 18.7962 16.1682 18.3426L16.1759 18.3393C17.134 19.4025 18.4993 20.0066 19.9298 19.9999C22.1204 19.9999 24.0666 18.5915 24.7448 16.5116L24.7459 16.5038C26.1454 16.2062 27.3514 15.3255 28.0606 14.0831C29.1548 12.1867 28.908 9.79698 27.4454 8.16951ZM20.8514 11.1445L18.8699 12.2885L16.8884 11.1445V8.85656L18.8699 7.71257L20.8514 8.85656V11.1445ZM25.8744 4.73311L25.8655 4.7309C26.3047 5.49098 26.4652 6.37276 26.3202 7.23794L22.2311 4.87694C22.1846 4.85039 22.1359 4.82937 22.0873 4.81499C21.9147 4.75967 21.7244 4.78069 21.5606 4.87473L16.8917 7.57096L16.8906 5.60162L20.7474 3.37449C21.1203 3.15875 21.5263 3.01049 21.9479 2.93415L21.9445 2.92198C23.4603 2.63986 25.0568 3.32028 25.8744 4.73311ZM17.8111 1.30004L17.8045 1.30668C18.6818 1.30668 19.526 1.60872 20.202 2.16633L16.1128 4.52733C16.0664 4.55388 16.0243 4.58597 15.9867 4.62137C15.8528 4.74307 15.7754 4.91899 15.7754 5.10707V10.4984L14.0694 9.51486L14.0683 5.0606C14.0683 4.62912 14.1435 4.20427 14.2862 3.80044L14.2741 3.79712C14.7907 2.34446 16.1781 1.30225 17.8111 1.30004ZM10.8056 6.56748L10.8078 6.57633C11.247 5.81625 11.9296 5.23651 12.7517 4.92894V9.65094C12.7517 9.70405 12.7583 9.75715 12.7705 9.80694C12.8092 9.98396 12.9232 10.1389 13.0858 10.2329L17.7547 12.928L16.0498 13.9138L12.1919 11.6878C11.8179 11.4731 11.4871 11.1943 11.2105 10.8691L11.2017 10.8779C10.1993 9.70515 9.99128 7.98253 10.8056 6.56748ZM11.8644 15.268L11.8732 15.2702C11.434 14.5101 11.2736 13.6283 11.4185 12.7632L15.5077 15.1242C15.5541 15.1507 15.6028 15.1717 15.6515 15.1861C15.8241 15.2414 16.0155 15.2204 16.1781 15.1264L20.847 12.4301L20.8481 14.3995L16.9913 16.6266C16.6185 16.8424 16.2124 16.9906 15.7909 17.067L15.7942 17.0791C14.2785 17.3612 12.682 16.6808 11.8644 15.268ZM19.9287 18.7011L19.9354 18.6944C19.058 18.6944 18.2138 18.3924 17.5378 17.8348L21.627 15.4738C21.6735 15.4472 21.7155 15.4151 21.7531 15.3797C21.887 15.258 21.9644 15.0821 21.9644 14.894V9.50269L23.6705 10.4863L23.6716 14.9405C23.6716 15.372 23.5963 15.7968 23.4536 16.2007L23.4658 16.204C22.948 17.6566 21.5606 18.6989 19.9287 18.7011ZM26.9332 13.4336L26.931 13.4248C26.4917 14.1849 25.8091 14.7646 24.9871 15.0722V10.3502C24.9871 10.2971 24.9804 10.244 24.9682 10.1942C24.9295 10.0171 24.8156 9.86226 24.6529 9.76822L19.984 7.07309L21.689 6.08731L25.5469 8.31334C25.9208 8.52797 26.2516 8.80678 26.5282 9.13205L26.5371 9.1232C27.5395 10.296 27.7475 12.0186 26.9332 13.4336Z"
          fill="#BBBBBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_21874_16624">
          <rect width="20" height="20" fill="white" transform="translate(9)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SpeechToTextIcon: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      width="44"
      height="31"
      viewBox="0 0 44 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M4.57466 24.416V25.32H3.08666V30H1.96666V25.32H0.478656V24.416H4.57466ZM6.51184 26.256C6.65584 26.0213 6.84251 25.8373 7.07184 25.704C7.30651 25.5707 7.57318 25.504 7.87184 25.504V26.68H7.57584C7.22384 26.68 6.95718 26.7627 6.77584 26.928C6.59984 27.0933 6.51184 27.3813 6.51184 27.792V30H5.39184V25.568H6.51184V26.256ZM8.33822 27.768C8.33822 27.32 8.42622 26.9227 8.60222 26.576C8.78355 26.2293 9.02622 25.9627 9.33022 25.776C9.63955 25.5893 9.98355 25.496 10.3622 25.496C10.6929 25.496 10.9809 25.5627 11.2262 25.696C11.4769 25.8293 11.6769 25.9973 11.8262 26.2V25.568H12.9542V30H11.8262V29.352C11.6822 29.56 11.4822 29.7333 11.2262 29.872C10.9756 30.0053 10.6849 30.072 10.3542 30.072C9.98089 30.072 9.63955 29.976 9.33022 29.784C9.02622 29.592 8.78355 29.3227 8.60222 28.976C8.42622 28.624 8.33822 28.2213 8.33822 27.768ZM11.8262 27.784C11.8262 27.512 11.7729 27.28 11.6662 27.088C11.5596 26.8907 11.4156 26.7413 11.2342 26.64C11.0529 26.5333 10.8582 26.48 10.6502 26.48C10.4422 26.48 10.2502 26.5307 10.0742 26.632C9.89822 26.7333 9.75422 26.8827 9.64222 27.08C9.53555 27.272 9.48222 27.5013 9.48222 27.768C9.48222 28.0347 9.53555 28.2693 9.64222 28.472C9.75422 28.6693 9.89822 28.8213 10.0742 28.928C10.2556 29.0347 10.4476 29.088 10.6502 29.088C10.8582 29.088 11.0529 29.0373 11.2342 28.936C11.4156 28.8293 11.5596 28.68 11.6662 28.488C11.7729 28.2907 11.8262 28.056 11.8262 27.784ZM16.5041 25.504C17.0321 25.504 17.4588 25.672 17.7841 26.008C18.1094 26.3387 18.2721 26.8027 18.2721 27.4V30H17.1521V27.552C17.1521 27.2 17.0641 26.9307 16.8881 26.744C16.7121 26.552 16.4721 26.456 16.1681 26.456C15.8588 26.456 15.6134 26.552 15.4321 26.744C15.2561 26.9307 15.1681 27.2 15.1681 27.552V30H14.0481V25.568H15.1681V26.12C15.3174 25.928 15.5068 25.7787 15.7361 25.672C15.9708 25.56 16.2268 25.504 16.5041 25.504ZM21.0332 30.072C20.6705 30.072 20.3452 30.008 20.0572 29.88C19.7692 29.7467 19.5398 29.568 19.3692 29.344C19.2038 29.12 19.1132 28.872 19.0972 28.6H20.2252C20.2465 28.7707 20.3292 28.912 20.4732 29.024C20.6225 29.136 20.8065 29.192 21.0252 29.192C21.2385 29.192 21.4038 29.1493 21.5212 29.064C21.6438 28.9787 21.7052 28.8693 21.7052 28.736C21.7052 28.592 21.6305 28.4853 21.4812 28.416C21.3372 28.3413 21.1052 28.2613 20.7852 28.176C20.4545 28.096 20.1825 28.0133 19.9692 27.928C19.7612 27.8427 19.5798 27.712 19.4252 27.536C19.2758 27.36 19.2012 27.1227 19.2012 26.824C19.2012 26.5787 19.2705 26.3547 19.4092 26.152C19.5532 25.9493 19.7558 25.7893 20.0172 25.672C20.2838 25.5547 20.5958 25.496 20.9532 25.496C21.4812 25.496 21.9025 25.6293 22.2172 25.896C22.5318 26.1573 22.7052 26.512 22.7372 26.96H21.6652C21.6492 26.784 21.5745 26.6453 21.4412 26.544C21.3132 26.4373 21.1398 26.384 20.9212 26.384C20.7185 26.384 20.5612 26.4213 20.4492 26.496C20.3425 26.5707 20.2892 26.6747 20.2892 26.808C20.2892 26.9573 20.3638 27.072 20.5132 27.152C20.6625 27.2267 20.8945 27.304 21.2092 27.384C21.5292 27.464 21.7932 27.5467 22.0012 27.632C22.2092 27.7173 22.3878 27.8507 22.5372 28.032C22.6918 28.208 22.7718 28.4427 22.7772 28.736C22.7772 28.992 22.7052 29.2213 22.5612 29.424C22.4225 29.6267 22.2198 29.7867 21.9532 29.904C21.6918 30.016 21.3852 30.072 21.0332 30.072ZM23.4085 27.784C23.4085 27.3253 23.5019 26.9253 23.6885 26.584C23.8752 26.2373 24.1339 25.9707 24.4645 25.784C24.7952 25.592 25.1739 25.496 25.6005 25.496C26.1499 25.496 26.6032 25.6347 26.9605 25.912C27.3232 26.184 27.5659 26.568 27.6885 27.064H26.4805C26.4165 26.872 26.3072 26.7227 26.1525 26.616C26.0032 26.504 25.8165 26.448 25.5925 26.448C25.2725 26.448 25.0192 26.5653 24.8325 26.8C24.6459 27.0293 24.5525 27.3573 24.5525 27.784C24.5525 28.2053 24.6459 28.5333 24.8325 28.768C25.0192 28.9973 25.2725 29.112 25.5925 29.112C26.0459 29.112 26.3419 28.9093 26.4805 28.504H27.6885C27.5659 28.984 27.3232 29.3653 26.9605 29.648C26.5979 29.9307 26.1445 30.072 25.6005 30.072C25.1739 30.072 24.7952 29.9787 24.4645 29.792C24.1339 29.6 23.8752 29.3333 23.6885 28.992C23.5019 28.6453 23.4085 28.2427 23.4085 27.784ZM29.629 26.256C29.773 26.0213 29.9597 25.8373 30.189 25.704C30.4237 25.5707 30.6904 25.504 30.989 25.504V26.68H30.693C30.341 26.68 30.0744 26.7627 29.893 26.928C29.717 27.0933 29.629 27.3813 29.629 27.792V30H28.509V25.568H29.629V26.256ZM32.3114 25.04C32.1141 25.04 31.9487 24.9787 31.8154 24.856C31.6874 24.728 31.6234 24.5707 31.6234 24.384C31.6234 24.1973 31.6874 24.0427 31.8154 23.92C31.9487 23.792 32.1141 23.728 32.3114 23.728C32.5087 23.728 32.6714 23.792 32.7994 23.92C32.9327 24.0427 32.9994 24.1973 32.9994 24.384C32.9994 24.5707 32.9327 24.728 32.7994 24.856C32.6714 24.9787 32.5087 25.04 32.3114 25.04ZM32.8634 25.568V30H31.7434V25.568H32.8634ZM35.09 26.216C35.234 26.0027 35.4313 25.8293 35.682 25.696C35.938 25.5627 36.2286 25.496 36.554 25.496C36.9326 25.496 37.274 25.5893 37.578 25.776C37.8873 25.9627 38.13 26.2293 38.306 26.576C38.4873 26.9173 38.578 27.3147 38.578 27.768C38.578 28.2213 38.4873 28.624 38.306 28.976C38.13 29.3227 37.8873 29.592 37.578 29.784C37.274 29.976 36.9326 30.072 36.554 30.072C36.2233 30.072 35.9326 30.008 35.682 29.88C35.4366 29.7467 35.2393 29.576 35.09 29.368V30H33.97V24.08H35.09V26.216ZM37.434 27.768C37.434 27.5013 37.378 27.272 37.266 27.08C37.1593 26.8827 37.0153 26.7333 36.834 26.632C36.658 26.5307 36.466 26.48 36.258 26.48C36.0553 26.48 35.8633 26.5333 35.682 26.64C35.506 26.7413 35.362 26.8907 35.25 27.088C35.1433 27.2853 35.09 27.5173 35.09 27.784C35.09 28.0507 35.1433 28.2827 35.25 28.48C35.362 28.6773 35.506 28.8293 35.682 28.936C35.8633 29.0373 36.0553 29.088 36.258 29.088C36.466 29.088 36.658 29.0347 36.834 28.928C37.0153 28.8213 37.1593 28.6693 37.266 28.472C37.378 28.2747 37.434 28.04 37.434 27.768ZM43.5118 27.688C43.5118 27.848 43.5012 27.992 43.4798 28.12H40.2398C40.2665 28.44 40.3785 28.6907 40.5758 28.872C40.7732 29.0533 41.0158 29.144 41.3038 29.144C41.7198 29.144 42.0158 28.9653 42.1918 28.608H43.3998C43.2718 29.0347 43.0265 29.3867 42.6638 29.664C42.3012 29.936 41.8558 30.072 41.3278 30.072C40.9012 30.072 40.5172 29.9787 40.1758 29.792C39.8398 29.6 39.5758 29.3307 39.3838 28.984C39.1972 28.6373 39.1038 28.2373 39.1038 27.784C39.1038 27.3253 39.1972 26.9227 39.3838 26.576C39.5705 26.2293 39.8318 25.9627 40.1678 25.776C40.5038 25.5893 40.8905 25.496 41.3278 25.496C41.7492 25.496 42.1252 25.5867 42.4558 25.768C42.7918 25.9493 43.0505 26.208 43.2318 26.544C43.4185 26.8747 43.5118 27.256 43.5118 27.688ZM42.3518 27.368C42.3465 27.08 42.2425 26.8507 42.0398 26.68C41.8372 26.504 41.5892 26.416 41.2958 26.416C41.0185 26.416 40.7838 26.5013 40.5918 26.672C40.4052 26.8373 40.2905 27.0693 40.2478 27.368H42.3518Z"
        fill={fillColor}
      />
      <g clipPath="url(#clip0_1780_7813)">
        <path
          d="M14.8322 7.50195C14.3751 7.50195 14 7.87703 14 8.33415C14.0039 12.1513 16.8756 15.359 20.6693 15.7848V18.3361H19.001C18.5399 18.3361 18.1688 18.7112 18.1688 19.1683C18.1688 19.6293 18.5439 20.0005 19.001 20.0005H24.002C24.463 20.0005 24.8341 19.6254 24.8341 19.1683C24.8341 18.7073 24.4591 18.3361 24.002 18.3361H22.3337V15.7848C26.1274 15.3551 28.9951 12.1513 29.0029 8.33415C29.0029 7.87312 28.6279 7.50195 28.1707 7.50195C27.7097 7.50195 27.3385 7.87703 27.3385 8.33415C27.3385 11.5574 24.7248 14.1673 21.5054 14.1673C18.286 14.1673 15.6683 11.5574 15.6683 8.33415C15.6683 7.87703 15.2932 7.50195 14.8322 7.50195Z"
          fill={fillColor}
        />
        <path
          d="M21.5018 12.5024C23.803 12.4985 25.6667 10.6349 25.6706 8.33366V4.16878C25.6706 1.86755 23.803 0 21.5018 0C19.2006 0 17.333 1.86755 17.333 4.16878V8.33757C17.3369 10.6349 19.2006 12.4985 21.5018 12.5024ZM19.0013 4.16878C19.0013 2.78961 20.1226 1.66829 21.5018 1.66829C22.881 1.66829 24.0023 2.78961 24.0023 4.16878V8.33757C24.0023 9.71674 22.881 10.8381 21.5018 10.8381C20.1226 10.8381 19.0013 9.71674 19.0013 8.33757V4.16878Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1780_7813">
          <rect
            width="17.9258"
            height="20"
            fill="white"
            transform="translate(13)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditIconWithoutStyle: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <path
        d="M18.0724 10.9999C17.6396 10.9999 17.285 11.3498 17.285 11.7873V19.647C17.285 20.0798 16.9351 20.4344 16.4977 20.4344H2.35747C1.92465 20.4344 1.57011 20.0844 1.57011 19.647V3.9275C1.57011 3.49469 1.92005 3.14014 2.35747 3.14014H11.7873C12.2202 3.14014 12.5747 2.79021 12.5747 2.35279C12.5747 1.91537 12.2248 1.56543 11.7873 1.56543H2.35747C1.05441 1.57003 0 2.62905 0 3.9275V19.6424C0 20.9455 1.05441 21.9999 2.35747 21.9999H16.5023C17.8053 21.9999 18.8597 20.9455 18.8597 19.6424V11.7873C18.8597 11.3544 18.5098 10.9999 18.0724 10.9999Z"
        fill="#CDD4D8"
      />
      <path
        d="M21.1236 0.879495C20.5618 0.317755 19.7975 4.936e-05 18.9963 4.936e-05C18.1997 -0.00455507 17.4308 0.31315 16.8691 0.879495L6.51831 11.2302C6.43082 11.3177 6.36636 11.4236 6.32953 11.5387L4.75942 16.2537C4.62128 16.6635 4.8469 17.1101 5.25669 17.2482C5.33497 17.2759 5.42245 17.2897 5.50533 17.2897C5.58821 17.2897 5.6757 17.2759 5.75397 17.2482L10.4689 15.6781C10.584 15.6413 10.6899 15.5722 10.7774 15.4893L21.1282 5.13859C22.2977 3.95986 22.3023 2.05823 21.1236 0.879495Z"
        fill="#CDD4D8"
      />
    </svg>
  );
};

export const CrossIconWithoutStyle: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  fillColor1,
  customClass,
  width = "20",
  height = "20",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
    >
      <circle cx="10" cy="10" r="10" fill={fillColor1} />
      <path
        d="M13.9494 6.05273L6.05469 13.9475"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.05058 6.05273L13.9453 13.9475"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftArrowIcon: FC<ISvgComponent> = ({
  fillColor,
  height,
  customClass,
}) => {
  return (
    <svg
      width="20"
      height={height ?? "16"}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <path
        d="M20.0002 8.00028C20.0002 8.55328 19.5532 9.00028 19.0002 9.00028H3.41422L8.70719 14.2933C9.09819 14.6842 9.09819 15.3163 8.70719 15.7073C8.51219 15.9023 8.25622 16.0003 8.00022 16.0003C7.74422 16.0003 7.48825 15.9023 7.29325 15.7073L0.29325 8.70731C-0.09775 8.31631 -0.09775 7.68425 0.29325 7.29325L7.29325 0.29325C7.68425 -0.09775 8.31619 -0.09775 8.70719 0.29325C9.09819 0.68425 9.09819 1.31631 8.70719 1.70731L3.41422 7.00028H19.0002C19.5532 7.00028 20.0002 7.44728 20.0002 8.00028Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const IPDInvoiceIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="34"
      viewBox="0 0 30 34"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 26.81C30 23.3389 27.1862 20.5254 23.7153 20.5254C20.2442 20.5254 17.4307 23.3389 17.4307 26.81C17.4307 30.2808 20.2442 33.0946 23.7153 33.0946C27.1862 33.0946 30 30.2808 30 26.81ZM24.3987 30.3361C24.7478 30.2354 25.0623 30.0601 25.3192 29.8307C25.7549 29.4416 26.0244 28.9 26.0244 28.2982C26.0244 27.6963 25.7549 27.1547 25.3192 26.7657C24.903 26.3941 24.3356 26.1642 23.7153 26.1642C23.4318 26.1642 23.1811 26.0669 23.005 25.9097C22.8485 25.7699 22.7516 25.5808 22.7516 25.3756C22.7516 25.1704 22.8484 24.9813 23.005 24.8416C23.1829 24.6827 23.4338 24.5844 23.7153 24.5844C23.8523 24.5844 23.9857 24.6097 24.1099 24.6557C24.2323 24.701 24.3394 24.7645 24.4257 24.8417C24.7014 25.0884 25.125 25.0649 25.3717 24.7891C25.6184 24.5134 25.5949 24.0899 25.3192 23.8431C25.1038 23.6507 24.8504 23.4972 24.5723 23.3944C24.5078 23.3705 24.4416 23.3493 24.3739 23.3309L24.366 22.9978C24.3573 22.6277 24.0502 22.3347 23.6801 22.3434C23.3101 22.3521 23.0171 22.6592 23.0258 23.0292L23.0332 23.3391C22.6829 23.4392 22.3679 23.6141 22.1115 23.8431C21.6758 24.2321 21.4062 24.7738 21.4062 25.3756C21.4062 25.9775 21.6758 26.519 22.1115 26.9081C22.5276 27.2797 23.0951 27.5096 23.7153 27.5096C23.9989 27.5096 24.2496 27.6069 24.4257 27.7641C24.5822 27.9039 24.679 28.093 24.679 28.2981C24.679 28.5033 24.5822 28.6924 24.4257 28.8321C24.2496 28.9894 23.9989 29.0867 23.7153 29.0867C23.5184 29.0867 23.3766 29.0544 23.2585 28.9947C23.1181 28.9237 22.9741 28.8012 22.806 28.6425C22.5361 28.3886 22.1113 28.4015 21.8574 28.6715C21.6035 28.9414 21.6164 29.3662 21.8863 29.6201C22.1379 29.8574 22.3695 30.049 22.6541 30.193C22.7826 30.258 22.9158 30.3105 23.058 30.3496L23.0646 30.6222C23.0733 30.9923 23.3804 31.2852 23.7504 31.2766C24.1205 31.2679 24.4135 30.9608 24.4048 30.5907L24.3987 30.3361Z"
        fill="#67CDDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.610404 0H17.4873V4.57797C17.4873 5.4886 18.2272 6.22856 19.1379 6.22856H23.7159V19.1819C19.5023 19.1819 16.086 22.5983 16.086 26.8118C16.086 27.9623 16.3412 29.053 16.7973 30.0313H0.610404C0.274258 30.0313 0 29.7571 0 29.421V0.610404C6.72696e-05 0.274191 0.274258 0 0.610404 0ZM14.3582 21.519H5.75054C5.41345 21.519 5.14014 21.7923 5.14014 22.1294C5.14014 22.4665 5.41345 22.7398 5.75054 22.7398H14.3582C14.6952 22.7398 14.9686 22.4665 14.9686 22.1294C14.9685 21.7923 14.6952 21.519 14.3582 21.519ZM14.3582 25.2341H5.75054C5.41345 25.2341 5.14014 25.5074 5.14014 25.8445C5.14014 26.1816 5.41345 26.4549 5.75054 26.4549H14.3582C14.6952 26.4549 14.9686 26.1816 14.9686 25.8445C14.9685 25.5074 14.6952 25.2341 14.3582 25.2341ZM17.9655 17.804H5.75054C5.41345 17.804 5.14014 18.0773 5.14014 18.4144C5.14014 18.7515 5.41345 19.0248 5.75054 19.0248H17.9654C18.3025 19.0248 18.5758 18.7515 18.5758 18.4144C18.5758 18.0772 18.3026 17.804 17.9655 17.804ZM10.4568 5.1363C10.2887 5.1363 10.1516 5.2734 10.1516 5.44144V7.70264H7.89046C7.72235 7.70264 7.58525 7.83974 7.58525 8.00784V10.8103C7.58525 10.9784 7.72235 11.1154 7.89046 11.1154H10.1516V13.3766C10.1516 13.5447 10.2887 13.6818 10.4568 13.6818H13.2592C13.4274 13.6818 13.5644 13.5447 13.5644 13.3766V11.1154H15.8256C15.9938 11.1154 16.1308 10.9783 16.1308 10.8103V8.00784C16.1308 7.83974 15.9937 7.70264 15.8256 7.70264H13.5644V5.44151C13.5644 5.2734 13.4274 5.13637 13.2592 5.13637L10.4568 5.1363Z"
        fill="#EAEFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8325 0.0546875V4.57978C18.8325 4.74789 18.9696 4.88498 19.1377 4.88498H23.6628C23.6332 4.82013 23.5912 4.76047 23.5369 4.70618L19.0113 0.180549C18.957 0.126262 18.8973 0.0842861 18.8325 0.0546875Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const ReportBuilderIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <g clipPath="url(#clip0_22802_27433)">
        <path
          d="M24.2578 1.64453H23.0864C23.5903 2.56967 23.877 3.62998 23.877 4.75609C23.877 6.21285 22.6941 7.39797 21.2402 7.39797H8.75977C7.30588 7.39797 6.12305 6.21279 6.12305 4.75609C6.12305 3.62998 6.40969 2.56973 6.91359 1.64453H5.74219C4.2883 1.64453 3.10547 2.82971 3.10547 4.28641V27.3588C3.10547 28.8155 4.2883 30.0007 5.74219 30.0007H24.2578C25.7117 30.0007 26.8945 28.8155 26.8945 27.3588V4.28641C26.8945 2.82965 25.7117 1.64453 24.2578 1.64453ZM11.9105 24.9678L9.99645 26.8856C9.65326 27.2295 9.09674 27.2296 8.7535 26.8856L7.816 25.9463C7.47275 25.6024 7.47275 25.0448 7.816 24.7009C8.15918 24.357 8.7157 24.357 9.05895 24.7009L9.375 25.0176L10.6676 23.7225C11.0108 23.3786 11.5673 23.3786 11.9105 23.7225C12.2537 24.0664 12.2537 24.6239 11.9105 24.9678ZM11.9105 19.9189L9.99645 21.8366C9.65326 22.1805 9.09674 22.1806 8.7535 21.8366L7.816 20.8973C7.47275 20.5534 7.47275 19.9959 7.816 19.652C8.15918 19.308 8.7157 19.308 9.05895 19.652L9.375 19.9686L10.6676 18.6736C11.0108 18.3296 11.5673 18.3296 11.9105 18.6736C12.2537 19.0174 12.2537 19.575 11.9105 19.9189ZM10.2308 16.3572C9.88764 16.7012 9.33111 16.7012 8.98787 16.3572C8.64463 16.0134 8.64463 15.4558 8.98787 15.1119L12.1519 11.9416C12.4951 11.5977 13.0516 11.5977 13.3949 11.9416L16.0547 14.6065L18.1516 12.5055H18.0469C17.5615 12.5055 17.168 12.1112 17.168 11.6249C17.168 11.1386 17.5615 10.7443 18.0469 10.7443C20.4671 10.7443 20.6735 10.6405 21.0043 11.1361C21.2061 11.4383 21.1523 11.5405 21.1523 13.8559C21.1523 14.3422 20.7588 14.7365 20.2734 14.7365C19.788 14.7365 19.3945 14.3422 19.3945 13.8559V13.7509L16.6761 16.4746C16.3329 16.8185 15.7764 16.8186 15.4332 16.4746L12.7734 13.8097L10.2308 16.3572ZM21.5039 26.1846H14.4141C13.9287 26.1846 13.5352 25.7904 13.5352 25.304C13.5352 24.8177 13.9287 24.4234 14.4141 24.4234H21.5039C21.9893 24.4234 22.3828 24.8177 22.3828 25.304C22.3828 25.7904 21.9893 26.1846 21.5039 26.1846ZM21.5039 21.1357H14.4141C13.9287 21.1357 13.5352 20.7414 13.5352 20.2551C13.5352 19.7687 13.9287 19.3745 14.4141 19.3745H21.5039C21.9893 19.3745 22.3828 19.7687 22.3828 20.2551C22.3828 20.7414 21.9893 21.1357 21.5039 21.1357Z"
          fill="#EAEFFE"
        />
        <path
          d="M17.373 0H12.627C10.0099 0 7.88086 2.13328 7.88086 4.75541C7.88086 5.24174 8.27437 5.63602 8.75977 5.63602H21.2402C21.7256 5.63602 22.1191 5.24174 22.1191 4.75541C22.1191 2.13328 19.9901 0 17.373 0Z"
          fill="#67CDDF"
        />
      </g>
      <defs>
        <clipPath id="clip0_22802_27433">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const inventoryItemMastersIcons: FC<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  width,
  height,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M13.6963 4.78729L14.4245 1.875H7.13794L7.86618 4.78729H13.6963Z"
        fill="#EAEFFE"
      />
      <path
        d="M12.1875 18.75V9.84375L19.6875 6.79962V2.8125C19.6875 2.29477 19.2677 1.875 18.75 1.875H15.391L14.5171 5.36957C14.4649 5.57831 14.2776 5.72479 14.0625 5.72479H7.5C7.28485 5.72479 7.09763 5.57831 7.04544 5.36957L6.17151 1.875H2.8125C2.29477 1.875 1.875 2.29477 1.875 2.8125V27.1875C1.875 27.7052 2.29477 28.125 2.8125 28.125H18.75C19.2677 28.125 19.6875 27.7052 19.6875 27.1875V23.5406L13.2861 20.4561C12.6338 20.1782 12.1875 19.5016 12.1875 18.75ZM5.625 23.4375C4.59091 23.4375 3.75 22.5966 3.75 21.5625C3.75 20.5284 4.59091 19.6875 5.625 19.6875C6.65909 19.6875 7.5 20.5284 7.5 21.5625C7.5 22.5966 6.65909 23.4375 5.625 23.4375ZM5.625 17.8125C4.59091 17.8125 3.75 16.9716 3.75 15.9375C3.75 14.9034 4.59091 14.0625 5.625 14.0625C6.65909 14.0625 7.5 14.9034 7.5 15.9375C7.5 16.9716 6.65909 17.8125 5.625 17.8125ZM5.625 12.1875C4.59091 12.1875 3.75 11.3466 3.75 10.3125C3.75 9.27841 4.59091 8.4375 5.625 8.4375C6.65909 8.4375 7.5 9.27841 7.5 10.3125C7.5 11.3466 6.65909 12.1875 5.625 12.1875Z"
        fill="#EAEFFE"
      />
      <path
        d="M28.1239 11.2422L21.0938 14.3667V22.4995L27.5565 19.611C27.9016 19.4636 28.125 19.1244 28.125 18.7495V11.2495C28.125 11.2469 28.1239 11.2447 28.1239 11.2422Z"
        fill="#67CDDF"
      />
      <path
        d="M20.9939 7.57622C20.7595 7.47459 20.4903 7.47459 20.2559 7.57622C20.2559 7.57622 13.6439 10.4209 13.6177 10.4353L20.6249 13.5496L27.6321 10.4353C27.6058 10.4209 20.9939 7.57622 20.9939 7.57622Z"
        fill="#67CDDF"
      />
      <path
        d="M13.125 11.2495V18.7495C13.125 19.1244 13.3484 19.4636 13.6935 19.611L20.1562 22.4995V14.3667L13.1261 11.2422C13.1261 11.2447 13.125 11.2469 13.125 11.2495Z"
        fill="#67CDDF"
      />
    </svg>
  );
};
export const AgentsIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 26 30"
      fill={fillColor}
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <g clipPath="url(#clip0_22302_20443)">
        <path
          d="M22.9549 24.2752V27.7977C22.9549 28.2841 22.5606 28.6784 22.0743 28.6784H15.0293V16.3496C19.3996 16.3496 22.9549 19.905 22.9549 24.2752Z"
          fill="#67CDDF"
        />
        <path
          d="M6.16408 18.1407C8.1014 18.1407 9.67191 16.5701 9.67191 14.6328C9.67191 12.6955 8.1014 11.125 6.16408 11.125C4.22676 11.125 2.65625 12.6955 2.65625 14.6328C2.65625 16.5701 4.22676 18.1407 6.16408 18.1407Z"
          fill="#FFDDCE"
        />
        <path
          d="M9.45616 19.0665C8.17984 20.4315 7.39726 22.2638 7.39726 24.2757V27.5047L7.10372 27.7982H0.880626C0.394521 27.7982 0 27.4037 0 26.9176V24.2757C0 20.8765 2.76517 18.1113 6.16438 18.1113C7.37378 18.1113 8.50333 18.4618 9.45616 19.0665Z"
          fill="#78E7DC"
        />
        <path
          d="M15.0291 16.3492C17.4609 16.3492 19.4322 14.3779 19.4322 11.9461C19.4322 9.51432 17.4609 7.54297 15.0291 7.54297C12.5973 7.54297 10.626 9.51432 10.626 11.9461C10.626 14.3779 12.5973 16.3492 15.0291 16.3492Z"
          fill="#D69A8B"
        />
        <path
          d="M19.4324 11.9461C19.4324 14.3737 17.4569 16.3492 15.0293 16.3492V7.54297C17.4569 7.54297 19.4324 9.51851 19.4324 11.9461Z"
          fill="#C28678"
        />
        <path
          d="M23.836 18.1407C25.7733 18.1407 27.3438 16.5701 27.3438 14.6328C27.3438 12.6955 25.7733 11.125 23.836 11.125C21.8986 11.125 20.3281 12.6955 20.3281 14.6328C20.3281 16.5701 21.8986 18.1407 23.836 18.1407Z"
          fill="#FFCCBD"
        />
        <path
          d="M30.0002 24.2757V26.9176C30.0002 27.4037 29.6057 27.7982 29.1196 27.7982H22.9552L22.6617 27.5047V24.2757C22.6617 22.2526 21.8703 20.4109 20.5811 19.0436C21.5263 18.4524 22.6417 18.1113 23.8358 18.1113C27.2351 18.1113 30.0002 20.8765 30.0002 24.2757Z"
          fill="#27BDF3"
        />
        <path
          d="M14.9829 16.3497C10.6095 16.3749 7.10352 19.989 7.10352 24.3624V27.7978C7.10352 28.2841 7.4978 28.6784 7.98414 28.6784H22.0742C22.5605 28.6784 22.9548 28.2841 22.9548 27.7978V24.2753C22.9548 19.8896 19.3743 16.3246 14.9829 16.3497Z"
          fill="#67CDDF"
        />
        <path
          d="M18.3233 1.57825C17.9795 1.23433 17.4219 1.23433 17.0779 1.57825L14.1782 4.47803L12.9809 3.28079C12.637 2.93688 12.0794 2.93688 11.7355 3.28079C11.3916 3.62471 11.3916 4.18226 11.7355 4.52617L13.5554 6.34613C13.8993 6.69005 14.4569 6.69011 14.8008 6.34613L18.3233 2.82363C18.6672 2.47972 18.6672 1.92216 18.3233 1.57825Z"
          fill="#F5F5F5"
        />
        <path
          d="M18.3234 2.82369L15.0293 6.11782V3.62682L17.0776 1.5779C17.4217 1.23445 17.9794 1.23445 18.3234 1.5779C18.6669 1.92193 18.6669 2.47966 18.3234 2.82369Z"
          fill="#F5F5F5"
        />
      </g>
      <defs>
        <clipPath id="clip0_22302_20443">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CampaignsIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className={customClass}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M20.1094 0C18.8965 0 17.9121 1.26761 17.9121 2.82948V21.4889C17.9121 23.0508 18.8965 24.3184 20.1094 24.3184C21.3223 24.3184 22.3066 23.0508 22.3066 21.4889V2.82948C22.3125 1.26761 21.3223 0 20.1094 0Z"
        fill="white"
      />
      <path
        d="M3.50977 6.6022V7.89244H0.878906C0.392578 7.89244 0 8.39798 0 9.02423V15.0076C0 15.6339 0.392578 16.1394 0.878906 16.1394H3.50977V17.7239C3.50977 18.2596 3.80273 18.7199 4.20703 18.8331L6.0293 19.3235V27.3442C6.0293 28.5816 6.68555 29.6455 7.62305 29.9322C7.78125 29.9775 7.93945 30.0001 8.09766 30.0001C8.55469 30.0001 9.00586 29.8039 9.375 29.4266C9.87305 28.9211 10.1543 28.159 10.1543 27.3442V25.8728H10.1836C12.2227 25.8728 13.9277 24.0318 14.3672 21.5796L16.1543 22.0625V2.26367L4.20703 5.49305C3.79688 5.60623 3.50977 6.06649 3.50977 6.6022ZM10.1543 20.4402L12.6445 21.1118C12.375 22.5378 11.373 23.6092 10.1836 23.6092H10.1543V20.4402Z"
        fill="#67CDDF"
      />
      <path
        d="M26.1516 4.66211C26.3509 4.66211 26.5442 4.57911 26.7083 4.40557L28.4778 2.51925C28.8528 2.11935 28.9055 1.4101 28.595 0.927199C28.2845 0.444301 27.7337 0.376394 27.3587 0.776293L25.5891 2.65507C25.2141 3.05497 25.1614 3.76422 25.472 4.24712C25.6477 4.51875 25.8997 4.66211 26.1516 4.66211Z"
        fill="#67CDDF"
      />
      <path
        d="M28.4778 21.8055L26.7083 19.9267C26.3333 19.5268 25.7825 19.5947 25.472 20.0776C25.1614 20.5605 25.2141 21.2697 25.5891 21.6696L27.3587 23.5484C27.5227 23.722 27.722 23.805 27.9153 23.805C28.1673 23.805 28.4192 23.6616 28.595 23.3975C28.9055 22.9146 28.8528 22.2054 28.4778 21.8055Z"
        fill="#67CDDF"
      />
      <path
        d="M29.1211 11.0312H25.3945C24.9082 11.0312 24.5156 11.5368 24.5156 12.163C24.5156 12.7893 24.9082 13.2948 25.3945 13.2948H29.1211C29.6074 13.2948 30 12.7893 30 12.163C30 11.5368 29.6074 11.0312 29.1211 11.0312Z"
        fill="#67CDDF"
      />
    </svg>
  );
};
export const LeadsIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <g clipPath="url(#clip0_22302_20369)">
        <path
          d="M22.0321 26.4406H18.7725C18.5225 26.4406 18.3198 26.238 18.3198 25.9879C18.3198 25.7378 18.5225 25.5352 18.7725 25.5352H22.0321C22.2822 25.5352 22.4848 25.7378 22.4848 25.9879C22.4848 26.238 22.2822 26.4406 22.0321 26.4406Z"
          fill="#FAD207"
        />
        <path
          d="M21.4284 20.4035H18.8931C18.6431 20.4035 18.4404 20.2008 18.4404 19.9508C18.4404 19.7007 18.6431 19.498 18.8931 19.498H21.4284C21.6784 19.498 21.8811 19.7007 21.8811 19.9508C21.8811 20.2008 21.6784 20.4035 21.4284 20.4035Z"
          fill="#FAD207"
        />
        <path
          d="M23.5411 23.4211H21.6397C21.3896 23.4211 21.187 23.2184 21.187 22.9683C21.187 22.7183 21.3896 22.5156 21.6397 22.5156H23.5411C23.7912 22.5156 23.9939 22.7183 23.9939 22.9683C23.9939 23.2184 23.7912 23.4211 23.5411 23.4211Z"
          fill="#FAD207"
        />
        <path
          d="M19.7083 23.4211H19.1348C18.8848 23.4211 18.6821 23.2184 18.6821 22.9683C18.6821 22.7183 18.8848 22.5156 19.1348 22.5156H19.7083C19.9584 22.5156 20.161 22.7183 20.161 22.9683C20.161 23.2184 19.9584 23.4211 19.7083 23.4211Z"
          fill="#FAD207"
        />
        <path
          d="M22.0321 4.46793H18.7725C18.5225 4.46793 18.3198 4.2653 18.3198 4.01522C18.3198 3.76514 18.5225 3.5625 18.7725 3.5625H22.0321C22.2822 3.5625 22.4848 3.76514 22.4848 4.01522C22.4848 4.2653 22.2822 4.46793 22.0321 4.46793Z"
          fill="#FAD207"
        />
        <path
          d="M21.4284 10.505H18.8931C18.6431 10.505 18.4404 10.3024 18.4404 10.0523C18.4404 9.80225 18.6431 9.59961 18.8931 9.59961H21.4284C21.6784 9.59961 21.8811 9.80225 21.8811 10.0523C21.8811 10.3024 21.6784 10.505 21.4284 10.505Z"
          fill="#FAD207"
        />
        <path
          d="M23.541 7.48551H22.2432C21.9932 7.48551 21.7905 7.28287 21.7905 7.03279C21.7905 6.78271 21.9932 6.58008 22.2432 6.58008H23.541C23.7911 6.58008 23.9937 6.78271 23.9937 7.03279C23.9937 7.28287 23.7911 7.48551 23.541 7.48551Z"
          fill="#FAD207"
        />
        <path
          d="M20.3119 7.48551H19.1348C18.8848 7.48551 18.6821 7.28287 18.6821 7.03279C18.6821 6.78271 18.8848 6.58008 19.1348 6.58008H20.3119C20.562 6.58008 20.7646 6.78271 20.7646 7.03279C20.7646 7.28287 20.562 7.48551 20.3119 7.48551Z"
          fill="#FAD207"
        />
        <path
          d="M17.022 24.4766V25.382C17.022 25.7154 16.7518 25.9856 16.4184 25.9856H13.3399L12.7363 25.2311L13.3399 24.4766H17.022Z"
          fill="#E6E6E6"
        />
        <path
          d="M26.9517 5.98641C28.0018 5.98641 28.8531 5.13512 28.8531 4.085C28.8531 3.03488 28.0018 2.18359 26.9517 2.18359C25.9016 2.18359 25.0503 3.03488 25.0503 4.085C25.0503 5.13512 25.9016 5.98641 26.9517 5.98641Z"
          fill="#FFC682"
        />
        <path
          d="M25.0108 11.882H28.8624C29.4657 11.882 30 11.3584 30 10.7551V10.5137C30 8.85476 28.6099 7.51562 26.9509 7.51562H26.9223C25.2633 7.51562 23.9185 8.86043 23.9185 10.5194V10.7897C23.9185 11.3929 24.4075 11.882 25.0108 11.882Z"
          fill="#67CDDF"
        />
        <path
          d="M26.9517 21.922C28.0018 21.922 28.8531 21.0707 28.8531 20.0205C28.8531 18.9704 28.0018 18.1191 26.9517 18.1191C25.9016 18.1191 25.0503 18.9704 25.0503 20.0205C25.0503 21.0707 25.9016 21.922 26.9517 21.922Z"
          fill="#FFC682"
        />
        <path
          d="M25.0108 27.8175H28.8624C29.4657 27.8175 30 27.2939 30 26.6907V26.4492C30 24.7903 28.6099 23.4512 26.9509 23.4512H26.9223C25.2633 23.4512 23.9185 24.796 23.9185 26.455V26.7252C23.9185 27.3285 24.4075 27.8175 25.0108 27.8175Z"
          fill="#67CDDF"
        />
        <path
          d="M17.022 4.61729V9.44627C17.022 9.77965 16.7518 10.0499 16.4184 10.0499H13.3399L12.7363 7.08285L13.3399 4.01367H16.4184C16.7518 4.01367 17.022 4.28391 17.022 4.61729Z"
          fill="#F5F5F5"
        />
        <path
          d="M17.022 20.5548V25.3838C17.022 25.7171 16.7518 25.9874 16.4184 25.9874H13.3399L12.7363 22.9693L13.3399 19.9512H16.4184C16.7518 19.9512 17.022 20.2214 17.022 20.5548Z"
          fill="#F5F5F5"
        />
        <path
          d="M13.34 19.9498V25.986H11.0807C5.04145 25.986 0.00301811 21.0448 0 15.0055V15.0001L3.01105 14.3965L6.03622 15.0001C6.03622 16.3667 6.59034 17.6041 7.48612 18.4999C8.38189 19.3957 9.61932 19.9498 10.9859 19.9498H13.34Z"
          fill="#78E7DC"
        />
        <path
          d="M13.34 4.01367V10.0499H10.9859C10.9473 10.0499 10.9087 10.0505 10.87 10.0517C8.18994 10.1127 6.03622 12.3044 6.03622 14.9996H0C0 8.94164 4.92797 4.01367 10.9859 4.01367H13.34Z"
          fill="#67CDDF"
        />
        <path
          d="M17.022 8.54102V9.44645C17.022 9.77983 16.7518 10.0501 16.4184 10.0501H13.3399L12.7363 9.29554L13.3399 8.54102H17.022Z"
          fill="#E6E6E6"
        />
        <path
          d="M13.3403 8.54102V10.0501H10.9861C10.9475 10.0501 10.9089 10.0507 10.8702 10.0519C8.19015 10.1128 6.03643 12.3046 6.03643 14.9998C5.9984 14.7541 6.03643 13.7466 6.03643 13.4907C6.03643 10.7569 8.91631 8.54102 11.6501 8.54102H13.3403Z"
          fill="#27BDF3"
        />
        <path
          d="M13.3399 24.4774V25.9865C11.2968 26.0119 8.97351 26.0581 7.07192 25.2294C2.9688 23.6665 -0.00313014 19.5203 0.000491588 15.1074C0.803308 20.3903 5.46749 24.4774 10.9598 24.4774H13.3399Z"
          fill="#07C3AA"
        />
        <path
          d="M26.2183 11.8816H25.011C24.4074 11.8816 23.9185 11.3927 23.9185 10.7897V10.5192C23.9185 8.86049 25.2633 7.51562 26.9221 7.51562H26.9511C27.1527 7.51562 27.35 7.53554 27.5414 7.57357C26.1639 7.84641 25.1257 9.0615 25.1257 10.5192V10.7897C25.1257 11.3927 25.6146 11.8816 26.2183 11.8816Z"
          fill="#27BDF3"
        />
        <path
          d="M26.2183 27.8172H25.011C24.4074 27.8172 23.9185 27.3282 23.9185 26.7252V26.4548C23.9185 24.796 25.2633 23.4512 26.9221 23.4512H26.9511C27.1527 23.4512 27.35 23.4711 27.5414 23.5091C26.1639 23.782 25.1257 24.997 25.1257 26.4548V26.7252C25.1257 27.3282 25.6146 27.8172 26.2183 27.8172Z"
          fill="#27BDF3"
        />
        <path
          d="M28.0769 5.61877C27.7618 5.85056 27.373 5.98758 26.9517 5.98758C25.9014 5.98758 25.0503 5.13587 25.0503 4.08617C25.0503 3.0896 25.8163 2.27229 26.7923 2.19141C26.3215 2.53668 26.0161 3.09503 26.0161 3.724C26.0161 4.7737 26.8672 5.62541 27.9175 5.62541C27.9712 5.62541 28.0243 5.623 28.0769 5.61877Z"
          fill="#FFAC5C"
        />
        <path
          d="M28.0769 21.5524C27.7618 21.7842 27.373 21.9212 26.9517 21.9212C25.9014 21.9212 25.0503 21.0695 25.0503 20.0198C25.0503 19.0232 25.8163 18.2059 26.7923 18.125C26.3215 18.4703 26.0161 19.0286 26.0161 19.6576C26.0161 20.7073 26.8672 21.559 27.9175 21.559C27.9712 21.559 28.0243 21.5566 28.0769 21.5524Z"
          fill="#FFAC5C"
        />
        <path
          d="M22.0321 26.4386H18.7725C18.5225 26.4386 18.3198 26.236 18.3198 25.9859C18.3198 25.7358 18.5225 25.5332 18.7725 25.5332H22.0321C22.2822 25.5332 22.4848 25.7358 22.4848 25.9859C22.4848 26.236 22.2822 26.4386 22.0321 26.4386Z"
          fill="#27BDF3"
        />
        <path
          d="M21.4284 20.4035H18.8931C18.6431 20.4035 18.4404 20.2008 18.4404 19.9508C18.4404 19.7007 18.6431 19.498 18.8931 19.498H21.4284C21.6784 19.498 21.8811 19.7007 21.8811 19.9508C21.8811 20.2008 21.6784 20.4035 21.4284 20.4035Z"
          fill="#27BDF3"
        />
        <path
          d="M23.5411 23.4211H21.6397C21.3896 23.4211 21.187 23.2184 21.187 22.9683C21.187 22.7183 21.3896 22.5156 21.6397 22.5156H23.5411C23.7912 22.5156 23.9939 22.7183 23.9939 22.9683C23.9939 23.2184 23.7912 23.4211 23.5411 23.4211Z"
          fill="#27BDF3"
        />
        <path
          d="M19.7083 23.4211H19.1348C18.8848 23.4211 18.6821 23.2184 18.6821 22.9683C18.6821 22.7183 18.8848 22.5156 19.1348 22.5156H19.7083C19.9584 22.5156 20.161 22.7183 20.161 22.9683C20.161 23.2184 19.9584 23.4211 19.7083 23.4211Z"
          fill="#27BDF3"
        />
        <path
          d="M22.0321 4.46793H18.7725C18.5225 4.46793 18.3198 4.2653 18.3198 4.01522C18.3198 3.76514 18.5225 3.5625 18.7725 3.5625H22.0321C22.2822 3.5625 22.4848 3.76514 22.4848 4.01522C22.4848 4.2653 22.2822 4.46793 22.0321 4.46793Z"
          fill="#27BDF3"
        />
        <path
          d="M21.4284 10.5031H18.8931C18.6431 10.5031 18.4404 10.3005 18.4404 10.0504C18.4404 9.80029 18.6431 9.59766 18.8931 9.59766H21.4284C21.6784 9.59766 21.8811 9.80029 21.8811 10.0504C21.8811 10.3005 21.6784 10.5031 21.4284 10.5031Z"
          fill="#27BDF3"
        />
        <path
          d="M23.5415 7.48551H22.2437C21.9937 7.48551 21.791 7.28287 21.791 7.03279C21.791 6.78271 21.9937 6.58008 22.2437 6.58008H23.5415C23.7916 6.58008 23.9942 6.78271 23.9942 7.03279C23.9942 7.28287 23.7916 7.48551 23.5415 7.48551Z"
          fill="#27BDF3"
        />
        <path
          d="M20.3119 7.48551H19.1348C18.8848 7.48551 18.6821 7.28287 18.6821 7.03279C18.6821 6.78271 18.8848 6.58008 19.1348 6.58008H20.3119C20.562 6.58008 20.7646 6.78271 20.7646 7.03279C20.7646 7.28287 20.562 7.48551 20.3119 7.48551Z"
          fill="#27BDF3"
        />
      </g>
      <defs>
        <clipPath id="clip0_22302_20369">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const EmployeesIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="49"
      height="42"
      viewBox="0 0 49 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6619_10759)">
        <path
          d="M44.1171 12.8892H33.2914C32.812 12.8892 32.3438 12.5262 32.3438 11.9251C32.3438 11.3239 32.7005 10.9609 33.2914 10.9609H44.1171C44.5965 10.9609 45.0648 11.3239 45.0648 11.9251C45.0648 12.5262 44.5965 12.8892 44.1171 12.8892Z"
          fill="black"
        />
        <path
          d="M48.0422 16.5181H33.3031C32.8237 16.5181 32.3555 16.1551 32.3555 15.554C32.3555 14.9528 32.7122 14.5898 33.3031 14.5898H48.0533C48.5327 14.5898 49.001 14.9528 49.001 15.554C49.001 16.1551 48.5216 16.5181 48.0422 16.5181Z"
          fill="black"
        />
        <path
          d="M27.2369 16.0321C27.1143 12.0395 24.6169 10.4629 21.5286 10.4629C18.4403 10.4629 15.943 12.0395 15.8203 16.0321C15.9318 19.0606 27.2369 19.0606 27.2369 16.0321Z"
          fill="#FD646F"
        />
        <path
          d="M21.531 19.185C18.5542 19.185 14.9865 18.3343 14.875 16.0431C14.9976 11.9257 17.495 9.50977 21.4195 9.50977C25.3439 9.50977 27.8413 11.9257 27.964 15.9183C28.0643 18.3343 24.6193 19.185 21.531 19.185ZM21.531 11.438C19.3904 11.438 16.7703 12.2887 16.6588 16.1565C16.6588 16.6443 18.5653 17.4836 21.531 17.4836C24.6193 17.4836 26.2916 16.6329 26.2916 16.1565C26.2805 12.1639 23.6716 11.438 21.531 11.438Z"
          fill="black"
        />
        <path
          d="M21.6404 7.80655C22.9519 7.80655 24.0151 6.72489 24.0151 5.39058C24.0151 4.05628 22.9519 2.97461 21.6404 2.97461C20.3288 2.97461 19.2656 4.05628 19.2656 5.39058C19.2656 6.72489 20.3288 7.80655 21.6404 7.80655Z"
          fill="#E4E7E7"
        />
        <path
          d="M21.6422 8.6581C19.8583 8.6581 18.3086 7.20625 18.3086 5.26667C18.3086 3.32708 19.8583 2 21.6422 2C23.426 2 24.8531 3.45185 24.8531 5.39144C24.8531 7.33102 23.426 8.6581 21.6422 8.6581ZM21.6422 3.81481C20.806 3.81481 20.0924 4.54074 20.0924 5.39144C20.0924 6.24213 20.806 6.84329 21.6422 6.84329C22.4783 6.84329 23.1919 6.11736 23.1919 5.26667C23.1919 4.41597 22.4783 3.81481 21.6422 3.81481Z"
          fill="black"
        />
        <path
          d="M44.1171 33.4536H33.2914C32.812 33.4536 32.3438 33.0907 32.3438 32.4895C32.3438 31.8884 32.7005 31.5254 33.2914 31.5254H44.1171C44.5965 31.5254 45.0648 31.8884 45.0648 32.4895C45.0648 33.0907 44.5965 33.4536 44.1171 33.4536Z"
          fill="black"
        />
        <path
          d="M48.0422 37.0825H33.3031C32.8237 37.0825 32.3555 36.7196 32.3555 36.1184C32.3555 35.5173 32.7122 35.1543 33.3031 35.1543H48.0533C48.5327 35.1543 49.001 35.5173 49.001 36.1184C49.001 36.7196 48.5216 37.0825 48.0422 37.0825Z"
          fill="black"
        />
        <path
          d="M27.2369 36.4813C27.1143 32.4887 24.6169 30.9121 21.5286 30.9121C18.4403 30.9121 15.943 32.4887 15.8203 36.4813C15.9318 39.5098 27.2369 39.5098 27.2369 36.4813Z"
          fill="#2EDFFC"
        />
        <path
          d="M21.531 39.6225C18.5542 39.6225 14.9865 38.7718 14.875 36.4806C14.9976 32.3632 17.495 29.9473 21.4195 29.9473C25.3439 29.9473 27.8413 32.3632 27.964 36.3558C28.0643 38.7831 24.6193 39.6225 21.531 39.6225ZM21.531 31.8868C19.3904 31.8868 16.7703 32.7375 16.6588 36.6054C16.6588 37.0931 18.5653 37.9325 21.531 37.9325C24.6193 37.9325 26.2916 37.0818 26.2916 36.6054C26.2805 32.6128 23.6716 31.8868 21.531 31.8868Z"
          fill="black"
        />
        <path
          d="M21.6404 28.246C22.9519 28.246 24.0151 27.1643 24.0151 25.83C24.0151 24.4957 22.9519 23.4141 21.6404 23.4141C20.3288 23.4141 19.2656 24.4957 19.2656 25.83C19.2656 27.1643 20.3288 28.246 21.6404 28.246Z"
          fill="#E4E7E7"
        />
        <path
          d="M21.6422 29.2223C19.8583 29.2223 18.3086 27.7705 18.3086 25.8309C18.3086 23.8913 19.7357 22.4395 21.6422 22.4395C23.5486 22.4395 24.8531 23.8913 24.8531 25.8309C24.8531 27.7705 23.426 29.2223 21.6422 29.2223ZM21.6422 24.379C20.806 24.379 20.0924 25.105 20.0924 25.9557C20.0924 26.8064 20.806 27.5323 21.6422 27.5323C22.4783 27.5323 23.1919 26.8064 23.1919 25.9557C23.1919 25.105 22.4783 24.379 21.6422 24.379Z"
          fill="black"
        />
        <path
          d="M5.47417 16.3947C2.37474 16.3947 0 13.8539 0 10.8368C0 7.81966 2.49738 5.26758 5.7083 5.26758C6.18771 5.26758 6.65597 5.63054 6.65597 6.2317C6.65597 6.83286 6.06507 6.95762 5.58567 6.95762C3.44505 6.95762 1.66121 8.64767 1.66121 10.712C1.66121 12.7764 3.32241 14.4664 5.35154 14.4664C7.38066 14.4664 9.04187 12.7764 9.04187 10.712C9.04187 10.2243 9.39863 9.7479 9.98953 9.7479C10.5804 9.7479 10.9372 10.1109 10.9372 10.712C10.9372 13.8539 8.56246 16.3947 5.47417 16.3947Z"
          fill="black"
        />
        <path
          d="M5.58609 12.2873C5.35196 12.2873 5.10668 12.1626 4.99519 12.0491L3.33398 10.3478C2.97721 9.98479 2.97721 9.38364 3.33398 9.02067C3.69075 8.65771 4.28165 8.65771 4.63842 9.02067L5.70873 10.1096L10.7035 5.02808C11.0603 4.66512 11.6512 4.66512 12.0079 5.02808C12.3647 5.39104 12.3647 5.9922 12.0079 6.35516L6.18814 12.0378C6.0655 12.2873 5.83137 12.2873 5.58609 12.2873Z"
          fill="black"
        />
        <path
          d="M5.47417 36.8436C2.37474 36.8436 0 34.3029 0 31.161C0 28.0191 2.37474 25.5918 5.47417 25.5918C5.95358 25.5918 6.42184 25.9548 6.42184 26.5559C6.42184 27.1571 5.94243 27.4066 5.47417 27.4066C3.33356 27.4066 1.78385 29.0967 1.78385 31.161C1.78385 33.214 3.44505 35.0288 5.47417 35.0288C7.5033 35.0288 9.16451 33.3388 9.16451 31.161C9.16451 30.6733 9.52127 30.1969 10.1122 30.1969C10.7031 30.1969 11.0598 30.5599 11.0598 31.161C10.9372 34.3029 8.56246 36.8436 5.47417 36.8436Z"
          fill="black"
        />
        <path
          d="M5.58609 32.8518C5.35196 32.8518 5.10668 32.727 4.99519 32.6136L3.33398 30.9236C2.97721 30.5606 2.97721 29.9594 3.33398 29.5965C3.69075 29.2335 4.28165 29.2335 4.63842 29.5965L5.70873 30.6854L10.7035 25.5925C11.0603 25.2296 11.6512 25.2296 12.0079 25.5925C12.3647 25.9555 12.3647 26.5567 12.0079 26.9196L6.42227 32.6023C6.0655 32.727 5.83137 32.8518 5.58609 32.8518Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_6619_10759">
          <rect width="49" height="42" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PencilIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.738281 39.832H25.8201V41.3074C25.8201 42.9396 24.5014 44.2582 22.8693 44.2582H3.68908C2.05692 44.2582 0.738281 42.9396 0.738281 41.3074V39.832Z"
        fill="#FD646F"
      />
      <path
        d="M33.2039 24.3457H42.0563C42.8678 24.3457 43.5317 25.0096 43.5317 25.8211V34.6735C43.5317 35.485 42.8678 36.1489 42.0563 36.1489H33.2039C32.3924 36.1489 31.7285 35.485 31.7285 34.6735V25.8211C31.7285 25.0096 32.3924 24.3457 33.2039 24.3457Z"
        fill="#2EDFFC"
      />
      <path
        d="M37.6154 32.4633C38.8377 32.4633 39.8285 31.4725 39.8285 30.2502C39.8285 29.0279 38.8377 28.0371 37.6154 28.0371C36.3932 28.0371 35.4023 29.0279 35.4023 30.2502C35.4023 31.4725 36.3932 32.4633 37.6154 32.4633Z"
        fill="#57B7EB"
      />
      <path
        d="M38.3549 30.2508C38.7623 30.2508 39.0926 29.9205 39.0926 29.5131C39.0926 29.1057 38.7623 28.7754 38.3549 28.7754C37.9475 28.7754 37.6172 29.1057 37.6172 29.5131C37.6172 29.9205 37.9475 30.2508 38.3549 30.2508Z"
        fill="#2EDFFC"
      />
      <path
        d="M0.738281 8.12109H9.59068V19.9243H0.738281V8.12109Z"
        fill="#2EDFFC"
      />
      <path
        d="M18.4524 12.5415C21.7117 12.5415 24.354 9.89925 24.354 6.63988C24.354 3.38052 21.7117 0.738281 18.4524 0.738281C15.193 0.738281 12.5508 3.38052 12.5508 6.63988C12.5508 9.89925 15.193 12.5415 18.4524 12.5415Z"
        fill="#FD646F"
      />
      <path
        d="M16.9629 8.85589V4.42969L21.3891 6.64279L16.9629 8.85589Z"
        fill="#2EDFFC"
      />
      <path
        d="M33.2039 1.47656H42.0563C42.8678 1.47656 43.5317 2.14049 43.5317 2.95196V11.8044C43.5317 12.6158 42.8678 13.2798 42.0563 13.2798H33.2039C32.3924 13.2798 31.7285 12.6158 31.7285 11.8044V2.95196C31.7285 2.14049 32.3924 1.47656 33.2039 1.47656Z"
        fill="#2EDFFC"
      />
      <path
        d="M13.5 32.993L16.0543 31.5176L18.0916 34.7299C18.4973 35.4399 18.2576 36.3344 17.5475 36.7493C16.8375 37.1551 15.943 36.9153 15.5281 36.2053L13.5 32.993Z"
        fill="#FD646F"
      />
      <path
        d="M8.73618 27.3677L11.9267 25.5234L15.6152 31.9138L12.4247 33.758C11.3642 34.3666 10.0087 34.007 9.40011 32.9465L7.92471 30.3923C7.31611 29.3318 7.67574 27.9763 8.73618 27.3677Z"
        fill="#FD646F"
      />
      <path
        d="M6.67998 31.1026L7.91563 30.3926L9.39103 32.9469L8.10927 33.6846C7.3808 34.0995 6.44945 33.8321 6.06216 33.0852C5.70253 32.3751 5.98839 31.4991 6.67998 31.1026Z"
        fill="#FD646F"
      />
      <path
        d="M25.8195 39.0985H24.3441V31.8691C24.3441 31.4633 24.0121 31.1314 23.6064 31.1314C23.2007 31.1314 22.8687 31.4633 22.8687 31.8691V39.0985H3.6885V24.3445H9.82985C10.2356 24.3445 10.5676 24.0126 10.5676 23.6068C10.5676 23.2011 10.2356 22.8691 9.82985 22.8691H2.9508C2.54507 22.8691 2.2131 23.2011 2.2131 23.6068V39.0985H0.7377C0.331965 39.0985 0 39.4305 0 39.8362V41.3116C0 43.3495 1.6506 45.0001 3.6885 45.0001H22.8687C24.9066 45.0001 26.5572 43.3495 26.5572 41.3116V39.8362C26.5572 39.4305 26.2252 39.0985 25.8195 39.0985ZM25.0818 41.3116C25.0818 42.5381 24.0951 43.5247 22.8687 43.5247H21.3933V42.787C21.3933 42.3813 21.0613 42.0493 20.6556 42.0493C20.2499 42.0493 19.9179 42.3813 19.9179 42.787V43.5247H6.6393V42.787C6.6393 42.3813 6.30734 42.0493 5.9016 42.0493C5.49587 42.0493 5.1639 42.3813 5.1639 42.787V43.5247H3.6885C2.46207 43.5247 1.4754 42.5381 1.4754 41.3116V40.5739H25.0818V41.3116Z"
        fill="black"
      />
      <path
        d="M38.3526 5.16681H39.828C40.2337 5.16681 40.5657 4.83484 40.5657 4.42911C40.5657 4.02337 40.2337 3.69141 39.828 3.69141H38.3526C37.1261 3.69141 36.1395 4.67808 36.1395 5.90451V6.64221H35.4018C34.996 6.64221 34.6641 6.97417 34.6641 7.37991C34.6641 7.78564 34.996 8.11761 35.4018 8.11761H36.1395V10.3307C36.1395 10.7364 36.4714 11.0684 36.8772 11.0684C37.2829 11.0684 37.6149 10.7364 37.6149 10.3307V8.11761H38.3526C38.7583 8.11761 39.0903 7.78564 39.0903 7.37991C39.0903 6.97417 38.7583 6.64221 38.3526 6.64221H37.6149V5.90451C37.6149 5.49877 37.9468 5.16681 38.3526 5.16681Z"
        fill="black"
      />
      <path
        d="M42.0557 0.738281H33.2033C31.9769 0.738281 30.9902 1.72496 30.9902 2.95138V4.42678C30.9902 4.83252 31.3222 5.16448 31.7279 5.16448C32.1337 5.16448 32.4656 4.83252 32.4656 4.42678V2.95138C32.4656 2.54565 32.7976 2.21368 33.2033 2.21368H42.0557C42.4615 2.21368 42.7934 2.54565 42.7934 2.95138V11.8038C42.7934 12.2095 42.4615 12.5415 42.0557 12.5415H33.2033C32.7976 12.5415 32.4656 12.2095 32.4656 11.8038V7.37758C32.4656 6.97185 32.1337 6.63988 31.7279 6.63988C31.3222 6.63988 30.9902 6.97185 30.9902 7.37758V11.8038C30.9902 13.0302 31.9769 14.0169 33.2033 14.0169H42.0557C43.2822 14.0169 44.2688 13.0302 44.2688 11.8038V2.95138C44.2688 1.72496 43.2822 0.738281 42.0557 0.738281Z"
        fill="black"
      />
      <path
        d="M34.6641 30.2496C34.6641 31.8818 35.9827 33.2004 37.6149 33.2004C39.247 33.2004 40.5657 31.8818 40.5657 30.2496C40.5657 28.6175 39.247 27.2988 37.6149 27.2988C35.9827 27.2988 34.6641 28.6175 34.6641 30.2496ZM39.0903 30.2496C39.0903 31.0611 38.4263 31.725 37.6149 31.725C36.8034 31.725 36.1395 31.0611 36.1395 30.2496C36.1395 29.4382 36.8034 28.7742 37.6149 28.7742C38.4263 28.7742 39.0903 29.4382 39.0903 30.2496Z"
        fill="black"
      />
      <path
        d="M42.0557 23.6074H33.2033C31.9769 23.6074 30.9902 24.5941 30.9902 25.8205V34.6729C30.9902 35.8994 31.9769 36.886 33.2033 36.886H42.0557C43.2822 36.886 44.2688 35.8994 44.2688 34.6729V33.1975C44.2688 32.7918 43.9369 32.4598 43.5311 32.4598C43.1254 32.4598 42.7934 32.7918 42.7934 33.1975V34.6729C42.7934 35.0787 42.4615 35.4106 42.0557 35.4106H33.2033C32.7976 35.4106 32.4656 35.0787 32.4656 34.6729V25.8205C32.4656 25.4148 32.7976 25.0828 33.2033 25.0828H42.0557C42.4615 25.0828 42.7934 25.4148 42.7934 25.8205V30.2467C42.7934 30.6525 43.1254 30.9844 43.5311 30.9844C43.9369 30.9844 44.2688 30.6525 44.2688 30.2467V25.8205C44.2688 24.5941 43.2822 23.6074 42.0557 23.6074Z"
        fill="black"
      />
      <path
        d="M16.575 9.48821C16.6949 9.56198 16.824 9.59887 16.9623 9.59887C17.0822 9.59887 17.1928 9.5712 17.2943 9.51588L21.7205 7.30277C22.0801 7.11835 22.2276 6.67573 22.0432 6.30688C21.9694 6.16856 21.8588 6.05791 21.7205 5.98414L17.2943 3.77103C16.9346 3.58661 16.4828 3.73415 16.3076 4.09378C16.2523 4.19521 16.2246 4.30587 16.2246 4.42574V8.85195C16.2246 9.11936 16.3537 9.34989 16.575 9.48821ZM17.7 5.63373L19.7379 6.64807L17.7 7.6624V5.63373Z"
        fill="black"
      />
      <path
        d="M18.4518 13.2786C22.1219 13.2786 25.0911 10.3094 25.0911 6.6393C25.0911 2.96924 22.1219 0 18.4518 0C14.7817 0 11.8125 2.96924 11.8125 6.6393C11.8125 10.3094 14.7817 13.2786 18.4518 13.2786ZM18.4518 1.4754C21.3012 1.4754 23.6157 3.78993 23.6157 6.6393C23.6157 9.48867 21.3012 11.8032 18.4518 11.8032C15.6024 11.8032 13.2879 9.48867 13.2879 6.6393C13.2879 3.78993 15.6024 1.4754 18.4518 1.4754Z"
        fill="black"
      />
      <path
        d="M25.8227 16.2358C26.0533 16.2358 26.2746 16.1251 26.4129 15.9407L28.626 12.9899C28.8657 12.6672 28.8012 12.1969 28.4785 11.9571C28.1557 11.7174 27.6946 11.7819 27.4457 12.1047L25.2326 15.0555C24.9836 15.3782 25.0574 15.8393 25.3801 16.0882C25.5092 16.1805 25.666 16.2358 25.8227 16.2358Z"
        fill="black"
      />
      <path
        d="M27.4474 18.8808C27.5857 19.0652 27.807 19.1759 28.0376 19.1759C28.1943 19.1759 28.3511 19.1206 28.4802 19.0283L31.431 16.8152C31.7537 16.5663 31.8275 16.1052 31.5785 15.7825C31.3296 15.4597 30.8685 15.3859 30.5458 15.6349L27.595 17.848C27.2722 18.097 27.1984 18.5581 27.4474 18.8808Z"
        fill="black"
      />
      <path
        d="M34.6666 20.5074C34.5928 20.1109 34.2147 19.8435 33.809 19.908C33.7998 19.908 33.7905 19.908 33.7813 19.9173L30.0928 20.655C29.6871 20.6919 29.392 21.0607 29.4289 21.4664C29.4658 21.8722 29.8346 22.1673 30.2404 22.1304H30.3879L34.0764 21.3927C34.4729 21.3189 34.7403 20.9408 34.6758 20.5351C34.6666 20.5259 34.6666 20.5166 34.6666 20.5074Z"
        fill="black"
      />
      <path
        d="M0.7377 20.6614H9.5901C9.99584 20.6614 10.3278 20.3295 10.3278 19.9237V8.12051C10.3278 7.71478 9.99584 7.38281 9.5901 7.38281H0.7377C0.331965 7.38281 0 7.71478 0 8.12051V19.9237C0 20.3295 0.331965 20.6614 0.7377 20.6614ZM1.4754 8.85821H8.8524V19.186H1.4754V8.85821Z"
        fill="black"
      />
      <path
        d="M6.64279 10.3359H5.16739C4.76165 10.3359 4.42969 10.6679 4.42969 11.0736C4.42969 11.4794 4.76165 11.8113 5.16739 11.8113H6.64279C7.04852 11.8113 7.38049 11.4794 7.38049 11.0736C7.38049 10.6679 7.04852 10.3359 6.64279 10.3359Z"
        fill="black"
      />
      <path
        d="M6.64163 13.2715H3.69083C3.28509 13.2715 2.95312 13.6034 2.95312 14.0092C2.95312 14.4149 3.28509 14.7469 3.69083 14.7469H6.64163C7.04736 14.7469 7.37933 14.4149 7.37933 14.0092C7.37933 13.6034 7.04736 13.2715 6.64163 13.2715Z"
        fill="black"
      />
      <path
        d="M6.64163 16.2246H3.69083C3.28509 16.2246 2.95312 16.5566 2.95312 16.9623C2.95312 17.368 3.28509 17.7 3.69083 17.7H6.64163C7.04736 17.7 7.37933 17.368 7.37933 16.9623C7.37933 16.5566 7.04736 16.2246 6.64163 16.2246Z"
        fill="black"
      />
      <path
        d="M25.1756 20.4306C24.9728 20.0801 24.5209 19.9511 24.1613 20.1539C23.8109 20.3568 23.6818 20.8086 23.8846 21.1683L27.1397 26.7932L15.3365 31.2194H15.2812C15.2596 31.2194 15.2259 31.2194 15.2259 31.2194L13.3079 32.326L12.0353 33.0637C11.6941 33.2573 11.2884 33.3126 10.9103 33.2112C10.5323 33.1098 10.2095 32.8608 10.0159 32.5288L8.54048 29.9746C8.18085 29.283 8.42061 28.4254 9.09376 28.0289L11.648 26.5535L13.4923 29.744C13.6214 29.9746 13.8704 30.1129 14.1378 30.1129C14.5435 30.1129 14.8755 29.7901 14.8755 29.3752C14.8755 29.2461 14.8386 29.117 14.774 29.0063L12.8745 25.7236L22.1326 18.0884L22.4369 18.614C22.6398 18.9644 23.0916 19.0935 23.4512 18.8906C23.8017 18.6877 23.9307 18.2359 23.7279 17.8763L22.9902 16.6037C22.8795 16.4193 22.6951 16.2902 22.483 16.2533C22.2709 16.2164 22.0496 16.2718 21.8744 16.4101L11.5466 24.9213L8.39294 26.7194C7.23106 27.3926 6.67779 28.7666 7.03742 30.0575L6.29972 30.4817C5.23927 31.0903 4.87042 32.4458 5.47903 33.5063C5.77411 34.0135 6.25361 34.3915 6.82533 34.5391C7.00975 34.5852 7.2034 34.6128 7.39705 34.6128C7.78434 34.6128 8.16241 34.5114 8.5036 34.3178L9.2413 33.8936C9.5917 34.2624 10.0435 34.5206 10.5323 34.6589C10.7812 34.7327 11.0487 34.7604 11.3069 34.7604C11.8232 34.7604 12.3304 34.6221 12.7823 34.3639L13.4277 33.995L14.9031 36.5585C15.5117 37.6098 16.8673 37.9786 17.9185 37.37C18.9789 36.7614 19.3386 35.4059 18.73 34.3454L17.3837 32.0032L28.4492 27.8537C28.652 27.7799 28.8088 27.6139 28.8826 27.411C28.9563 27.2082 28.9379 26.9869 28.8272 26.8024L25.1756 20.4306ZM7.74745 33.036C7.58147 33.1374 7.3786 33.1651 7.18496 33.1098C7.00053 33.0637 6.83455 32.9346 6.73312 32.7686C6.63168 32.6026 6.60402 32.3997 6.65935 32.2061C6.71467 32.0124 6.83455 31.8557 7.00975 31.7543L7.65524 31.3854L8.39294 32.6579L7.74745 33.036ZM17.4574 35.1016C17.5589 35.2676 17.5865 35.4704 17.5312 35.6641C17.4759 35.8485 17.356 36.0145 17.1808 36.1067C16.8304 36.3096 16.3785 36.1897 16.1757 35.8393L14.7003 33.2758L15.9267 32.5749H15.982L17.4574 35.1016Z"
        fill="black"
      />
    </svg>
  );
};
export const PlugIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="49"
      height="42"
      viewBox="0 0 49 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1930_6177)">
        <path
          d="M43.4502 6.73454C45.1151 6.73454 46.4648 5.38742 46.4648 3.72567C46.4648 2.06391 45.1151 0.716797 43.4502 0.716797C41.7853 0.716797 40.4355 2.06391 40.4355 3.72567C40.4355 5.38742 41.7853 6.73454 43.4502 6.73454Z"
          fill="#FFC682"
        />
        <path
          d="M40.3687 16.066H46.4746C47.4316 16.066 48.2738 15.235 48.2738 14.2798V13.8977C48.2738 11.2709 46.0727 9.15039 43.4408 9.15039H43.393C40.7611 9.15039 38.627 11.2805 38.627 13.9073V14.3371C38.6461 15.2923 39.4213 16.066 40.3687 16.066Z"
          fill="#50758D"
        />
        <path
          d="M43.4502 31.9513C45.1151 31.9513 46.4648 30.6042 46.4648 28.9425C46.4648 27.2807 45.1151 25.9336 43.4502 25.9336C41.7853 25.9336 40.4355 27.2807 40.4355 28.9425C40.4355 30.6042 41.7853 31.9513 43.4502 31.9513Z"
          fill="#FFC682"
        />
        <path
          d="M40.3687 41.2848H46.4746C47.4316 41.2848 48.2738 40.4537 48.2738 39.4985V39.1165C48.2738 36.4897 46.0727 34.3691 43.4408 34.3691H43.393C40.7611 34.3691 38.627 36.4992 38.627 39.126V39.5559C38.6461 40.5111 39.4213 41.2848 40.3687 41.2848Z"
          fill="#50758D"
        />
        <path
          d="M27.707 4.56652V12.2081C27.707 12.7335 27.2764 13.1633 26.75 13.1633H21.8691L20.9121 8.46373L21.8691 3.61133H26.75C27.2764 3.61133 27.707 4.04117 27.707 4.56652Z"
          fill="#F5F5F5"
        />
        <path
          d="M27.707 29.7833V37.4249C27.707 37.9503 27.2764 38.3801 26.75 38.3801H21.8691L20.9121 33.6041L21.8691 28.8281H26.75C27.2764 28.8281 27.707 29.258 27.707 29.7833Z"
          fill="#F5F5F5"
        />
        <path
          d="M21.8691 28.8288V38.3808H18.2898C8.70996 38.3808 0.72832 30.5673 0.71875 21.0058V20.9962L5.49434 20.041L10.2891 20.9962C10.2891 23.155 11.1695 25.1131 12.5859 26.5364C14.0023 27.95 15.9643 28.8288 18.1367 28.8288H21.8691Z"
          fill="#FD646F"
        />
        <path
          d="M21.8691 3.61133V13.1633H18.1367C18.0793 13.1633 18.0123 13.1633 17.9549 13.1633C13.7057 13.2588 10.2891 16.7262 10.2891 20.9959H0.71875C0.71875 11.4057 8.52812 3.61133 18.1367 3.61133H21.8691Z"
          fill="#2EDFFC"
        />
        <path
          d="M35.6514 39.0969H30.4834C30.091 39.0969 29.7656 38.7721 29.7656 38.3805C29.7656 37.9888 30.091 37.6641 30.4834 37.6641H35.6514C36.0437 37.6641 36.3691 37.9888 36.3691 38.3805C36.3691 38.7721 36.0437 39.0969 35.6514 39.0969Z"
          fill="#FAD207"
        />
        <path
          d="M34.6943 29.5441H30.6748C30.2824 29.5441 29.957 29.2194 29.957 28.8277C29.957 28.4361 30.2824 28.1113 30.6748 28.1113H34.6943C35.0867 28.1113 35.4121 28.4361 35.4121 28.8277C35.4121 29.2194 35.0867 29.5441 34.6943 29.5441Z"
          fill="#FAD207"
        />
        <path
          d="M38.0449 34.3215H35.0303C34.6379 34.3215 34.3125 33.9967 34.3125 33.6051C34.3125 33.2134 34.6379 32.8887 35.0303 32.8887H38.0449C38.4373 32.8887 38.7627 33.2134 38.7627 33.6051C38.7627 33.9967 38.4373 34.3215 38.0449 34.3215Z"
          fill="#FAD207"
        />
        <path
          d="M31.9668 34.3215H31.0576C30.6652 34.3215 30.3398 33.9967 30.3398 33.6051C30.3398 33.2134 30.6652 32.8887 31.0576 32.8887H31.9668C32.3592 32.8887 32.6846 33.2134 32.6846 33.6051C32.6846 33.9967 32.3592 34.3215 31.9668 34.3215Z"
          fill="#FAD207"
        />
        <path
          d="M35.6514 4.32733H30.4834C30.091 4.32733 29.7656 4.00256 29.7656 3.61093C29.7656 3.2193 30.091 2.89453 30.4834 2.89453H35.6514C36.0437 2.89453 36.3691 3.2193 36.3691 3.61093C36.3691 4.00256 36.0437 4.32733 35.6514 4.32733Z"
          fill="#FAD207"
        />
        <path
          d="M34.6943 13.8801H30.6748C30.2824 13.8801 29.957 13.5553 29.957 13.1637C29.957 12.772 30.2824 12.4473 30.6748 12.4473H34.6943C35.0867 12.4473 35.4121 12.772 35.4121 13.1637C35.4121 13.5553 35.0867 13.8801 34.6943 13.8801Z"
          fill="#FAD207"
        />
        <path
          d="M38.0449 9.10272H35.9873C35.5949 9.10272 35.2695 8.77795 35.2695 8.38632C35.2695 7.99469 35.5949 7.66992 35.9873 7.66992H38.0449C38.4373 7.66992 38.7627 7.99469 38.7627 8.38632C38.7627 8.7875 38.4373 9.10272 38.0449 9.10272Z"
          fill="#FAD207"
        />
        <path
          d="M32.9238 9.10272H31.0576C30.6652 9.10272 30.3398 8.77795 30.3398 8.38632C30.3398 7.99469 30.6652 7.66992 31.0576 7.66992H32.9238C33.3162 7.66992 33.6416 7.99469 33.6416 8.38632C33.6416 8.7875 33.3162 9.10272 32.9238 9.10272Z"
          fill="#FAD207"
        />
        <path
          d="M27.707 10.7754V12.2082C27.707 12.7335 27.2764 13.1634 26.75 13.1634H21.8691L20.9121 11.9694L21.8691 10.7754H27.707Z"
          fill="#E6E6E6"
        />
        <path
          d="M21.8693 10.7754V13.1634H18.1368C18.0794 13.1634 18.0124 13.1634 17.955 13.1634C13.7058 13.2589 10.2892 16.7263 10.2892 20.996C10.2318 20.6044 10.2892 19.0092 10.2892 18.608C10.2892 14.281 14.8542 10.7754 19.1896 10.7754H21.8693Z"
          fill="#27BDF3"
        />
        <path
          d="M27.707 35.9922V37.425C27.707 37.9503 27.2764 38.3802 26.75 38.3802H21.8691L20.9121 37.1862L21.8691 35.9922H27.707Z"
          fill="#E6E6E6"
        />
        <path
          d="M21.8691 35.9926V38.3806C18.6344 38.4188 14.9498 38.4952 11.9352 37.1866C5.42734 34.7127 0.71875 28.1505 0.71875 21.168C1.9916 29.5259 9.38945 35.9926 18.0984 35.9926H21.8691Z"
          fill="#FC4755"
        />
        <path
          d="M42.2928 16.066H40.3787C39.4217 16.066 38.6465 15.2923 38.6465 14.3371V13.9073C38.6465 11.2805 40.7807 9.15039 43.4125 9.15039H43.4604C43.7762 9.15039 44.092 9.17905 44.3982 9.24591C42.2162 9.67575 40.5701 11.5957 40.5701 13.9073V14.3371C40.5605 15.2923 41.3357 16.066 42.2928 16.066Z"
          fill="#2B597F"
        />
        <path
          d="M42.2928 41.2848H40.3787C39.4217 41.2848 38.6465 40.5111 38.6465 39.5559V39.126C38.6465 36.4992 40.7807 34.3691 43.4125 34.3691H43.4604C43.7762 34.3691 44.092 34.3978 44.3982 34.4647C42.2162 34.8945 40.5701 36.824 40.5701 39.126V39.5559C40.5605 40.5111 41.3357 41.2848 42.2928 41.2848Z"
          fill="#2B597F"
        />
        <path
          d="M45.2303 6.15208C44.7326 6.51505 44.1105 6.73475 43.4502 6.73475C41.785 6.73475 40.4355 5.38792 40.4355 3.72588C40.4355 2.14981 41.651 0.86029 43.2014 0.726562C42.4549 1.27102 41.9668 2.15936 41.9668 3.15276C41.9668 4.8148 43.3162 6.16163 44.9814 6.16163C45.0676 6.16163 45.1537 6.16163 45.2303 6.15208Z"
          fill="#FFAC5C"
        />
        <path
          d="M45.2303 31.3689C44.7326 31.7319 44.1105 31.9515 43.4502 31.9515C41.785 31.9515 40.4355 30.6047 40.4355 28.9427C40.4355 27.3666 41.651 26.0771 43.2014 25.9434C42.4549 26.4878 41.9668 27.3762 41.9668 28.3696C41.9668 30.0316 43.3162 31.3784 44.9814 31.3784C45.0676 31.3784 45.1537 31.3784 45.2303 31.3689Z"
          fill="#FFAC5C"
        />
        <path
          d="M35.6514 39.0969H30.4834C30.091 39.0969 29.7656 38.7721 29.7656 38.3805C29.7656 37.9888 30.091 37.6641 30.4834 37.6641H35.6514C36.0437 37.6641 36.3691 37.9888 36.3691 38.3805C36.3691 38.7721 36.0437 39.0969 35.6514 39.0969Z"
          fill="#FAD207"
        />
        <path
          d="M34.6943 29.5441H30.6748C30.2824 29.5441 29.957 29.2194 29.957 28.8277C29.957 28.4361 30.2824 28.1113 30.6748 28.1113H34.6943C35.0867 28.1113 35.4121 28.4361 35.4121 28.8277C35.4121 29.2194 35.0867 29.5441 34.6943 29.5441Z"
          fill="#FAD207"
        />
        <path
          d="M38.043 34.3215H35.0283C34.6359 34.3215 34.3105 33.9967 34.3105 33.6051C34.3105 33.2134 34.6359 32.8887 35.0283 32.8887H38.043C38.4354 32.8887 38.7607 33.2134 38.7607 33.6051C38.7607 33.9967 38.4354 34.3215 38.043 34.3215Z"
          fill="#FAD207"
        />
        <path
          d="M31.9668 34.3215H31.0576C30.6652 34.3215 30.3398 33.9967 30.3398 33.6051C30.3398 33.2134 30.6652 32.8887 31.0576 32.8887H31.9668C32.3592 32.8887 32.6846 33.2134 32.6846 33.6051C32.6846 33.9967 32.3592 34.3215 31.9668 34.3215Z"
          fill="#FAD207"
        />
        <path
          d="M35.6514 4.32733H30.4834C30.091 4.32733 29.7656 4.00256 29.7656 3.61093C29.7656 3.2193 30.091 2.89453 30.4834 2.89453H35.6514C36.0437 2.89453 36.3691 3.2193 36.3691 3.61093C36.3691 4.00256 36.0437 4.32733 35.6514 4.32733Z"
          fill="#FAD207"
        />
        <path
          d="M34.6943 13.8801H30.6748C30.2824 13.8801 29.957 13.5553 29.957 13.1637C29.957 12.772 30.2824 12.4473 30.6748 12.4473H34.6943C35.0867 12.4473 35.4121 12.772 35.4121 13.1637C35.4121 13.5553 35.0867 13.8801 34.6943 13.8801Z"
          fill="#FAD207"
        />
        <path
          d="M38.043 9.10272H35.9854C35.593 9.10272 35.2676 8.77795 35.2676 8.38632C35.2676 7.99469 35.593 7.66992 35.9854 7.66992H38.043C38.4354 7.66992 38.7607 7.99469 38.7607 8.38632C38.7607 8.7875 38.4354 9.10272 38.043 9.10272Z"
          fill="#FAD207"
        />
        <path
          d="M32.9238 9.10272H31.0576C30.6652 9.10272 30.3398 8.77795 30.3398 8.38632C30.3398 7.99469 30.6652 7.66992 31.0576 7.66992H32.9238C33.3162 7.66992 33.6416 7.99469 33.6416 8.38632C33.6416 8.7875 33.3162 9.10272 32.9238 9.10272Z"
          fill="#FAD207"
        />
        <path
          d="M43.4492 7.45053C45.5068 7.45053 47.1816 5.77894 47.1816 3.72527C47.1816 1.67159 45.5068 0 43.4492 0C41.3916 0 39.7168 1.67159 39.7168 3.72527C39.7168 5.77894 41.3916 7.45053 43.4492 7.45053ZM43.4492 1.4328C44.7125 1.4328 45.7461 2.46441 45.7461 3.72527C45.7461 4.98613 44.7125 6.01774 43.4492 6.01774C42.1859 6.01774 41.1523 4.98613 41.1523 3.72527C41.1523 2.46441 42.1859 1.4328 43.4492 1.4328Z"
          fill="black"
        />
        <path
          d="M43.4496 8.43359H43.4018C40.3775 8.43359 37.918 10.8884 37.918 13.9069V14.3367C37.918 15.6835 39.0186 16.782 40.368 16.782H46.4738C47.8424 16.782 48.9908 15.6358 48.9908 14.2794V13.8973C49.0004 10.8884 46.5121 8.43359 43.4496 8.43359ZM47.5648 14.2794C47.5648 14.8334 47.048 15.3492 46.4834 15.3492H40.3775C39.8225 15.3492 39.3631 14.8907 39.3631 14.3367V13.9069C39.3631 11.6813 41.1814 9.86639 43.4113 9.86639H43.4592C45.7273 9.86639 47.5744 11.6717 47.5744 13.8973V14.2794H47.5648Z"
          fill="black"
        />
        <path
          d="M47.1816 28.9421C47.1816 26.8884 45.5068 25.2168 43.4492 25.2168C41.3916 25.2168 39.7168 26.8884 39.7168 28.9421C39.7168 30.9957 41.3916 32.6673 43.4492 32.6673C45.5068 32.6673 47.1816 30.9957 47.1816 28.9421ZM41.1523 28.9421C41.1523 27.6812 42.1859 26.6496 43.4492 26.6496C44.7125 26.6496 45.7461 27.6812 45.7461 28.9421C45.7461 30.2029 44.7125 31.2345 43.4492 31.2345C42.1859 31.2345 41.1523 30.2029 41.1523 28.9421Z"
          fill="black"
        />
        <path
          d="M43.4496 33.6523H43.4018C40.3775 33.6523 37.918 36.1072 37.918 39.1256V39.5555C37.918 40.9023 39.0186 42.0008 40.368 42.0008H46.4738C47.8424 42.0008 48.9908 40.8545 48.9908 39.4981V39.1161C49.0004 36.1072 46.5121 33.6523 43.4496 33.6523ZM47.5648 39.4981C47.5648 40.0522 47.048 40.568 46.4834 40.568H40.3775C39.8225 40.568 39.3631 40.1095 39.3631 39.5555V39.1256C39.3631 36.9 41.1814 35.0851 43.4113 35.0851H43.4592C45.7273 35.0851 47.5744 36.8905 47.5744 39.1161V39.4981H47.5648Z"
          fill="black"
        />
        <path
          d="M27.7061 2.89453H18.1357C13.2932 2.89453 8.74727 4.77627 5.31152 8.20543C1.88535 11.6346 0 16.1718 0 20.9955V21.0051C0 26.2777 2.36387 31.2925 6.4791 34.7599C6.77578 35.0178 7.23516 34.9796 7.49356 34.6739C7.75195 34.3683 7.71367 33.9193 7.40742 33.6614C3.79941 30.6239 1.65566 26.2969 1.45469 21.7119H9.59902C9.9627 26.0963 13.6568 29.5445 18.1357 29.5445H21.1504V37.6637H18.2889C15.4273 37.6637 12.585 36.9186 10.068 35.5049C9.72344 35.3139 9.2832 35.4381 9.0918 35.782C8.90039 36.1258 9.02481 36.5652 9.36934 36.7563C12.0969 38.2846 15.1785 39.0965 18.2984 39.0965H27.7156C28.108 39.0965 28.4334 38.7717 28.4334 38.3801V28.8281C28.4334 28.4365 28.108 28.1117 27.7156 28.1117H18.1453C14.2119 28.1117 11.0154 24.9214 11.0154 20.9955C11.0154 19.2188 11.6758 17.5186 12.8721 16.2004C13.14 15.9043 13.1209 15.4554 12.8242 15.1879C12.5275 14.9205 12.0777 14.9396 11.8098 15.2357C10.5369 16.6398 9.76172 18.4069 9.60859 20.2791H1.45469C1.62695 16.1049 3.34961 12.1981 6.33555 9.21793C9.49375 6.06578 13.6855 4.32733 18.1453 4.32733H21.1504V12.4465H18.1357C16.9777 12.4465 15.858 12.6757 14.8053 13.1151C14.4416 13.268 14.2693 13.6883 14.4225 14.0512C14.5756 14.4142 14.9967 14.5861 15.3604 14.4333C16.2408 14.0608 17.1691 13.8697 18.1357 13.8697H27.7061C28.0984 13.8697 28.4238 13.545 28.4238 13.1533V3.60138C28.4238 3.2193 28.0984 2.89453 27.7061 2.89453ZM26.9883 37.6637H22.5859V29.5445H26.9883V37.6637ZM26.9883 12.4465H22.5859V4.32733H26.9883V12.4465Z"
          fill="black"
        />
        <path
          d="M30.4814 4.32733H35.6494C36.0418 4.32733 36.3672 4.00256 36.3672 3.61093C36.3672 3.2193 36.0418 2.89453 35.6494 2.89453H30.4814C30.0891 2.89453 29.7637 3.2193 29.7637 3.61093C29.7637 4.00256 30.0891 4.32733 30.4814 4.32733Z"
          fill="black"
        />
        <path
          d="M29.9551 13.1617C29.9551 13.5533 30.2805 13.8781 30.6729 13.8781H34.6924C35.0848 13.8781 35.4102 13.5533 35.4102 13.1617C35.4102 12.7701 35.0848 12.4453 34.6924 12.4453H30.6729C30.2805 12.4453 29.9551 12.7701 29.9551 13.1617Z"
          fill="black"
        />
        <path
          d="M35.2656 8.38632C35.2656 8.77795 35.591 9.10272 35.9834 9.10272H38.041C38.4334 9.10272 38.7588 8.77795 38.7588 8.38632C38.7588 7.99469 38.4334 7.66992 38.041 7.66992H35.9834C35.591 7.66992 35.2656 7.99469 35.2656 8.38632Z"
          fill="black"
        />
        <path
          d="M32.9219 9.10272C33.3143 9.10272 33.6396 8.77795 33.6396 8.38632C33.6396 7.99469 33.3143 7.66992 32.9219 7.66992H31.0557C30.6633 7.66992 30.3379 7.99469 30.3379 8.38632C30.3379 8.77795 30.6633 9.10272 31.0557 9.10272H32.9219Z"
          fill="black"
        />
        <path
          d="M35.6494 37.6641H30.4814C30.0891 37.6641 29.7637 37.9888 29.7637 38.3805C29.7637 38.7721 30.0891 39.0969 30.4814 39.0969H35.6494C36.0418 39.0969 36.3672 38.7721 36.3672 38.3805C36.3672 37.9888 36.0418 37.6641 35.6494 37.6641Z"
          fill="black"
        />
        <path
          d="M35.4102 28.8277C35.4102 28.4361 35.0848 28.1113 34.6924 28.1113H30.6729C30.2805 28.1113 29.9551 28.4361 29.9551 28.8277C29.9551 29.2194 30.2805 29.5441 30.6729 29.5441H34.6924C35.0848 29.5441 35.4102 29.2289 35.4102 28.8277Z"
          fill="black"
        />
        <path
          d="M35.0264 34.3195H38.041C38.4334 34.3195 38.7588 33.9947 38.7588 33.6031C38.7588 33.2115 38.4334 32.8867 38.041 32.8867H35.0264C34.634 32.8867 34.3086 33.2115 34.3086 33.6031C34.3086 33.9947 34.634 34.3195 35.0264 34.3195Z"
          fill="black"
        />
        <path
          d="M31.0557 32.8867C30.6633 32.8867 30.3379 33.2115 30.3379 33.6031C30.3379 33.9947 30.6633 34.3195 31.0557 34.3195H31.9648C32.3572 34.3195 32.6826 33.9947 32.6826 33.6031C32.6826 33.2115 32.3572 32.8867 31.9648 32.8867H31.0557Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1930_6177">
          <rect width="49" height="42" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Dashy2Icon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.1" width="50" height="50" rx="15" fill="#FFA873" />
      <rect
        x="15"
        y="15"
        width="8"
        height="9"
        rx="1"
        stroke="#FFA873"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="15"
        y="29"
        width="8"
        height="6"
        rx="1"
        stroke="#FFA873"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="28"
        y="15"
        width="7"
        height="6"
        rx="1"
        stroke="#FFA873"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="28"
        y="26"
        width="7"
        height="9"
        rx="1"
        stroke="#FFA873"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DashyIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="8"
        height="9"
        rx="1"
        stroke="#02BF90"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1"
        y="15"
        width="8"
        height="6"
        rx="1"
        stroke="#02BF90"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="14"
        y="1"
        width="7"
        height="6"
        rx="1"
        stroke="#02BF90"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="14"
        y="12"
        width="7"
        height="9"
        rx="1"
        stroke="#02BF90"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PlusIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#02BF90" />
      <path
        d="M12.5 5.20898V19.7923"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M5.20703 12.502L19.7904 12.502"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const CalllIcon: React.FunctionComponent<ISvgComponent> = ({
  handleClick,
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <circle cx="14" cy="14" r="14" fill="#02BF90" />
      <path
        d="M20.2559 19.9035C19.6502 20.6035 18.7843 21 17.8677 21C17.8389 21 17.8102 21 17.7815 20.9993C11.8954 20.8394 7.15959 16.1035 7.00117 10.2182C6.97538 9.26246 7.37771 8.35684 8.10426 7.73198C8.7947 7.13733 9.69367 6.88908 10.572 7.04603C10.7069 7.07035 10.8225 7.10122 10.9213 7.13364C11.3103 7.26259 11.5933 7.59948 11.6581 8.01064L12.1519 11.1459C12.2138 11.5387 12.0605 11.9367 11.7532 12.1857C11.6913 12.2358 11.6272 12.2836 11.5601 12.3278C11.3892 12.4443 11.3243 12.6425 11.401 12.8186C12.1393 14.5171 13.4804 15.8581 15.1782 16.5965C15.355 16.6738 15.5532 16.6076 15.6726 16.4329C15.7072 16.3828 15.7433 16.3335 15.7801 16.2863C16.0277 15.9709 16.4338 15.8191 16.8346 15.8832L20.0267 16.4146C20.4482 16.4853 20.7908 16.7837 20.9006 17.1757C20.9205 17.2472 20.9397 17.3283 20.9559 17.4204C21.1099 18.3054 20.8549 19.2094 20.2559 19.9035Z"
        fill="white"
      />
    </svg>
  );
};
export const SpeakIcon: React.FunctionComponent<ISvgComponent> = ({
  handleClick,
}) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 50C38.7695 50 50 38.7695 50 25C50 11.2305 38.7695 0 25 0C11.2305 0 0 11.2305 0 25C0 38.7695 11.2305 50 25 50Z"
        fill="#CDD4D8"
      />
      <path
        d="M26.7746 17.319V33.0635C26.7746 34.7671 25.8137 36.2685 24.2664 36.9798C23.6827 37.2494 23.0675 37.38 22.4581 37.38C21.4585 37.38 20.4748 37.0243 19.6746 36.3374L15.9547 33.1454C15.8242 33.0336 15.6592 32.9718 15.49 32.9718L14.4317 32.9704C12.5402 32.9689 11 31.4242 11 29.5284V20.8513C11 18.9569 12.5388 17.4137 14.4303 17.4094L15.49 17.408C15.6592 17.4065 15.8241 17.3461 15.9532 17.2357L19.676 14.0424C20.9638 12.9367 22.7276 12.69 24.2664 13.4013C25.8137 14.1126 26.7746 15.6125 26.7746 17.319ZM31.5026 20.0222C31.0236 19.3941 30.1245 19.2667 29.4935 19.7471C28.8625 20.226 28.7392 21.125 29.2182 21.756C29.9653 22.7412 30.3611 23.93 30.3611 25.192C30.3611 26.4539 29.9667 27.6428 29.2182 28.6279C28.7392 29.2589 28.8625 30.1583 29.4935 30.6372C29.7531 30.8337 30.0585 30.9282 30.3597 30.9282C30.7942 30.9282 31.2215 30.7317 31.504 30.3603C32.6326 28.8732 33.2292 27.0849 33.2292 25.192C33.2292 23.299 32.6312 21.5094 31.5026 20.0222ZM35.2971 15.627C34.7665 15.0376 33.8616 14.9917 33.2723 15.5209C32.6843 16.05 32.6355 16.9562 33.1661 17.5456C35.0547 19.6464 36.0959 22.3612 36.0959 25.1906C36.0959 28.02 35.0547 30.7347 33.1661 32.8356C32.6355 33.425 32.6843 34.3311 33.2723 34.8603C33.5462 35.1069 33.8903 35.2289 34.2316 35.2289C34.6231 35.2289 35.0146 35.0697 35.2971 34.7542C37.6604 32.1256 38.964 28.7284 38.964 25.1906C38.964 21.6528 37.6619 18.2556 35.2971 15.627Z"
        fill="white"
      />
    </svg>
  );
};
export const RecIcon: React.FunctionComponent<ISvgComponent> = ({
  handleClick,
}) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 50C38.7695 50 50 38.7695 50 25C50 11.2305 38.7695 0 25 0C11.2305 0 0 11.2305 0 25C0 38.7695 11.2305 50 25 50Z"
        fill="#EF5350"
      />
      <path
        d="M19.375 18.0256V13.3077C19.375 10.3814 21.8988 8 25 8C28.1012 8 30.625 10.3814 30.625 13.3077V18.0256C30.625 20.9519 28.1012 23.3333 25 23.3333C21.8988 23.3333 19.375 20.9519 19.375 18.0256ZM35 18.0256C35 17.3734 34.44 16.8462 33.75 16.8462C33.06 16.8462 32.5 17.3734 32.5 18.0256C32.5 21.9286 29.1362 25.1026 25 25.1026C20.8637 25.1026 17.5 21.9286 17.5 18.0256C17.5 17.3734 16.94 16.8462 16.25 16.8462C15.56 16.8462 15 17.3734 15 18.0256C15 22.8285 18.825 26.7962 23.75 27.38V28.641H20C19.31 28.641 18.75 29.1683 18.75 29.8205C18.75 30.4728 19.31 31 20 31H30C30.69 31 31.25 30.4728 31.25 29.8205C31.25 29.1683 30.69 28.641 30 28.641H26.25V27.38C31.175 26.7962 35 22.8285 35 18.0256Z"
        fill="white"
      />
      <path
        d="M16 33.8916H18.6514C19.195 33.8916 19.6621 33.973 20.0527 34.1357C20.4466 34.2985 20.7493 34.5394 20.9609 34.8584C21.1725 35.1774 21.2783 35.5697 21.2783 36.0352C21.2783 36.416 21.2132 36.7432 21.083 37.0166C20.9561 37.2868 20.7754 37.513 20.541 37.6953C20.3099 37.8743 20.0381 38.0176 19.7256 38.125L19.2617 38.3691H16.957L16.9473 37.2266H18.6611C18.9183 37.2266 19.1315 37.181 19.3008 37.0898C19.4701 36.9987 19.597 36.8717 19.6816 36.709C19.7695 36.5462 19.8135 36.3574 19.8135 36.1426C19.8135 35.9147 19.7712 35.7178 19.6865 35.5518C19.6019 35.3857 19.4733 35.2588 19.3008 35.1709C19.1283 35.083 18.9118 35.0391 18.6514 35.0391H17.4648V41.001H16V33.8916ZM19.9746 41.001L18.3535 37.832L19.9014 37.8223L21.542 40.9326V41.001H19.9746Z"
        fill="white"
      />
      <path
        d="M27.2768 39.8584V41.001H23.4926V39.8584H27.2768ZM23.9711 33.8916V41.001H22.5062V33.8916H23.9711ZM26.7836 36.7871V37.9004H23.4926V36.7871H26.7836ZM27.2719 33.8916V35.0391H23.4926V33.8916H27.2719Z"
        fill="white"
      />
      <path
        d="M32.3523 38.6426H33.8123C33.783 39.1211 33.6512 39.5459 33.4168 39.917C33.1857 40.2881 32.8618 40.5778 32.4451 40.7861C32.0317 40.9945 31.5337 41.0986 30.951 41.0986C30.4952 41.0986 30.0867 41.0205 29.7254 40.8643C29.3641 40.7048 29.0548 40.4769 28.7977 40.1807C28.5437 39.8844 28.3501 39.5264 28.2166 39.1064C28.0831 38.6865 28.0164 38.2161 28.0164 37.6953V37.2021C28.0164 36.6813 28.0848 36.2109 28.2215 35.791C28.3615 35.3678 28.56 35.0081 28.8172 34.7119C29.0776 34.4157 29.3885 34.1878 29.7498 34.0283C30.1111 33.8688 30.5148 33.7891 30.9607 33.7891C31.5532 33.7891 32.0529 33.8965 32.4598 34.1113C32.8699 34.3262 33.1873 34.6224 33.4119 35C33.6398 35.3776 33.7765 35.8073 33.8221 36.2891H32.3572C32.341 36.0026 32.284 35.7601 32.1863 35.5615C32.0887 35.3597 31.9406 35.2083 31.742 35.1074C31.5467 35.0033 31.2863 34.9512 30.9607 34.9512C30.7166 34.9512 30.5034 34.9967 30.3211 35.0879C30.1388 35.179 29.9858 35.3174 29.8621 35.5029C29.7384 35.6885 29.6456 35.9229 29.5838 36.2061C29.5252 36.486 29.4959 36.8148 29.4959 37.1924V37.6953C29.4959 38.0632 29.5236 38.387 29.5789 38.667C29.6342 38.9437 29.7189 39.1781 29.8328 39.3701C29.95 39.5589 30.0997 39.7021 30.282 39.7998C30.4676 39.8942 30.6906 39.9414 30.951 39.9414C31.257 39.9414 31.5092 39.8926 31.7078 39.7949C31.9064 39.6973 32.0577 39.5524 32.1619 39.3604C32.2693 39.1683 32.3328 38.929 32.3523 38.6426Z"
        fill="white"
      />
    </svg>
  );
};

export const FishIcon: React.FunctionComponent<ISvgComponent> = ({
  handleClick,
}) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35 70C54.2773 70 70 54.2773 70 35C70 15.7227 54.2773 0 35 0C15.7227 0 0 15.7227 0 35C0 54.2773 15.7227 70 35 70Z"
        fill="#B11313"
      />
      <path
        d="M13.9953 34.6724C13.8769 32.3612 14.7532 30.1476 16.4073 28.5615C16.4591 28.5117 16.5109 28.462 16.5641 28.4136C27.4616 18.5169 44.2018 18.8675 54.6714 29.2128C56.3717 30.8926 57.2128 33.2229 56.9831 35.6076C56.7662 37.8753 55.5736 39.8788 53.7172 41.1155C53.4318 41.3049 53.1696 41.4494 52.9353 41.5618C52.0102 42.0023 50.9167 41.8841 50.0882 41.2544L43.7721 36.4515C42.9809 35.8499 42.5687 34.8666 42.6922 33.8855C42.7172 33.6879 42.7502 33.4907 42.7947 33.2949C42.9017 32.789 42.6757 32.3191 42.2327 32.134C37.9615 30.3469 33.221 30.2478 28.88 31.8533C28.427 32.0197 28.1841 32.4822 28.2709 33.0038C28.2951 33.1542 28.3153 33.3057 28.3304 33.4545C28.4294 34.452 27.9596 35.4287 27.1254 36.0066L20.446 40.5713C19.5631 41.173 18.4284 41.2275 17.552 40.7101C17.3924 40.6156 17.2175 40.5024 17.0289 40.3643C15.2197 39.034 14.1154 36.9615 13.9953 34.6724Z"
        fill="white"
      />
    </svg>
  );
};
export const NoteIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.987 5.177L10.573 0.762939C10.242 0.431939 9.803 0.25 9.336 0.25H4.75C2.131 0.25 0 2.381 0 5V15C0 17.619 2.131 19.75 4.75 19.75H10.75C13.369 19.75 15.5 17.619 15.5 15V6.41394C15.5 5.94694 15.318 5.507 14.987 5.177ZM10.5 2.81006L12.939 5.24902H12.25C11.285 5.24902 10.5 4.46402 10.5 3.49902V2.81006ZM10.75 18.25H4.75C2.958 18.25 1.5 16.792 1.5 15V5C1.5 3.208 2.958 1.75 4.75 1.75H9V3.5C9 5.292 10.458 6.75 12.25 6.75H14V15C14 16.792 12.542 18.25 10.75 18.25Z"
        fill="#797979"
      />
    </svg>
  );
};

export const PharmacyStoreIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.02553 10.1047C8.85614 11.1053 10.1119 11.7463 11.5115 11.7463C12.9111 11.7463 14.1668 11.1119 14.9974 10.1047C15.828 11.1053 17.0837 11.7463 18.4834 11.7463C19.883 11.7463 21.1387 11.1119 21.9693 10.1047C22.7999 11.1053 24.0556 11.7463 25.4552 11.7463C27.9471 11.7463 29.9745 9.7319 29.9876 7.24008L29.9811 7.08311L29.9484 6.93269L29.896 6.78226C29.896 6.78226 28.2348 3.11974 27.4762 1.4389C27.0837 0.562511 26.2139 0.0065918 25.2525 0.0065918C21.6554 0.0065918 8.32638 0.0065918 4.72926 0.0065918C3.76785 0.0065918 2.898 0.569051 2.50559 1.4389C1.74692 3.1132 0.0857037 6.78226 0.0857037 6.78226C0.0268417 6.91961 -0.00585938 7.06349 -0.00585938 7.21392C-0.00585938 9.71882 2.02815 11.7463 4.52651 11.7463C5.9392 11.7463 7.19493 11.1053 8.02553 10.1047Z"
        fill={fillColor ? fillColor : "#67cddf"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7312 30C17.5481 29.8562 17.3781 29.6992 17.208 29.5357C15.4487 27.7764 14.932 25.2388 15.6711 23.0282H10.8117C9.46438 23.0282 8.37217 21.936 8.37217 20.5887C8.37217 19.3722 8.37217 17.6194 8.37217 16.4029C8.37217 15.0556 9.46438 13.9634 10.8117 13.9634H19.1243C20.465 13.9634 21.5507 15.0426 21.5638 16.3768C23.2512 15.278 25.3506 15.0622 27.2015 15.7358V12.8843C26.6521 13.0543 26.0635 13.1459 25.4552 13.1459C24.1537 13.1459 22.9438 12.7273 21.9693 12.0079C20.9883 12.7208 19.7849 13.1459 18.4834 13.1459C17.1818 13.1459 15.9719 12.7273 14.9974 12.0079C14.0164 12.7208 12.813 13.1459 11.5115 13.1459C10.21 13.1459 9.00003 12.7273 8.02553 12.0079C7.0445 12.7208 5.8411 13.1459 4.5396 13.1459C3.93135 13.1459 3.34927 13.0543 2.79336 12.8843V28.9602C2.79336 29.5357 3.26425 30.0066 3.83979 30.0066H17.7312V30ZM16.8483 20.9288H10.8117C10.622 20.9288 10.465 20.7718 10.465 20.5821V16.3964C10.465 16.2067 10.622 16.0498 10.8117 16.0498H19.1243C19.314 16.0498 19.4709 16.2002 19.4709 16.3964L19.4905 18.2604L17.208 20.5363C17.0837 20.6606 16.966 20.7914 16.8483 20.9288Z"
        fill={fillColor ? fillColor : "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.04712 30.0001H13.6043C14.1799 30.0001 14.6508 29.5292 14.6508 28.9536C14.6508 28.3781 14.1799 27.9072 13.6043 27.9072H1.04712C0.471577 27.9072 0.000680847 28.3781 0.000680847 28.9536C0.000680847 29.5292 0.471577 30.0001 1.04712 30.0001Z"
        fill={fillColor ? fillColor : "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1178 20.6017L18.1956 21.5239C16.2597 23.4664 16.2597 26.6057 18.1956 28.5481C20.138 30.484 23.2773 30.484 25.2198 28.5481L26.142 27.6259L19.1178 20.6017ZM20.6024 19.1171L27.6266 26.1413L28.5488 25.2191C30.4847 23.2767 30.4847 20.1374 28.5488 18.1949C26.6063 16.259 23.467 16.259 21.5246 18.1949L20.6024 19.1171Z"
        fill={fillColor ? fillColor : "white"}
      />
    </svg>
  );
};

export const WarningIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5013 18.3646L15.0233 1.82631C13.6612 -0.607154 10.3407 -0.610387 8.9767 1.82631L0.499073 18.3646C-0.893396 20.8512 0.792464 24 3.52167 24H20.478C23.205 24 24.8938 20.8537 23.5013 18.3646ZM12 21.0154C11.2248 21.0154 10.5937 20.3458 10.5937 19.5232C10.5937 18.7005 11.2248 18.0309 12 18.0309C12.7752 18.0309 13.4062 18.7005 13.4062 19.5232C13.4062 20.3458 12.7752 21.0154 12 21.0154ZM13.4062 15.0463C13.4062 15.8689 12.7752 16.5386 12 16.5386C11.2248 16.5386 10.5937 15.8689 10.5937 15.0463V7.58488C10.5937 6.76224 11.2248 6.0926 12 6.0926C12.7752 6.0926 13.4062 6.76224 13.4062 7.58488V15.0463Z"
        fill="#FFA009"
      />
    </svg>
  );
};

export const PharmacyNotificationIcon: React.FunctionComponent<
  ISvgComponent
> = ({ fillColor }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.1" width="32" height="32" rx="10" fill={fillColor} />
      <path
        d="M12.5 11H14.5M12.5 11V8M12.5 11H10.5V8H12.5M14.5 11V8M14.5 11H16.5V8H14.5M14.5 8H12.5M20 20H18.5C18.1023 20 17.7208 20.158 17.4393 20.4393C17.158 20.7205 17 21.102 17 21.5C17 22.3282 17.6715 23 18.5 23H20M20 20V23M20 20H21.5C21.8978 20 22.2793 20.158 22.5608 20.4393C22.842 20.7205 23 21.102 23 21.5C23 22.3282 22.3285 23 21.5 23H20M8 15.0355C8 14.3725 8.2635 13.7365 8.73226 13.2677C9.11302 12.8867 9.5 12.5 9.5 12.5V11H15.5V12.5C15.5 12.5 15.887 12.8867 16.2677 13.2677C16.7365 13.7365 17 14.3725 17 15.0355V22C17 22.5522 16.5522 23 16 23H8.99999C8.44776 23 8 22.5522 8 22V15.0355ZM8.50002 11H10.5V8H8.50002V11ZM9.99999 16.5H11.5V15H13.5V16.5H15V18.5H13.5V20H11.5V18.5H9.99999V16.5Z"
        stroke={fillColor}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// export const HamburgerIconOpen: React.FunctionComponent<ISvgComponent> = ({
//   handleClick,
//   customClass,
// }) => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="60"
//       height="60"
//       viewBox="0 0 60 60"
//       fill="none"
//       onClick={(e) => {
//         handleClick && handleClick(e);
//       }}
//       className={customClass}
//       style={{ cursor: "pointer" }}
//     >
//       <g filter="url(#filter0_d_22332_22516)">
//         <rect x="18" y="18" width="20" height="20" rx="4" fill="white" />
//       </g>
//       <path
//         d="M22 23.625C22 23.2794 22.2912 23 22.65 23H31.1C31.4588 23 31.75 23.2794 31.75 23.625C31.75 23.9706 31.4588 24.25 31.1 24.25H22.65C22.2912 24.25 22 23.9706 22 23.625ZM34.35 27.375H22.65C22.2912 27.375 22 27.6544 22 28C22 28.3456 22.2912 28.625 22.65 28.625H34.35C34.7088 28.625 35 28.3456 35 28C35 27.6544 34.7088 27.375 34.35 27.375ZM28.5 31.75H22.65C22.2912 31.75 22 32.0294 22 32.375C22 32.7206 22.2912 33 22.65 33H28.5C28.8588 33 29.15 32.7206 29.15 32.375C29.15 32.0294 28.8588 31.75 28.5 31.75Z"
//         fill="#100A26"
//       />
//       <defs>
//         <filter
//           id="filter0_d_22332_22516"
//           x="0"
//           y="0"
//           width="60"
//           height="60"
//           filterUnits="userSpaceOnUse"
//           colorInterpolationFilters="sRGB"
//         >
//           <feFlood floodOpacity="0" result="BackgroundImageFix" />
//           <feColorMatrix
//             in="SourceAlpha"
//             type="matrix"
//             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//             result="hardAlpha"
//           />
//           <feOffset dx="2" dy="2" />
//           <feGaussianBlur stdDeviation="10" />
//           <feComposite in2="hardAlpha" operator="out" />
//           <feColorMatrix
//             type="matrix"
//             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
//           />
//           <feBlend
//             mode="normal"
//             in2="BackgroundImageFix"
//             result="effect1_dropShadow_22332_22516"
//           />
//           <feBlend
//             mode="normal"
//             in="SourceGraphic"
//             in2="effect1_dropShadow_22332_22516"
//             result="shape"
//           />
//         </filter>
//       </defs>
//     </svg>
//   );
// };

export const HamburgerIconClose: React.FunctionComponent<ISvgComponent> = ({
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <g filter="url(#filter0_d_22782_28039)">
        <rect x="18" y="18" width="20" height="20" rx="4" fill="white" />
      </g>
      <path
        d="M35 32.375C35 32.7206 34.7088 33 34.35 33H25.9C25.5412 33 25.25 32.7206 25.25 32.375C25.25 32.0294 25.5412 31.75 25.9 31.75H34.35C34.7088 31.75 35 32.0294 35 32.375ZM22.65 28.625H34.35C34.7088 28.625 35 28.3456 35 28C35 27.6544 34.7088 27.375 34.35 27.375H22.65C22.2912 27.375 22 27.6544 22 28C22 28.3456 22.2912 28.625 22.65 28.625ZM28.5 24.25H34.35C34.7088 24.25 35 23.9706 35 23.625C35 23.2794 34.7088 23 34.35 23H28.5C28.1412 23 27.85 23.2794 27.85 23.625C27.85 23.9706 28.1412 24.25 28.5 24.25Z"
        fill="#100A26"
      />
      <defs>
        <filter
          id="filter0_d_22782_28039"
          x="0"
          y="0"
          width="60"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22782_28039"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22782_28039"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const RadiologyJobIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M15 0C6.7506 0 0 6.70225 0 15C0 23.2494 6.7506 30 15 30C23.2494 30 30 23.2494 30 15C30.006 6.70225 23.2554 0 15 0ZM15 27.1898C8.29774 27.1898 2.81023 21.7023 2.81023 15C2.81023 8.24939 8.29774 2.81023 15 2.81023C21.7023 2.81023 27.1898 8.24939 27.1898 15C27.1898 21.7083 21.7083 27.1898 15 27.1898Z"
        fill="#67CDDF"
      />
      <path
        d="M10.9689 15V14.9033H6.84121C6.32751 14.9033 5.90446 15.3263 5.90446 15.7917C5.90446 18.2756 7.12525 20.8078 9.23444 22.5423C9.60914 22.8686 10.2195 22.778 10.5459 22.4033L13.6885 18.3723C12.2381 17.8646 11.1563 16.5471 10.9689 15Z"
        fill="#EAEFFE"
      />
      <path
        d="M23.1587 14.9094H19.0371V15.0061C18.8497 16.6015 17.774 17.913 16.3175 18.4267L19.4601 22.4577C19.7865 22.8807 20.3485 22.9291 20.7716 22.5967C22.8807 20.8622 24.1015 18.33 24.1015 15.8461C24.0532 15.2841 23.6301 14.9094 23.1587 14.9094Z"
        fill="#EAEFFE"
      />
      <path
        d="M12.3288 11.5311C13.0298 10.8723 14.0149 10.546 15 10.546C15.8461 10.546 16.6862 10.83 17.3932 11.3437L18.9887 8.06207C19.2244 7.59068 19.0371 7.02863 18.5657 6.84128C16.0818 5.71719 13.2655 5.76554 11.0173 6.84128C10.5459 7.07698 10.3586 7.63903 10.5943 8.06207L12.3288 11.5311Z"
        fill="#EAEFFE"
      />
      <path
        d="M18.0943 14.861C18.0943 14.7643 18.0943 14.6253 18.0943 14.5346C18.0943 13.5979 17.6712 12.7035 16.9702 12.1414C16.4081 11.67 15.7494 11.4404 15 11.4404C14.1116 11.4404 13.3139 11.8151 12.7518 12.3771C12.2381 12.9391 11.9057 13.6885 11.9057 14.5346V14.861C12.0447 16.1724 13.0298 17.2542 14.3413 17.5322C14.577 17.5806 14.7643 17.5806 15 17.5806C15.2357 17.5806 15.4714 17.5806 15.6587 17.5322C16.9702 17.2542 17.9553 16.2208 18.0943 14.861Z"
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const RadiologyRequestIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M15 0C6.72882 0 0 6.16699 0 13.7476C0 17.7393 1.878 21.4819 5.09856 24.0747L6.95258 19.5337C5.54608 17.9004 4.77091 15.8862 4.77091 13.7549C4.77091 8.58399 9.35802 4.37988 15 4.37988C20.642 4.37988 25.2291 8.58399 25.2291 13.7549C25.2291 15.8862 24.4539 17.9077 23.0474 19.5337L24.9014 24.0747C28.13 21.4966 30 17.7466 30 13.7549C30.008 6.16699 23.2712 0 15 0Z"
        fill="#67CDDF"
      />
      <path
        d="M19.7788 16.2525H10.229C9.94127 16.2525 9.69353 16.4136 9.58964 16.6553L5.66583 26.25H24.3419L20.4181 16.6553C20.3142 16.4136 20.0665 16.2525 19.7788 16.2525Z"
        fill="#EAEFFE"
      />
      <path
        d="M5.45824 29.3774C5.45824 29.7217 5.76192 30 6.13751 30H23.8706C24.2462 30 24.5499 29.7217 24.5499 29.3774V27.5024H5.45824V29.3774Z"
        fill="#70DCD4"
      />
    </svg>
  );
};

export const RadiologyInvoiceIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M30.0002 8.0138V27.219C30 27.641 29.879 28.0557 29.649 28.4226C29.4189 28.7895 29.0877 29.0961 28.6878 29.3124C28.2878 29.5287 27.8328 29.6472 27.3671 29.6565C26.9014 29.6658 26.441 29.5655 26.0309 29.3653L25.5386 29.1145C24.9359 28.7197 24.205 28.5186 23.4617 28.543C22.7069 28.5207 21.9653 28.7266 21.354 29.1284C20.3765 29.6975 19.239 30 18.0771 30C16.9152 30 15.7777 29.6975 14.8002 29.1284C14.1834 28.7381 13.4445 28.5378 12.6925 28.557C11.9451 28.5368 11.2107 28.7373 10.6002 29.1284L10.1233 29.3793C9.71318 29.5794 9.25281 29.6797 8.78713 29.6705C8.32145 29.6612 7.86639 29.5426 7.46643 29.3263C7.06647 29.1101 6.73528 28.8035 6.50525 28.4366C6.27522 28.0696 6.1542 27.6549 6.15403 27.233V2.78741C6.15544 2.07623 5.85673 1.39145 5.31904 0.873262C4.78135 0.355075 4.04535 0.0426698 3.26172 0H21.154C23.4989 0.00368476 25.7466 0.849176 27.4047 2.35126C29.0628 3.85334 29.9961 5.88954 30.0002 8.0138Z"
        fill="#EAEFFE"
      />
      <path
        d="M6.92308 3.13557V14.982C6.92083 15.1965 6.84582 15.4052 6.70821 15.5797C6.5706 15.7542 6.37706 15.8862 6.15385 15.9576C6.03143 16.002 5.90107 16.0256 5.76923 16.0273H1.15385C0.84907 16.0237 0.557894 15.9124 0.342363 15.7172C0.126833 15.5219 0.00398812 15.2581 3.55724e-06 14.982V3.13557C-0.00126418 2.33577 0.336362 1.56603 0.943235 0.985141C1.55011 0.404251 2.37994 0.0565175 3.26154 0.0136719H3.46154C4.37694 0.0136637 5.25507 0.342131 5.9038 0.927203C6.55252 1.51227 6.91901 2.30631 6.92308 3.13557Z"
        fill="#67CDDF"
      />
      <path
        d="M15.453 16.0219V15.9355H11.8236C11.372 15.9355 11 16.3133 11 16.7288C11 18.9467 12.0734 21.2078 13.9279 22.7566C14.2574 23.048 14.7941 22.9671 15.081 22.6325L17.8442 19.0331C16.5689 18.5798 15.6177 17.4033 15.453 16.0219Z"
        fill="#002C5A"
      />
      <path
        d="M26.171 15.9409H22.547V16.0273C22.3823 17.4519 21.4364 18.623 20.1558 19.0817L22.919 22.6811C23.2059 23.0588 23.7001 23.102 24.0721 22.8052C25.9266 21.2564 27 18.9953 27 16.7774C26.9575 16.2755 26.5855 15.9409 26.171 15.9409Z"
        fill="#002C5A"
      />
      <path
        d="M16.6487 12.9243C17.2651 12.3361 18.1312 12.0447 18.9974 12.0447C19.7413 12.0447 20.4799 12.2984 21.1017 12.7571L22.5045 9.82678C22.7118 9.40586 22.547 8.90399 22.1325 8.7367C19.9486 7.73297 17.4723 7.77614 15.4956 8.7367C15.0811 8.94716 14.9164 9.44903 15.1236 9.82678L16.6487 12.9243Z"
        fill="#002C5A"
      />
      <path
        d="M21.718 15.8977C21.718 15.8114 21.718 15.6873 21.718 15.6063C21.718 14.7699 21.3461 13.9712 20.7297 13.4693C20.2355 13.0484 19.6563 12.8434 18.9974 12.8434C18.2162 12.8434 17.5148 13.1779 17.0206 13.6798C16.5689 14.1817 16.2767 14.8508 16.2767 15.6063V15.8977C16.3989 17.0688 17.2651 18.0347 18.4182 18.283C18.6254 18.3261 18.7901 18.3261 18.9974 18.3261C19.2046 18.3261 19.4118 18.3261 19.5766 18.283C20.7297 18.0347 21.5958 17.1119 21.718 15.8977Z"
        fill="#002C5A"
      />
    </svg>
  );
};

export const LabJobIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="30"
      viewBox="0 0 35 30"
      fill="none"
    >
      <path
        d="M11.13 16.8766C15.0824 16.8766 18.2865 13.0987 18.2865 8.43832C18.2865 3.77797 15.0824 0 11.13 0C7.17752 0 3.97343 3.77797 3.97343 8.43832C3.97343 13.0987 7.17752 16.8766 11.13 16.8766Z"
        fill="#FFCCBD"
      />
      <path
        d="M15.1107 18.7489H7.15654C3.20553 18.7577 0.00745473 22.5286 0 27.1872V29.0595C0 29.5781 0.357827 30 0.797656 30H16.8179L20.3887 21.5792C19.0468 19.7949 17.131 18.7665 15.1107 18.7489Z"
        fill="#67CDDF"
      />
      <path
        d="M34.9031 28.6464L32.3014 22.5022H21.7753L19.1736 28.6464C18.9798 29.1122 19.1363 29.6748 19.5314 29.9033C19.6433 29.9648 19.7625 30 19.8893 30H34.2023C34.6422 30 35 29.5781 35 29.0683C34.9851 28.9188 34.9627 28.7782 34.9031 28.6464Z"
        fill="#EAEFFE"
      />
      <path
        d="M23.0574 9.37883H23.8551V17.5974L22.5654 20.6299H31.5037L30.214 17.5974V9.37883H31.0116C31.4515 9.37883 31.8093 8.95691 31.8093 8.43831C31.8093 7.9197 31.4515 7.49779 31.0116 7.49779H23.0574C22.6176 7.49779 22.2598 7.9197 22.2598 8.43831C22.2672 8.95691 22.6176 9.37883 23.0574 9.37883Z"
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const LaboratoryRequestIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="35"
      viewBox="0 0 30 35"
      fill="none"
    >
      <path
        d="M8.12152 4.54994L13.5195 1.37848L12.9804 0.496764C12.6794 0.0114772 12.0353 -0.145728 11.5382 0.148178L7.93949 2.2602C7.4424 2.55411 7.28137 3.18293 7.58242 3.66822L8.12152 4.54994Z"
        fill="#78E7DC"
      />
      <path
        d="M29.8466 23.9341C29.5455 23.4488 28.9014 23.2984 28.4043 23.5923L22.5442 27.0645C22.8243 27.7139 23.0063 28.4179 23.0693 29.1492L29.4895 25.3421C29.9936 25.0482 30.1477 24.4194 29.8466 23.9341Z"
        fill="#78E7DC"
      />
      <path
        d="M24.1545 32.9495H21.0039V29.8054C21.0039 26.9757 18.6515 24.6791 15.753 24.6791C12.8544 24.6791 10.502 26.9757 10.502 29.8054V32.9495H7.35138C6.77027 32.9495 6.30118 33.4074 6.30118 33.9747C6.30118 34.5421 6.77027 35 7.35138 35H24.1545C24.7356 35 25.2047 34.5421 25.2047 33.9747C25.2047 33.4074 24.7356 32.9495 24.1545 32.9495ZM15.753 30.8306C15.1718 30.8306 14.7028 30.3727 14.7028 29.8054C14.7028 29.2381 15.1718 28.7801 15.753 28.7801C16.3341 28.7801 16.8032 29.2381 16.8032 29.8054C16.8032 30.3727 16.3341 30.8306 15.753 30.8306Z"
        fill="#EAEFFE"
      />
      <path
        d="M7.94649 8.24085L9.0527 10.0385L11.2931 8.71931C13.9466 7.15409 17.3703 8.02213 18.9456 10.5374C20.5699 13.1279 19.7157 16.5044 17.0482 18.0628L14.7938 19.382L15.5079 20.5507C15.809 21.036 16.4531 21.1932 16.9502 20.8993C16.9852 20.8788 17.3353 20.6738 17.8673 20.3594L19.4777 22.9772C19.7787 23.4625 20.4228 23.6197 20.9199 23.3258L24.5186 21.2137C25.0157 20.9198 25.1767 20.291 24.8757 19.8057L23.2654 17.1879C23.8045 16.8735 24.1475 16.6684 24.1475 16.6684C24.6446 16.3745 24.8057 15.7457 24.5046 15.2604C24.4766 15.2194 16.9222 2.94371 16.8942 2.9027C16.5791 2.45842 15.963 2.32855 15.4869 2.60195L8.30356 6.83284C7.80646 7.12674 7.64543 7.75557 7.94649 8.24085Z"
        fill="#67CDDF"
      />
      <path
        d="M8.40158 29.8054C8.40158 27.7959 9.24873 25.9846 10.614 24.6791H9.45177C7.71545 24.6791 6.30118 23.2984 6.30118 21.6033C6.30118 19.9083 7.71545 18.5276 9.45177 18.5276H11.8742C12.0633 18.5276 12.2523 18.4797 12.4133 18.384L15.97 16.3062C17.6363 15.3356 18.1614 13.2304 17.1532 11.6105C16.159 10.018 14.0166 9.51217 12.3783 10.4759L9.15071 12.376C4.07476 12.5333 0 16.6138 0 21.6033C0 26.3469 3.68269 30.2633 8.40158 30.776V29.8054Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const LabInvoiceIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M6.92308 3.13557V14.982C6.92083 15.1965 6.84582 15.4052 6.70821 15.5797C6.5706 15.7542 6.37706 15.8862 6.15385 15.9576C6.03143 16.002 5.90107 16.0256 5.76923 16.0273H1.15385C0.84907 16.0237 0.557894 15.9124 0.342363 15.7172C0.126833 15.5219 0.00398812 15.2581 3.55724e-06 14.982V3.13557C-0.00126418 2.33577 0.336362 1.56603 0.943235 0.985141C1.55011 0.404251 2.37994 0.0565175 3.26154 0.0136719H3.46154C4.37694 0.0136637 5.25507 0.342131 5.9038 0.927203C6.55252 1.51227 6.91901 2.30631 6.92308 3.13557Z"
        fill="#67CDDF"
      />
      <path
        d="M30.0002 8.0138V27.219C30 27.641 29.879 28.0557 29.649 28.4226C29.4189 28.7895 29.0877 29.0961 28.6878 29.3124C28.2878 29.5287 27.8328 29.6472 27.3671 29.6565C26.9014 29.6658 26.441 29.5655 26.0309 29.3653L25.5386 29.1145C24.9359 28.7197 24.205 28.5186 23.4617 28.543C22.7069 28.5207 21.9653 28.7266 21.354 29.1284C20.3765 29.6975 19.239 30 18.0771 30C16.9152 30 15.7777 29.6975 14.8002 29.1284C14.1834 28.7381 13.4445 28.5378 12.6925 28.557C11.9451 28.5368 11.2107 28.7373 10.6002 29.1284L10.1233 29.3793C9.71318 29.5794 9.25281 29.6797 8.78713 29.6705C8.32145 29.6612 7.86639 29.5426 7.46643 29.3263C7.06647 29.1101 6.73528 28.8035 6.50525 28.4366C6.27522 28.0696 6.1542 27.6549 6.15403 27.233V2.78741C6.15544 2.07623 5.85673 1.39145 5.31904 0.873262C4.78135 0.355075 4.04535 0.0426698 3.26172 0H21.154C23.4989 0.00368476 25.7466 0.849176 27.4047 2.35126C29.0628 3.85334 29.9961 5.88954 30.0002 8.0138Z"
        fill="#EAEFFE"
      />
      <path
        d="M24.9147 21.9773L22.6253 17.3356H13.3625L11.073 21.9773C10.9024 22.3293 11.0402 22.7543 11.3879 22.927C11.4863 22.9734 11.5912 23 11.7028 23H24.2981C24.6851 23 25 22.6813 25 22.2961C24.9869 22.1832 24.9672 22.077 24.9147 21.9773Z"
        fill="#002C5A"
      />
      <path
        d="M14.4907 7.42109H15.1926V13.6301L14.0578 15.9211H21.9233L20.7884 13.6301V7.42109H21.4903C21.8773 7.42109 22.1922 7.10234 22.1922 6.71055C22.1922 6.31875 21.8773 6 21.4903 6H14.4907C14.1037 6 13.7888 6.31875 13.7888 6.71055C13.7954 7.10234 14.1037 7.42109 14.4907 7.42109Z"
        fill="#002C5A"
      />
    </svg>
  );
};

export const AddIconV2: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
    >
      <path
        d="M20.5685 8.25H14.6918V2.75C14.6918 2.02065 14.3822 1.32118 13.8312 0.805456C13.2801 0.289731 12.5327 0 11.7534 0C10.9741 0 10.2267 0.289731 9.67569 0.805456C9.12464 1.32118 8.81507 2.02065 8.81507 2.75V8.25H2.93836C2.15906 8.25 1.41167 8.53973 0.860624 9.05546C0.309576 9.57118 0 10.2707 0 11C0 11.7293 0.309576 12.4288 0.860624 12.9445C1.41167 13.4603 2.15906 13.75 2.93836 13.75H8.81507V19.25C8.81507 19.9793 9.12464 20.6788 9.67569 21.1945C10.2267 21.7103 10.9741 22 11.7534 22C12.5327 22 13.2801 21.7103 13.8312 21.1945C14.3822 20.6788 14.6918 19.9793 14.6918 19.25V13.75H20.5685C21.3478 13.75 22.0952 13.4603 22.6462 12.9445C23.1973 12.4288 23.5068 11.7293 23.5068 11C23.5068 10.2707 23.1973 9.57118 22.6462 9.05546C22.0952 8.53973 21.3478 8.25 20.5685 8.25Z"
        // fill="#CDD4D8"
        fill={fillColor}
      />
    </svg>
  );
};

export const EditIconV2: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
  height,
  width,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "23"}
      height={height ? height : "22"}
      viewBox="0 0 23 22"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M18.0724 10.9999C17.6396 10.9999 17.285 11.3498 17.285 11.7873V19.647C17.285 20.0798 16.9351 20.4344 16.4977 20.4344H2.35747C1.92465 20.4344 1.57011 20.0844 1.57011 19.647V3.9275C1.57011 3.49469 1.92005 3.14014 2.35747 3.14014H11.7873C12.2202 3.14014 12.5747 2.79021 12.5747 2.35279C12.5747 1.91537 12.2248 1.56543 11.7873 1.56543H2.35747C1.05441 1.57003 0 2.62905 0 3.9275V19.6424C0 20.9455 1.05441 21.9999 2.35747 21.9999H16.5023C17.8053 21.9999 18.8597 20.9455 18.8597 19.6424V11.7873C18.8597 11.3544 18.5098 10.9999 18.0724 10.9999Z"
        fill={fillColor}
      />
      <path
        d="M21.1236 0.879495C20.5618 0.317755 19.7975 4.936e-05 18.9963 4.936e-05C18.1997 -0.00455507 17.4308 0.31315 16.8691 0.879495L6.51831 11.2302C6.43082 11.3177 6.36636 11.4236 6.32953 11.5387L4.75942 16.2537C4.62128 16.6635 4.8469 17.1101 5.25669 17.2482C5.33497 17.2759 5.42245 17.2897 5.50533 17.2897C5.58821 17.2897 5.6757 17.2759 5.75397 17.2482L10.4689 15.6781C10.584 15.6413 10.6899 15.5722 10.7774 15.4893L21.1282 5.13859C22.2977 3.95986 22.3023 2.05823 21.1236 0.879495Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const DeleteIconV2: FC<ISvgComponent> = ({
  fillColor,
  customClass,
  mouseEnter,
  mouseLeave,
  handleClick,
  width,
  height,
}) => {
  return (
    <svg
      width={width ? width : "26"}
      height={height ? height : "26"}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      style={{ cursor: "pointer" }}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M22 4.67539C22 5.28369 21.5072 5.77539 20.9 5.77539H1.1C0.4928 5.77539 0 5.28369 0 4.67539C0 4.06709 0.4928 3.57539 1.1 3.57539H5.01492C5.48902 3.57539 5.9081 3.2739 6.0588 2.8229L6.40637 1.7801C6.70667 0.880303 7.54601 0.275391 8.49311 0.275391H13.508C14.4562 0.275391 15.2955 0.880328 15.5947 1.77903L15.9423 2.82397C16.0919 3.27277 16.5121 3.57539 16.9862 3.57539H20.9C21.5072 3.57539 22 4.06709 22 4.67539ZM19.03 8.00842L18.359 18.1284C18.216 20.1524 16.522 21.7254 14.509 21.7254H7.491C5.478 21.7254 3.784 20.1524 3.641 18.1394L2.97001 8.00842C2.95901 7.86542 3.01402 7.71129 3.11302 7.60129C3.22302 7.49129 3.36601 7.42539 3.52001 7.42539H18.48C18.634 7.42539 18.777 7.49129 18.887 7.60129C18.986 7.71129 19.041 7.86542 19.03 8.00842ZM9.9 11.2754C9.9 10.6704 9.405 10.1754 8.8 10.1754C8.195 10.1754 7.7 10.6704 7.7 11.2754V16.7754C7.7 17.3804 8.195 17.8754 8.8 17.8754C9.405 17.8754 9.9 17.3804 9.9 16.7754V11.2754ZM14.3 11.2754C14.3 10.6704 13.805 10.1754 13.2 10.1754C12.595 10.1754 12.1 10.6704 12.1 11.2754V16.7754C12.1 17.3804 12.595 17.8754 13.2 17.8754C13.805 17.8754 14.3 17.3804 14.3 16.7754V11.2754Z"
        // fill="#CDD4D8"
        fill={fillColor}
      />
    </svg>
  );
};

// export const FilterIcon: FC<ISvgComponent> = ({ fillColor, handleClick }) => {
//   return (
//     <svg
//       onClick={handleClick}
//       width="15"
//       height="16"
//       viewBox="0 0 15 16"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M13.0714 0H1.92857C0.864857 0 0 0.827897 0 1.84615V3.55779C0 3.94097 0.156 4.30195 0.439715 4.57272L4.82915 8.77454C5.03143 8.96818 5.14286 9.22585 5.14286 9.4999V15.3846C5.14286 15.6176 5.28086 15.831 5.49858 15.9352C5.58944 15.9787 5.688 16 5.78571 16C5.922 16 6.0583 15.9581 6.17144 15.8769L9.60001 13.4154C9.76115 13.2989 9.85714 13.1167 9.85714 12.9231V9.5007C9.85714 9.22665 9.96857 8.96898 10.1709 8.77534L14.5603 4.57352C14.844 4.30193 15 3.94177 15 3.55859V1.84696C15 0.827878 14.1351 0 13.0714 0ZM1.92857 1.23077H13.0714C13.4263 1.23077 13.7143 1.50646 13.7143 1.84615V3.28205H1.28571V1.84615C1.28571 1.50646 1.57371 1.23077 1.92857 1.23077ZM9.26229 7.90485C8.81657 8.33152 8.57143 8.89762 8.57143 9.5007V12.6154L6.42857 14.1538V9.5007C6.42857 8.89762 6.18343 8.33152 5.73771 7.90485L2.19428 4.51282H12.8049L9.26229 7.90485Z"
//         fill={fillColor}
//       />
//     </svg>
//   );
// };

export const PharmacyMainstoreIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M20.2941 0H9.70588V10.5882H20.2941V0ZM17.6471 6.17647H15.8824V7.94118H14.1176V6.17647H12.3529V4.41177H14.1176V2.64706H15.8824V4.41177H17.6471V6.17647Z"
        fill="#67CDDF"
      />
      <path
        d="M22.0588 7.05882H28.2353V10.5882H22.0588V7.05882Z"
        fill="#67CDDF"
      />
      <path
        d="M1.76471 7.05882H7.94118V10.5882H1.76471V7.05882Z"
        fill="#67CDDF"
      />
      <path
        d="M18.5294 16.1559V17.6471H23.8235V16.1559C22.0822 15.7931 20.2708 15.7931 18.5294 16.1559Z"
        fill="#67CDDF"
      />
      <path
        d="M1.76471 12.3529V28.2353H0V30H30V28.2353H28.2353V12.3529H1.76471ZM13.2353 28.2353H11.4706V17.6471C10.8301 17.6471 6.82124 17.6471 6.17647 17.6471V28.2353H4.41176V15.8824H13.2353V28.2353ZM25.5882 22.2806C22.8986 23.1452 19.4295 23.1361 16.7647 22.2806V14.7678C19.7266 13.9102 22.627 13.9104 25.5882 14.7678V22.2806Z"
        fill="#EAEFFE"
      />
      <path
        d="M18.5294 20.9029C20.2731 21.2667 22.0797 21.2666 23.8235 20.9029V19.4118H18.5294V20.9029Z"
        fill="#67CDDF"
      />
      <path d="M0 10.5882H1.76471V12.3529L0 12.3529V10.5882Z" fill="#78E7DC" />
      <path
        d="M28.2353 10.5882H30V12.3529L28.2353 12.3529V10.5882Z"
        fill="#78E7DC"
      />
    </svg>
  );
};

export const InpersonIcon: FC<ISvgComponent> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
    >
      <rect
        x="2"
        y="1.5"
        width="35"
        height="35"
        rx="11.5"
        fill="#0BD26E"
        stroke="white"
        stroke-width="3"
      />
      <path
        d="M20.5996 12.262C20.5973 11.8165 20.7272 11.3803 20.973 11.0087C21.2188 10.6371 21.5694 10.3469 21.9803 10.1747C22.3912 10.0026 22.844 9.95632 23.2812 10.0418C23.7185 10.1272 24.1205 10.3406 24.4364 10.6548C24.7522 10.969 24.9677 11.3698 25.0555 11.8066C25.1433 12.2434 25.0994 12.6964 24.9295 13.1083C24.7595 13.5201 24.4712 13.8722 24.1009 14.12C23.7306 14.3677 23.2952 14.5 22.8496 14.5C22.2553 14.499 21.6854 14.2632 21.264 13.8441C20.8426 13.4249 20.6038 12.8563 20.5996 12.262Z"
        fill="white"
      />
      <path
        d="M26.7936 19.5846C26.7162 19.7499 26.5964 19.8892 26.4476 19.9868C26.2989 20.0844 26.1271 20.1364 25.9517 20.137C25.8117 20.1347 25.6741 20.0976 25.5503 20.0287L23.252 18.8381C23.0904 18.7556 22.9548 18.626 22.8612 18.4648L21.998 16.927L20.8009 19.8421L22.4776 22.5593C22.5987 22.7548 22.6629 22.9831 22.6623 23.2163V26.777C22.6626 26.9538 22.6262 27.1286 22.5556 27.2891C22.4851 27.4496 22.3821 27.592 22.2538 27.7064C22.0425 27.8919 21.776 27.9936 21.5007 27.9938C21.4358 28.001 21.3703 28.001 21.3053 27.9938C21.0324 27.9362 20.7874 27.78 20.6128 27.5522C20.4382 27.3244 20.3451 27.0396 20.3498 26.7472V23.582L18.9999 21.3948C18.8393 21.4134 18.6773 21.4134 18.5168 21.3948L17.7353 23.1304C17.6598 23.2942 17.5506 23.4382 17.4156 23.5522L14.3961 26.1649C14.1876 26.341 13.9283 26.4371 13.6608 26.4374C13.4872 26.4356 13.3163 26.3927 13.1607 26.3119C13.0051 26.2312 12.8689 26.1146 12.7621 25.9708C12.6652 25.8482 12.5926 25.7064 12.5487 25.5538C12.5048 25.4013 12.4904 25.241 12.5063 25.0825C12.5375 24.7595 12.6896 24.4628 12.929 24.2576L15.7709 21.839L16.8081 19.5435C16.7584 19.1572 16.8087 18.7639 16.9538 18.4051L18.3072 15.1056L17.4014 15.4788L16.1438 18.4648C16.0404 18.6989 15.8535 18.8807 15.6234 18.971C15.3933 19.0613 15.1387 19.0528 14.9146 18.9473C14.6904 18.8418 14.5149 18.6479 14.4258 18.4074C14.3368 18.1669 14.3414 17.8992 14.4387 17.6623L15.8597 14.3031C15.9104 14.1761 15.9869 14.0621 16.0839 13.9693C16.1808 13.8765 16.2958 13.807 16.4209 13.7656L18.8578 12.8139C19.0973 12.7214 19.3529 12.6841 19.6073 12.7047C19.8617 12.7254 20.1089 12.8033 20.332 12.9333C20.3654 12.9535 20.3944 12.9809 20.4171 13.0137C20.4398 13.0465 20.4555 13.084 20.4634 13.1237C20.5316 13.485 20.7168 13.8104 20.9875 14.0445C21.2582 14.2786 21.5977 14.4069 21.9483 14.4076C22.0877 14.4091 22.2265 14.3889 22.3604 14.3479C22.4016 14.3349 22.4453 14.3328 22.4874 14.3419C22.5296 14.3511 22.569 14.3711 22.6019 14.4002C22.8447 14.6094 23.0504 14.8621 23.2094 15.1467L24.3461 17.1921L26.4029 18.2558C26.6213 18.3787 26.7849 18.5871 26.858 18.8358C26.9312 19.0846 26.9081 19.3536 26.7936 19.5846Z"
        fill="white"
      />
    </svg>
  );
};

export const AudioIcon: FC<ISvgComponent> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
    >
      <rect
        x="2"
        y="1.5"
        width="35"
        height="35"
        rx="11.5"
        fill="#5554DB"
        stroke="white"
        stroke-width="3"
      />
      <path
        d="M25.1908 21.8529L23.6994 20.3612C23.3015 19.9633 22.6063 19.9626 22.2077 20.3612L21.959 20.6099L24.9422 23.593L25.1908 23.3444C25.6038 22.9314 25.6024 22.2638 25.1908 21.8529Z"
        fill="white"
      />
      <path
        d="M21.448 21.096C21.1342 21.3391 20.6865 21.3294 20.3998 21.042L17.4509 18.0911C17.1635 17.8037 17.1538 17.3557 17.3969 17.0426L14.4206 14.0664C13.1402 15.5589 13.1902 17.8078 14.6034 19.221L19.2699 23.8895C20.626 25.2456 22.8473 25.4254 24.4246 24.0723L21.448 21.096Z"
        fill="white"
      />
      <path
        d="M18.1283 14.7904L16.6369 13.2987C16.239 12.9008 15.5438 12.9001 15.1452 13.2987L14.8965 13.5474L17.8797 16.5305L18.1283 16.2818C18.5412 15.8689 18.5399 15.2013 18.1283 14.7904Z"
        fill="white"
      />
    </svg>
  );
};

export const VideoCallIcon: FC<ISvgComponent> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
    >
      <rect
        x="2"
        y="1.5"
        width="35"
        height="35"
        rx="11.5"
        fill="#A079EC"
        stroke="white"
        stroke-width="3"
      />
      <path
        d="M27.6408 13.3468C27.561 13.3156 27.4843 13.2999 27.4106 13.2999C27.2448 13.2999 27.1068 13.3594 26.9963 13.4781L23.2856 17.2469V15.7C23.2856 14.9562 23.0262 14.3204 22.5075 13.7922C21.9888 13.2641 21.3644 13 20.6337 13H14.1517C13.4213 13 12.7967 13.2641 12.2779 13.7922C11.7594 14.3204 11.5 14.9562 11.5 15.7V22.3001C11.5 23.0438 11.7594 23.6796 12.278 24.2078C12.7967 24.7359 13.4214 25 14.1518 25H20.6338C21.3644 25 21.9888 24.7359 22.5076 24.2078C23.0263 23.6796 23.2856 23.0439 23.2856 22.3001V20.7437L26.9963 24.5219C27.1069 24.6405 27.2449 24.7 27.4106 24.7C27.4844 24.7 27.5611 24.6844 27.6409 24.6532C27.8804 24.547 28 24.3626 28 24.1001V13.9C27.9999 13.6374 27.8803 13.453 27.6408 13.3468Z"
        fill="white"
      />
      <path
        d="M15.7852 22.2148L15.7852 15.7863"
        stroke="#A079EC"
        stroke-linecap="round"
      />
      <path
        d="M18.3574 20.7148L18.3574 17.2863"
        stroke="#A079EC"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const ChatTypeIcon: FC<ISvgComponent> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
    >
      <rect
        x="2"
        y="1.5"
        width="35"
        height="35"
        rx="11.5"
        fill="#FFA873"
        stroke="white"
        stroke-width="3"
      />
      <path
        d="M24.8135 16.1992H22.8359V18.9995C22.8359 20.1036 21.95 20.9997 20.8584 20.9997H17.2065L16.4551 21.5037V22.1998C16.4551 22.8638 16.985 23.3999 17.6416 23.3999H21.5307L23.801 24.936C24.1108 25.1101 24.418 24.8984 24.418 24.6V23.3999H24.8135C25.47 23.3999 26 22.8638 26 22.1998V17.3993C26 16.7353 25.47 16.1992 24.8135 16.1992Z"
        fill="white"
      />
      <path
        d="M20.8584 13H13.6865C13.03 13 12.5 13.536 12.5 14.2001V19.0006C12.5 19.6646 13.03 20.2007 13.6865 20.2007H14.082V21.4008C14.082 21.6898 14.3779 21.8991 14.6674 21.7529C14.6753 21.7449 14.6911 21.7449 14.699 21.7368C16.8748 20.2611 16.3872 20.5901 16.8743 20.2647C16.9376 20.2247 17.0088 20.2007 17.0879 20.2007H20.8584C21.515 20.2007 22.0449 19.6646 22.0449 19.0006V14.2001C22.0449 13.536 21.515 13 20.8584 13ZM17.6943 17.8005H14.4775C13.9562 17.8005 13.954 17.0004 14.4775 17.0004H17.6943C18.2157 17.0004 18.2178 17.8005 17.6943 17.8005ZM20.0674 16.2003H14.4775C13.9562 16.2003 13.954 15.4002 14.4775 15.4002H20.0674C20.5887 15.4002 20.5909 16.2003 20.0674 16.2003Z"
        fill="white"
      />
    </svg>
  );
};

export const CheckRoundIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 23 23"
      fill="none"
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M11 0C4.93737 0 0 4.93737 0 11C0 17.0626 4.93737 22 11 22C17.0626 22 22 17.0626 22 11C22 4.93737 17.0741 0 11 0ZM17.3267 9.13987L10.4144 16.0522C10.1159 16.3507 9.72547 16.5115 9.31211 16.5115C8.89875 16.5115 8.50835 16.3507 8.20981 16.0522L4.68476 12.5271C4.38622 12.2286 4.22547 11.8382 4.22547 11.4248C4.22547 11.0115 4.38622 10.6211 4.68476 10.3225C4.9833 10.024 5.3737 9.86326 5.78706 9.86326C6.20042 9.86326 6.59081 10.024 6.88935 10.3225L9.31211 12.7453L15.1221 6.93528C15.4207 6.63674 15.8111 6.47599 16.2244 6.47599C16.6378 6.47599 17.0282 6.63674 17.3267 6.93528C17.9238 7.55532 17.9238 8.5428 17.3267 9.13987Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CalenderFileIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3.65535C12 2.09843 10.7368 0.824585 9.15789 0.738432V0.615385C9.15789 0.276923 8.87368 0 8.52632 0C8.17895 0 7.89474 0.276923 7.89474 0.615385V0.719952H4.10526V0.615385C4.10526 0.276923 3.82105 0 3.47368 0C3.12632 0 2.84211 0.276923 2.84211 0.615385V0.738432C1.26316 0.824585 0 2.09843 0 3.65535V4.81851C0 4.83697 0.00630885 4.85534 0.0126246 4.8738C0.00630885 4.88611 0 4.90462 0 4.92308V9.23077C0 10.7569 1.27579 12 2.84211 12H9.15789C10.7242 12 12 10.7569 12 9.23077V4.92308C12 4.90462 11.9937 4.88611 11.9874 4.8738C11.9937 4.85534 12 4.83697 12 4.81851V3.65535ZM3.47368 9.84615C3.12632 9.84615 2.84211 9.56923 2.84211 9.23077C2.84211 8.89231 3.12632 8.61539 3.47368 8.61539C3.82105 8.61539 4.10526 8.89231 4.10526 9.23077C4.10526 9.56923 3.82105 9.84615 3.47368 9.84615ZM3.47368 7.38462C3.12632 7.38462 2.84211 7.10769 2.84211 6.76923C2.84211 6.43077 3.12632 6.15385 3.47368 6.15385C3.82105 6.15385 4.10526 6.43077 4.10526 6.76923C4.10526 7.10769 3.82105 7.38462 3.47368 7.38462ZM6 9.84615C5.65263 9.84615 5.36842 9.56923 5.36842 9.23077C5.36842 8.89231 5.65263 8.61539 6 8.61539C6.34737 8.61539 6.63158 8.89231 6.63158 9.23077C6.63158 9.56923 6.34737 9.84615 6 9.84615ZM6 7.38462C5.65263 7.38462 5.36842 7.10769 5.36842 6.76923C5.36842 6.43077 5.65263 6.15385 6 6.15385C6.34737 6.15385 6.63158 6.43077 6.63158 6.76923C6.63158 7.10769 6.34737 7.38462 6 7.38462ZM8.52632 9.84615C8.17895 9.84615 7.89474 9.56923 7.89474 9.23077C7.89474 8.89231 8.17895 8.61539 8.52632 8.61539C8.87368 8.61539 9.15789 8.89231 9.15789 9.23077C9.15789 9.56923 8.87368 9.84615 8.52632 9.84615ZM8.52632 7.38462C8.17895 7.38462 7.89474 7.10769 7.89474 6.76923C7.89474 6.43077 8.17895 6.15385 8.52632 6.15385C8.87368 6.15385 9.15789 6.43077 9.15789 6.76923C9.15789 7.10769 8.87368 7.38462 8.52632 7.38462ZM10.7368 4.61538H1.26316V3.65535C1.26316 2.76304 1.97053 2.03689 2.86737 1.96304C2.92422 2.24612 3.17053 2.46154 3.47368 2.46154C3.78316 2.46154 4.02947 2.23995 4.08632 1.95072H7.91368C7.97053 2.23995 8.21684 2.46154 8.52632 2.46154C8.82947 2.46154 9.07578 2.24612 9.13263 1.96304C10.0295 2.03689 10.7368 2.76919 10.7368 3.65535V4.61538Z"
        fill="#02BF90"
      />
    </svg>
  );
};

// export const DepartmentsIcon: React.FunctionComponent<ISvgComponent> = ({}) => {
//   return (
//     <svg
//       width="47"
//       height="47"
//       viewBox="0 0 47 47"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M31.807 22.1016V21.9516H31.657H30.2578H30.1078V22.1016V23.5007V23.6507H30.2578H31.657H31.807V23.5007V22.1016Z"
//         fill="black"
//         stroke="black"
//         strokeWidth="0.3"
//       />
//       <path
//         d="M24.3421 34.3301V34.1801H24.1921H22.793H22.643V34.3301V35.7292V35.8792H22.793H24.1921H24.3421V35.7292V34.3301Z"
//         fill="black"
//         stroke="black"
//         strokeWidth="0.3"
//       />
//       <path
//         d="M16.8929 22.1016V21.9516H16.7429H15.3438H15.1937V22.1016V23.5007V23.6507H15.3438H16.7429H16.8929V23.5007V22.1016Z"
//         fill="black"
//         stroke="black"
//         strokeWidth="0.3"
//       />
//       <path
//         d="M23.5004 18.9288C26.458 18.9288 29.0515 17.45 30.5985 15.1295C29.0515 12.8772 26.4466 11.3984 23.5004 11.3984C20.5543 11.3984 17.9494 12.8772 16.4023 15.1295C17.9494 17.4614 20.5429 18.9288 23.5004 18.9288Z"
//         fill="#FDBF5E"
//       />
//       <path
//         d="M23.5013 9.93029C24.9776 9.93029 26.1744 8.73348 26.1744 7.25714C26.1744 5.7808 24.9776 4.58398 23.5013 4.58398C22.0249 4.58398 20.8281 5.7808 20.8281 7.25714C20.8281 8.73348 22.0249 9.93029 23.5013 9.93029Z"
//         fill="#FDBF5E"
//       />
//       <path
//         d="M10.352 45.296C13.3095 45.296 15.903 43.8172 17.4501 41.4967C15.903 39.2444 13.2981 37.7656 10.352 37.7656C7.40583 37.7656 4.80092 39.2444 3.25391 41.4967C4.73267 43.8286 7.33758 45.296 10.352 45.296Z"
//         fill="#FD646F"
//       />
//       <path
//         d="M10.5 36.294C11.9741 36.2123 13.1029 34.9511 13.0213 33.477C12.9396 32.0029 11.6784 30.874 10.2043 30.9557C8.73017 31.0373 7.60134 32.2985 7.68298 33.7727C7.76463 35.2468 9.02583 36.3756 10.5 36.294Z"
//         fill="#FD646F"
//       />
//       <path
//         d="M36.6489 45.296C39.6064 45.296 42.1999 43.8172 43.7469 41.4967C42.1999 39.2444 39.595 37.7656 36.6489 37.7656C33.6913 37.7656 31.0978 39.2444 29.5508 41.4967C31.0978 43.8286 33.7027 45.296 36.6489 45.296Z"
//         fill="#2EDFFC"
//       />
//       <path
//         d="M36.6497 36.2975C38.1261 36.2975 39.3229 35.1007 39.3229 33.6243C39.3229 32.148 38.1261 30.9512 36.6497 30.9512C35.1734 30.9512 33.9766 32.148 33.9766 33.6243C33.9766 35.1007 35.1734 36.2975 36.6497 36.2975Z"
//         fill="#2EDFFC"
//       />
//       <path
//         d="M10.339 27.2062H10.3386C5.06967 27.2177 0.85 31.436 0.85 36.6496C0.85 41.9424 5.0692 46.15 10.3504 46.15C15.5627 46.15 19.8507 41.9316 19.8507 36.6496C19.8507 34.5014 19.1069 32.5407 17.8882 30.9273L23.5683 27.6769L29.2483 30.9273C28.0297 32.54 27.2858 34.4903 27.2858 36.6496C27.2858 41.862 31.5042 46.15 36.7861 46.15C41.9324 46.15 46.15 41.9295 46.15 36.6496C46.15 31.436 41.9417 27.2175 36.6496 27.2175C34.1787 27.2175 32.002 28.193 30.2962 29.6528L24.3553 26.2343V19.7821C29.1451 19.3573 33.0004 15.3197 33.0004 10.3617C33.0004 5.06849 28.7124 0.85 23.5 0.85C18.2877 0.85 13.9996 5.06837 13.9996 10.3504C13.9996 15.2968 17.788 19.3467 22.6447 19.7709V26.2228L16.695 29.6401C14.9961 28.1133 12.8068 27.2062 10.339 27.2062ZM10.3504 44.4509C6.00813 44.4509 2.54914 41.003 2.54914 36.6496C2.54914 32.3748 5.99787 28.8484 10.3504 28.8484C14.6248 28.8484 18.1509 32.2965 18.1516 36.6485C18.084 41.0045 14.6339 44.4509 10.3504 44.4509ZM15.6988 10.3504C15.6988 6.00897 19.2141 2.54914 23.5 2.54914C27.786 2.54914 31.3012 5.99774 31.3012 10.3504C31.3012 14.6248 27.8531 18.151 23.5011 18.1516C19.2237 18.0839 15.6988 14.6329 15.6988 10.3504ZM36.6496 44.4509C32.3748 44.4509 28.8484 41.0021 28.8484 36.6496C28.8484 32.3748 32.2972 28.8484 36.6496 28.8484C40.9245 28.8484 44.4509 32.2972 44.4509 36.6496C44.4509 41.0031 41.0031 44.4509 36.6496 44.4509Z"
//         fill="black"
//         stroke="black"
//         strokeWidth="0.3"
//       />
//     </svg>
//   );
// };

export const DocumentsIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="39"
      height="45"
      viewBox="0 0 39 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.660156 7.35352V16.554H37.5941V7.35352H0.660156ZM10.5532 13.9225C9.45834 13.9225 8.57456 13.0387 8.57456 11.9439C8.57456 10.849 9.45834 9.96527 10.5532 9.96527C11.648 9.96527 12.5318 10.849 12.5318 11.9439C12.5318 13.0387 11.648 13.9225 10.5532 13.9225ZM27.701 13.9225C26.6062 13.9225 25.7224 13.0387 25.7224 11.9439C25.7224 10.849 26.6062 9.96527 27.701 9.96527C28.7959 9.96527 29.6797 10.849 29.6797 11.9439C29.6797 13.0387 28.7959 13.9225 27.701 13.9225Z"
        fill="#2EDFFC"
      />
      <path
        d="M19.1291 20.5898C13.7077 20.5898 9.30859 24.9889 9.30859 30.4103C9.30859 35.8317 13.7077 40.2308 19.1291 40.2308C24.5504 40.2308 28.9495 35.8317 28.9495 30.4103C28.9495 24.9889 24.5504 20.5898 19.1291 20.5898ZM19.1291 37.0056C18.4036 37.0056 17.81 36.4121 17.81 35.6866C17.81 34.9611 18.4036 34.3675 19.1291 34.3675C19.8545 34.3675 20.4481 34.9611 20.4481 35.6866C20.4481 36.4121 19.8545 37.0056 19.1291 37.0056ZM20.4481 31.7294H17.81V23.815H20.4481V31.7294Z"
        fill="#FD646F"
      />
      <path
        d="M7.91406 11.9428C7.91406 13.4004 9.09463 14.581 10.5522 14.581C12.0098 14.581 13.1903 13.4004 13.1903 11.9428C13.1903 10.4853 12.0098 9.30469 10.5522 9.30469C9.09463 9.30469 7.91406 10.4853 7.91406 11.9428ZM11.8713 11.9428C11.8713 12.6683 11.2777 13.2619 10.5522 13.2619C9.82671 13.2619 9.23313 12.6683 9.23313 11.9428C9.23313 11.2173 9.82671 10.6238 10.5522 10.6238C11.2777 10.6238 11.8713 11.2107 11.8713 11.9428Z"
        fill="black"
      />
      <path
        d="M32.9753 43.6816H31.6562V45.0007H32.9753V43.6816Z"
        fill="black"
      />
      <path
        d="M30.3386 6.69427V2.63814C30.3386 1.18057 29.158 0 27.7004 0C26.2429 0 25.0623 1.18057 25.0623 2.63814V6.69427H13.1907V2.63814C13.1907 1.18057 12.0101 0 10.5525 0C9.09497 0 7.91441 1.18057 7.91441 2.63814V6.69427H0V45H30.3386V43.6809H1.31907V17.2204H17.1479V15.9014H1.31907V8.01334H36.9339V15.8948H18.467V17.2138H36.9339V43.6809H34.2958V45H38.253V6.69427H30.3386ZM11.8716 6.69427H9.23348V2.63814C9.23348 1.91265 9.82706 1.31907 10.5525 1.31907C11.278 1.31907 11.8716 1.91265 11.8716 2.63814V6.69427ZM29.0195 6.69427H26.3814V2.63814C26.3814 1.91265 26.9749 1.31907 27.7004 1.31907C28.4259 1.31907 29.0195 1.91265 29.0195 2.63814V6.69427Z"
        fill="black"
      />
      <path
        d="M30.3388 11.9428C30.3388 10.4853 29.1582 9.30469 27.7006 9.30469C26.2431 9.30469 25.0625 10.4853 25.0625 11.9428C25.0625 13.4004 26.2431 14.581 27.7006 14.581C29.1582 14.581 30.3388 13.3938 30.3388 11.9428ZM26.3816 11.9428C26.3816 11.2173 26.9751 10.6238 27.7006 10.6238C28.4261 10.6238 29.0197 11.2173 29.0197 11.9428C29.0197 12.6683 28.4261 13.2619 27.7006 13.2619C26.9751 13.2619 26.3816 12.6683 26.3816 11.9428Z"
        fill="black"
      />
      <path d="M6.59641 18.541H5.27734V19.8601H6.59641V18.541Z" fill="black" />
      <path d="M3.95579 18.541H2.63672V19.8601H3.95579V18.541Z" fill="black" />
      <path
        d="M10.0466 31.6384L8.74077 31.8164C9.07713 34.3095 10.3039 36.6047 12.2033 38.2733C14.116 39.9617 16.576 40.8916 19.1284 40.8916C24.9059 40.8916 29.6084 36.1892 29.6084 30.4116C29.6084 24.6341 24.9059 19.9316 19.1284 19.9316C13.3509 19.9316 8.64844 24.6341 8.64844 30.4116H9.96751C9.96751 25.3596 14.0764 21.2507 19.1284 21.2507C24.1805 21.2507 28.2894 25.3596 28.2894 30.4116C28.2894 35.4637 24.1805 39.5726 19.1284 39.5726C14.5579 39.5726 10.6534 36.1628 10.0466 31.6384Z"
        fill="black"
      />
      <path
        d="M21.1056 23.1562H17.1484V32.3897H21.1056V23.1562ZM19.7866 31.0707H18.4675V24.4753H19.7866V31.0707Z"
        fill="black"
      />
      <path
        d="M19.127 37.6662C20.2153 37.6662 21.1056 36.7758 21.1056 35.6876C21.1056 34.5994 20.2153 33.709 19.127 33.709C18.0388 33.709 17.1484 34.5994 17.1484 35.6876C17.1484 36.7758 18.0388 37.6662 19.127 37.6662ZM19.127 35.0281C19.4898 35.0281 19.7866 35.3248 19.7866 35.6876C19.7866 36.0503 19.4898 36.3471 19.127 36.3471C18.7643 36.3471 18.4675 36.0503 18.4675 35.6876C18.4675 35.3248 18.7643 35.0281 19.127 35.0281Z"
        fill="black"
      />
    </svg>
  );
};

export const DepartmentsIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.807 22.1016V21.9516H31.657H30.2578H30.1078V22.1016V23.5007V23.6507H30.2578H31.657H31.807V23.5007V22.1016Z"
        fill="black"
        stroke="black"
        strokeWidth="0.3"
      />
      <path
        d="M24.3421 34.3301V34.1801H24.1921H22.793H22.643V34.3301V35.7292V35.8792H22.793H24.1921H24.3421V35.7292V34.3301Z"
        fill="black"
        stroke="black"
        strokeWidth="0.3"
      />
      <path
        d="M16.8929 22.1016V21.9516H16.7429H15.3438H15.1937V22.1016V23.5007V23.6507H15.3438H16.7429H16.8929V23.5007V22.1016Z"
        fill="black"
        stroke="black"
        strokeWidth="0.3"
      />
      <path
        d="M23.5004 18.9288C26.458 18.9288 29.0515 17.45 30.5985 15.1295C29.0515 12.8772 26.4466 11.3984 23.5004 11.3984C20.5543 11.3984 17.9494 12.8772 16.4023 15.1295C17.9494 17.4614 20.5429 18.9288 23.5004 18.9288Z"
        fill="#FDBF5E"
      />
      <path
        d="M23.5013 9.93029C24.9776 9.93029 26.1744 8.73348 26.1744 7.25714C26.1744 5.7808 24.9776 4.58398 23.5013 4.58398C22.0249 4.58398 20.8281 5.7808 20.8281 7.25714C20.8281 8.73348 22.0249 9.93029 23.5013 9.93029Z"
        fill="#FDBF5E"
      />
      <path
        d="M10.352 45.296C13.3095 45.296 15.903 43.8172 17.4501 41.4967C15.903 39.2444 13.2981 37.7656 10.352 37.7656C7.40583 37.7656 4.80092 39.2444 3.25391 41.4967C4.73267 43.8286 7.33758 45.296 10.352 45.296Z"
        fill="#FD646F"
      />
      <path
        d="M10.5 36.294C11.9741 36.2123 13.1029 34.9511 13.0213 33.477C12.9396 32.0029 11.6784 30.874 10.2043 30.9557C8.73017 31.0373 7.60134 32.2985 7.68298 33.7727C7.76463 35.2468 9.02583 36.3756 10.5 36.294Z"
        fill="#FD646F"
      />
      <path
        d="M36.6489 45.296C39.6064 45.296 42.1999 43.8172 43.7469 41.4967C42.1999 39.2444 39.595 37.7656 36.6489 37.7656C33.6913 37.7656 31.0978 39.2444 29.5508 41.4967C31.0978 43.8286 33.7027 45.296 36.6489 45.296Z"
        fill="#2EDFFC"
      />
      <path
        d="M36.6497 36.2975C38.1261 36.2975 39.3229 35.1007 39.3229 33.6243C39.3229 32.148 38.1261 30.9512 36.6497 30.9512C35.1734 30.9512 33.9766 32.148 33.9766 33.6243C33.9766 35.1007 35.1734 36.2975 36.6497 36.2975Z"
        fill="#2EDFFC"
      />
      <path
        d="M10.339 27.2062H10.3386C5.06967 27.2177 0.85 31.436 0.85 36.6496C0.85 41.9424 5.0692 46.15 10.3504 46.15C15.5627 46.15 19.8507 41.9316 19.8507 36.6496C19.8507 34.5014 19.1069 32.5407 17.8882 30.9273L23.5683 27.6769L29.2483 30.9273C28.0297 32.54 27.2858 34.4903 27.2858 36.6496C27.2858 41.862 31.5042 46.15 36.7861 46.15C41.9324 46.15 46.15 41.9295 46.15 36.6496C46.15 31.436 41.9417 27.2175 36.6496 27.2175C34.1787 27.2175 32.002 28.193 30.2962 29.6528L24.3553 26.2343V19.7821C29.1451 19.3573 33.0004 15.3197 33.0004 10.3617C33.0004 5.06849 28.7124 0.85 23.5 0.85C18.2877 0.85 13.9996 5.06837 13.9996 10.3504C13.9996 15.2968 17.788 19.3467 22.6447 19.7709V26.2228L16.695 29.6401C14.9961 28.1133 12.8068 27.2062 10.339 27.2062ZM10.3504 44.4509C6.00813 44.4509 2.54914 41.003 2.54914 36.6496C2.54914 32.3748 5.99787 28.8484 10.3504 28.8484C14.6248 28.8484 18.1509 32.2965 18.1516 36.6485C18.084 41.0045 14.6339 44.4509 10.3504 44.4509ZM15.6988 10.3504C15.6988 6.00897 19.2141 2.54914 23.5 2.54914C27.786 2.54914 31.3012 5.99774 31.3012 10.3504C31.3012 14.6248 27.8531 18.151 23.5011 18.1516C19.2237 18.0839 15.6988 14.6329 15.6988 10.3504ZM36.6496 44.4509C32.3748 44.4509 28.8484 41.0021 28.8484 36.6496C28.8484 32.3748 32.2972 28.8484 36.6496 28.8484C40.9245 28.8484 44.4509 32.2972 44.4509 36.6496C44.4509 41.0031 41.0031 44.4509 36.6496 44.4509Z"
        fill="black"
        stroke="black"
        strokeWidth="0.3"
      />
    </svg>
  );
};

// export const PresentIcon: FC<ISvgComponent> = ({ customClass }) => {
//   return (
//     <svg
//       width="39"
//       height="45"
//       viewBox="0 0 39 45"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M0.660156 7.35352V16.554H37.5941V7.35352H0.660156ZM10.5532 13.9225C9.45834 13.9225 8.57456 13.0387 8.57456 11.9439C8.57456 10.849 9.45834 9.96527 10.5532 9.96527C11.648 9.96527 12.5318 10.849 12.5318 11.9439C12.5318 13.0387 11.648 13.9225 10.5532 13.9225ZM27.701 13.9225C26.6062 13.9225 25.7224 13.0387 25.7224 11.9439C25.7224 10.849 26.6062 9.96527 27.701 9.96527C28.7959 9.96527 29.6797 10.849 29.6797 11.9439C29.6797 13.0387 28.7959 13.9225 27.701 13.9225Z"
//         fill="#2EDFFC"
//       />
//       <path
//         d="M19.1291 20.5898C13.7077 20.5898 9.30859 24.9889 9.30859 30.4103C9.30859 35.8317 13.7077 40.2308 19.1291 40.2308C24.5504 40.2308 28.9495 35.8317 28.9495 30.4103C28.9495 24.9889 24.5504 20.5898 19.1291 20.5898ZM19.1291 37.0056C18.4036 37.0056 17.81 36.4121 17.81 35.6866C17.81 34.9611 18.4036 34.3675 19.1291 34.3675C19.8545 34.3675 20.4481 34.9611 20.4481 35.6866C20.4481 36.4121 19.8545 37.0056 19.1291 37.0056ZM20.4481 31.7294H17.81V23.815H20.4481V31.7294Z"
//         fill="#FD646F"
//       />
//       <path
//         d="M7.91406 11.9428C7.91406 13.4004 9.09463 14.581 10.5522 14.581C12.0098 14.581 13.1903 13.4004 13.1903 11.9428C13.1903 10.4853 12.0098 9.30469 10.5522 9.30469C9.09463 9.30469 7.91406 10.4853 7.91406 11.9428ZM11.8713 11.9428C11.8713 12.6683 11.2777 13.2619 10.5522 13.2619C9.82671 13.2619 9.23313 12.6683 9.23313 11.9428C9.23313 11.2173 9.82671 10.6238 10.5522 10.6238C11.2777 10.6238 11.8713 11.2107 11.8713 11.9428Z"
//         fill="black"
//       />
//       <path
//         d="M32.9753 43.6816H31.6562V45.0007H32.9753V43.6816Z"
//         fill="black"
//       />
//       <path
//         d="M30.3386 6.69427V2.63814C30.3386 1.18057 29.158 0 27.7004 0C26.2429 0 25.0623 1.18057 25.0623 2.63814V6.69427H13.1907V2.63814C13.1907 1.18057 12.0101 0 10.5525 0C9.09497 0 7.91441 1.18057 7.91441 2.63814V6.69427H0V45H30.3386V43.6809H1.31907V17.2204H17.1479V15.9014H1.31907V8.01334H36.9339V15.8948H18.467V17.2138H36.9339V43.6809H34.2958V45H38.253V6.69427H30.3386ZM11.8716 6.69427H9.23348V2.63814C9.23348 1.91265 9.82706 1.31907 10.5525 1.31907C11.278 1.31907 11.8716 1.91265 11.8716 2.63814V6.69427ZM29.0195 6.69427H26.3814V2.63814C26.3814 1.91265 26.9749 1.31907 27.7004 1.31907C28.4259 1.31907 29.0195 1.91265 29.0195 2.63814V6.69427Z"
//         fill="black"
//       />
//       <path
//         d="M30.3388 11.9428C30.3388 10.4853 29.1582 9.30469 27.7006 9.30469C26.2431 9.30469 25.0625 10.4853 25.0625 11.9428C25.0625 13.4004 26.2431 14.581 27.7006 14.581C29.1582 14.581 30.3388 13.3938 30.3388 11.9428ZM26.3816 11.9428C26.3816 11.2173 26.9751 10.6238 27.7006 10.6238C28.4261 10.6238 29.0197 11.2173 29.0197 11.9428C29.0197 12.6683 28.4261 13.2619 27.7006 13.2619C26.9751 13.2619 26.3816 12.6683 26.3816 11.9428Z"
//         fill="black"
//       />
//       <path d="M6.59641 18.541H5.27734V19.8601H6.59641V18.541Z" fill="black" />
//       <path d="M3.95579 18.541H2.63672V19.8601H3.95579V18.541Z" fill="black" />
//       <path
//         d="M10.0466 31.6384L8.74077 31.8164C9.07713 34.3095 10.3039 36.6047 12.2033 38.2733C14.116 39.9617 16.576 40.8916 19.1284 40.8916C24.9059 40.8916 29.6084 36.1892 29.6084 30.4116C29.6084 24.6341 24.9059 19.9316 19.1284 19.9316C13.3509 19.9316 8.64844 24.6341 8.64844 30.4116H9.96751C9.96751 25.3596 14.0764 21.2507 19.1284 21.2507C24.1805 21.2507 28.2894 25.3596 28.2894 30.4116C28.2894 35.4637 24.1805 39.5726 19.1284 39.5726C14.5579 39.5726 10.6534 36.1628 10.0466 31.6384Z"
//         fill="black"
//       />
//       <path
//         d="M21.1056 23.1562H17.1484V32.3897H21.1056V23.1562ZM19.7866 31.0707H18.4675V24.4753H19.7866V31.0707Z"
//         fill="black"
//       />
//       <path
//         d="M19.127 37.6662C20.2153 37.6662 21.1056 36.7758 21.1056 35.6876C21.1056 34.5994 20.2153 33.709 19.127 33.709C18.0388 33.709 17.1484 34.5994 17.1484 35.6876C17.1484 36.7758 18.0388 37.6662 19.127 37.6662ZM19.127 35.0281C19.4898 35.0281 19.7866 35.3248 19.7866 35.6876C19.7866 36.0503 19.4898 36.3471 19.127 36.3471C18.7643 36.3471 18.4675 36.0503 18.4675 35.6876C18.4675 35.3248 18.7643 35.0281 19.127 35.0281Z"
//         fill="black"
//       />
//     </svg>
//   );
// };

// export const FolderIcon: React.FunctionComponent<ISvgComponent> = ({
//   fillColor,
// }) => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="36"
//       height="30"
//       viewBox="0 0 36 30"
//       fill="none"
//     >
//       <path
//         d="M35.625 14.0625V21.5625C35.625 26.2144 31.8394 30 27.1875 30H8.4375C3.78562 30 0 26.2144 0 21.5625V8.4375C0 3.78562 3.78562 0 8.4375 0H12.5569C13.8131 0 14.9794 0.624587 15.6769 1.67084L17.7563 4.7905C18.105 5.31175 18.6881 5.625 19.3163 5.625H27.1875C31.8394 5.625 35.625 9.41063 35.625 14.0625Z"
//         fill={fillColor}
//       />
//     </svg>
//   );
// };

export const ViewChartOfAccountsIcon: React.FunctionComponent<
  ISvgComponent
> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 31"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0403 13.8024C26.7944 15.744 28.1008 17.4315 28.9597 18.9436C32.1109 24.4778 27.629 30.0968 21.623 30C15.6169 30.1028 11.1351 24.4778 14.2863 18.9436C15.1452 17.4315 16.4516 15.75 18.2056 13.8024C18.4173 13.869 18.6351 13.9052 18.871 13.9052H24.381C24.6109 13.9052 24.8347 13.869 25.0403 13.8024ZM2.75202 0C1.23992 0 0 1.23992 0 2.75202V22.8569C0 24.369 1.23992 25.6089 2.75202 25.6089H12.877C11.8851 23.244 12.1875 20.6855 13.4456 18.4718C13.7056 18.0181 13.9839 17.5706 14.2863 17.129C14.1109 17.0141 13.996 16.8206 13.996 16.5968V15.7742C13.996 15.4234 14.2802 15.1391 14.631 15.1391H15.7802C16.2944 14.5101 16.8266 13.8931 17.3589 13.3065C17.2016 13.1552 17.0685 12.9859 16.9597 12.7923H14.6371C14.2863 12.7923 14.002 12.5081 14.002 12.1573V11.3347C14.002 10.9839 14.2863 10.6996 14.6371 10.6996H16.9173C17.1109 10.3185 17.4194 9.99798 17.7944 9.78629L17.129 9.13307C16.7298 8.73387 16.5121 8.21976 16.4819 7.69355H3.66532C3.31452 7.69355 3.03024 7.40927 3.03024 7.05847V4.57863C3.03024 4.22782 3.31452 3.94355 3.66532 3.94355H17.5706C17.9214 3.94355 18.2056 4.22782 18.2056 4.57863V5.37702C18.6532 5.27419 19.125 5.31048 19.5605 5.48589C19.8508 4.78427 20.4919 4.27621 21.2419 4.14315V2.75202C21.2419 1.23992 20.002 0 18.4899 0H2.75202ZM18.871 12.9375C18.1935 12.9375 17.6371 12.381 17.6371 11.7036C17.6371 11.0262 18.1935 10.4698 18.871 10.4698H24.381C25.0585 10.4698 25.6149 11.0262 25.6149 11.7036C25.6149 12.381 25.0585 12.9375 24.381 12.9375H18.871ZM4.24597 10.7056H6.61089C6.96169 10.7056 7.24597 10.9899 7.24597 11.3407V12.1573C7.24597 12.5081 6.96169 12.7923 6.61089 12.7923H4.24597C3.89516 12.7923 3.61089 12.5081 3.61089 12.1573V11.3347C3.61694 10.9899 3.90121 10.7056 4.24597 10.7056ZM9.44153 19.5726C9.09073 19.5726 8.80645 19.8569 8.80645 20.2077V21.0302C8.80645 21.3811 9.09073 21.6653 9.44153 21.6653H11.8065C12.1573 21.6653 12.4415 21.3811 12.4415 21.0302V20.2016C12.4415 19.8508 12.1573 19.5665 11.8065 19.5665H9.44153V19.5726ZM4.24597 19.5726H6.61089C6.96169 19.5726 7.24597 19.8569 7.24597 20.2077V21.0302C7.24597 21.3811 6.96169 21.6653 6.61089 21.6653H4.24597C3.89516 21.6653 3.61089 21.3811 3.61089 21.0302V20.2016C3.61694 19.8569 3.90121 19.5726 4.24597 19.5726ZM9.44153 15.1391C9.09073 15.1391 8.80645 15.4234 8.80645 15.7742V16.5968C8.80645 16.9476 9.09073 17.2319 9.44153 17.2319H11.8065C12.1573 17.2319 12.4415 16.9476 12.4415 16.5968V15.7742C12.4415 15.4234 12.1573 15.1391 11.8065 15.1391H9.44153ZM4.24597 15.1391H6.61089C6.96169 15.1391 7.24597 15.4234 7.24597 15.7742V16.5968C7.24597 16.9476 6.96169 17.2319 6.61089 17.2319H4.24597C3.89516 17.2319 3.61089 16.9476 3.61089 16.5968V15.7742C3.61694 15.4234 3.90121 15.1391 4.24597 15.1391ZM9.44153 10.7056H11.8065C12.1573 10.7056 12.4415 10.9899 12.4415 11.3407V12.1573C12.4415 12.5081 12.1573 12.7923 11.8065 12.7923H9.44153C9.09073 12.7923 8.80645 12.5081 8.80645 12.1573V11.3347C8.80645 10.9899 9.09073 10.7056 9.44153 10.7056ZM21.5625 24.1936C21.1935 24.1815 20.8306 24.0847 20.5464 23.8911C20.2863 23.7157 20.0867 23.4677 20.0081 23.1351C19.9355 22.8327 19.6331 22.6512 19.3306 22.7238C19.0282 22.7964 18.8468 23.0988 18.9194 23.4012C19.0766 24.0302 19.4456 24.502 19.9294 24.8286C20.2621 25.0464 20.6431 25.1915 21.0423 25.2641V25.6996C21.0423 26.0081 21.2964 26.2621 21.6048 26.2621C21.9133 26.2621 22.1673 26.0081 22.1673 25.6996V25.2762C22.6573 25.2036 23.1532 25.0222 23.5403 24.7258C24.0121 24.369 24.3206 23.8609 24.3024 23.1774C24.3024 23.0988 24.2964 23.0323 24.2903 22.9718C24.1996 22.2218 23.7944 21.7319 23.256 21.4113C22.7843 21.127 22.2157 20.9819 21.6956 20.8972C21.3206 20.8367 20.9274 20.7339 20.6371 20.5403C20.4133 20.3952 20.25 20.1835 20.2379 19.875C20.2198 19.5423 20.3649 19.2702 20.6008 19.0827C20.7823 18.9375 21.0121 18.8347 21.2601 18.7863C21.3629 18.7681 21.4657 18.756 21.5685 18.75C21.5806 18.75 21.5927 18.75 21.6048 18.75C21.6169 18.75 21.629 18.75 21.6472 18.75C21.7863 18.75 21.9254 18.7681 22.0585 18.8044C22.4758 18.9073 22.8569 19.1855 23.0565 19.6633C23.1774 19.9476 23.504 20.0806 23.7883 19.9657C24.0726 19.8448 24.2056 19.5181 24.0907 19.2339C23.7399 18.3931 23.0685 17.9093 22.3306 17.7218C22.2762 17.7097 22.2218 17.6976 22.1673 17.6855V17.25C22.1673 16.9415 21.9133 16.6875 21.6048 16.6875C21.2964 16.6875 21.0423 16.9415 21.0423 17.25V17.6915C20.6189 17.7762 20.2198 17.9577 19.8992 18.2177C19.4032 18.6169 19.0887 19.2036 19.125 19.9294C19.1613 20.6613 19.5242 21.1512 20.0323 21.4839C20.4738 21.7742 21.0181 21.9194 21.5202 22.004C21.9254 22.0706 22.3548 22.1734 22.6815 22.373C22.9415 22.5302 23.1411 22.7601 23.1835 23.1048C23.1895 23.1532 23.1895 23.1835 23.1895 23.2077C23.1956 23.4798 23.0625 23.6915 22.869 23.8427C22.621 24.0302 22.2762 24.1391 21.9254 24.1815C21.8286 24.1935 21.75 24.1996 21.6774 24.1996H21.6532C21.6351 24.1996 21.623 24.1996 21.6048 24.1996C21.5867 24.1936 21.5746 24.1936 21.5625 24.1936ZM18.8649 9.50202L17.8125 8.4496C17.3165 7.95363 17.3165 7.14919 17.8125 6.65323C18.2298 6.23589 18.8952 6.16331 19.3972 6.48387C19.5847 6.60484 19.7964 6.62298 20.002 6.53831C20.2077 6.45363 20.3407 6.29032 20.3891 6.07258C20.5161 5.50403 21.0242 5.0746 21.629 5.0746C22.2218 5.0746 22.7419 5.49194 22.869 6.07258C22.9173 6.29032 23.0504 6.45363 23.256 6.53831C23.4617 6.62298 23.6734 6.60484 23.8609 6.48387C24.3508 6.16935 25.0161 6.22379 25.4456 6.65323C25.9415 7.14919 25.9415 7.95363 25.4456 8.4496L24.3931 9.50202H24.3871H18.8649Z"
        fill={fillColor ? fillColor : "#EAEFFE"}
        // fill="#EAEFFE"
      />
    </svg>
  );
};

export const UserTickIcon: FC<ISvgComponent> = ({
  fillColor,
  // customClass,
  // handleClick,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      // onClick={(e) => {
      //   handleClick && handleClick(e);
      // }}
      // className={customClass}
      style={{ cursor: "pointer" }}
    >
      <rect width="26" height="26" rx="6" fill="#02BF90" />
      <path
        d="M18.4212 9.26954C18.7818 9.63015 18.7818 10.2148 18.4212 10.5754L12.2674 16.7293C12.0877 16.909 11.8514 17 11.6151 17C11.3788 17 11.1425 16.9102 10.9628 16.7293L7.27046 13.037C6.90985 12.6763 6.90985 12.0917 7.27046 11.7311C7.63108 11.3705 8.2157 11.3705 8.57631 11.7311L11.6163 14.771L17.1178 9.26954C17.4772 8.91015 18.0606 8.91015 18.4212 9.26954Z"
        fill={fillColor ? fillColor : "white"}
      />
    </svg>
  );
};

export const OpenEyeIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M20.4586 6.8442C19.0334 4.47894 15.8515 0.5 10.4931 0.5C5.14571 0.5 1.95278 4.47894 0.538603 6.8442C-0.179535 8.04894 -0.179535 9.53 0.538603 10.7237C1.95278 13.1 5.14571 17.0789 10.4931 17.0789C15.8515 17.0789 19.0334 13.1 20.4586 10.7237C20.8122 10.1268 21 9.46368 21 8.78947C21 8.11526 20.8122 7.45209 20.4586 6.8442ZM10.4931 13.7632C7.75311 13.7632 5.52135 11.5305 5.52135 8.78947C5.52135 6.04842 7.75311 3.81579 10.4931 3.81579C13.2331 3.81579 15.4648 6.04842 15.4648 8.78947C15.4648 11.5305 13.2331 13.7632 10.4931 13.7632ZM13.2441 8.63486C13.2552 8.69012 13.2551 8.73421 13.2551 8.78947C13.2551 10.3147 12.0177 11.5526 10.4931 11.5526C8.96842 11.5526 7.73101 10.3147 7.73101 8.78947C7.73101 7.26421 8.96842 6.02632 10.4931 6.02632C11.167 6.02632 11.7857 6.26956 12.2608 6.66745C11.8741 6.8443 11.5979 7.23105 11.5979 7.68421C11.5979 8.29211 12.0951 8.78947 12.7027 8.78947C12.9016 8.78947 13.0894 8.73433 13.2441 8.63486Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Pdf: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  customClass,
  handleClick,
  mouseEnter,
  mouseLeave,
}) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onMouseEnter={(e) => mouseEnter && mouseEnter(e)}
      onMouseLeave={(e) => mouseLeave && mouseLeave(e)}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M14.2628 15.1263H12.974C12.5015 15.1263 12.1148 15.513 12.1148 15.9855V21.1408C12.1148 21.6133 12.5015 22 12.974 22H14.2628C15.6848 22 16.8405 20.8444 16.8405 19.4224V17.7039C16.8405 16.282 15.6848 15.1263 14.2628 15.1263ZM15.122 19.4224C15.122 19.8949 14.7354 20.2816 14.2628 20.2816H13.8332V16.8447H14.2628C14.7354 16.8447 15.122 17.2314 15.122 17.7039V19.4224Z"
        fill="#CDD4D8"
      />
      <path
        d="M21.1365 15.1263H18.5589C18.0863 15.1263 17.6997 15.513 17.6997 15.9855V21.1408C17.6997 21.6133 18.0863 22 18.5589 22C19.0314 22 19.4181 21.6133 19.4181 21.1408V19.4224H20.2773C20.7499 19.4224 21.1365 19.0357 21.1365 18.5632C21.1365 18.0906 20.7499 17.7039 20.2773 17.7039H19.4181V16.8447H21.1365C21.6091 16.8447 21.9957 16.4581 21.9957 15.9855C21.9957 15.513 21.6091 15.1263 21.1365 15.1263Z"
        fill="#CDD4D8"
      />
      <path
        d="M9.1076 15.1263H7.38918C6.91662 15.1263 6.52997 15.513 6.52997 15.9855V21.1408C6.52997 21.6133 6.91662 22 7.38918 22C7.86175 22 8.24839 21.6133 8.24839 21.1408V19.4224H9.1076C10.2933 19.4224 11.2556 18.4601 11.2556 17.2743C11.2556 16.0886 10.2933 15.1263 9.1076 15.1263ZM9.1076 17.7039H8.24839V16.8447H9.1076C9.34388 16.8447 9.5372 17.0381 9.5372 17.2743C9.5372 17.5106 9.34388 17.7039 9.1076 17.7039Z"
        fill="#CDD4D8"
      />
      <path
        d="M7.9863 13.5024C8.00778 13.5196 8.02496 13.5411 8.04644 13.5583C8.05503 13.5669 8.06792 13.5755 8.07651 13.5798C8.0894 13.5883 8.09799 13.5969 8.11088 13.6055C8.12377 13.6141 8.13666 13.6227 8.14955 13.627C8.16243 13.6356 8.17103 13.6399 8.18391 13.6485C8.1968 13.6571 8.20969 13.6614 8.22258 13.6657C8.23547 13.67 8.24836 13.6786 8.26124 13.6829C8.27413 13.6872 8.28702 13.6915 8.29991 13.6957C8.3128 13.7 8.32568 13.7043 8.33857 13.7086C8.35146 13.7129 8.36435 13.7172 8.37724 13.7172C8.39012 13.7215 8.40301 13.7258 8.4202 13.7258C8.43738 13.7301 8.45027 13.7301 8.46745 13.7344C8.48034 13.7344 8.49323 13.7387 8.50612 13.7387C8.53619 13.743 8.56197 13.743 8.59204 13.743C8.62211 13.743 8.64789 13.743 8.67796 13.7387C8.69085 13.7387 8.70373 13.7344 8.71662 13.7344C8.73381 13.7301 8.7467 13.7301 8.76388 13.7258C8.77677 13.7215 8.79395 13.7172 8.80684 13.7172C8.81973 13.7129 8.83262 13.7129 8.8455 13.7086C8.85839 13.7043 8.87128 13.7 8.88417 13.6957C8.89706 13.6915 8.90995 13.6872 8.92283 13.6829C8.93572 13.6786 8.94861 13.67 8.9615 13.6657C8.97439 13.6614 8.98727 13.6528 9.00016 13.6485C9.01305 13.6442 9.02164 13.6356 9.03453 13.627C9.04742 13.6184 9.06031 13.6141 9.07319 13.6055C9.08608 13.5969 9.09897 13.5883 9.10756 13.5798C9.11615 13.5712 9.12904 13.5626 9.13764 13.5583C9.15912 13.5411 9.1806 13.5239 9.19778 13.5024C9.19778 13.5024 9.19778 13.5024 9.20208 13.5024L10.9205 11.784C11.2556 11.4489 11.2556 10.9033 10.9205 10.5682C10.5854 10.2331 10.0398 10.2331 9.70471 10.5682L9.45125 10.8217V7.73714C9.45125 7.26458 9.0646 6.87794 8.59204 6.87794C8.11947 6.87794 7.73283 7.26458 7.73283 7.73714V10.8174L7.47936 10.5639C7.14427 10.2288 6.59868 10.2288 6.26359 10.5639C5.9285 10.899 5.9285 11.4446 6.26359 11.7797L7.9863 13.5024Z"
        fill="#CDD4D8"
      />
      <path
        d="M17.1798 5.94571C17.1798 5.93712 17.1798 5.93283 17.1798 5.92423C17.1756 5.89846 17.1756 5.87698 17.167 5.8512C17.167 5.84261 17.1627 5.83402 17.1627 5.82972C17.1584 5.81254 17.1541 5.79535 17.1498 5.77817C17.1455 5.76958 17.1455 5.75669 17.1412 5.7481C17.1369 5.73521 17.1326 5.71802 17.124 5.70514C17.1197 5.69654 17.1154 5.68795 17.1111 5.67936C17.1025 5.65788 17.0896 5.6364 17.081 5.61492C17.0767 5.60633 17.0724 5.60203 17.0682 5.59344C17.0596 5.57626 17.051 5.56337 17.0424 5.54618C17.0381 5.53759 17.0338 5.53329 17.0252 5.5247C17.0166 5.51181 17.0037 5.49893 16.9951 5.48174C16.9908 5.47745 16.9865 5.46885 16.9822 5.46456C16.965 5.44737 16.9522 5.43019 16.935 5.40871L11.7797 0.253466C11.7625 0.236282 11.7454 0.219098 11.7239 0.201914C11.7196 0.197618 11.711 0.193322 11.7067 0.189026C11.6938 0.176137 11.6809 0.167545 11.6637 0.158953C11.6551 0.154657 11.6508 0.150361 11.6423 0.141769C11.6294 0.133177 11.6122 0.124585 11.595 0.115993C11.5864 0.111697 11.5821 0.107401 11.5735 0.103105C11.552 0.0902167 11.5306 0.0816247 11.5091 0.0730326C11.5005 0.0687366 11.4919 0.0644405 11.4833 0.0601445C11.4704 0.0558485 11.4532 0.0472564 11.4403 0.0429604C11.4318 0.0386643 11.4189 0.0343683 11.4103 0.0343683C11.3931 0.0300723 11.3759 0.0257762 11.3587 0.0214802C11.3501 0.0214802 11.3458 0.0171841 11.3372 0.0171841C11.3115 0.0128881 11.29 0.00859207 11.2642 0.00429604C11.2556 0.00429604 11.2513 0.00429604 11.2427 0.00429604C11.2212 0.00429604 11.1998 0 11.1826 0C11.1783 0 11.174 0 11.1697 0H2.57762C1.15563 0.00429604 0 1.15993 0 2.58192V19.4224C0 20.8444 1.15563 22 2.57762 22H4.29604C4.7686 22 5.15524 21.6134 5.15524 21.1408C5.15524 20.6682 4.7686 20.2816 4.29604 20.2816H2.57762C2.10506 20.2816 1.71841 19.8949 1.71841 19.4224V2.58192C1.71841 2.10935 2.10506 1.72271 2.57762 1.72271H10.3105V4.30033C10.3105 5.72232 11.4661 6.87795 12.8881 6.87795H15.4657V12.8924C15.4657 13.365 15.8524 13.7516 16.3249 13.7516C16.7975 13.7516 17.1841 13.365 17.1841 12.8924V6.01875C17.1841 6.01445 17.1841 6.01015 17.1841 6.00586C17.1841 5.98438 17.1841 5.96719 17.1798 5.94571ZM12.8881 5.15954C12.4155 5.15954 12.0289 4.7729 12.0289 4.30033V2.93849L14.25 5.15954H12.8881Z"
        fill="#CDD4D8"
      />
    </svg>
  );
};

export const AbsentIcon: FC<ISvgComponent> = ({ customClass, handleClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <rect width="26" height="26" rx="6" fill="#B11313" />
      <path
        d="M14.916 16.012H10.842L10.142 18H8.476L11.962 8.256H13.81L17.296 18H15.616L14.916 16.012ZM14.468 14.71L12.886 10.188L11.29 14.71H14.468Z"
        fill="white"
      />
    </svg>
  );
};

// export const OpenEyeIcon: React.FunctionComponent<ISvgComponent> = ({
//   fillColor,
// }) => {
//   return (
//     // <svg
//     //   width="30"
//     //   height="32"
//     //   viewBox="0 0 28 30"
//     //   fill="none"
//     //   xmlns="http://www.w3.org/2000/svg"
//     // >
//     //   <path
//     //     xmlns="http://www.w3.org/2000/svg"
//     //     d="M23.3995 3.8594C23.3995 1.74433 21.6613 0 19.5401 0H9.70624C8.70948 0 7.71272 0.370745 7.09279 1.11831L1.23987 6.59441C0.498379 7.22042 0 8.33874 0 9.45705V26.1345C0 28.2496 1.74433 29.9939 3.8594 29.9939H19.5401C21.6552 29.9939 23.3995 28.2496 23.3995 26.1345V3.8594ZM2.4919 9.33549C2.4919 8.96475 2.74109 8.58792 2.99028 8.33874L8.71556 2.86264C8.83711 2.74109 9.21394 2.4919 9.71232 2.4919H9.83387V7.22042C9.83387 8.46637 8.83711 9.58468 7.46961 9.58468L2.4919 9.33549ZM19.2909 19.5401L14.5624 24.8947C14.3132 25.1438 13.9425 25.2654 13.6933 25.2654H13.5717C13.201 25.2654 12.8241 25.0162 12.575 24.767L9.96151 20.7861L5.98055 25.0162C5.48217 25.5146 4.7346 25.5146 4.23622 25.0162C3.73784 24.5178 3.73784 23.7703 4.23622 23.2719L9.34157 17.9173C9.59076 17.6681 9.96151 17.5466 10.3383 17.5466C10.7091 17.5466 11.0859 17.7958 11.3351 18.045L13.9485 22.0259L17.5588 17.9173C18.0571 17.419 18.8047 17.419 19.3031 17.7958C19.7893 18.1726 19.7893 19.0417 19.2909 19.5401ZM18.9202 11.9489H13.5656C12.8181 11.9489 12.3197 11.4506 12.3197 10.703C12.3197 9.95543 12.8181 9.45705 13.5656 9.45705H18.9202C19.5401 9.45705 20.1661 9.95543 20.1661 10.703C20.1661 11.4506 19.6677 11.9489 18.9202 11.9489ZM18.9202 6.97123H13.5656C12.8181 6.97123 12.3197 6.47285 12.3197 5.72528C12.3197 4.97771 12.8181 4.47934 13.5656 4.47934H18.9202C19.5401 4.47934 20.1661 4.97771 20.1661 5.72528C20.1661 6.47285 19.6677 6.97123 18.9202 6.97123Z"
//     //     fill={fillColor}
//     //   />
//     // </svg>
//     <svg
//       width="28"
//       height="28"
//       viewBox="0 0 22 22"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       className={customClass}
//       onClick={(e) => {
//         handleClick && handleClick(e);
//       }}
//     >
//       <path
//         d="M20.4586 6.8442C19.0334 4.47894 15.8515 0.5 10.4931 0.5C5.14571 0.5 1.95278 4.47894 0.538603 6.8442C-0.179535 8.04894 -0.179535 9.53 0.538603 10.7237C1.95278 13.1 5.14571 17.0789 10.4931 17.0789C15.8515 17.0789 19.0334 13.1 20.4586 10.7237C20.8122 10.1268 21 9.46368 21 8.78947C21 8.11526 20.8122 7.45209 20.4586 6.8442ZM10.4931 13.7632C7.75311 13.7632 5.52135 11.5305 5.52135 8.78947C5.52135 6.04842 7.75311 3.81579 10.4931 3.81579C13.2331 3.81579 15.4648 6.04842 15.4648 8.78947C15.4648 11.5305 13.2331 13.7632 10.4931 13.7632ZM13.2441 8.63486C13.2552 8.69012 13.2551 8.73421 13.2551 8.78947C13.2551 10.3147 12.0177 11.5526 10.4931 11.5526C8.96842 11.5526 7.73101 10.3147 7.73101 8.78947C7.73101 7.26421 8.96842 6.02632 10.4931 6.02632C11.167 6.02632 11.7857 6.26956 12.2608 6.66745C11.8741 6.8443 11.5979 7.23105 11.5979 7.68421C11.5979 8.29211 12.0951 8.78947 12.7027 8.78947C12.9016 8.78947 13.0894 8.73433 13.2441 8.63486Z"
//         fill={fillColor}
//       />
//     </svg>
//   );
// };

export const PresentIcon: FC<ISvgComponent> = ({
  customClass,
  handleClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <rect width="26" height="26" rx="6" fill="#02BF90" />
      <path
        d="M18.4212 9.26954C18.7818 9.63015 18.7818 10.2148 18.4212 10.5754L12.2674 16.7293C12.0877 16.909 11.8514 17 11.6151 17C11.3788 17 11.1425 16.9102 10.9628 16.7293L7.27046 13.037C6.90985 12.6763 6.90985 12.0917 7.27046 11.7311C7.63108 11.3705 8.2157 11.3705 8.57631 11.7311L11.6163 14.771L17.1178 9.26954C17.4772 8.91015 18.0606 8.91015 18.4212 9.26954Z"
        fill="white"
      />
    </svg>
  );
};

// export const CheckRoundIcon: React.FunctionComponent<ISvgComponent> = ({
//   fillColor,
//   customClass,
//   handleClick,
// }) => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="25"
//       height="30"
//       viewBox="0 0 25 30"
//       fill="none"
//       className={customClass}
//       onClick={(e) => {
//         handleClick && handleClick(e);
//       }}
//     >
//       <path
//         d="M18.9399 7.02593H23.9087L17.9062 1.02344V5.9923C17.9996 6.55893 18.3795 7.02593 18.9399 7.02593Z"
//         fill="#67CDDF"
//       />
//       <path
//         d="M24.7572 9.00374H18.9415C17.254 9.00374 15.9402 7.68991 15.9402 6.00249V0.1868C15.9402 0.0933998 15.9402 0.0933998 15.9402 0H1.87422C0.846824 0 0 0.940224 0 1.96762V27.939C0 29.066 0.846824 30 1.96762 30H22.9701C24.0971 30 24.9377 29.0598 24.9377 28.0324V9.00374C24.944 9.00374 24.8506 9.00374 24.7572 9.00374Z"
//         fill="#EAEFFE"
//       />
//       <path
//         d="M19.62 20.0484L14.8328 25.496C14.5805 25.7496 14.2052 25.8732 13.9529 25.8732H13.8298C13.4545 25.8732 13.073 25.6197 12.8207 25.3662L10.1748 21.316L6.14441 25.6197C5.63984 26.1268 4.88299 26.1268 4.37842 25.6197C3.87386 25.1127 3.87386 24.3521 4.37842 23.845L9.54715 18.3974C9.79944 18.1438 10.1748 18.0202 10.5563 18.0202C10.9316 18.0202 11.3131 18.2737 11.5654 18.5272L14.2113 22.5774L17.8663 18.3974C18.3709 17.8903 19.1278 17.8903 19.6323 18.2737C20.1246 18.6571 20.1246 19.5413 19.62 20.0484Z"
//         fill="#67CDDF"
//       />
//       <path
//         d="M10.6018 11.4768H5.2462C4.49848 11.4768 4 10.9783 4 10.2306C4 9.48286 4.49848 8.98438 5.2462 8.98438H10.6018C11.2219 8.98438 11.848 9.48286 11.848 10.2306C11.848 10.9783 11.3495 11.4768 10.6018 11.4768Z"
//         fill="#002C5A"
//       />
//       <path
//         d="M10.6018 6.4924H5.2462C4.49848 6.4924 4 5.99392 4 5.2462C4 4.49848 4.49848 4 5.2462 4H10.6018C11.2219 4 11.848 4.49848 11.848 5.2462C11.848 5.99392 11.3495 6.4924 10.6018 6.4924Z"
//         fill="#002C5A"
//       />
//     </svg>
//   );
// };

export const VouchersIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5406 14.8785L13.2901 21.7771L9.17696 12.686L7.39453 8.74762L22.645 1.85305C23.1363 1.62981 23.721 1.84908 23.9443 2.34036L25.1624 5.03229C25.2517 5.22738 25.1868 5.43832 25.0284 5.58463C24.4154 6.14887 24.3422 7.43596 24.9026 8.67863C25.4669 9.92091 26.482 10.7127 27.3103 10.6233C27.5215 10.6031 27.7245 10.6965 27.8138 10.8872L28.6258 12.686L29.0319 13.5793C29.2552 14.0706 29.0319 14.6553 28.5406 14.8785Z"
        fill="#EAEFFE"
      />
      <path
        d="M28.5394 14.88L13.2889 21.7786L9.17578 12.6875H28.6247L29.0307 13.5808C29.254 14.0721 29.0307 14.6568 28.5394 14.88Z"
        fill="#78E7DC"
      />
      <path
        d="M13.2895 21.7794L7.35741 24.4593C6.86613 24.6825 6.28147 24.4593 6.05814 23.968L4.84005 21.284C4.75073 21.0851 4.81973 20.874 4.97407 20.7279C5.59124 20.1634 5.66836 18.8764 5.10403 17.6297C4.54365 16.3914 3.52451 15.5956 2.69223 15.685C2.48109 15.7052 2.27807 15.6158 2.18866 15.417L0.970572 12.733C0.962443 12.7167 0.958478 12.7046 0.95035 12.6884C0.759428 12.2013 0.986829 11.6449 1.46185 11.4296L7.39399 8.75L9.17642 12.6884L13.2895 21.7794Z"
        fill="#67CDDF"
      />
      <path
        d="M13.2884 21.7786L7.35628 24.4584C6.865 24.6816 6.28034 24.4584 6.05701 23.9671L4.83892 21.2831C4.7496 21.0843 4.81859 20.8731 4.97294 20.727C5.59011 20.1626 5.66723 18.8755 5.10289 17.6288C4.54252 16.3905 3.52338 15.5947 2.6911 15.6841C2.47996 15.7044 2.27694 15.615 2.18753 15.4161L0.969441 12.7321C0.961312 12.7159 0.957347 12.7038 0.949219 12.6875H9.17529L13.2884 21.7786Z"
        fill="#78E7DC"
      />
      <path
        d="M25.9656 20.8659C25.9656 22.2731 26.5832 23.4478 27.3983 23.716C27.6059 23.7869 27.7578 23.959 27.7578 24.1768V27.2192C27.7578 27.7761 27.3021 28.2317 26.7453 28.2317H9.49219V13.5H26.7453C27.3021 13.5 27.7578 13.9556 27.7578 14.5125V17.555C27.7578 17.7727 27.6059 17.9448 27.3983 18.0157C26.5832 18.2839 25.9656 19.4635 25.9656 20.8659Z"
        fill="#EAEFFE"
      />
      <path
        d="M9.49376 13.5V28.2317H2.78594C2.22901 28.2317 1.77344 27.7761 1.77344 27.2192V24.1817C1.77344 23.959 1.92534 23.7869 2.13286 23.716C2.95304 23.4478 3.57065 22.2731 3.57065 20.8659C3.57065 19.4635 2.95304 18.2839 2.13286 18.0157C1.92534 17.9448 1.77344 17.7727 1.77344 17.55V14.5125C1.77344 13.9556 2.22901 13.5 2.78594 13.5H9.49376Z"
        fill="#67CDDF"
      />
      <path
        d="M14.2485 18.0764C14.0047 17.7831 13.8828 17.41 13.8828 16.9574C13.8828 16.5045 14.0047 16.1316 14.2485 15.8382C14.4923 15.5451 14.8378 15.3984 15.2849 15.3984C15.7318 15.3984 16.0772 15.5451 16.321 15.8382C16.5648 16.1316 16.6867 16.5045 16.6867 16.9574C16.6867 17.41 16.5648 17.7831 16.321 18.0764C16.0772 18.3696 15.7318 18.5161 15.2849 18.5161C14.8378 18.5161 14.4923 18.3696 14.2485 18.0764ZM15.8682 17.6713C16.0074 17.4857 16.0772 17.2476 16.0772 16.9574C16.0772 16.667 16.0074 16.429 15.8682 16.2432C15.7289 16.0575 15.5344 15.9645 15.2849 15.9645C15.0351 15.9645 14.8406 16.0575 14.7013 16.2432C14.5621 16.429 14.4923 16.667 14.4923 16.9574C14.4923 17.2476 14.5621 17.4857 14.7013 17.6713C14.8406 17.8572 15.0351 17.95 15.2849 17.95C15.5344 17.95 15.7289 17.8572 15.8682 17.6713ZM15.0844 21.6293C15.0263 21.5742 14.9972 21.506 14.9972 21.4247C14.9972 21.3724 15.0117 21.3232 15.0408 21.2766L18.5853 15.6075C18.643 15.5147 18.7245 15.4682 18.829 15.4682C18.9162 15.4682 18.9871 15.4915 19.0423 15.5379C19.0976 15.5843 19.1253 15.6482 19.1253 15.7294C19.1253 15.7933 19.1047 15.8571 19.064 15.9209L15.5461 21.5553C15.517 21.6017 15.4791 21.6392 15.4327 21.6685C15.3863 21.6974 15.337 21.7121 15.2849 21.7121C15.2091 21.7121 15.1425 21.6844 15.0844 21.6293ZM17.7841 21.3419C17.5403 21.0487 17.4184 20.6756 17.4184 20.2229C17.4184 19.7701 17.5403 19.3972 17.7841 19.1038C18.0279 18.8107 18.3734 18.664 18.8202 18.664C19.2674 18.664 19.6128 18.8107 19.8566 19.1038C20.1004 19.3972 20.2223 19.7701 20.2223 20.2229C20.2223 20.6756 20.1004 21.0487 19.8566 21.3419C19.6128 21.635 19.2674 21.7817 18.8202 21.7817C18.3734 21.7817 18.0279 21.635 17.7841 21.3419ZM19.4038 20.9369C19.543 20.7513 19.6128 20.5132 19.6128 20.2229C19.6128 19.9326 19.543 19.6946 19.4038 19.5088C19.2645 19.3231 19.07 19.2301 18.8202 19.2301C18.5707 19.2301 18.3762 19.3231 18.2369 19.5088C18.0977 19.6946 18.0279 19.9326 18.0279 20.2229C18.0279 20.5132 18.0977 20.7513 18.2369 20.9369C18.3762 21.1228 18.5707 21.2156 18.8202 21.2156C19.07 21.2156 19.2645 21.1228 19.4038 20.9369Z"
        fill="#002C5A"
      />
      <path
        d="M23.4179 23.4916V23.8419C23.4179 23.9421 23.3391 24.021 23.2388 24.021H12.8354C12.735 24.021 12.6562 23.9421 12.6562 23.8419V23.4916C12.6562 23.3914 12.735 23.3125 12.8354 23.3125H23.2388C23.3391 23.3125 23.4179 23.3914 23.4179 23.4916Z"
        fill="#002C5A"
      />
      <path
        d="M16.6338 25.5932V25.9435C16.6338 26.0437 16.555 26.1226 16.4546 26.1226H12.8354C12.735 26.1226 12.6562 26.0437 12.6562 25.9435V25.5932C12.6562 25.4929 12.735 25.4141 12.8354 25.4141H16.4546C16.555 25.4141 16.6338 25.4929 16.6338 25.5932Z"
        fill="#002C5A"
      />
      <path
        d="M23.4198 25.5932V25.9435C23.4198 26.0437 23.341 26.1226 23.2407 26.1226H17.8236C17.7233 26.1226 17.6445 26.0437 17.6445 25.9435V25.5932C17.6445 25.4929 17.7233 25.4141 17.8236 25.4141H23.2407C23.341 25.4141 23.4198 25.4929 23.4198 25.5932Z"
        fill="#002C5A"
      />
      <path
        d="M9.93966 14.8448V15.7337C9.93966 15.9821 9.7417 16.18 9.49333 16.18C9.24874 16.18 9.05078 15.9821 9.05078 15.7337V14.8448C9.05078 14.6003 9.24874 14.3984 9.49333 14.3984V14.4022C9.7417 14.4022 9.93966 14.6003 9.93966 14.8448Z"
        fill="#002C5A"
      />
      <path
        d="M9.93966 17.6338V18.5227C9.93966 18.7712 9.7417 18.9691 9.49333 18.9691C9.24874 18.9691 9.05078 18.7712 9.05078 18.5227V17.6338C9.05078 17.3893 9.24874 17.1875 9.49333 17.1875V17.1913C9.7417 17.1913 9.93966 17.3893 9.93966 17.6338Z"
        fill="#002C5A"
      />
      <path
        d="M9.93966 20.4229V21.3118C9.93966 21.5603 9.7417 21.7581 9.49333 21.7581C9.24874 21.7581 9.05078 21.5603 9.05078 21.3118V20.4229C9.05078 20.1784 9.24874 19.9766 9.49333 19.9766V19.9804C9.7417 19.9804 9.93966 20.1784 9.93966 20.4229Z"
        fill="#002C5A"
      />
      <path
        d="M9.93966 23.212V24.1008C9.93966 24.3493 9.7417 24.5472 9.49333 24.5472C9.24874 24.5472 9.05078 24.3493 9.05078 24.1008V23.212C9.05078 22.9675 9.24874 22.7656 9.49333 22.7656V22.7694C9.7417 22.7694 9.93966 22.9675 9.93966 23.212Z"
        fill="#002C5A"
      />
      <path
        d="M9.93966 26.001V26.8899C9.93966 27.1384 9.7417 27.3362 9.49333 27.3362C9.24874 27.3362 9.05078 27.1384 9.05078 26.8899V26.001C9.05078 25.7565 9.24874 25.5547 9.49333 25.5547V25.5585C9.7417 25.5585 9.93966 25.7565 9.93966 26.001Z"
        fill="#002C5A"
      />
      <g opacity="0.3">
        <path
          d="M22.5432 28.2309H16.2741L11.3164 13.5H17.5896L22.5432 28.2309Z"
          fill="white"
          fill-opacity="0.3"
        />
        <path
          d="M25.9432 28.2309H24.1607L19.2031 13.5H20.9856L25.9432 28.2309Z"
          fill="white"
        />
      </g>
      <path
        d="M7.43968 25.8929H7.11257C7.01898 25.8929 6.94531 25.8194 6.94531 25.7257V16.011C6.94531 15.9173 7.01898 15.8438 7.11257 15.8438H7.43968C7.53327 15.8438 7.60693 15.9173 7.60693 16.011V25.7257C7.60693 25.8194 7.53327 25.8929 7.43968 25.8929Z"
        fill="#002C5A"
      />
      <path
        d="M5.47874 19.5579H5.15163C5.05804 19.5579 4.98438 19.4844 4.98438 19.3907V16.011C4.98438 15.9173 5.05804 15.8438 5.15163 15.8438H5.47874C5.57233 15.8438 5.64599 15.9173 5.64599 16.011V19.3907C5.64599 19.4844 5.57233 19.5579 5.47874 19.5579Z"
        fill="#002C5A"
      />
      <path
        d="M5.47874 25.8929H5.15163C5.05804 25.8929 4.98438 25.8193 4.98438 25.7257V20.6673C4.98438 20.5736 5.05804 20.5 5.15163 20.5H5.47874C5.57233 20.5 5.64599 20.5736 5.64599 20.6673V25.7257C5.64599 25.8193 5.57233 25.8929 5.47874 25.8929Z"
        fill="#002C5A"
      />
    </svg>
  );
};

export const CamerIcon: FC<ISvgComponent> = ({ fillColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_23940_22798)">
        <path d="M30 7.78906H0V8.86469H30V7.78906Z" fill="#002C5A" />
        <path
          d="M0 28.9775C0 29.5437 0.459045 30.0027 1.02515 30.0027H28.9749C29.5411 30.0027 30.0001 29.5437 30.0001 28.9775V8.86719H0V28.9775Z"
          fill="#EAEFFE"
        />
        <path
          d="M30 3.78296C30 3.21686 29.5411 2.75781 28.9749 2.75781H1.02515C0.459045 2.75781 0 3.21686 0 3.78296V7.7876H30V3.78296Z"
          fill="#67CDDF"
        />
        <path
          d="M4.89655 0C4.52008 0 4.21484 0.305176 4.21484 0.681641V4.83667C4.21484 5.21314 4.52008 5.51837 4.89655 5.51837C5.27307 5.51837 5.57825 5.21314 5.57825 4.83667V0.681641C5.57831 0.305176 5.27313 0 4.89655 0Z"
          fill="#78E7DC"
        />
        <path
          d="M7.66992 0C7.29352 0 6.98828 0.305176 6.98828 0.681641V4.83667C6.98828 5.21314 7.29352 5.51837 7.66992 5.51837C8.04651 5.51837 8.35168 5.21314 8.35168 4.83667V0.681641C8.35168 0.305176 8.04651 0 7.66992 0Z"
          fill="#78E7DC"
        />
        <path
          d="M22.3301 0C21.9537 0 21.6484 0.305176 21.6484 0.681641V4.83667C21.6484 5.21314 21.9537 5.51837 22.3301 5.51837C22.7067 5.51837 23.0118 5.21314 23.0118 4.83667V0.681641C23.0118 0.305176 22.7067 0 22.3301 0Z"
          fill="#78E7DC"
        />
        <path
          d="M25.1035 0C24.7271 0 24.4219 0.305176 24.4219 0.681641V4.83667C24.4219 5.21314 24.7271 5.51837 25.1035 5.51837C25.4801 5.51837 25.7853 5.21314 25.7853 4.83667V0.681641C25.7853 0.305176 25.4801 0 25.1035 0Z"
          fill="#78E7DC"
        />
        <path
          d="M15 13.0938V25.7638C18.4987 25.7638 21.3349 22.9276 21.3349 19.4288C21.3349 15.93 18.4987 13.0938 15 13.0938Z"
          fill="#78E7DC"
        />
        <path
          d="M8.66406 19.4288C8.66406 22.9276 11.5003 25.7638 14.9992 25.7638V13.0938C11.5003 13.0938 8.66406 15.93 8.66406 19.4288Z"
          fill="#67CDDF"
        />
        <path
          d="M13.5587 22.1226C13.5305 22.1226 13.5023 22.121 13.4741 22.1184C13.2407 22.0939 13.0298 21.9708 12.8934 21.7806L11.2507 19.4858C10.9876 19.1183 11.0722 18.6075 11.4398 18.3444C11.8073 18.0823 12.3181 18.1654 12.5812 18.5335L13.6865 20.0776L17.5297 16.5583C17.8616 16.2541 18.3804 16.2754 18.6857 16.6094C18.9908 16.9423 18.968 17.4601 18.6345 17.7653L14.1111 21.9079C13.9598 22.0465 13.7622 22.1226 13.5587 22.1226Z"
          fill="#002C5A"
        />
      </g>
      <defs>
        <clipPath id="clip0_23940_22798">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// export const UserTickIcon: FC<ISvgComponent> = ({ fillColor }) => {
//   return (
//     <svg
//       width="30"
//       height="30"
//       viewBox="0 0 30 30"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g clip-path="url(#clip0_23940_9617)">
//         <path
//           d="M16.5525 6.72252C16.5525 10.1505 13.7736 12.9294 10.3456 12.9294C6.91758 12.9294 4.13867 10.1505 4.13867 6.72252C4.13867 3.29453 6.91758 0.515625 10.3456 0.515625C13.7736 0.515625 16.5525 3.29453 16.5525 6.72252Z"
//           fill="#FFCCBD"
//         />
//         <path
//           d="M16.5517 21.7228C16.5494 19.7889 17.3829 17.9486 18.8379 16.6746C17.0849 14.3157 14.3181 12.9267 11.3793 12.9297H9.31034C4.16849 12.9297 0 17.0982 0 22.24V29.4814H20.6897V27.9297C18.1833 26.8864 16.551 24.4376 16.5517 21.7228Z"
//           fill="#67CDDF"
//         />
//         <path
//           d="M29.9998 21.7229C29.9998 23.9711 28.8762 26.0707 27.0055 27.3178C25.135 28.5647 22.7647 28.7945 20.6895 27.9297C20.3452 27.7876 20.0146 27.6143 19.7014 27.4125C16.9632 25.6941 15.8353 22.2704 17.0162 19.2609C18.197 16.2514 21.3522 14.5082 24.5284 15.1106C27.7045 15.7127 30.0026 18.4901 29.9998 21.7229Z"
//           fill="#EAEFFE"
//         />
//         <path
//           d="M22.2418 22.2395L20.1728 20.1705L18.6211 21.7223L22.2418 25.3429L27.9314 19.6533L26.3797 18.1016L22.2418 22.2395Z"
//           fill="#002C5A"
//         />
//         <path
//           d="M20.6897 27.9313V29.483H0V27.4141H19.7016C20.0148 27.6159 20.3454 27.7891 20.6897 27.9313Z"
//           fill="#78E7DC"
//         />
//       </g>
//       <defs>
//         <clipPath id="clip0_23940_9617">
//           <rect width="30" height="30" fill="white" />
//         </clipPath>
//       </defs>
//     </svg>
//   );
// };

// export const ViewChartOfAccountsIcon: React.FunctionComponent<
//   ISvgComponent
// > = ({ fillColor }) => {
//   return (
//     <svg
//       width="30"
//       height="30"
//       viewBox="0 0 30 30"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g clip-path="url(#clip0_23940_39213)">
//         <path
//           d="M29.5018 28.245H0.50771C0.231642 28.245 0.0078125 28.0212 0.0078125 27.7451C0.0078125 27.469 0.231642 27.2452 0.50771 27.2452H29.0019V4.2499C29.0019 3.97383 29.2257 3.75 29.5018 3.75C29.7779 3.75 30.0017 3.97383 30.0017 4.2499V27.7451C30.0017 28.0212 29.7779 28.245 29.5018 28.245Z"
//           fill="#67CDDF"
//         />
//         <path
//           d="M3.00391 14.75H9.00268V25.7478H3.00391V14.75Z"
//           fill="#EAEFFE"
//         />
//         <path d="M12.0039 8.75H18.0027V25.7465H12.0039V8.75Z" fill="#EAEFFE" />
//         <path d="M21 3.75H26.9988V25.7455H21V3.75Z" fill="#EAEFFE" />
//         <path
//           d="M10.504 2.2499L12.1502 3.89606L8.00451 8.04172L6.85825 6.89545C6.66304 6.7003 6.3466 6.7003 6.15139 6.89545L0.152615 12.8942C-0.0459691 13.086 -0.051468 13.4025 0.140305 13.6011C0.332079 13.7997 0.648577 13.8052 0.847161 13.6134C0.851348 13.6094 0.855409 13.6053 0.859471 13.6011L6.50482 7.95573L7.65108 9.102C7.84629 9.29715 8.16273 9.29715 8.35794 9.102L12.857 4.60292L14.5032 6.24908L15.0031 1.75L10.504 2.2499Z"
//           fill="#78E7DC"
//         />
//         <path
//           d="M5.0038 24.2496C4.72774 24.2496 4.50391 24.0258 4.50391 23.7497V22.7499C4.50391 22.4738 4.72774 22.25 5.0038 22.25C5.27987 22.25 5.5037 22.4738 5.5037 22.7499V23.7497C5.5037 24.0258 5.27994 24.2496 5.0038 24.2496Z"
//           fill="#002C5A"
//         />
//         <path
//           d="M5.0038 21.2494C4.72774 21.2494 4.50391 21.0256 4.50391 20.7495V18.7499C4.50391 18.4738 4.72774 18.25 5.0038 18.25C5.27987 18.25 5.5037 18.4738 5.5037 18.7499V20.7495C5.5037 21.0256 5.27994 21.2494 5.0038 21.2494Z"
//           fill="#002C5A"
//         />
//         <path
//           d="M13.9999 24.2496C13.7238 24.2496 13.5 24.0258 13.5 23.7497V22.7499C13.5 22.4738 13.7238 22.25 13.9999 22.25C14.276 22.25 14.4998 22.4738 14.4998 22.7499V23.7497C14.4998 24.0258 14.276 24.2496 13.9999 24.2496Z"
//           fill="#002C5A"
//         />
//         <path
//           d="M13.9999 21.2488C13.7238 21.2488 13.5 21.0249 13.5 20.7489V15.7499C13.5 15.4738 13.7238 15.25 13.9999 15.25C14.276 15.25 14.4998 15.4738 14.4998 15.7499V20.7489C14.4998 21.0249 14.276 21.2488 13.9999 21.2488Z"
//           fill="#002C5A"
//         />
//         <path
//           d="M22.9999 24.2496C22.7238 24.2496 22.5 24.0258 22.5 23.7497V22.7499C22.5 22.4738 22.7238 22.25 22.9999 22.25C23.276 22.25 23.4998 22.4738 23.4998 22.7499V23.7497C23.4998 24.0258 23.276 24.2496 22.9999 24.2496Z"
//           fill="#002C5A"
//         />
//         <path
//           d="M22.9999 21.2478C22.7238 21.2478 22.5 21.0239 22.5 20.7479V10.7499C22.5 10.4738 22.7238 10.25 22.9999 10.25C23.276 10.25 23.4998 10.4738 23.4998 10.7499V20.7479C23.4998 21.0239 23.276 21.2478 22.9999 21.2478Z"
//           fill="#002C5A"
//         />
//         <path
//           d="M26.1591 18C22.2052 18 19 21.1865 19 25.1174C19 29.0514 22.2088 32.2347 26.1591 32.2347C30.1057 32.2347 33.3182 29.055 33.3182 25.1174C33.3182 21.1865 30.113 18 26.1591 18Z"
//           fill="#78E7DC"
//         />
//         <path
//           d="M26.1605 20.0312C28.9846 20.0312 31.2741 22.3074 31.2741 25.1151C31.2741 27.9227 28.9846 30.1989 26.1605 30.1989C23.3364 30.1989 21.0469 27.9227 21.0469 25.1151C21.0469 22.3074 23.3364 20.0312 26.1605 20.0312Z"
//           fill="#EAEFFE"
//         />
//         <path
//           d="M26.0467 24.3832V23.4797C25.7017 23.5088 25.5292 23.6512 25.5292 23.9054C25.5292 24.0281 25.5729 24.125 25.6588 24.1962C25.7453 24.2667 25.8743 24.3297 26.0467 24.3832ZM26.3945 25.7498V26.6317C26.7736 26.6167 26.9638 26.4873 26.9638 26.2426C26.9638 26.1151 26.912 26.0162 26.8084 25.945C26.7047 25.8738 26.567 25.8088 26.3945 25.7498ZM26.3945 23.4871V24.4863L26.6304 24.5453C26.8819 24.6137 27.1084 24.6883 27.3108 24.7689C27.5126 24.8496 27.6838 24.9506 27.8242 25.0706C27.9647 25.1906 28.0731 25.3363 28.1495 25.5078C28.2258 25.6793 28.264 25.8847 28.264 26.1246C28.264 26.4039 28.215 26.6418 28.1161 26.8377C28.0179 27.0336 27.8856 27.1943 27.7206 27.319C27.5556 27.4437 27.3661 27.5386 27.1519 27.6017C26.9372 27.6654 26.7122 27.702 26.4756 27.7121V28.5642H25.9656V27.7047C25.6254 27.6755 25.2893 27.6071 24.9565 27.4993C24.6238 27.3915 24.3244 27.2492 24.0586 27.0729L24.5904 26.0223C24.6102 26.0467 24.6633 26.0873 24.7493 26.1436C24.8359 26.1999 24.9456 26.2588 25.0786 26.3198C25.2115 26.3809 25.3615 26.4398 25.5292 26.4961C25.6969 26.5523 25.8694 26.593 26.0467 26.6174V25.64L25.6922 25.5369C25.4501 25.4637 25.2409 25.3844 25.0635 25.2983C24.8863 25.2129 24.7397 25.1133 24.6238 25.0008C24.5079 24.8882 24.422 24.7581 24.3654 24.611C24.3088 24.4646 24.2802 24.2931 24.2802 24.0972C24.2802 23.8423 24.3244 23.6159 24.4131 23.4173C24.5018 23.2187 24.6211 23.0486 24.7718 22.9069C24.9217 22.7646 25.099 22.6527 25.3036 22.5721C25.5081 22.4914 25.729 22.4385 25.9656 22.4141V21.6719H26.4756V22.4141C26.7953 22.4433 27.0961 22.5144 27.377 22.627C27.6579 22.7402 27.9019 22.8554 28.1085 22.9727L27.5767 23.9718C27.5617 23.9521 27.5188 23.9203 27.4472 23.8762C27.3763 23.8322 27.2849 23.7847 27.1738 23.7332C27.0633 23.6817 26.9399 23.6329 26.8042 23.5861C26.6685 23.5393 26.5322 23.5068 26.3945 23.4871Z"
//           fill="#002C5A"
//         />
//       </g>
//       <defs>
//         <clipPath id="clip0_23940_39213">
//           <rect width="30" height="30" fill="white" />
//         </clipPath>
//       </defs>
//     </svg>
//   );
// };

export const FolderIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      width="30"
      height="28"
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1898 3.98438H26.3789V9.41697H30.0006V5.79524C30.0006 4.79504 29.19 3.98438 28.1898 3.98438Z"
        fill="#78E7DC"
      />
      <path
        d="M28.1891 5.79197L22.7565 13.0354H0V2.17024C0 1.17004 0.810664 0.359375 1.81087 0.359375H10.628C11.1084 0.359375 11.569 0.55012 11.9089 0.889959L15 3.98111H26.3783C27.3785 3.98111 28.1891 4.79177 28.1891 5.79197Z"
        fill="#67CDDF"
      />
      <path
        d="M26.3776 5.78906L22.7559 10.3162H28.1885V5.78906H26.3776Z"
        fill="#EAEFFE"
      />
      <path
        d="M26.378 5.78906V14.8434L1.81055 7.59993V5.78906H26.378Z"
        fill="#EAEFFE"
      />
      <path
        d="M1.81055 7.60156H19.3717V13.0342H1.81055V7.60156Z"
        fill="#EAEFFE"
      />
      <path
        d="M28.1898 7.60156L26.3789 9.41243V27.6418H28.1898C29.19 27.6418 30.0006 26.8311 30.0006 25.8309V9.41243C30.0006 8.41223 29.19 7.60156 28.1898 7.60156Z"
        fill="#78E7DC"
      />
      <path
        d="M28.1891 7.60156V25.8309C28.1891 26.8311 27.3785 27.6418 26.3783 27.6418H1.81087C0.810664 27.6418 0 26.8311 0 25.8309V13.0342C0 12.034 0.810664 11.2233 1.81087 11.2233H15L18.0911 8.13215C18.431 7.79231 18.8915 7.60156 19.372 7.60156H28.1891Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const MobileIcon = () => {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="10.5"
        height="18.5"
        rx="1.25"
        stroke="#181818"
        strokeWidth="1.5"
      />
      <circle cx="6" cy="16" r="1" fill="#181818" />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 7C16.25 9.23638 15.111 11.0661 13.7225 12.4666C12.3347 13.8664 10.7605 14.7711 10.0527 15.1382C10.0164 15.157 9.98363 15.157 9.94729 15.1382C9.23948 14.7711 7.66527 13.8664 6.27749 12.4666C4.88902 11.0661 3.75 9.23638 3.75 7C3.75 3.54822 6.54822 0.75 10 0.75C13.4518 0.75 16.25 3.54822 16.25 7Z"
        stroke="#181818"
        strokeWidth="1.5"
      />
      <circle cx="10" cy="7" r="2.25" stroke="#181818" strokeWidth="1.5" />
      <path
        d="M17.7942 15.5C18.5841 15.9561 19 16.4734 19 17C19 17.5266 18.5841 18.0439 17.7942 18.5C17.0043 18.9561 15.8682 19.3348 14.5 19.5981C13.1318 19.8614 11.5798 20 10 20C8.42017 20 6.86817 19.8614 5.5 19.5981C4.13183 19.3348 2.99569 18.9561 2.20577 18.5C1.41586 18.0439 1 17.5266 1 17C1 16.4734 1.41586 15.9561 2.20577 15.5"
        stroke="#181818"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const UnavailablityIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1797 22.0898C14.1797 17.728 17.728 14.1797 22.0898 14.1797C26.4516 14.1797 30 17.728 30 22.0898C30 26.4516 26.4516 30 22.0898 30C17.728 30 14.1797 26.4516 14.1797 22.0898ZM20.7071 19.2929C20.3166 18.9024 19.6834 18.9024 19.2929 19.2929C18.9024 19.6834 18.9024 20.3166 19.2929 20.7071L20.5858 22L19.2929 23.2929C18.9024 23.6834 18.9024 24.3166 19.2929 24.7071C19.6834 25.0976 20.3166 25.0976 20.7071 24.7071L22 23.4142L23.2929 24.7071C23.6834 25.0976 24.3166 25.0976 24.7071 24.7071C25.0976 24.3166 25.0976 23.6834 24.7071 23.2929L23.4142 22L24.7071 20.7071C25.0976 20.3166 25.0976 19.6834 24.7071 19.2929C24.3166 18.9024 23.6834 18.9024 23.2929 19.2929L22 20.5858L20.7071 19.2929Z"
        fill="#67CDDF"
      />
      <path
        d="M28.1836 2.69531C28.1836 2.20299 27.797 1.81641 27.3047 1.81641H22.9102V4.45312C22.9102 4.94522 22.5236 5.33203 22.0313 5.33203C21.5389 5.33203 21.1523 4.94522 21.1523 4.45312V1.81641H17.6367V4.45312C17.6367 4.94522 17.2501 5.33203 16.7578 5.33203C16.2655 5.33203 15.8789 4.94522 15.8789 4.45312V1.81641H12.3633V4.45312C12.3633 4.94522 11.9767 5.33203 11.4844 5.33203C10.9921 5.33203 10.6055 4.94522 10.6055 4.45312V1.81641H7.08984V4.45312C7.08984 4.94522 6.70326 5.33203 6.21094 5.33203C5.71861 5.33203 5.33203 4.94522 5.33203 4.45312V1.81641H0.878906C0.386581 1.81641 0 2.20299 0 2.69531V7.08984H28.1836V2.69531Z"
        fill="#67CDDF"
      />
      <path
        d="M13.2422 17.6367H13.4532C13.7741 17.0132 14.1362 16.4147 14.5793 15.8789H13.2422C12.7565 15.8789 12.3633 15.4857 12.3633 15C12.3633 14.5143 12.7565 14.1211 13.2422 14.1211H15C15.36 14.1211 15.6674 14.3383 15.8034 14.648C17.4873 13.2255 19.6593 12.3633 22.0313 12.3633H20.2734C19.7878 12.3633 19.3945 11.9701 19.3945 11.4844C19.3945 10.9987 19.7878 10.6055 20.2734 10.6055H22.0313C22.5169 10.6055 22.9102 10.9987 22.9102 11.4844C22.9102 11.9701 22.5169 12.3633 22.0313 12.3633C24.3665 12.3633 26.5109 13.196 28.1836 14.5793V8.84766H0V25.5469C0 26.0326 0.393219 26.4258 0.878906 26.4258H13.4306C12.7533 25.1056 12.3633 23.6142 12.3633 22.0312C12.3633 21.0638 12.5368 20.1418 12.8025 19.2599C12.5446 19.1068 12.3633 18.8377 12.3633 18.5156C12.3633 18.0299 12.7565 17.6367 13.2422 17.6367ZM13.2422 10.6055H15C15.4857 10.6055 15.8789 10.9987 15.8789 11.4844C15.8789 11.9701 15.4857 12.3633 15 12.3633H13.2422C12.7565 12.3633 12.3633 11.9701 12.3633 11.4844C12.3633 10.9987 12.7565 10.6055 13.2422 10.6055ZM7.96875 22.9102H6.21094C5.72525 22.9102 5.33203 22.5169 5.33203 22.0312C5.33203 21.5456 5.72525 21.1523 6.21094 21.1523H7.96875C8.45444 21.1523 8.84766 21.5456 8.84766 22.0312C8.84766 22.5169 8.45444 22.9102 7.96875 22.9102ZM7.96875 19.3945H6.21094C5.72525 19.3945 5.33203 19.0013 5.33203 18.5156C5.33203 18.0299 5.72525 17.6367 6.21094 17.6367H7.96875C8.45444 17.6367 8.84766 18.0299 8.84766 18.5156C8.84766 19.0013 8.45444 19.3945 7.96875 19.3945ZM7.96875 15.8789H6.21094C5.72525 15.8789 5.33203 15.4857 5.33203 15C5.33203 14.5143 5.72525 14.1211 6.21094 14.1211H7.96875C8.45444 14.1211 8.84766 14.5143 8.84766 15C8.84766 15.4857 8.45444 15.8789 7.96875 15.8789ZM7.96875 12.3633H6.21094C5.72525 12.3633 5.33203 11.9701 5.33203 11.4844C5.33203 10.9987 5.72525 10.6055 6.21094 10.6055H7.96875C8.45444 10.6055 8.84766 10.9987 8.84766 11.4844C8.84766 11.9701 8.45444 12.3633 7.96875 12.3633Z"
        fill="#EAEFFE"
      />
      <path
        d="M7.08594 0.878906C7.08594 0.386581 6.69936 0 6.20703 0C5.71471 0 5.32812 0.386581 5.32812 0.878906V1.81641H7.08594V0.878906Z"
        fill="#EAEFFE"
      />
      <path
        d="M12.3672 0.878906C12.3672 0.386581 11.9806 0 11.4883 0C10.996 0 10.6094 0.386581 10.6094 0.878906V1.81641H12.3672V0.878906Z"
        fill="#EAEFFE"
      />
      <path
        d="M17.6367 0.878906C17.6367 0.386581 17.2501 0 16.7578 0C16.2655 0 15.8789 0.386581 15.8789 0.878906V1.81641H17.6367V0.878906Z"
        fill="#EAEFFE"
      />
      <path
        d="M22.9102 0.878906C22.9102 0.386581 22.5236 0 22.0312 0C21.5389 0 21.1523 0.386581 21.1523 0.878906V1.81641H22.9102V0.878906Z"
        fill="#EAEFFE"
      />
    </svg>
  );
};

export const UPAYConfigIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4088 17.3777V16.1381C17.4088 15.0037 18.1118 13.9788 19.1581 13.5879C19.5749 13.4321 19.9439 13.1653 20.2251 12.8163C20.7529 12.1614 21.5263 11.7858 22.3469 11.7858H24.5834V9.26025H0V20.9509C0 21.4363 0.39352 21.8299 0.878915 21.8299H18.2838C17.7087 20.4208 17.4088 18.9063 17.4088 17.3777ZM4.41848 13.0088H10.616C11.1014 13.0088 11.4949 13.4023 11.4949 13.8877C11.4949 14.3731 11.1014 14.7667 10.616 14.7667H4.41848C3.93309 14.7667 3.53957 14.3731 3.53957 13.8877C3.53957 13.4023 3.93309 13.0088 4.41848 13.0088ZM4.41848 16.5247H12.9599C13.4453 16.5247 13.8388 16.9182 13.8388 17.4036C13.8388 17.889 13.4453 18.2826 12.9599 18.2826H4.41848C3.93309 18.2826 3.53957 17.889 3.53957 17.4036C3.53957 16.9182 3.93309 16.5247 4.41848 16.5247Z"
        fill="#EAEFFE"
      />
      <path
        d="M24.5834 7.50224V4.87892C24.5834 4.39352 24.1899 4 23.7045 4H0.878915C0.39352 4 0 4.39352 0 4.87892V7.50224H24.5834Z"
        fill="#67CDDF"
      />
      <path
        d="M29.9976 17.3775V16.1379C29.9976 15.733 29.7538 15.3698 29.3909 15.2342C28.679 14.9681 28.0495 14.5134 27.5706 13.9192C27.3781 13.6805 27.1036 13.5435 26.8174 13.5435H22.3443C22.0581 13.5435 21.7836 13.6805 21.5911 13.9192C21.1122 14.5134 20.4827 14.9681 19.7708 15.2342C19.4079 15.3698 19.1641 15.733 19.1641 16.1379V17.3775C19.1641 20.9055 21.0518 24.2108 24.0906 26.0034C24.393 26.1818 24.7687 26.1818 25.0711 26.0034C28.1099 24.2108 29.9976 20.9055 29.9976 17.3775ZM24.8278 21.488C24.663 21.6528 24.4394 21.7454 24.2063 21.7454C23.9731 21.7454 23.7496 21.6529 23.5848 21.488L22.284 20.1871C21.9408 19.8439 21.9408 19.2874 22.284 18.9442C22.6272 18.6009 23.1838 18.6009 23.5269 18.9442L24.2062 19.6235L26.2205 17.6091C26.5638 17.266 27.1203 17.266 27.4635 17.6091C27.8067 17.9523 27.8067 18.5089 27.4635 18.8521L24.8278 21.488Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const ImportUtilityIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.1875 4.1792L3.69913 4.18613L7.1875 0.697754V4.1792Z"
        fill="#67CDDF"
      />
      <path
        d="M8.08664 6.01349C8.57477 6.01257 8.96974 5.61286 8.96974 5.12002V0H23.744C24.2328 0 24.6289 0.399933 24.6289 0.893468V16.817C23.7078 16.4285 22.6976 16.2135 21.6384 16.2135C21.1152 16.2135 20.604 16.2662 20.1095 16.366C20.1688 16.2464 20.2027 16.1116 20.2027 15.9686C20.2027 15.4753 19.8066 15.0753 19.318 15.0753H8.66019C8.1716 15.0753 7.77526 15.4753 7.77526 15.9686C7.77526 16.4621 8.1716 16.8621 8.66019 16.8621H18.5435C15.7872 18.0729 13.8549 20.8487 13.8549 24.0721C13.8549 25.3234 14.1465 26.5069 14.664 27.5581H3.88592C3.39711 27.5581 3.001 27.1582 3.001 26.6647V6.02361L8.08664 6.01349ZM11.8459 8.9402C11.8459 9.43373 12.242 9.83367 12.7306 9.83367H19.318C19.8066 9.83367 20.2027 9.43373 20.2027 8.9402C20.2027 8.44689 19.8066 8.04673 19.318 8.04673H12.7306C12.242 8.04673 11.8459 8.44666 11.8459 8.9402ZM8.66019 13.348H19.318C19.8066 13.348 20.2027 12.9478 20.2027 12.4545C20.2027 11.961 19.8066 11.561 19.318 11.561H8.66019C8.1716 11.561 7.77526 11.961 7.77526 12.4545C7.77526 12.9478 8.17137 13.348 8.66019 13.348Z"
        fill="#EAEFFE"
      />
      <path
        d="M15.9052 24.0699C15.9052 20.7998 18.5655 18.1396 21.8355 18.1396C25.1053 18.1396 27.7656 20.7998 27.7656 24.0699C27.7656 27.3399 25.1053 30.0001 21.8355 30.0001C18.5655 30.0001 15.9052 27.3397 15.9052 24.0699ZM19.0341 25.3547L21.3276 26.9958C21.4797 27.1045 21.6576 27.1587 21.8355 27.1587C22.0188 27.1587 22.2021 27.1009 22.3566 26.9859L24.5597 25.3448C24.9462 25.0569 25.026 24.5101 24.7382 24.1238C24.4503 23.7372 23.9036 23.6573 23.517 23.9452L22.7079 24.5479V21.7689C22.7079 21.287 22.3173 20.8964 21.8355 20.8964C21.3535 20.8964 20.9629 21.287 20.9629 21.7689V24.5888L20.0498 23.9353C19.6578 23.655 19.1127 23.7453 18.8324 24.1373C18.5518 24.5292 18.6423 25.0742 19.0341 25.3547Z"
        fill="#67CDDF"
      />
    </svg>
  );
};

export const InvoiceTemplateIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_24184_46520)">
        <path
          d="M1.72852 1.75781H0.459366C0.167084 2.26753 0 2.85759 0 3.48633V6.97266C0 7.45789 0.393677 7.85156 0.878906 7.85156H3.45703V3.48633C3.45703 2.53304 2.68181 1.75781 1.72852 1.75781Z"
          fill="#EAEFFE"
        />
        <path
          d="M20.7175 11.4258C15.5983 11.4258 11.4336 15.5919 11.4336 20.7129C11.4336 25.8339 15.5983 30 20.7175 30C25.8369 30 30.0016 25.8339 30.0016 20.7129C30.0016 15.5919 25.8369 11.4258 20.7175 11.4258ZM19.8649 19.8633H21.6227C23.0766 19.8633 24.2594 21.0461 24.2594 22.5C24.2594 23.9342 23.1082 25.1038 21.6813 25.1353V25.7227C21.6813 26.2081 21.2879 26.6016 20.8024 26.6016C20.317 26.6016 19.9235 26.2081 19.9235 25.7227V25.1367H18.1071C17.6216 25.1367 17.2282 24.7433 17.2282 24.2578C17.2282 23.7724 17.6216 23.3789 18.1071 23.3789H21.6227C22.1073 23.3789 22.5016 22.9845 22.5016 22.5C22.5016 22.0155 22.1073 21.6211 21.6227 21.6211H19.8649C18.4111 21.6211 17.2282 20.4382 17.2282 18.9844C17.2282 17.5305 18.4111 16.3477 19.8649 16.3477H19.9235V15.7617C19.9235 15.2763 20.317 14.8828 20.8024 14.8828C21.2879 14.8828 21.6813 15.2763 21.6813 15.7617V16.3477H23.3805C23.866 16.3477 24.2594 16.7411 24.2594 17.2266C24.2594 17.712 23.866 18.1055 23.3805 18.1055H19.8649C19.3804 18.1055 18.986 18.4998 18.986 18.9844C18.986 19.4689 19.3804 19.8633 19.8649 19.8633Z"
          fill="#67CDDF"
        />
        <path
          d="M9.66992 23.7891C9.18446 23.7891 8.79102 23.3956 8.79102 22.9102C8.79102 22.4247 9.18446 22.0313 9.66992 22.0313H9.75438C9.70265 21.5989 9.6761 21.159 9.6761 20.7129C9.6761 20.5657 9.67976 20.4192 9.68549 20.2734H9.66992C9.18446 20.2734 8.79102 19.88 8.79102 19.3945C8.79102 18.9091 9.18446 18.5156 9.66992 18.5156H9.89583C10.0226 17.8894 10.2028 17.2824 10.431 16.6992H9.66992C9.18446 16.6992 8.79102 16.3058 8.79102 15.8203C8.79102 15.3349 9.18446 14.9414 9.66992 14.9414H11.3071C11.6951 14.3108 12.1448 13.7222 12.6472 13.1836H9.66992C9.18446 13.1836 8.79102 12.7901 8.79102 12.3047C8.79102 11.8192 9.18446 11.4258 9.66992 11.4258H14.7474C16.47 10.3139 18.5199 9.66797 20.7178 9.66797H9.66992C9.18446 9.66797 8.79102 9.27452 8.79102 8.78906C8.79102 8.30361 9.18446 7.91016 9.66992 7.91016H21.9746C22.4601 7.91016 22.8535 8.30361 22.8535 8.78906C22.8535 9.27452 22.4601 9.66797 21.9746 9.66797H20.7178C22.7819 9.66797 24.7148 10.2379 26.3691 11.2278V3.48633C26.3691 1.56395 24.8052 0 22.8828 0H3.51758C3.51414 0 3.51117 0.000686648 3.50751 0.000686648C3.5011 0.000686648 3.49469 0 3.48828 0C3.18478 0 2.88998 0.0393677 2.60938 0.11261C4.10764 0.502625 5.2168 1.86745 5.2168 3.48633V27.3047C5.2168 27.7899 5.61047 28.1836 6.0957 28.1836H12.5927C11.4541 26.9453 10.5937 25.4471 10.1124 23.7891H9.66992ZM9.66992 4.39453H14.9434C15.4288 4.39453 15.8223 4.78798 15.8223 5.27344C15.8223 5.7589 15.4288 6.15234 14.9434 6.15234H9.66992C9.18446 6.15234 8.79102 5.7589 8.79102 5.27344C8.79102 4.78798 9.18446 4.39453 9.66992 4.39453Z"
          fill="#EAEFFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_24184_46520">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FilterIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      style={{ cursor: "pointer" }}
    >
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="5.5"
        fill="white"
        stroke="#E2E8F0"
      />
      <path
        d="M22.0714 8H10.9286C9.86486 8 9 8.8279 9 9.84615V11.5578C9 11.941 9.156 12.3019 9.43971 12.5727L13.8291 16.7745C14.0314 16.9682 14.1429 17.2258 14.1429 17.4999V23.3846C14.1429 23.6176 14.2809 23.831 14.4986 23.9352C14.5894 23.9787 14.688 24 14.7857 24C14.922 24 15.0583 23.9581 15.1714 23.8769L18.6 21.4154C18.7612 21.2989 18.8571 21.1167 18.8571 20.9231V17.5007C18.8571 17.2267 18.9686 16.969 19.1709 16.7753L23.5603 12.5735C23.844 12.3019 24 11.9418 24 11.5586V9.84696C24 8.82788 23.1351 8 22.0714 8ZM10.9286 9.23077H22.0714C22.4263 9.23077 22.7143 9.50646 22.7143 9.84615V11.2821H10.2857V9.84615C10.2857 9.50646 10.5737 9.23077 10.9286 9.23077ZM18.2623 15.9048C17.8166 16.3315 17.5714 16.8976 17.5714 17.5007V20.6154L15.4286 22.1538V17.5007C15.4286 16.8976 15.1834 16.3315 14.7377 15.9048L11.1943 12.5128H21.8049L18.2623 15.9048Z"
        fill="#002C5A"
      />
    </svg>
  );
};

// export const FilterIcon: React.FunctionComponent<ISvgComponent> = ({
//   fillColor,
//   handleClick,
// }) => {
//   return (
//     <svg
//       width="32"
//       height="32"
//       viewBox="0 0 32 32"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       onClick={(e) => {
//         handleClick && handleClick(e);
//       }}
//       style={{ cursor: "pointer" }}
//     >
//       <rect
//         x="0.5"
//         y="0.5"
//         width="31"
//         height="31"
//         rx="5.5"
//         fill="white"
//         stroke="#E2E8F0"
//       />
//       <path
//         d="M22.0714 8H10.9286C9.86486 8 9 8.8279 9 9.84615V11.5578C9 11.941 9.156 12.3019 9.43971 12.5727L13.8291 16.7745C14.0314 16.9682 14.1429 17.2258 14.1429 17.4999V23.3846C14.1429 23.6176 14.2809 23.831 14.4986 23.9352C14.5894 23.9787 14.688 24 14.7857 24C14.922 24 15.0583 23.9581 15.1714 23.8769L18.6 21.4154C18.7612 21.2989 18.8571 21.1167 18.8571 20.9231V17.5007C18.8571 17.2267 18.9686 16.969 19.1709 16.7753L23.5603 12.5735C23.844 12.3019 24 11.9418 24 11.5586V9.84696C24 8.82788 23.1351 8 22.0714 8ZM10.9286 9.23077H22.0714C22.4263 9.23077 22.7143 9.50646 22.7143 9.84615V11.2821H10.2857V9.84615C10.2857 9.50646 10.5737 9.23077 10.9286 9.23077ZM18.2623 15.9048C17.8166 16.3315 17.5714 16.8976 17.5714 17.5007V20.6154L15.4286 22.1538V17.5007C15.4286 16.8976 15.1834 16.3315 14.7377 15.9048L11.1943 12.5128H21.8049L18.2623 15.9048Z"
//         fill="#002C5A"
//       />
//     </svg>
//   );
// };

export const EnableDowloadIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
    >
      <path
        d="M24.0003 19.1042L24.0003 13.5364C24.0123 12.2511 23.4925 11.0137 22.5551 10.0958C21.6177 9.1779 20.3392 8.65456 19.0003 8.64062L16.0003 8.64062C15.7351 8.64062 15.4807 8.74176 15.2932 8.92179C15.1056 9.10182 15.0003 9.34599 15.0003 9.60059C15.0003 9.85519 15.1056 10.0994 15.2932 10.2794C15.4807 10.4594 15.7351 10.5605 16.0003 10.5605L19.0003 10.5606C19.8089 10.5742 20.5788 10.8952 21.1412 11.453C21.7037 12.0109 22.0126 12.7602 22.0003 13.5364L22.0003 19.1042C22.0126 19.8805 21.7037 20.6297 21.1412 21.1876C20.5788 21.7455 19.8089 22.0665 19.0003 22.0801L5.00028 22.0801C4.19168 22.0665 3.42173 21.7455 2.85932 21.1876C2.29691 20.6297 1.98798 19.8805 2.00028 19.1042L2.00028 13.5364C1.98798 12.7602 2.29691 12.0109 2.85932 11.453C3.42173 10.8952 4.19168 10.5742 5.00028 10.5605L8.00028 10.5605C8.2655 10.5605 8.51986 10.4594 8.70739 10.2794C8.89493 10.0994 9.00029 9.85518 9.00029 9.60059C9.00029 9.34599 8.89493 9.10182 8.70739 8.92179C8.51986 8.74176 8.2655 8.64062 8.00028 8.64062L5.00028 8.64062C3.66134 8.65456 2.38285 9.1779 1.44544 10.0958C0.50803 11.0137 -0.0117147 12.2511 0.000283972 13.5364L0.000283718 19.1042C-0.0117151 20.3896 0.50803 21.627 1.44544 22.5449C2.38285 23.4628 3.66134 23.9861 5.00028 24L19.0003 24C20.3392 23.9861 21.6177 23.4628 22.5551 22.5449C23.4925 21.627 24.0123 20.3896 24.0003 19.1042Z"
        fill="#02BF90"
      />
      <path
        d="M11.9882 14.1533C12.2534 14.1533 12.5078 14.0522 12.6953 13.8722C12.8828 13.6921 12.9882 13.448 12.9882 13.1934L12.9582 2.4533L17.2812 6.60321C17.3734 6.6949 17.4838 6.76803 17.6058 6.81834C17.7278 6.86865 17.859 6.89514 17.9918 6.89624C18.1246 6.89735 18.2563 6.87306 18.3792 6.82479C18.502 6.77653 18.6137 6.70525 18.7076 6.61511C18.8015 6.52498 18.8757 6.4178 18.926 6.29982C18.9763 6.18185 19.0016 6.05544 19.0005 5.92798C18.9993 5.80051 18.9717 5.67455 18.9193 5.55743C18.8669 5.44031 18.7907 5.33438 18.6952 5.24583L14.1092 0.843439C13.5466 0.303543 12.7837 0.000247441 11.9882 0.000247432C11.1927 0.000247423 10.4298 0.303543 9.8672 0.843439L5.2812 5.24391C5.09904 5.42496 4.99825 5.66745 5.00053 5.91915C5.0028 6.17085 5.10797 6.41162 5.29338 6.5896C5.47879 6.76759 5.7296 6.86854 5.9918 6.87073C6.254 6.87292 6.5066 6.77616 6.6952 6.60129L10.9582 2.50993L10.9882 13.1934C10.9882 13.448 11.0936 13.6921 11.2811 13.8722C11.4686 14.0522 11.723 14.1533 11.9882 14.1533Z"
        fill="#02BF90"
      />
    </svg>
  );
};
export const ScribedImageIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="41"
      viewBox="0 0 34 41"
      fill="none"
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M3.06203 30.056C2.6727 30.056 2.3207 29.9893 2.00603 29.856C1.6967 29.7227 1.45136 29.5307 1.27003 29.28C1.0887 29.0293 0.995365 28.7333 0.990031 28.392H2.19003C2.20603 28.6213 2.28603 28.8027 2.43003 28.936C2.57936 29.0693 2.78203 29.136 3.03803 29.136C3.29936 29.136 3.5047 29.0747 3.65403 28.952C3.80336 28.824 3.87803 28.6587 3.87803 28.456C3.87803 28.2907 3.82736 28.1547 3.72603 28.048C3.6247 27.9413 3.4967 27.8587 3.34203 27.8C3.1927 27.736 2.9847 27.6667 2.71803 27.592C2.35536 27.4853 2.05936 27.3813 1.83003 27.28C1.60603 27.1733 1.41136 27.016 1.24603 26.808C1.08603 26.5947 1.00603 26.312 1.00603 25.96C1.00603 25.6293 1.0887 25.3413 1.25403 25.096C1.41936 24.8507 1.65136 24.664 1.95003 24.536C2.2487 24.4027 2.59003 24.336 2.97403 24.336C3.55003 24.336 4.0167 24.4773 4.37403 24.76C4.7367 25.0373 4.9367 25.4267 4.97403 25.928H3.74203C3.73136 25.736 3.6487 25.5787 3.49403 25.456C3.3447 25.328 3.1447 25.264 2.89403 25.264C2.67536 25.264 2.49936 25.32 2.36603 25.432C2.23803 25.544 2.17403 25.7067 2.17403 25.92C2.17403 26.0693 2.22203 26.1947 2.31803 26.296C2.41936 26.392 2.54203 26.472 2.68603 26.536C2.83536 26.5947 3.04336 26.664 3.31003 26.744C3.6727 26.8507 3.9687 26.9573 4.19803 27.064C4.42736 27.1707 4.6247 27.3307 4.79003 27.544C4.95536 27.7573 5.03803 28.0373 5.03803 28.384C5.03803 28.6827 4.9607 28.96 4.80603 29.216C4.65136 29.472 4.4247 29.6773 4.12603 29.832C3.82736 29.9813 3.4727 30.056 3.06203 30.056ZM5.72103 27.784C5.72103 27.3253 5.81436 26.9253 6.00103 26.584C6.1877 26.2373 6.44636 25.9707 6.77703 25.784C7.1077 25.592 7.48636 25.496 7.91303 25.496C8.46236 25.496 8.9157 25.6347 9.27303 25.912C9.6357 26.184 9.87836 26.568 10.001 27.064H8.79303C8.72903 26.872 8.6197 26.7227 8.46503 26.616C8.3157 26.504 8.12903 26.448 7.90503 26.448C7.58503 26.448 7.3317 26.5653 7.14503 26.8C6.95836 27.0293 6.86503 27.3573 6.86503 27.784C6.86503 28.2053 6.95836 28.5333 7.14503 28.768C7.3317 28.9973 7.58503 29.112 7.90503 29.112C8.35836 29.112 8.65436 28.9093 8.79303 28.504H10.001C9.87836 28.984 9.6357 29.3653 9.27303 29.648C8.91036 29.9307 8.45703 30.072 7.91303 30.072C7.48636 30.072 7.1077 29.9787 6.77703 29.792C6.44636 29.6 6.1877 29.3333 6.00103 28.992C5.81436 28.6453 5.72103 28.2427 5.72103 27.784ZM11.9415 26.256C12.0855 26.0213 12.2722 25.8373 12.5015 25.704C12.7362 25.5707 13.0029 25.504 13.3015 25.504V26.68H13.0055C12.6535 26.68 12.3869 26.7627 12.2055 26.928C12.0295 27.0933 11.9415 27.3813 11.9415 27.792V30H10.8215V25.568H11.9415V26.256ZM14.6239 25.04C14.4266 25.04 14.2612 24.9787 14.1279 24.856C13.9999 24.728 13.9359 24.5707 13.9359 24.384C13.9359 24.1973 13.9999 24.0427 14.1279 23.92C14.2612 23.792 14.4266 23.728 14.6239 23.728C14.8212 23.728 14.9839 23.792 15.1119 23.92C15.2452 24.0427 15.3119 24.1973 15.3119 24.384C15.3119 24.5707 15.2452 24.728 15.1119 24.856C14.9839 24.9787 14.8212 25.04 14.6239 25.04ZM15.1759 25.568V30H14.0559V25.568H15.1759ZM17.4025 26.216C17.5465 26.0027 17.7438 25.8293 17.9945 25.696C18.2505 25.5627 18.5411 25.496 18.8665 25.496C19.2451 25.496 19.5865 25.5893 19.8905 25.776C20.1998 25.9627 20.4425 26.2293 20.6185 26.576C20.7998 26.9173 20.8905 27.3147 20.8905 27.768C20.8905 28.2213 20.7998 28.624 20.6185 28.976C20.4425 29.3227 20.1998 29.592 19.8905 29.784C19.5865 29.976 19.2451 30.072 18.8665 30.072C18.5358 30.072 18.2451 30.008 17.9945 29.88C17.7491 29.7467 17.5518 29.576 17.4025 29.368V30H16.2825V24.08H17.4025V26.216ZM19.7465 27.768C19.7465 27.5013 19.6905 27.272 19.5785 27.08C19.4718 26.8827 19.3278 26.7333 19.1465 26.632C18.9705 26.5307 18.7785 26.48 18.5705 26.48C18.3678 26.48 18.1758 26.5333 17.9945 26.64C17.8185 26.7413 17.6745 26.8907 17.5625 27.088C17.4558 27.2853 17.4025 27.5173 17.4025 27.784C17.4025 28.0507 17.4558 28.2827 17.5625 28.48C17.6745 28.6773 17.8185 28.8293 17.9945 28.936C18.1758 29.0373 18.3678 29.088 18.5705 29.088C18.7785 29.088 18.9705 29.0347 19.1465 28.928C19.3278 28.8213 19.4718 28.6693 19.5785 28.472C19.6905 28.2747 19.7465 28.04 19.7465 27.768ZM25.8243 27.688C25.8243 27.848 25.8137 27.992 25.7923 28.12H22.5523C22.579 28.44 22.691 28.6907 22.8883 28.872C23.0857 29.0533 23.3283 29.144 23.6163 29.144C24.0323 29.144 24.3283 28.9653 24.5043 28.608H25.7123C25.5843 29.0347 25.339 29.3867 24.9763 29.664C24.6137 29.936 24.1683 30.072 23.6403 30.072C23.2137 30.072 22.8297 29.9787 22.4883 29.792C22.1523 29.6 21.8883 29.3307 21.6963 28.984C21.5097 28.6373 21.4163 28.2373 21.4163 27.784C21.4163 27.3253 21.5097 26.9227 21.6963 26.576C21.883 26.2293 22.1443 25.9627 22.4803 25.776C22.8163 25.5893 23.203 25.496 23.6403 25.496C24.0617 25.496 24.4377 25.5867 24.7683 25.768C25.1043 25.9493 25.363 26.208 25.5443 26.544C25.731 26.8747 25.8243 27.256 25.8243 27.688ZM24.6643 27.368C24.659 27.08 24.555 26.8507 24.3523 26.68C24.1497 26.504 23.9017 26.416 23.6083 26.416C23.331 26.416 23.0963 26.5013 22.9043 26.672C22.7177 26.8373 22.603 27.0693 22.5603 27.368H24.6643ZM26.3538 27.768C26.3538 27.32 26.4418 26.9227 26.6178 26.576C26.7992 26.2293 27.0445 25.9627 27.3538 25.776C27.6632 25.5893 28.0072 25.496 28.3858 25.496C28.6738 25.496 28.9485 25.56 29.2098 25.688C29.4712 25.8107 29.6792 25.976 29.8338 26.184V24.08H30.9698V30H29.8338V29.344C29.6952 29.5627 29.5005 29.7387 29.2498 29.872C28.9992 30.0053 28.7085 30.072 28.3778 30.072C28.0045 30.072 27.6632 29.976 27.3538 29.784C27.0445 29.592 26.7992 29.3227 26.6178 28.976C26.4418 28.624 26.3538 28.2213 26.3538 27.768ZM29.8418 27.784C29.8418 27.512 29.7885 27.28 29.6818 27.088C29.5752 26.8907 29.4312 26.7413 29.2498 26.64C29.0685 26.5333 28.8738 26.48 28.6658 26.48C28.4578 26.48 28.2658 26.5307 28.0898 26.632C27.9138 26.7333 27.7698 26.8827 27.6578 27.08C27.5512 27.272 27.4978 27.5013 27.4978 27.768C27.4978 28.0347 27.5512 28.2693 27.6578 28.472C27.7698 28.6693 27.9138 28.8213 28.0898 28.928C28.2712 29.0347 28.4632 29.088 28.6658 29.088C28.8738 29.088 29.0685 29.0373 29.2498 28.936C29.4312 28.8293 29.5752 28.68 29.6818 28.488C29.7885 28.2907 29.8418 28.056 29.8418 27.784ZM5.47669 32.416V38H4.35669V32.416H5.47669ZM12.0873 33.504C12.6313 33.504 13.0686 33.672 13.3993 34.008C13.7353 34.3387 13.9033 34.8027 13.9033 35.4V38H12.7833V35.552C12.7833 35.2053 12.6953 34.9413 12.5193 34.76C12.3433 34.5733 12.1033 34.48 11.7993 34.48C11.4953 34.48 11.2526 34.5733 11.0713 34.76C10.8953 34.9413 10.8073 35.2053 10.8073 35.552V38H9.68725V35.552C9.68725 35.2053 9.59925 34.9413 9.42325 34.76C9.24725 34.5733 9.00725 34.48 8.70325 34.48C8.39392 34.48 8.14858 34.5733 7.96725 34.76C7.79125 34.9413 7.70325 35.2053 7.70325 35.552V38H6.58325V33.568H7.70325V34.104C7.84725 33.9173 8.03125 33.7707 8.25525 33.664C8.48458 33.5573 8.73525 33.504 9.00725 33.504C9.35392 33.504 9.66325 33.5787 9.93525 33.728C10.2073 33.872 10.4179 34.08 10.5673 34.352C10.7113 34.096 10.9193 33.8907 11.1913 33.736C11.4686 33.5813 11.7673 33.504 12.0873 33.504ZM14.6781 35.768C14.6781 35.32 14.7661 34.9227 14.9421 34.576C15.1234 34.2293 15.3661 33.9627 15.6701 33.776C15.9794 33.5893 16.3234 33.496 16.7021 33.496C17.0327 33.496 17.3207 33.5627 17.5661 33.696C17.8167 33.8293 18.0167 33.9973 18.1661 34.2V33.568H19.2941V38H18.1661V37.352C18.0221 37.56 17.8221 37.7333 17.5661 37.872C17.3154 38.0053 17.0247 38.072 16.6941 38.072C16.3207 38.072 15.9794 37.976 15.6701 37.784C15.3661 37.592 15.1234 37.3227 14.9421 36.976C14.7661 36.624 14.6781 36.2213 14.6781 35.768ZM18.1661 35.784C18.1661 35.512 18.1127 35.28 18.0061 35.088C17.8994 34.8907 17.7554 34.7413 17.5741 34.64C17.3927 34.5333 17.1981 34.48 16.9901 34.48C16.7821 34.48 16.5901 34.5307 16.4141 34.632C16.2381 34.7333 16.0941 34.8827 15.9821 35.08C15.8754 35.272 15.8221 35.5013 15.8221 35.768C15.8221 36.0347 15.8754 36.2693 15.9821 36.472C16.0941 36.6693 16.2381 36.8213 16.4141 36.928C16.5954 37.0347 16.7874 37.088 16.9901 37.088C17.1981 37.088 17.3927 37.0373 17.5741 36.936C17.7554 36.8293 17.8994 36.68 18.0061 36.488C18.1127 36.2907 18.1661 36.056 18.1661 35.784ZM22.1239 33.496C22.4546 33.496 22.7453 33.5627 22.9959 33.696C23.2466 33.824 23.4439 33.992 23.5879 34.2V33.568H24.7159V38.032C24.7159 38.4427 24.6333 38.808 24.4679 39.128C24.3026 39.4533 24.0546 39.7093 23.7239 39.896C23.3933 40.088 22.9933 40.184 22.5239 40.184C21.8946 40.184 21.3773 40.0373 20.9719 39.744C20.5719 39.4507 20.3453 39.0507 20.2919 38.544H21.4039C21.4626 38.7467 21.5879 38.9067 21.7799 39.024C21.9773 39.1467 22.2146 39.208 22.4919 39.208C22.8173 39.208 23.0813 39.1093 23.2839 38.912C23.4866 38.72 23.5879 38.4267 23.5879 38.032V37.344C23.4439 37.552 23.2439 37.7253 22.9879 37.864C22.7373 38.0027 22.4493 38.072 22.1239 38.072C21.7506 38.072 21.4093 37.976 21.0999 37.784C20.7906 37.592 20.5453 37.3227 20.3639 36.976C20.1879 36.624 20.0999 36.2213 20.0999 35.768C20.0999 35.32 20.1879 34.9227 20.3639 34.576C20.5453 34.2293 20.7879 33.9627 21.0919 33.776C21.4013 33.5893 21.7453 33.496 22.1239 33.496ZM23.5879 35.784C23.5879 35.512 23.5346 35.28 23.4279 35.088C23.3213 34.8907 23.1773 34.7413 22.9959 34.64C22.8146 34.5333 22.6199 34.48 22.4119 34.48C22.2039 34.48 22.0119 34.5307 21.8359 34.632C21.6599 34.7333 21.5159 34.8827 21.4039 35.08C21.2973 35.272 21.2439 35.5013 21.2439 35.768C21.2439 36.0347 21.2973 36.2693 21.4039 36.472C21.5159 36.6693 21.6599 36.8213 21.8359 36.928C22.0173 37.0347 22.2093 37.088 22.4119 37.088C22.6199 37.088 22.8146 37.0373 22.9959 36.936C23.1773 36.8293 23.3213 36.68 23.4279 36.488C23.5346 36.2907 23.5879 36.056 23.5879 35.784ZM29.9298 35.688C29.9298 35.848 29.9191 35.992 29.8978 36.12H26.6578C26.6845 36.44 26.7965 36.6907 26.9938 36.872C27.1911 37.0533 27.4338 37.144 27.7218 37.144C28.1378 37.144 28.4338 36.9653 28.6098 36.608H29.8178C29.6898 37.0347 29.4445 37.3867 29.0818 37.664C28.7191 37.936 28.2738 38.072 27.7458 38.072C27.3191 38.072 26.9351 37.9787 26.5938 37.792C26.2578 37.6 25.9938 37.3307 25.8018 36.984C25.6151 36.6373 25.5218 36.2373 25.5218 35.784C25.5218 35.3253 25.6151 34.9227 25.8018 34.576C25.9885 34.2293 26.2498 33.9627 26.5858 33.776C26.9218 33.5893 27.3085 33.496 27.7458 33.496C28.1671 33.496 28.5431 33.5867 28.8738 33.768C29.2098 33.9493 29.4685 34.208 29.6498 34.544C29.8365 34.8747 29.9298 35.256 29.9298 35.688ZM28.7698 35.368C28.7645 35.08 28.6605 34.8507 28.4578 34.68C28.2551 34.504 28.0071 34.416 27.7138 34.416C27.4365 34.416 27.2018 34.5013 27.0098 34.672C26.8231 34.8373 26.7085 35.0693 26.6658 35.368H28.7698Z"
        fill="#BBBBBB"
      />
      <g clipPath="url(#clip0_30269_19503)">
        <path
          d="M25.2143 7.92857C24.1429 6.85714 22.4286 6.85714 21.3571 7.92857L14.0714 15.2143C14 15.2857 13.9286 15.4286 13.8571 15.5714L13.1429 19.1429C13.0714 19.3571 13.1429 19.6429 13.3571 19.7857C13.5 19.9286 13.7857 20 14 20L17.5714 19.2857C17.7143 19.2857 17.8571 19.2143 17.9286 19.0714L25.2143 11.7857C26.2857 10.7143 26.2857 9 25.2143 7.92857ZM17.0714 17.9286L14.7857 18.3571L15.2143 16.0714L21 10.2857L22.8571 12.1429L17.0714 17.9286ZM24.2143 10.7857L23.8571 11.1429L22 9.28571L22.3571 8.92857C22.8571 8.42857 23.7143 8.42857 24.2143 8.92857C24.7143 9.42857 24.7143 10.2857 24.2143 10.7857Z"
          fill="#BBBBBB"
        />
        <path
          d="M17.6429 9.07143C17.9286 9.35714 18.3571 9.35714 18.6429 9.07143C18.9286 8.78571 18.9286 8.35714 18.6429 8.07143L17.2143 6.64286C16.9286 6.35714 16.5 6.35714 16.2143 6.64286L12.4286 10.4286L10.7857 8.78572C10.5 8.5 10.0714 8.5 9.78571 8.78572L7.42857 11.1429V2.14286C7.42857 1.71429 7.71429 1.42857 8.14286 1.42857H21C21.4286 1.42857 21.7143 1.71429 21.7143 2.14286V5C21.7143 5.42857 22 5.71429 22.4286 5.71429C22.8571 5.71429 23.1429 5.42857 23.1429 5V2.14286C23.1429 0.928571 22.2143 0 21 0H8.14286C6.92857 0 6 0.928571 6 2.14286V15C6 16.2143 6.92857 17.1429 8.14286 17.1429H11.7143C12.1429 17.1429 12.4286 16.8571 12.4286 16.4286C12.4286 16 12.1429 15.7143 11.7143 15.7143H8.14286C7.71429 15.7143 7.42857 15.4286 7.42857 15V13.1429L10.2857 10.2857L11.9286 11.9286C12.2143 12.2143 12.6429 12.2143 12.9286 11.9286L16.7143 8.14286L17.6429 9.07143Z"
          fill="#BBBBBB"
        />
        <path
          d="M10.2857 5C10.2857 6.21429 11.2143 7.14286 12.4286 7.14286C13.6429 7.14286 14.5714 6.21429 14.5714 5C14.5714 3.78571 13.6429 2.85714 12.4286 2.85714C11.2143 2.85714 10.2857 3.78571 10.2857 5ZM13.1429 5C13.1429 5.42857 12.8571 5.71429 12.4286 5.71429C12 5.71429 11.7143 5.42857 11.7143 5C11.7143 4.57143 12 4.28571 12.4286 4.28571C12.8571 4.28571 13.1429 4.57143 13.1429 5Z"
          fill="#BBBBBB"
        />
      </g>
      <defs>
        <clipPath id="clip0_30269_19503">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(6.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ScribedNoteIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="39"
      viewBox="0 0 34 39"
      fill="none"
      className={customClass}
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M3.06203 30.056C2.6727 30.056 2.3207 29.9893 2.00603 29.856C1.6967 29.7227 1.45136 29.5307 1.27003 29.28C1.0887 29.0293 0.995365 28.7333 0.990031 28.392H2.19003C2.20603 28.6213 2.28603 28.8027 2.43003 28.936C2.57936 29.0693 2.78203 29.136 3.03803 29.136C3.29936 29.136 3.5047 29.0747 3.65403 28.952C3.80336 28.824 3.87803 28.6587 3.87803 28.456C3.87803 28.2907 3.82736 28.1547 3.72603 28.048C3.6247 27.9413 3.4967 27.8587 3.34203 27.8C3.1927 27.736 2.9847 27.6667 2.71803 27.592C2.35536 27.4853 2.05936 27.3813 1.83003 27.28C1.60603 27.1733 1.41136 27.016 1.24603 26.808C1.08603 26.5947 1.00603 26.312 1.00603 25.96C1.00603 25.6293 1.0887 25.3413 1.25403 25.096C1.41936 24.8507 1.65136 24.664 1.95003 24.536C2.2487 24.4027 2.59003 24.336 2.97403 24.336C3.55003 24.336 4.0167 24.4773 4.37403 24.76C4.7367 25.0373 4.9367 25.4267 4.97403 25.928H3.74203C3.73136 25.736 3.6487 25.5787 3.49403 25.456C3.3447 25.328 3.1447 25.264 2.89403 25.264C2.67536 25.264 2.49936 25.32 2.36603 25.432C2.23803 25.544 2.17403 25.7067 2.17403 25.92C2.17403 26.0693 2.22203 26.1947 2.31803 26.296C2.41936 26.392 2.54203 26.472 2.68603 26.536C2.83536 26.5947 3.04336 26.664 3.31003 26.744C3.6727 26.8507 3.9687 26.9573 4.19803 27.064C4.42736 27.1707 4.6247 27.3307 4.79003 27.544C4.95536 27.7573 5.03803 28.0373 5.03803 28.384C5.03803 28.6827 4.9607 28.96 4.80603 29.216C4.65136 29.472 4.4247 29.6773 4.12603 29.832C3.82736 29.9813 3.4727 30.056 3.06203 30.056ZM5.72103 27.784C5.72103 27.3253 5.81436 26.9253 6.00103 26.584C6.1877 26.2373 6.44636 25.9707 6.77703 25.784C7.1077 25.592 7.48636 25.496 7.91303 25.496C8.46236 25.496 8.9157 25.6347 9.27303 25.912C9.6357 26.184 9.87836 26.568 10.001 27.064H8.79303C8.72903 26.872 8.6197 26.7227 8.46503 26.616C8.3157 26.504 8.12903 26.448 7.90503 26.448C7.58503 26.448 7.3317 26.5653 7.14503 26.8C6.95836 27.0293 6.86503 27.3573 6.86503 27.784C6.86503 28.2053 6.95836 28.5333 7.14503 28.768C7.3317 28.9973 7.58503 29.112 7.90503 29.112C8.35836 29.112 8.65436 28.9093 8.79303 28.504H10.001C9.87836 28.984 9.6357 29.3653 9.27303 29.648C8.91036 29.9307 8.45703 30.072 7.91303 30.072C7.48636 30.072 7.1077 29.9787 6.77703 29.792C6.44636 29.6 6.1877 29.3333 6.00103 28.992C5.81436 28.6453 5.72103 28.2427 5.72103 27.784ZM11.9415 26.256C12.0855 26.0213 12.2722 25.8373 12.5015 25.704C12.7362 25.5707 13.0029 25.504 13.3015 25.504V26.68H13.0055C12.6535 26.68 12.3869 26.7627 12.2055 26.928C12.0295 27.0933 11.9415 27.3813 11.9415 27.792V30H10.8215V25.568H11.9415V26.256ZM14.6239 25.04C14.4266 25.04 14.2612 24.9787 14.1279 24.856C13.9999 24.728 13.9359 24.5707 13.9359 24.384C13.9359 24.1973 13.9999 24.0427 14.1279 23.92C14.2612 23.792 14.4266 23.728 14.6239 23.728C14.8212 23.728 14.9839 23.792 15.1119 23.92C15.2452 24.0427 15.3119 24.1973 15.3119 24.384C15.3119 24.5707 15.2452 24.728 15.1119 24.856C14.9839 24.9787 14.8212 25.04 14.6239 25.04ZM15.1759 25.568V30H14.0559V25.568H15.1759ZM17.4025 26.216C17.5465 26.0027 17.7438 25.8293 17.9945 25.696C18.2505 25.5627 18.5411 25.496 18.8665 25.496C19.2451 25.496 19.5865 25.5893 19.8905 25.776C20.1998 25.9627 20.4425 26.2293 20.6185 26.576C20.7998 26.9173 20.8905 27.3147 20.8905 27.768C20.8905 28.2213 20.7998 28.624 20.6185 28.976C20.4425 29.3227 20.1998 29.592 19.8905 29.784C19.5865 29.976 19.2451 30.072 18.8665 30.072C18.5358 30.072 18.2451 30.008 17.9945 29.88C17.7491 29.7467 17.5518 29.576 17.4025 29.368V30H16.2825V24.08H17.4025V26.216ZM19.7465 27.768C19.7465 27.5013 19.6905 27.272 19.5785 27.08C19.4718 26.8827 19.3278 26.7333 19.1465 26.632C18.9705 26.5307 18.7785 26.48 18.5705 26.48C18.3678 26.48 18.1758 26.5333 17.9945 26.64C17.8185 26.7413 17.6745 26.8907 17.5625 27.088C17.4558 27.2853 17.4025 27.5173 17.4025 27.784C17.4025 28.0507 17.4558 28.2827 17.5625 28.48C17.6745 28.6773 17.8185 28.8293 17.9945 28.936C18.1758 29.0373 18.3678 29.088 18.5705 29.088C18.7785 29.088 18.9705 29.0347 19.1465 28.928C19.3278 28.8213 19.4718 28.6693 19.5785 28.472C19.6905 28.2747 19.7465 28.04 19.7465 27.768ZM25.8243 27.688C25.8243 27.848 25.8137 27.992 25.7923 28.12H22.5523C22.579 28.44 22.691 28.6907 22.8883 28.872C23.0857 29.0533 23.3283 29.144 23.6163 29.144C24.0323 29.144 24.3283 28.9653 24.5043 28.608H25.7123C25.5843 29.0347 25.339 29.3867 24.9763 29.664C24.6137 29.936 24.1683 30.072 23.6403 30.072C23.2137 30.072 22.8297 29.9787 22.4883 29.792C22.1523 29.6 21.8883 29.3307 21.6963 28.984C21.5097 28.6373 21.4163 28.2373 21.4163 27.784C21.4163 27.3253 21.5097 26.9227 21.6963 26.576C21.883 26.2293 22.1443 25.9627 22.4803 25.776C22.8163 25.5893 23.203 25.496 23.6403 25.496C24.0617 25.496 24.4377 25.5867 24.7683 25.768C25.1043 25.9493 25.363 26.208 25.5443 26.544C25.731 26.8747 25.8243 27.256 25.8243 27.688ZM24.6643 27.368C24.659 27.08 24.555 26.8507 24.3523 26.68C24.1497 26.504 23.9017 26.416 23.6083 26.416C23.331 26.416 23.0963 26.5013 22.9043 26.672C22.7177 26.8373 22.603 27.0693 22.5603 27.368H24.6643ZM26.3538 27.768C26.3538 27.32 26.4418 26.9227 26.6178 26.576C26.7992 26.2293 27.0445 25.9627 27.3538 25.776C27.6632 25.5893 28.0072 25.496 28.3858 25.496C28.6738 25.496 28.9485 25.56 29.2098 25.688C29.4712 25.8107 29.6792 25.976 29.8338 26.184V24.08H30.9698V30H29.8338V29.344C29.6952 29.5627 29.5005 29.7387 29.2498 29.872C28.9992 30.0053 28.7085 30.072 28.3778 30.072C28.0045 30.072 27.6632 29.976 27.3538 29.784C27.0445 29.592 26.7992 29.3227 26.6178 28.976C26.4418 28.624 26.3538 28.2213 26.3538 27.768ZM29.8418 27.784C29.8418 27.512 29.7885 27.28 29.6818 27.088C29.5752 26.8907 29.4312 26.7413 29.2498 26.64C29.0685 26.5333 28.8738 26.48 28.6658 26.48C28.4578 26.48 28.2658 26.5307 28.0898 26.632C27.9138 26.7333 27.7698 26.8827 27.6578 27.08C27.5512 27.272 27.4978 27.5013 27.4978 27.768C27.4978 28.0347 27.5512 28.2693 27.6578 28.472C27.7698 28.6693 27.9138 28.8213 28.0898 28.928C28.2712 29.0347 28.4632 29.088 28.6658 29.088C28.8738 29.088 29.0685 29.0373 29.2498 28.936C29.4312 28.8293 29.5752 28.68 29.6818 28.488C29.7885 28.2907 29.8418 28.056 29.8418 27.784ZM10.6366 38H9.51659L6.98059 34.168V38H5.86059V32.408H6.98059L9.51659 36.248V32.408H10.6366V38ZM13.7114 38.072C13.2847 38.072 12.9007 37.9787 12.5594 37.792C12.2181 37.6 11.9487 37.3307 11.7514 36.984C11.5594 36.6373 11.4634 36.2373 11.4634 35.784C11.4634 35.3307 11.5621 34.9307 11.7594 34.584C11.9621 34.2373 12.2367 33.9707 12.5834 33.784C12.9301 33.592 13.3167 33.496 13.7434 33.496C14.1701 33.496 14.5567 33.592 14.9034 33.784C15.2501 33.9707 15.5221 34.2373 15.7194 34.584C15.9221 34.9307 16.0234 35.3307 16.0234 35.784C16.0234 36.2373 15.9194 36.6373 15.7114 36.984C15.5087 37.3307 15.2314 37.6 14.8794 37.792C14.5327 37.9787 14.1434 38.072 13.7114 38.072ZM13.7114 37.096C13.9141 37.096 14.1034 37.048 14.2794 36.952C14.4607 36.8507 14.6047 36.7013 14.7114 36.504C14.8181 36.3067 14.8714 36.0667 14.8714 35.784C14.8714 35.3627 14.7594 35.04 14.5354 34.816C14.3167 34.5867 14.0474 34.472 13.7274 34.472C13.4074 34.472 13.1381 34.5867 12.9194 34.816C12.7061 35.04 12.5994 35.3627 12.5994 35.784C12.5994 36.2053 12.7034 36.5307 12.9114 36.76C13.1247 36.984 13.3914 37.096 13.7114 37.096ZM18.149 34.488V36.632C18.149 36.7813 18.1836 36.8907 18.253 36.96C18.3276 37.024 18.4503 37.056 18.621 37.056H19.141V38H18.437C17.493 38 17.021 37.5413 17.021 36.624V34.488H16.493V33.568H17.021V32.472H18.149V33.568H19.141V34.488H18.149ZM24.0665 35.688C24.0665 35.848 24.0559 35.992 24.0345 36.12H20.7945C20.8212 36.44 20.9332 36.6907 21.1305 36.872C21.3279 37.0533 21.5705 37.144 21.8585 37.144C22.2745 37.144 22.5705 36.9653 22.7465 36.608H23.9545C23.8265 37.0347 23.5812 37.3867 23.2185 37.664C22.8559 37.936 22.4105 38.072 21.8825 38.072C21.4559 38.072 21.0719 37.9787 20.7305 37.792C20.3945 37.6 20.1305 37.3307 19.9385 36.984C19.7519 36.6373 19.6585 36.2373 19.6585 35.784C19.6585 35.3253 19.7519 34.9227 19.9385 34.576C20.1252 34.2293 20.3865 33.9627 20.7225 33.776C21.0585 33.5893 21.4452 33.496 21.8825 33.496C22.3039 33.496 22.6799 33.5867 23.0105 33.768C23.3465 33.9493 23.6052 34.208 23.7865 34.544C23.9732 34.8747 24.0665 35.256 24.0665 35.688ZM22.9065 35.368C22.9012 35.08 22.7972 34.8507 22.5945 34.68C22.3919 34.504 22.1439 34.416 21.8505 34.416C21.5732 34.416 21.3385 34.5013 21.1465 34.672C20.9599 34.8373 20.8452 35.0693 20.8025 35.368H22.9065ZM26.58 38.072C26.2174 38.072 25.892 38.008 25.604 37.88C25.316 37.7467 25.0867 37.568 24.916 37.344C24.7507 37.12 24.66 36.872 24.644 36.6H25.772C25.7934 36.7707 25.876 36.912 26.02 37.024C26.1694 37.136 26.3534 37.192 26.572 37.192C26.7854 37.192 26.9507 37.1493 27.068 37.064C27.1907 36.9787 27.252 36.8693 27.252 36.736C27.252 36.592 27.1774 36.4853 27.028 36.416C26.884 36.3413 26.652 36.2613 26.332 36.176C26.0014 36.096 25.7294 36.0133 25.516 35.928C25.308 35.8427 25.1267 35.712 24.972 35.536C24.8227 35.36 24.748 35.1227 24.748 34.824C24.748 34.5787 24.8174 34.3547 24.956 34.152C25.1 33.9493 25.3027 33.7893 25.564 33.672C25.8307 33.5547 26.1427 33.496 26.5 33.496C27.028 33.496 27.4494 33.6293 27.764 33.896C28.0787 34.1573 28.252 34.512 28.284 34.96H27.212C27.196 34.784 27.1214 34.6453 26.988 34.544C26.86 34.4373 26.6867 34.384 26.468 34.384C26.2654 34.384 26.108 34.4213 25.996 34.496C25.8894 34.5707 25.836 34.6747 25.836 34.808C25.836 34.9573 25.9107 35.072 26.06 35.152C26.2094 35.2267 26.4414 35.304 26.756 35.384C27.076 35.464 27.34 35.5467 27.548 35.632C27.756 35.7173 27.9347 35.8507 28.084 36.032C28.2387 36.208 28.3187 36.4427 28.324 36.736C28.324 36.992 28.252 37.2213 28.108 37.424C27.9694 37.6267 27.7667 37.7867 27.5 37.904C27.2387 38.016 26.932 38.072 26.58 38.072Z"
        fill="#BBBBBB"
      />
      <path
        d="M21.0088 14.5703H18.7041C18.2726 14.5703 17.9229 14.9201 17.9229 15.3516C17.9229 15.783 18.2726 16.1328 18.7041 16.1328H21.0088C21.4403 16.1328 21.79 15.783 21.79 15.3516C21.79 14.9201 21.4403 14.5703 21.0088 14.5703Z"
        fill="#BBBBBB"
      />
      <path
        d="M21.0088 9.84375H18.7041C18.2726 9.84375 17.9229 10.1935 17.9229 10.625C17.9229 11.0565 18.2726 11.4062 18.7041 11.4062H21.0088C21.4403 11.4062 21.79 11.0565 21.79 10.625C21.79 10.1935 21.4403 9.84375 21.0088 9.84375Z"
        fill="#BBBBBB"
      />
      <path
        d="M24.1295 13.75C24.5609 13.75 24.9107 13.4002 24.9107 12.9688V3.125C24.9107 1.40188 23.5088 0 21.7857 0H12.1807C10.4575 0 9.05566 1.40188 9.05566 3.125V16.875C9.05566 18.5981 10.4575 20 12.1807 20H21.7857C23.5088 20 24.9107 18.5981 24.9107 16.875C24.9107 16.4435 24.5609 16.0938 24.1295 16.0938C23.698 16.0938 23.3482 16.4435 23.3482 16.875C23.3482 17.7366 22.6473 18.4375 21.7857 18.4375H12.1807C11.3191 18.4375 10.6182 17.7366 10.6182 16.875V3.125C10.6182 2.26344 11.3191 1.5625 12.1807 1.5625H21.7857C22.6473 1.5625 23.3482 2.26344 23.3482 3.125V12.9688C23.3482 13.4002 23.698 13.75 24.1295 13.75Z"
        fill="#BBBBBB"
      />
      <path
        d="M16.9751 3.10866C16.6425 2.83389 16.1501 2.88069 15.8753 3.21335L14.1876 5.25604L13.5216 4.57218C13.2207 4.26307 12.726 4.25647 12.4169 4.55749C12.1078 4.8585 12.1012 5.35311 12.4022 5.66225L13.2402 6.52292C13.2471 6.53003 13.2542 6.53698 13.2614 6.54382C13.5146 6.78487 13.8526 6.91893 14.2003 6.91893C14.2302 6.91886 14.2602 6.91788 14.2902 6.91585C14.6669 6.89073 15.0188 6.70839 15.2566 6.4153L17.0798 4.20854C17.3546 3.87589 17.3078 3.38346 16.9751 3.10866Z"
        fill="#BBBBBB"
      />
      <path
        d="M16.9751 12.6351C16.6425 12.3603 16.1501 12.4072 15.8753 12.7398L14.1871 14.783L13.5201 14.1018C13.2182 13.7936 12.7236 13.7884 12.4153 14.0903C12.107 14.3922 12.1019 14.8868 12.4037 15.1951L13.2417 16.0509C13.2482 16.0574 13.2547 16.0639 13.2613 16.0702C13.5146 16.3113 13.8526 16.4454 14.2003 16.4454C14.2302 16.4453 14.2602 16.4443 14.2902 16.4423C14.6669 16.4172 15.0187 16.2349 15.2566 15.9418L17.0798 13.735C17.3546 13.4023 17.3078 12.9099 16.9751 12.6351Z"
        fill="#BBBBBB"
      />
      <path
        d="M21.0088 5.03906H18.7041C18.2726 5.03906 17.9229 5.38883 17.9229 5.82031C17.9229 6.2518 18.2726 6.60156 18.7041 6.60156H21.0088C21.4403 6.60156 21.79 6.2518 21.79 5.82031C21.79 5.38883 21.4403 5.03906 21.0088 5.03906Z"
        fill="#BBBBBB"
      />
      <path
        d="M16.9751 7.90854C16.6425 7.63374 16.1501 7.68061 15.8753 8.01323L14.1871 10.0565L13.5201 9.3753C13.2182 9.06702 12.7236 9.06186 12.4153 9.36374C12.107 9.66562 12.1019 10.1603 12.4037 10.4685L13.2417 11.3244C13.2482 11.3309 13.2547 11.3373 13.2613 11.3437C13.5146 11.5847 13.8526 11.7188 14.2003 11.7188C14.2302 11.7187 14.2602 11.7178 14.2902 11.7158C14.6669 11.6907 15.0187 11.5083 15.2566 11.2152L17.0798 9.00843C17.3546 8.67577 17.3078 8.18335 16.9751 7.90854Z"
        fill="#BBBBBB"
      />
    </svg>
  );
};
export const HamburgerIconOpen: React.FunctionComponent<ISvgComponent> = ({
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <g filter="url(#filter0_d_22332_22516)">
        <rect x="18" y="18" width="20" height="20" rx="4" fill="white" />
      </g>
      <path
        d="M22 23.625C22 23.2794 22.2912 23 22.65 23H31.1C31.4588 23 31.75 23.2794 31.75 23.625C31.75 23.9706 31.4588 24.25 31.1 24.25H22.65C22.2912 24.25 22 23.9706 22 23.625ZM34.35 27.375H22.65C22.2912 27.375 22 27.6544 22 28C22 28.3456 22.2912 28.625 22.65 28.625H34.35C34.7088 28.625 35 28.3456 35 28C35 27.6544 34.7088 27.375 34.35 27.375ZM28.5 31.75H22.65C22.2912 31.75 22 32.0294 22 32.375C22 32.7206 22.2912 33 22.65 33H28.5C28.8588 33 29.15 32.7206 29.15 32.375C29.15 32.0294 28.8588 31.75 28.5 31.75Z"
        fill="#100A26"
      />
      <defs>
        <filter
          id="filter0_d_22332_22516"
          x="0"
          y="0"
          width="60"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22332_22516"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22332_22516"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const ChatIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
    >
      <g filter="url(#filter0_d_29524_16936)">
        <circle cx="42" cy="42" r="25" fill="#5936F1" />
        <path
          d="M49.0631 34.9269C47.938 33.8013 46.5603 32.9609 45.0447 32.4756C43.529 31.9904 41.9194 31.8743 40.3498 32.1372C38.7751 32.3989 37.2861 33.0342 36.0075 33.99C34.729 34.9457 33.6982 36.194 33.0015 37.6303C32.3047 39.0665 31.9625 40.6488 32.0033 42.2446C32.0441 43.8403 32.4668 45.4031 33.236 46.8018C33.2574 46.8588 33.2574 46.9215 33.236 46.9785L32.2782 50.2797C32.2156 50.481 32.2093 50.6956 32.2602 50.9002C32.311 51.1048 32.4169 51.2916 32.5665 51.4402C32.7161 51.5888 32.9035 51.6935 33.1084 51.7431C33.3134 51.7926 33.528 51.785 33.7289 51.721L37.0114 50.7353C37.0716 50.7141 37.1373 50.7141 37.1974 50.7353C38.6632 51.5584 40.3147 51.9937 41.9957 52C42.7175 51.9985 43.4372 51.9237 44.1438 51.7768C45.8967 51.3907 47.5135 50.5401 48.8246 49.3142C50.1357 48.0884 51.093 46.5324 51.596 44.8094C52.099 43.0864 52.1293 41.2598 51.6836 39.5211C51.238 37.7823 50.3328 36.1955 49.0631 34.9269ZM38.2761 43.5843C38.0462 43.5843 37.8215 43.5162 37.6303 43.3884C37.4392 43.2607 37.2902 43.0792 37.2022 42.8668C37.1142 42.6544 37.0912 42.4207 37.1361 42.1952C37.1809 41.9697 37.2916 41.7626 37.4542 41.6C37.6167 41.4375 37.8239 41.3267 38.0493 41.2819C38.2748 41.237 38.5085 41.2601 38.7209 41.348C38.9333 41.436 39.1149 41.585 39.2426 41.7762C39.3703 41.9673 39.4385 42.192 39.4385 42.4219C39.4385 42.7302 39.316 43.0259 39.098 43.2439C38.8801 43.4619 38.5844 43.5843 38.2761 43.5843ZM41.9957 43.5843C41.7659 43.5843 41.5411 43.5162 41.35 43.3884C41.1588 43.2607 41.0098 43.0792 40.9218 42.8668C40.8339 42.6544 40.8108 42.4207 40.8557 42.1952C40.9005 41.9697 41.0113 41.7626 41.1738 41.6C41.3364 41.4375 41.5435 41.3267 41.769 41.2819C41.9945 41.237 42.2282 41.2601 42.4406 41.348C42.653 41.436 42.8345 41.585 42.9622 41.7762C43.09 41.9673 43.1581 42.192 43.1581 42.4219C43.1581 42.7302 43.0357 43.0259 42.8177 43.2439C42.5997 43.4619 42.304 43.5843 41.9957 43.5843ZM45.7154 43.5843C45.4855 43.5843 45.2607 43.5162 45.0696 43.3884C44.8784 43.2607 44.7295 43.0792 44.6415 42.8668C44.5535 42.6544 44.5305 42.4207 44.5753 42.1952C44.6202 41.9697 44.7309 41.7626 44.8935 41.6C45.056 41.4375 45.2631 41.3267 45.4886 41.2819C45.7141 41.237 45.9478 41.2601 46.1602 41.348C46.3726 41.436 46.5541 41.585 46.6819 41.7762C46.8096 41.9673 46.8778 42.192 46.8778 42.4219C46.8778 42.7302 46.7553 43.0259 46.5373 43.2439C46.3193 43.4619 46.0237 43.5843 45.7154 43.5843Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_29524_16936"
          x="0"
          y="0"
          width="90"
          height="90"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="3" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.185033 0 0 0 0 0.0818056 0 0 0 0 0.633333 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_29524_16936"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_29524_16936"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ChatCloseIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
    >
      <g filter="url(#filter0_d_29525_17359)">
        <circle cx="42" cy="42" r="25" fill="#5936F1" />
        <path
          d="M35.6026 50C35.3918 50.001 35.183 49.9599 34.9884 49.8791C34.7937 49.7983 34.6172 49.6794 34.4691 49.5295C34.1687 49.2287 34 48.821 34 48.396C34 47.9709 34.1687 47.5632 34.4691 47.2625L47.3011 34.4305C47.6052 34.1472 48.0073 33.9929 48.4229 34.0002C48.8384 34.0076 49.2349 34.1759 49.5288 34.4698C49.8226 34.7637 49.991 35.1602 49.9983 35.5757C50.0057 35.9913 49.8514 36.3934 49.5681 36.6975L36.7361 49.5295C36.588 49.6794 36.4114 49.7983 36.2168 49.8791C36.0222 49.9599 35.8133 50.001 35.6026 50Z"
          fill="white"
        />
        <path
          d="M48.4341 50C48.2233 50.001 48.0145 49.9599 47.8199 49.8791C47.6252 49.7983 47.4487 49.6794 47.3006 49.5295L34.4686 36.6975C34.1853 36.3934 34.031 35.9913 34.0383 35.5757C34.0457 35.1602 34.214 34.7637 34.5079 34.4698C34.8018 34.1759 35.1982 34.0076 35.6138 34.0002C36.0293 33.9929 36.4315 34.1472 36.7356 34.4305L49.5676 47.2625C49.8679 47.5632 50.0367 47.9709 50.0367 48.396C50.0367 48.821 49.8679 49.2287 49.5676 49.5295C49.4195 49.6794 49.2429 49.7983 49.0483 49.8791C48.8536 49.9599 48.6448 50.001 48.4341 50Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_29525_17359"
          x="0"
          y="0"
          width="90"
          height="90"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="3" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.185033 0 0 0 0 0.0818056 0 0 0 0 0.633333 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_29525_17359"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_29525_17359"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ChatBackIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      style={{ marginRight: "3px" }}
    >
      <path
        d="M20.0002 8.00028C20.0002 8.55328 19.5532 9.00028 19.0002 9.00028H3.41422L8.70719 14.2933C9.09819 14.6842 9.09819 15.3163 8.70719 15.7073C8.51219 15.9023 8.25622 16.0003 8.00022 16.0003C7.74422 16.0003 7.48825 15.9023 7.29325 15.7073L0.29325 8.70731C-0.09775 8.31631 -0.09775 7.68425 0.29325 7.29325L7.29325 0.29325C7.68425 -0.09775 8.31619 -0.09775 8.70719 0.29325C9.09819 0.68425 9.09819 1.31631 8.70719 1.70731L3.41422 7.00028H19.0002C19.5532 7.00028 20.0002 7.44728 20.0002 8.00028Z"
        fill="#0E26A3"
      />
    </svg>
  );
};

// export const DatePickerIcon: React.FunctionComponent<ISvgComponent> = ({
//   fillColor,
//   handleClick,
//   customClass,
// }) => {
//   return (
//     <svg style={{
//       position: "relative",
//       right: "10px",
//       padding: "12px",
//       height: "10px",
//       width: "10px",
//       color: "black",
//       zIndex: "99999",
//     }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" fill="#0E26A3"></path></svg>
//   );
// };

export const DatePickerIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 0.85C12.75 0.37995 12.3692 0 11.9 0C11.4308 0 11.05 0.37995 11.05 0.85H5.95C5.95 0.37995 5.5692 0 5.1 0C4.6308 0 4.25 0.37995 4.25 0.85C1.90655 0.85 0 2.75655 0 5.1V12.75C0 15.0935 1.90655 17 4.25 17H12.75C15.0935 17 17 15.0935 17 12.75V5.1C17 2.75655 15.0935 0.85 12.75 0.85ZM4.25 2.55V3.4C4.25 3.87005 4.6308 4.25 5.1 4.25C5.5692 4.25 5.95 3.87005 5.95 3.4V2.55H11.05V3.4C11.05 3.87005 11.4308 4.25 11.9 4.25C12.3692 4.25 12.75 3.87005 12.75 3.4V2.55C14.1559 2.55 15.3 3.6941 15.3 5.1H1.7C1.7 3.6941 2.8441 2.55 4.25 2.55ZM12.75 15.3H4.25C2.8441 15.3 1.7 14.1559 1.7 12.75V6.8H15.3V12.75C15.3 14.1559 14.1559 15.3 12.75 15.3ZM12.75 9.35C12.75 9.8192 12.3692 10.2 11.9 10.2C11.4308 10.2 11.05 9.8192 11.05 9.35C11.05 8.8808 11.4308 8.5 11.9 8.5C12.3692 8.5 12.75 8.8808 12.75 9.35ZM9.35 9.35C9.35 9.8192 8.9692 10.2 8.5 10.2C8.0308 10.2 7.65 9.8192 7.65 9.35C7.65 8.8808 8.0308 8.5 8.5 8.5C8.9692 8.5 9.35 8.8808 9.35 9.35ZM5.95 9.35C5.95 9.8192 5.5692 10.2 5.1 10.2C4.6308 10.2 4.25 9.8192 4.25 9.35C4.25 8.8808 4.6308 8.5 5.1 8.5C5.5692 8.5 5.95 8.8808 5.95 9.35ZM12.75 12.75C12.75 13.2192 12.3692 13.6 11.9 13.6C11.4308 13.6 11.05 13.2192 11.05 12.75C11.05 12.2808 11.4308 11.9 11.9 11.9C12.3692 11.9 12.75 12.2808 12.75 12.75ZM9.35 12.75C9.35 13.2192 8.9692 13.6 8.5 13.6C8.0308 13.6 7.65 13.2192 7.65 12.75C7.65 12.2808 8.0308 11.9 8.5 11.9C8.9692 11.9 9.35 12.2808 9.35 12.75ZM5.95 12.75C5.95 13.2192 5.5692 13.6 5.1 13.6C4.6308 13.6 4.25 13.2192 4.25 12.75C4.25 12.2808 4.6308 11.9 5.1 11.9C5.5692 11.9 5.95 12.2808 5.95 12.75Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const TotalPtientIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="39"
      height="40"
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.47 21.9199H26.4694M12.0703 21.9199H12.0865M21.0698 29.1195H12.0703M26.4694 29.1195H26.4533"
        stroke="#5936F1"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.0733 2.12305V5.72283M8.47461 2.12305V5.72283"
        stroke="#5936F1"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.17188 20.5626C2.17188 12.7199 2.17188 8.7986 4.42555 6.36219C6.67923 3.92578 10.3065 3.92578 17.5609 3.92578H20.9807C28.2352 3.92578 31.8624 3.92578 34.1161 6.36219C36.3698 8.7986 36.3698 12.7199 36.3698 20.5626V21.4869C36.3698 29.3296 36.3698 33.2509 34.1161 35.6873C31.8624 38.1237 28.2352 38.1237 20.9807 38.1237H17.5609C10.3065 38.1237 6.67923 38.1237 4.42555 35.6873C2.17188 33.2509 2.17188 29.3296 2.17188 21.4869V20.5626Z"
        stroke="#5936F1"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.06836 12.9238H35.4664"
        stroke="#5936F1"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FlotingIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      cursor="pointer"
    >
      <circle opacity="0.1" cx="28" cy="28" r="28" fill="#02BF90" />
      <circle opacity="0.2" cx="28" cy="28" r="20" fill="#02BF90" />
      <circle opacity="0.6" cx="28" cy="28" r="13" fill="white" />
    </svg>
  );
};

export const StarIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="39"
      height="40"
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.47 21.9199H26.4694M12.0703 21.9199H12.0865M21.0698 29.1195H12.0703M26.4694 29.1195H26.4533"
        stroke="#5936F1"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.0733 2.12305V5.72283M8.47461 2.12305V5.72283"
        stroke="#5936F1"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.17188 20.5626C2.17188 12.7199 2.17188 8.7986 4.42555 6.36219C6.67923 3.92578 10.3065 3.92578 17.5609 3.92578H20.9807C28.2352 3.92578 31.8624 3.92578 34.1161 6.36219C36.3698 8.7986 36.3698 12.7199 36.3698 20.5626V21.4869C36.3698 29.3296 36.3698 33.2509 34.1161 35.6873C31.8624 38.1237 28.2352 38.1237 20.9807 38.1237H17.5609C10.3065 38.1237 6.67923 38.1237 4.42555 35.6873C2.17188 33.2509 2.17188 29.3296 2.17188 21.4869V20.5626Z"
        stroke="#5936F1"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.06836 12.9238H35.4664"
        stroke="#5936F1"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RatingIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.42167 1.36019L8.89552 4.34662C9.00897 4.57651 9.22848 4.73607 9.48211 4.77273L12.778 5.25164C13.4169 5.34456 13.6722 6.12991 13.2099 6.58069L10.825 8.90537C10.6415 9.0843 10.5575 9.34231 10.6009 9.59502L11.1639 12.8775C11.273 13.5139 10.605 13.9993 10.0334 13.6988L7.08549 12.1491C6.8586 12.0299 6.58744 12.0299 6.36033 12.1491L3.41263 13.6988C2.84102 13.9993 2.17304 13.5139 2.28211 12.8775L2.84518 9.59502C2.88852 9.34231 2.80482 9.0843 2.62105 8.90537L0.236194 6.58069C-0.226343 6.12991 0.0289049 5.34456 0.668065 5.25164L3.96394 4.77273C4.2178 4.73584 4.43708 4.57651 4.55053 4.34662L6.02437 1.36019C6.31029 0.780979 7.13599 0.780979 7.42167 1.36019Z"
        fill="#FCE340"
      />
    </svg>
  );
};

export const CalendarIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="39"
      height="40"
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.2921 2.12305V5.72283M8.69336 2.12305V5.72283"
        stroke="#02BF90"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.39062 20.5626C2.39062 12.7199 2.39062 8.7986 4.6443 6.36219C6.89798 3.92578 10.5252 3.92578 17.7797 3.92578H21.1995C28.454 3.92578 32.0812 3.92578 34.3349 6.36219C36.5886 8.7986 36.5886 12.7199 36.5886 20.5626V21.4869C36.5886 29.3296 36.5886 33.2509 34.3349 35.6873C32.0812 38.1237 28.454 38.1237 21.1995 38.1237H17.7797C10.5252 38.1237 6.89798 38.1237 4.6443 35.6873C2.39062 33.2509 2.39062 29.3296 2.39062 21.4869V20.5626Z"
        stroke="#02BF90"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.28906 12.9238H35.6871"
        stroke="#02BF90"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8516 24.9689L18.3129 28.4302L25.9278 20.123"
        stroke="#02BF90"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrivedIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="38"
      height="40"
      viewBox="0 0 38 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.6885 2.12305V5.72283M8.08984 2.12305V5.72283"
        stroke="#3371EB"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.78711 20.5626C1.78711 12.7199 1.78711 8.7986 4.04079 6.36219C6.29446 3.92578 9.9217 3.92578 17.1762 3.92578H20.596C27.8504 3.92578 31.4777 3.92578 33.7314 6.36219C35.985 8.7986 35.985 12.7199 35.985 20.5626V21.4869C35.985 29.3296 35.985 33.2509 33.7314 35.6873C31.4777 38.1237 27.8504 38.1237 20.596 38.1237H17.1762C9.9217 38.1237 6.29446 38.1237 4.04079 35.6873C1.78711 33.2509 1.78711 29.3296 1.78711 21.4869V20.5626Z"
        stroke="#3371EB"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.68555 12.9238H35.0836"
        stroke="#3371EB"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0918 17.3535V19.8918"
        stroke="#3371EB"
        strokeWidth="2.8234"
        strokeLinecap="round"
      />
      <path
        d="M19.0918 30.0449V32.5832"
        stroke="#3371EB"
        strokeWidth="2.8234"
        strokeLinecap="round"
      />
      <path
        d="M26.7063 24.9688L24.168 24.9688"
        stroke="#3371EB"
        strokeWidth="2.8234"
        strokeLinecap="round"
      />
      <path
        d="M14.0149 24.9688L11.4766 24.9688"
        stroke="#3371EB"
        strokeWidth="2.8234"
        strokeLinecap="round"
      />
      <path
        d="M24.4745 19.5859L22.6797 21.3808"
        stroke="#3371EB"
        strokeWidth="2.8234"
        strokeLinecap="round"
      />
      <path
        d="M15.5038 28.5586L13.709 30.3534"
        stroke="#3371EB"
        strokeWidth="2.8234"
        strokeLinecap="round"
      />
      <path
        d="M24.4745 30.3534L22.6797 28.5586"
        stroke="#3371EB"
        strokeWidth="2.8234"
        strokeLinecap="round"
      />
      <path
        d="M15.5038 21.3808L13.709 19.5859"
        stroke="#3371EB"
        strokeWidth="2.8234"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const CancelledIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="38"
      height="40"
      viewBox="0 0 38 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9112 2.12305V5.72283M8.3125 2.12305V5.72283"
        stroke="#B11313"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.9082 12.9238H35.3063"
        stroke="#B11313"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.00977 20.5626C2.00977 12.7199 2.00977 8.7986 4.26344 6.36219C6.51712 3.92578 10.1444 3.92578 17.3988 3.92578H20.8186C28.0731 3.92578 31.7003 3.92578 33.954 6.36219C36.2077 8.7986 36.2077 12.7199 36.2077 20.5626V21.4869C36.2077 29.3296 36.2077 33.2509 33.954 35.6873C31.7003 38.1237 28.0731 38.1237 20.8186 38.1237H17.3988C10.1444 38.1237 6.51712 38.1237 4.26344 35.6873C2.00977 33.2509 2.00977 29.3296 2.00977 21.4869V20.5626Z"
        stroke="#B11313"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6055 21.0195L19.1052 25.5193M19.1052 25.5193L23.6049 30.019M19.1052 25.5193L23.6049 21.0195M19.1052 25.5193L14.6055 30.019"
        stroke="#B11313"
        strokeWidth="3.52924"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EmptyStarIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0288 8.54735L11.0289 8.54733L13.4137 6.2227C13.4137 6.22268 13.4137 6.22267 13.4137 6.22265C13.5792 6.06117 13.4878 5.77978 13.259 5.74644C13.2589 5.74644 13.2589 5.74644 13.2589 5.74644L9.96345 5.26759C9.96341 5.26758 9.96337 5.26758 9.96333 5.26757L9.96308 5.26754L10.035 4.77273C9.78134 4.73607 9.56183 4.57651 9.44839 4.34662L11.0288 8.54735ZM11.0288 8.54735C10.7276 8.84105 10.5897 9.26452 10.6609 9.67955L11.224 12.962C11.224 12.962 11.224 12.962 11.224 12.9621C11.263 13.19 11.0237 13.3639 10.8189 13.2562L7.87101 11.7066L7.87091 11.7065C7.49842 11.5108 7.05312 11.5108 6.68063 11.7065L6.68053 11.7066L3.73263 13.2562C3.52783 13.3639 3.28848 13.19 3.32755 12.962L3.89061 9.67956L3.39781 9.59502L3.89061 9.67955C3.9618 9.26452 3.82399 8.84105 3.52271 8.54735L3.52269 8.54733L1.13789 6.2227C1.13787 6.22268 1.13785 6.22267 1.13783 6.22265C0.972183 6.06105 1.06368 5.77975 1.29259 5.74644C1.29261 5.74644 1.29262 5.74644 1.29263 5.74644L4.58847 5.26754L4.58847 5.26754C5.00514 5.20698 5.36523 4.94541 5.55153 4.5679C5.55153 4.5679 5.55153 4.56789 5.55153 4.56789L7.02536 1.58151L11.0288 8.54735ZM7.52619 1.58151L9.00001 4.56789L7.02538 1.58147C7.12789 1.37389 7.42366 1.37389 7.52617 1.58147C7.52617 1.58148 7.52618 1.58149 7.52619 1.58151Z"
        stroke="#002C5A"
        strokeOpacity="0.3"
      />
    </svg>
  );
};
export const SalesIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 19H2.6C2.03995 19 1.75992 19 1.54601 18.891C1.35785 18.7951 1.20487 18.6422 1.10899 18.454C1 18.2401 1 17.9601 1 17.4V1M19 5L13.5657 10.4343C13.3677 10.6323 13.2687 10.7313 13.1545 10.7684C13.0541 10.8011 12.9459 10.8011 12.8455 10.7684C12.7313 10.7313 12.6323 10.6323 12.4343 10.4343L10.5657 8.56569C10.3677 8.36768 10.2687 8.26867 10.1545 8.23158C10.0541 8.19895 9.94591 8.19895 9.84549 8.23158C9.73133 8.26867 9.63232 8.36768 9.43431 8.56569L5 13M19 5H15M19 5V9"
        stroke="#02BF90"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CollectionIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 13.6667C7.5 14.9553 8.54467 16 9.83333 16H12C13.3807 16 14.5 14.8807 14.5 13.5C14.5 12.1193 13.3807 11 12 11H10C8.61929 11 7.5 9.88071 7.5 8.5C7.5 7.11929 8.61929 6 10 6H12.1667C13.4553 6 14.5 7.04467 14.5 8.33333M11 4.5V6M11 16V17.5M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="#02BF90"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PrecriptionIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8484 21.7071C16.239 22.0976 16.8721 22.0976 17.2627 21.7071C17.6532 21.3166 17.6532 20.6834 17.2627 20.2929L15.8484 21.7071ZM7.26266 10.2929C6.87214 9.90237 6.23897 9.90237 5.84845 10.2929C5.45792 10.6834 5.45792 11.3166 5.84845 11.7071L7.26266 10.2929ZM0 18.7778C0 19.3301 0.447715 19.7778 1 19.7778C1.55228 19.7778 2 19.3301 2 18.7778H0ZM1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12V10ZM17.2627 15.0404C17.6532 14.6499 17.6532 14.0168 17.2627 13.6262C16.8721 13.2357 16.239 13.2357 15.8484 13.6262L17.2627 15.0404ZM9.18178 20.2929C8.79126 20.6834 8.79126 21.3166 9.18178 21.7071C9.57231 22.0976 10.2055 22.0976 10.596 21.7071L9.18178 20.2929ZM17.2627 20.2929L7.26266 10.2929L5.84845 11.7071L15.8484 21.7071L17.2627 20.2929ZM2 18.7778V3.22222H0V18.7778H2ZM3.22222 2H6V0H3.22222V2ZM6 2C8.20914 2 10 3.79086 10 6H12C12 2.68629 9.31371 0 6 0V2ZM10 6C10 8.20914 8.20914 10 6 10V12C9.31371 12 12 9.31371 12 6H10ZM6 10H1V12H6V10ZM2 3.22222C2 2.78423 2.02417 2.50158 2.06539 2.31394C2.10412 2.13763 2.14314 2.11441 2.12877 2.12877C2.11441 2.14314 2.13763 2.10412 2.31394 2.06539C2.50158 2.02417 2.78423 2 3.22222 2V0C2.74095 0 2.2862 0.0237927 1.88481 0.111971C1.47209 0.202636 1.05467 0.374452 0.71456 0.71456C0.374452 1.05467 0.202636 1.4721 0.111971 1.88481C0.0237927 2.2862 0 2.74095 0 3.22222H2ZM15.8484 13.6262L9.18178 20.2929L10.596 21.7071L17.2627 15.0404L15.8484 13.6262Z"
        fill="#02BF90"
      />
    </svg>
  );
};

export const ReceiptIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 17.6458V7.05426C1 4.20025 1 2.77325 1.87868 1.88663C2.75736 1 4.17157 1 7 1H11C13.8284 1 15.2426 1 16.1213 1.88663C17 2.77325 17 4.20025 17 7.05426V17.6458C17 19.1575 17 19.9133 16.538 20.2108C15.7831 20.6971 14.6161 19.6774 14.0291 19.3073C13.5441 19.0014 13.3017 18.8485 13.0325 18.8397C12.7417 18.8301 12.4949 18.9768 11.9709 19.3073L10.06 20.5124C9.54454 20.8374 9.28679 21 9 21C8.71321 21 8.45546 20.8374 7.94 20.5124L6.02913 19.3073C5.54415 19.0014 5.30166 18.8485 5.03253 18.8397C4.74172 18.8301 4.49493 18.9768 3.97087 19.3073C3.38395 19.6774 2.21687 20.6971 1.46195 20.2108C1 19.9133 1 19.1575 1 17.6458Z"
        stroke="#02BF90"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 5L5 5"
        stroke="#02BF90"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 9H5"
        stroke="#02BF90"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 8.875C10.6716 8.875 10 9.46263 10 10.1875C10 10.9124 10.6716 11.5 11.5 11.5C12.3284 11.5 13 12.0876 13 12.8125C13 13.5374 12.3284 14.125 11.5 14.125M11.5 8.875C12.1531 8.875 12.7087 9.24023 12.9146 9.75M11.5 8.875V8M11.5 14.125C10.8469 14.125 10.2913 13.7598 10.0854 13.25M11.5 14.125V15"
        stroke="#02BF90"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ChatsIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <circle cx="20.5" cy="20.5" r="20" fill="white" stroke="#02BF90" />
      <path
        d="M26.2 15.75V14.8C26.2 12.7043 24.4957 11 22.4 11H14.8C12.7043 11 11 12.7043 11 14.8V24.3C11 24.6857 11.2337 25.0334 11.5909 25.1797C11.7068 25.2272 11.8284 25.25 11.95 25.25C12.2008 25.25 12.4459 25.1512 12.6283 24.965L14.211 23.35H14.8V24.3C14.8 26.3957 16.5043 28.1 18.6 28.1H26.789L28.3717 29.715C28.5541 29.9002 28.8001 30 29.05 30C29.1707 30 29.2932 29.9772 29.4091 29.9297C29.7663 29.7844 30 29.4357 30 29.05V19.55C30 17.4543 28.2957 15.75 26.2 15.75ZM13.812 21.45C13.5564 21.45 13.3123 21.5526 13.1337 21.735L12.9 21.9735V14.8C12.9 13.7521 13.7521 12.9 14.8 12.9H22.4C23.4478 12.9 24.3 13.7521 24.3 14.8V19.55C24.3 20.5978 23.4478 21.45 22.4 21.45H13.812ZM28.1 26.7235L27.8663 26.485C27.6877 26.3036 27.4426 26.2 27.188 26.2H18.6C17.5521 26.2 16.7 25.3478 16.7 24.3V23.35H22.4C24.4957 23.35 26.2 21.6457 26.2 19.55V17.65C27.2479 17.65 28.1 18.5021 28.1 19.55V26.7235Z"
        fill="#02BF90"
      />
    </svg>
  );
};

export const PurchaseIcon: React.FunctionComponent<ISvgComponent> = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 15H13.7632C18.2508 15 18.9333 12.1808 19.761 8.06908C19.9998 6.88311 20.1192 6.29013 19.8321 5.89507C19.545 5.5 18.9947 5.5 17.8941 5.5H17.5M4.5 5.5H6"
        stroke="#02BF90"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 6C9 6 10 6 11 8C11 8 14.1765 3 17 2"
        stroke="#02BF90"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 15L3.87873 2.51493C3.65615 1.62459 2.85618 1 1.93845 1H1"
        stroke="#02BF90"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.38 15H6.96857C5.60522 15 4.5 16.1513 4.5 17.5714C4.5 17.8081 4.6842 18 4.91143 18H16"
        stroke="#02BF90"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="19.5" r="1.5" stroke="#02BF90" strokeWidth="1.5" />
      <circle cx="16" cy="19.5" r="1.5" stroke="#02BF90" strokeWidth="1.5" />
    </svg>
  );
};
export const FloatCloseIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <rect opacity="0.4" width="40" height="40" rx="20" fill="#02BF90" />
      <rect x="7" y="7" width="26" height="26" rx="13" fill="white" />
      <path
        d="M26 14L14 26M14 14L26 26"
        stroke="#02BF90"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const TodoIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <>
      <svg
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={handleClick}
      >
        <circle cx="20.5" cy="20.5" r="20" fill="white" stroke="#02BF90" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.1471 12.7478V27.2162C30.1471 28.9284 28.8514 30.3165 27.253 30.3165H13.7471C12.1488 30.3165 10.853 28.9284 10.853 27.2162V12.7478C10.853 11.0355 12.1488 9.64746 13.7471 9.64746H27.253C28.8514 9.64746 30.1471 11.0355 30.1471 12.7478ZM19.536 13.7812H25.3242C25.857 13.7812 26.2889 14.2439 26.2889 14.8147C26.2889 15.3855 25.857 15.8482 25.3242 15.8482H19.536C19.0032 15.8482 18.5713 15.3855 18.5713 14.8147C18.5713 14.2439 19.0032 13.7812 19.536 13.7812ZM16.6403 14.8149C16.6388 14.6798 16.6126 14.5464 16.5632 14.4222C16.5143 14.2969 16.4458 14.1816 16.3606 14.0811C16.2668 13.9898 16.1591 13.9164 16.0422 13.8641C15.683 13.7023 15.2681 13.7879 14.9907 14.0811C14.9055 14.1816 14.837 14.2969 14.7881 14.4222C14.7387 14.5464 14.7124 14.6798 14.7109 14.8149C14.7094 15.0896 14.8101 15.3536 14.9907 15.5486C15.1756 15.7375 15.4202 15.8445 15.6756 15.8483C15.8022 15.8518 15.9277 15.8235 16.0422 15.7656C16.1591 15.7133 16.2668 15.6399 16.3606 15.5486C16.5369 15.3506 16.6368 15.0885 16.6403 14.8149ZM16.0422 19.031C15.683 18.8692 15.2681 18.9548 14.9907 19.2481C14.9014 19.3451 14.8323 19.4613 14.7881 19.5891C14.7387 19.7133 14.7125 19.8468 14.711 19.9818C14.7095 20.2565 14.8101 20.5205 14.9907 20.7156C15.1756 20.9044 15.4202 21.0114 15.6757 21.0153C15.8017 21.0136 15.9263 20.9855 16.0422 20.9326C16.1592 20.8802 16.2668 20.8068 16.3606 20.7156L16.4764 20.5605C16.5129 20.5029 16.5421 20.4404 16.5632 20.3745C16.5977 20.3171 16.6238 20.2544 16.6404 20.1885C16.6451 20.1197 16.6451 20.0506 16.6404 19.9818C16.6368 19.7082 16.5369 19.4461 16.3606 19.2481C16.2668 19.1568 16.1592 19.0834 16.0422 19.031ZM19.5359 18.9483H25.3241C25.8569 18.9483 26.2888 19.411 26.2888 19.9818C26.2888 20.5525 25.8569 21.0152 25.3241 21.0152H19.5359C19.0031 21.0152 18.5711 20.5525 18.5711 19.9818C18.5711 19.411 19.0031 18.9483 19.5359 18.9483ZM16.3608 24.4159C16.267 24.3246 16.1593 24.2512 16.0424 24.1989C15.6832 24.037 15.2683 24.1227 14.9909 24.4159C14.9031 24.5142 14.8342 24.6301 14.7883 24.7569C14.6851 25.0071 14.6851 25.2922 14.7883 25.5424C14.8342 25.6692 14.9031 25.7851 14.9909 25.8834C15.1758 26.0723 15.4204 26.1793 15.6758 26.1831C15.8019 26.1815 15.9264 26.1534 16.0424 26.1004C16.1593 26.0481 16.267 25.9747 16.3608 25.8834C16.4486 25.7851 16.5175 25.6692 16.5634 25.5424C16.6666 25.2922 16.6666 25.0071 16.5634 24.7569C16.5175 24.6301 16.4486 24.5142 16.3608 24.4159ZM19.536 24.1152H25.3242C25.857 24.1152 26.2889 24.5779 26.2889 25.1487C26.2889 25.7194 25.857 26.1821 25.3242 26.1821H19.536C19.0032 26.1821 18.5713 25.7194 18.5713 25.1487C18.5713 24.5779 19.0032 24.1152 19.536 24.1152ZM27.2523 11.7158C27.7851 11.7158 28.217 12.1785 28.217 12.7493V27.2176C28.217 27.7884 27.7851 28.2511 27.2523 28.2511H13.7464C13.2137 28.2511 12.7817 27.7884 12.7817 27.2176V12.7493C12.7817 12.1785 13.2137 11.7158 13.7464 11.7158H27.2523Z"
          fill="#02BF90"
        />
      </svg>
    </>
  );
};
export const AllergyIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <>
      <svg
        width="101"
        height="35"
        viewBox="0 0 101 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="101" height="35" rx="17.5" fill="#E40303" />
        <path
          d="M22.5 5C15.5913 5 10 10.5907 10 17.5C10 24.4087 15.5907 30 22.5 30C29.4087 30 35 24.4093 35 17.5C35 10.5913 29.4093 5 22.5 5ZM33.5352 17.5C33.5352 20.2794 32.5019 22.8217 30.7998 24.7641L27.7116 21.6758C28.5199 20.0992 28.2963 18.1915 28.2842 18.0939C28.2427 17.7612 27.9807 17.4992 27.648 17.4577C27.6327 17.4558 27.573 17.4487 27.4774 17.4413C28.5605 15.8078 28.2974 13.564 28.2842 13.458C28.2427 13.1253 27.9807 12.8632 27.648 12.8218C27.573 12.8125 26.4286 12.6782 25.187 12.9835C25.2406 12.7329 25.2712 12.4733 25.2712 12.2063C25.2712 9.91719 23.0447 8.15796 22.9499 8.08418C22.6854 7.87827 22.3147 7.87827 22.0502 8.08418C21.9554 8.15796 19.7289 9.91719 19.7289 12.2063C19.7289 12.4732 19.7594 12.7328 19.8131 12.9835C19.4815 12.902 19.1571 12.8517 18.8579 12.8222L15.2359 9.2002C17.1783 7.4981 19.7206 6.46484 22.5 6.46484C28.5848 6.46484 33.5352 11.4152 33.5352 17.5ZM21.754 22.4958C21.0125 22.4907 19.7704 22.3597 19.025 21.6143C18.2794 20.8687 18.1485 19.6263 18.1435 18.8854C18.885 18.8904 20.1271 19.0215 20.8725 19.7668C21.618 20.5124 21.749 21.7548 21.754 22.4958ZM21.754 17.858C19.3457 17.8362 18.1606 16.7812 18.1435 14.2495C20.5439 14.2655 21.7362 15.332 21.754 17.858ZM26.8564 14.2494C26.8401 16.6863 25.7437 17.8423 23.2479 17.8598C23.2707 15.3411 24.4308 14.2656 26.8564 14.2494ZM22.5 14.7592C21.8364 14.0867 21.1937 13.1551 21.1937 12.2063C21.1937 11.152 21.9796 10.1808 22.5 9.65337C23.0207 10.1812 23.8063 11.1521 23.8063 12.2063C23.8063 13.1548 23.1601 14.0903 22.5 14.7592ZM24.1275 19.7668C24.8731 19.0213 26.1155 18.8903 26.8564 18.8853C26.8515 19.6268 26.7204 20.8689 25.975 21.6143C25.2294 22.3599 23.987 22.4908 23.2461 22.4958C23.2511 21.7544 23.3821 20.5122 24.1275 19.7668ZM11.4648 17.5C11.4648 14.7206 12.4981 12.1783 14.2002 10.2359L16.9612 12.997C16.8291 13.1124 16.7388 13.2742 16.7159 13.4579C16.7026 13.564 16.4395 15.8077 17.5226 17.4412C17.4271 17.4487 17.3673 17.4558 17.3521 17.4577C17.0194 17.4992 16.7573 17.7612 16.7159 18.0938C16.701 18.213 16.3706 21.0314 17.9893 22.6501C19.1045 23.7654 20.7886 23.9552 21.7676 23.9606V26.3379C21.7676 26.7424 22.0956 27.0703 22.5 27.0703C22.9045 27.0703 23.2325 26.7424 23.2325 26.3379V23.9606C24.153 23.9555 25.6964 23.7871 26.8045 22.8403L29.7641 25.7998C27.8217 27.5019 25.2794 28.5352 22.5 28.5352C16.4152 28.5352 11.4648 23.5848 11.4648 17.5Z"
          fill="white"
        />
        <path
          d="M46.958 20.138H43.066L42.422 22H40.364L43.878 12.214H46.16L49.674 22H47.602L46.958 20.138ZM46.426 18.57L45.012 14.482L43.598 18.57H46.426ZM52.9475 11.64V22H50.9875V11.64H52.9475ZM56.844 11.64V22H54.884V11.64H56.844ZM65.9905 17.954C65.9905 18.234 65.9718 18.486 65.9345 18.71H60.2645C60.3111 19.27 60.5071 19.7087 60.8525 20.026C61.1978 20.3433 61.6225 20.502 62.1265 20.502C62.8545 20.502 63.3725 20.1893 63.6805 19.564H65.7945C65.5705 20.3107 65.1411 20.9267 64.5065 21.412C63.8718 21.888 63.0925 22.126 62.1685 22.126C61.4218 22.126 60.7498 21.9627 60.1525 21.636C59.5645 21.3 59.1025 20.8287 58.7665 20.222C58.4398 19.6153 58.2765 18.9153 58.2765 18.122C58.2765 17.3193 58.4398 16.6147 58.7665 16.008C59.0931 15.4013 59.5505 14.9347 60.1385 14.608C60.7265 14.2813 61.4031 14.118 62.1685 14.118C62.9058 14.118 63.5638 14.2767 64.1425 14.594C64.7305 14.9113 65.1831 15.364 65.5005 15.952C65.8271 16.5307 65.9905 17.198 65.9905 17.954ZM63.9605 17.394C63.9511 16.89 63.7691 16.4887 63.4145 16.19C63.0598 15.882 62.6258 15.728 62.1125 15.728C61.6271 15.728 61.2165 15.8773 60.8805 16.176C60.5538 16.4653 60.3531 16.8713 60.2785 17.394H63.9605ZM69.3811 15.448C69.6331 15.0373 69.9597 14.7153 70.3611 14.482C70.7717 14.2487 71.2384 14.132 71.7611 14.132V16.19H71.2431C70.6271 16.19 70.1604 16.3347 69.8431 16.624C69.5351 16.9133 69.3811 17.4173 69.3811 18.136V22H67.4211V14.244H69.3811V15.448ZM76.1192 14.118C76.6979 14.118 77.2066 14.2347 77.6452 14.468C78.0839 14.692 78.4292 14.986 78.6812 15.35V14.244H80.6552V22.056C80.6552 22.7747 80.5106 23.414 80.2212 23.974C79.9319 24.5433 79.4979 24.9913 78.9192 25.318C78.3406 25.654 77.6406 25.822 76.8192 25.822C75.7179 25.822 74.8126 25.5653 74.1032 25.052C73.4032 24.5387 73.0066 23.8387 72.9132 22.952H74.8592C74.9619 23.3067 75.1812 23.5867 75.5172 23.792C75.8626 24.0067 76.2779 24.114 76.7632 24.114C77.3326 24.114 77.7946 23.9413 78.1492 23.596C78.5039 23.26 78.6812 22.7467 78.6812 22.056V20.852C78.4292 21.216 78.0792 21.5193 77.6312 21.762C77.1926 22.0047 76.6886 22.126 76.1192 22.126C75.4659 22.126 74.8686 21.958 74.3272 21.622C73.7859 21.286 73.3566 20.8147 73.0392 20.208C72.7312 19.592 72.5772 18.8873 72.5772 18.094C72.5772 17.31 72.7312 16.6147 73.0392 16.008C73.3566 15.4013 73.7812 14.9347 74.3132 14.608C74.8546 14.2813 75.4566 14.118 76.1192 14.118ZM78.6812 18.122C78.6812 17.646 78.5879 17.24 78.4012 16.904C78.2146 16.5587 77.9626 16.2973 77.6452 16.12C77.3279 15.9333 76.9872 15.84 76.6232 15.84C76.2592 15.84 75.9232 15.9287 75.6152 16.106C75.3072 16.2833 75.0552 16.5447 74.8592 16.89C74.6726 17.226 74.5792 17.6273 74.5792 18.094C74.5792 18.5607 74.6726 18.9713 74.8592 19.326C75.0552 19.6713 75.3072 19.9373 75.6152 20.124C75.9326 20.3107 76.2686 20.404 76.6232 20.404C76.9872 20.404 77.3279 20.3153 77.6452 20.138C77.9626 19.9513 78.2146 19.69 78.4012 19.354C78.5879 19.0087 78.6812 18.598 78.6812 18.122ZM89.9895 14.244L85.1875 25.668H83.1015L84.7815 21.804L81.6735 14.244H83.8715L85.8735 19.662L87.9035 14.244H89.9895Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const InsuranceIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <>
      <svg
        width="122"
        height="35"
        viewBox="0 0 122 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={customClass}
      >
        <rect width="122" height="35" rx="17.5" fill="#026ABF" />
        <path
          d="M32.774 11.7806L32.7736 11.7567C32.7618 11.1335 32.7506 10.5448 32.7506 9.97839C32.7506 9.12039 32.0526 8.42239 31.1946 8.42239C27.8748 8.42239 25.3552 7.47587 23.2652 5.44371C22.6569 4.85213 21.7039 4.85208 21.0956 5.44366C19.0057 7.47587 16.4863 8.42239 13.167 8.42239C12.309 8.42239 11.611 9.12039 11.611 9.97839C11.611 10.5569 11.5997 11.1514 11.5876 11.781C11.5314 14.7202 11.4616 18.378 12.6891 21.6983C13.3641 23.5241 14.3861 25.1107 15.7267 26.4141C17.2536 27.8987 19.2535 29.0762 21.6707 29.9141C21.835 29.9711 22.0065 30 22.1804 30C22.3544 30 22.526 29.971 22.69 29.9141C25.1074 29.0762 27.1075 27.8986 28.6345 26.414C29.9753 25.1105 30.9974 23.5239 31.6724 21.6981C32.9001 18.3776 32.8302 14.7197 32.774 11.7806ZM30.2986 21.1902C29.004 24.6915 26.3583 27.0925 22.2098 28.5304C22.1909 28.537 22.1701 28.5371 22.1504 28.5303C18.0027 27.0926 15.3572 24.6917 14.0628 21.1905C12.9312 18.1295 12.9953 14.7716 13.0519 11.809C13.0641 11.1723 13.0756 10.5709 13.0756 9.97839C13.0756 9.92806 13.1166 9.88705 13.167 9.88705C16.8921 9.88705 19.7359 8.80881 22.1167 6.49367C22.1345 6.47634 22.1574 6.46765 22.1803 6.46765C22.2032 6.46765 22.2261 6.47639 22.244 6.49372C24.625 8.80881 27.469 9.88705 31.1946 9.88705C31.2449 9.88705 31.2859 9.92806 31.2859 9.97839C31.2859 10.5587 31.2972 11.1541 31.3092 11.7845L31.3096 11.8084V11.8085C31.3663 14.7711 31.4304 18.1291 30.2986 21.1902Z"
          fill="white"
        />
        <path
          d="M26.7314 15.0626H24.375V12.706C24.375 12.3015 24.0471 11.9736 23.6427 11.9736H20.7199C20.3155 11.9736 19.9876 12.3015 19.9876 12.706V15.0626H17.6308C17.2263 15.0626 16.8984 15.3905 16.8984 15.795V18.7178C16.8984 19.1222 17.2263 19.4501 17.6308 19.4501H19.9876V21.8067C19.9876 22.2112 20.3155 22.5391 20.7199 22.5391H23.6427C24.0471 22.5391 24.375 22.2112 24.375 21.8067V19.4501H26.7315C27.1359 19.4501 27.4638 19.1222 27.4638 18.7178V15.795C27.4638 15.3905 27.1359 15.0626 26.7314 15.0626ZM25.9991 17.9854H23.6427C23.2383 17.9854 22.9104 18.3133 22.9104 18.7178V21.0744H21.4523V18.7178C21.4523 18.3133 21.1244 17.9854 20.7199 17.9854H18.3631V16.5273H20.7199C21.1244 16.5273 21.4523 16.1994 21.4523 15.795V13.4383H22.9104V15.795C22.9104 16.1994 23.2383 16.5273 23.6427 16.5273H25.9991V17.9854H25.9991Z"
          fill="white"
        />
        <path
          d="M42.926 12.228V22H40.966V12.228H42.926ZM49.1605 14.132C50.0845 14.132 50.8312 14.426 51.4005 15.014C51.9698 15.5927 52.2545 16.4047 52.2545 17.45V22H50.2945V17.716C50.2945 17.1 50.1405 16.6287 49.8325 16.302C49.5245 15.966 49.1045 15.798 48.5725 15.798C48.0312 15.798 47.6018 15.966 47.2845 16.302C46.9765 16.6287 46.8225 17.1 46.8225 17.716V22H44.8625V14.244H46.8225V15.21C47.0838 14.874 47.4152 14.6127 47.8165 14.426C48.2272 14.23 48.6752 14.132 49.1605 14.132ZM57.0863 22.126C56.4517 22.126 55.8823 22.014 55.3783 21.79C54.8743 21.5567 54.473 21.244 54.1743 20.852C53.885 20.46 53.7263 20.026 53.6983 19.55H55.6723C55.7097 19.8487 55.8543 20.096 56.1063 20.292C56.3677 20.488 56.6897 20.586 57.0723 20.586C57.4457 20.586 57.735 20.5113 57.9403 20.362C58.155 20.2127 58.2623 20.0213 58.2623 19.788C58.2623 19.536 58.1317 19.3493 57.8703 19.228C57.6183 19.0973 57.2123 18.9573 56.6523 18.808C56.0737 18.668 55.5977 18.5233 55.2243 18.374C54.8603 18.2247 54.543 17.996 54.2723 17.688C54.011 17.38 53.8803 16.9647 53.8803 16.442C53.8803 16.0127 54.0017 15.6207 54.2443 15.266C54.4963 14.9113 54.851 14.6313 55.3083 14.426C55.775 14.2207 56.321 14.118 56.9463 14.118C57.8703 14.118 58.6077 14.3513 59.1583 14.818C59.709 15.2753 60.0123 15.896 60.0683 16.68H58.1923C58.1643 16.372 58.0337 16.1293 57.8003 15.952C57.5763 15.7653 57.273 15.672 56.8903 15.672C56.5357 15.672 56.2603 15.7373 56.0643 15.868C55.8777 15.9987 55.7843 16.1807 55.7843 16.414C55.7843 16.6753 55.915 16.876 56.1763 17.016C56.4377 17.1467 56.8437 17.282 57.3943 17.422C57.9543 17.562 58.4163 17.7067 58.7803 17.856C59.1443 18.0053 59.457 18.2387 59.7183 18.556C59.989 18.864 60.129 19.2747 60.1383 19.788C60.1383 20.236 60.0123 20.6373 59.7603 20.992C59.5177 21.3467 59.163 21.6267 58.6963 21.832C58.239 22.028 57.7023 22.126 57.0863 22.126ZM69.0693 14.244V22H67.0953V21.02C66.8433 21.356 66.5119 21.622 66.1013 21.818C65.6999 22.0047 65.2613 22.098 64.7853 22.098C64.1786 22.098 63.6419 21.972 63.1753 21.72C62.7086 21.4587 62.3399 21.0807 62.0693 20.586C61.8079 20.082 61.6773 19.4847 61.6773 18.794V14.244H63.6373V18.514C63.6373 19.13 63.7913 19.606 64.0993 19.942C64.4073 20.2687 64.8273 20.432 65.3593 20.432C65.9006 20.432 66.3253 20.2687 66.6333 19.942C66.9413 19.606 67.0953 19.13 67.0953 18.514V14.244H69.0693ZM72.9631 15.448C73.2151 15.0373 73.5418 14.7153 73.9431 14.482C74.3538 14.2487 74.8204 14.132 75.3431 14.132V16.19H74.8251C74.2091 16.19 73.7424 16.3347 73.4251 16.624C73.1171 16.9133 72.9631 17.4173 72.9631 18.136V22H71.0031V14.244H72.9631V15.448ZM76.1593 18.094C76.1593 17.31 76.3133 16.6147 76.6213 16.008C76.9386 15.4013 77.3633 14.9347 77.8953 14.608C78.4366 14.2813 79.0386 14.118 79.7013 14.118C80.2799 14.118 80.7839 14.2347 81.2133 14.468C81.6519 14.7013 82.0019 14.9953 82.2633 15.35V14.244H84.2373V22H82.2633V20.866C82.0113 21.23 81.6613 21.5333 81.2133 21.776C80.7746 22.0093 80.2659 22.126 79.6873 22.126C79.0339 22.126 78.4366 21.958 77.8953 21.622C77.3633 21.286 76.9386 20.8147 76.6213 20.208C76.3133 19.592 76.1593 18.8873 76.1593 18.094ZM82.2633 18.122C82.2633 17.646 82.1699 17.24 81.9833 16.904C81.7966 16.5587 81.5446 16.2973 81.2273 16.12C80.9099 15.9333 80.5693 15.84 80.2053 15.84C79.8413 15.84 79.5053 15.9287 79.1973 16.106C78.8893 16.2833 78.6373 16.5447 78.4413 16.89C78.2546 17.226 78.1613 17.6273 78.1613 18.094C78.1613 18.5607 78.2546 18.9713 78.4413 19.326C78.6373 19.6713 78.8893 19.9373 79.1973 20.124C79.5146 20.3107 79.8506 20.404 80.2053 20.404C80.5693 20.404 80.9099 20.3153 81.2273 20.138C81.5446 19.9513 81.7966 19.69 81.9833 19.354C82.1699 19.0087 82.2633 18.598 82.2633 18.122ZM90.4495 14.132C91.3735 14.132 92.1202 14.426 92.6895 15.014C93.2589 15.5927 93.5435 16.4047 93.5435 17.45V22H91.5835V17.716C91.5835 17.1 91.4295 16.6287 91.1215 16.302C90.8135 15.966 90.3935 15.798 89.8615 15.798C89.3202 15.798 88.8909 15.966 88.5735 16.302C88.2655 16.6287 88.1115 17.1 88.1115 17.716V22H86.1515V14.244H88.1115V15.21C88.3729 14.874 88.7042 14.6127 89.1055 14.426C89.5162 14.23 89.9642 14.132 90.4495 14.132ZM94.9034 18.122C94.9034 17.3193 95.0667 16.6193 95.3934 16.022C95.7201 15.4153 96.1727 14.9487 96.7514 14.622C97.3301 14.286 97.9927 14.118 98.7394 14.118C99.7007 14.118 100.494 14.3607 101.119 14.846C101.754 15.322 102.179 15.994 102.393 16.862H100.279C100.167 16.526 99.9761 16.2647 99.7054 16.078C99.4441 15.882 99.1174 15.784 98.7254 15.784C98.1654 15.784 97.7221 15.9893 97.3954 16.4C97.0687 16.8013 96.9054 17.3753 96.9054 18.122C96.9054 18.8593 97.0687 19.4333 97.3954 19.844C97.7221 20.2453 98.1654 20.446 98.7254 20.446C99.5187 20.446 100.037 20.0913 100.279 19.382H102.393C102.179 20.222 101.754 20.8893 101.119 21.384C100.485 21.8787 99.6914 22.126 98.7394 22.126C97.9927 22.126 97.3301 21.9627 96.7514 21.636C96.1727 21.3 95.7201 20.8333 95.3934 20.236C95.0667 19.6293 94.9034 18.9247 94.9034 18.122ZM111.039 17.954C111.039 18.234 111.021 18.486 110.983 18.71H105.313C105.36 19.27 105.556 19.7087 105.901 20.026C106.247 20.3433 106.671 20.502 107.175 20.502C107.903 20.502 108.421 20.1893 108.729 19.564H110.843C110.619 20.3107 110.19 20.9267 109.555 21.412C108.921 21.888 108.141 22.126 107.217 22.126C106.471 22.126 105.799 21.9627 105.201 21.636C104.613 21.3 104.151 20.8287 103.815 20.222C103.489 19.6153 103.325 18.9153 103.325 18.122C103.325 17.3193 103.489 16.6147 103.815 16.008C104.142 15.4013 104.599 14.9347 105.187 14.608C105.775 14.2813 106.452 14.118 107.217 14.118C107.955 14.118 108.613 14.2767 109.191 14.594C109.779 14.9113 110.232 15.364 110.549 15.952C110.876 16.5307 111.039 17.198 111.039 17.954ZM109.009 17.394C109 16.89 108.818 16.4887 108.463 16.19C108.109 15.882 107.675 15.728 107.161 15.728C106.676 15.728 106.265 15.8773 105.929 16.176C105.603 16.4653 105.402 16.8713 105.327 17.394H109.009Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const OngoingBackIcon: React.FunctionComponent<ISvgComponent> = ({
  fillColor,
  handleClick,
  customClass,
}) => {
  return (
    <>
      <svg
        width="20"
        className={customClass}
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={(e) => {
          handleClick && handleClick(e);
        }}
      >
        <path
          d="M20.0002 8.00028C20.0002 8.55328 19.5532 9.00028 19.0002 9.00028H3.41422L8.70719 14.2933C9.09819 14.6842 9.09819 15.3163 8.70719 15.7073C8.51219 15.9023 8.25622 16.0003 8.00022 16.0003C7.74422 16.0003 7.48825 15.9023 7.29325 15.7073L0.29325 8.70731C-0.09775 8.31631 -0.09775 7.68425 0.29325 7.29325L7.29325 0.29325C7.68425 -0.09775 8.31619 -0.09775 8.70719 0.29325C9.09819 0.68425 9.09819 1.31631 8.70719 1.70731L3.41422 7.00028H19.0002C19.5532 7.00028 20.0002 7.44728 20.0002 8.00028Z"
          fill={fillColor ? fillColor : "#0E26A3"}
        />
      </svg>
    </>
  );
};
